// Board Exam - Special Populations
// Complete file with all 9 topics and questions

export const questions = {
  "1. Pediatric and Adolescent Care": [
    {
      id: 25100,
      question: "What is interprofessional education (IPE) defined as according to the chapter?",
      options: [
        "When dentists from multiple specialties collaborate together",
        "When students from two or more professions learn about, from, and with each other",
        "When healthcare workers provide services in hospital settings",
        "When primary care providers refer patients to specialists"
      ],
      correct: "B"
    },
    {
      id: 25101,
      question: "What does oral health literacy (OHL) refer to in patient care?",
      options: [
        "The number of years of formal education completed",
        "The degree to which a person can get, evaluate, understand, and use oral health information",
        "The ability to read dental terminology in textbooks",
        "The completion of dental hygiene courses by patients"
      ],
      correct: "B"
    },
    {
      id: 25102,
      question: "What defines early childhood caries (ECC) in children younger than 71 months?",
      options: [
        "Only cavitated lesions in permanent teeth observed",
        "Presence of one or more decayed, missing, or filled tooth surfaces in primary teeth",
        "Any white spot lesions on permanent molars",
        "Missing teeth due to trauma in young children"
      ],
      correct: "B"
    },
    {
      id: 25103,
      question: "Which teeth are most susceptible to dental caries in children aged 1 year?",
      options: [
        "Mandibular central incisors and first molars bilaterally",
        "Maxillary anterior teeth including central and lateral incisors",
        "Mandibular second molars and maxillary canines exclusively",
        "All primary molars equally without preference shown"
      ],
      correct: "B"
    },
    {
      id: 25104,
      question: "At what age does the American Academy of Pediatric Dentistry recommend establishing a dental home?",
      options: [
        "By 6 months of age before eruption",
        "No later than 12 months of age",
        "Between 18 and 24 months of age",
        "By age 3 years before school"
      ],
      correct: "B"
    },
    {
      id: 25105,
      question: "What is a dental home according to the AAPD definition?",
      options: [
        "A portable dental clinic for home visits",
        "The ongoing relationship delivering comprehensive, accessible, coordinated, family-centered oral healthcare",
        "The primary residence where oral hygiene occurs",
        "A dental insurance plan covering family members"
      ],
      correct: "B"
    },
    {
      id: 25106,
      question: "What are enamel developmental defects (EDDs) influenced by during development?",
      options: [
        "Only dietary factors during childhood years",
        "Genetic and environmental factors during amelogenesis",
        "Poor oral hygiene practices exclusively",
        "Excessive fluoride exposure after age 5"
      ],
      correct: "B"
    },
    {
      id: 25107,
      question: "At what age does eruption of the first primary tooth typically occur?",
      options: [
        "Around 3 to 4 months in mandible",
        "Around 5 to 8 months in mandible",
        "Around 10 to 12 months in maxilla",
        "Around 15 to 18 months bilaterally"
      ],
      correct: "B"
    },
    {
      id: 25108,
      question: "How many primary teeth typically erupt by 20 to 30 months of age?",
      options: [
        "12 teeth including incisors and canines",
        "All 20 primary teeth completely erupted",
        "16 teeth excluding second molars",
        "8 teeth limited to anterior region"
      ],
      correct: "B"
    },
    {
      id: 25109,
      question: "What is the recommended approach for caregivers to alleviate teething pain?",
      options: [
        "Apply teething gels containing benzocaine regularly",
        "Rub clean fingers around gingiva and use solid teething toys",
        "Give aspirin dissolved in juice frequently",
        "Use amber teething necklaces continuously worn"
      ],
      correct: "B"
    },
    {
      id: 25110,
      question: "What bacteria is primarily transmitted vertically from mother to child causing dental caries?",
      options: [
        "Lactobacillus acidophilus from dietary sources",
        "Streptococcus mutans through saliva transmission",
        "Prevotella species from periodontal pockets",
        "Tannerella forsythensis from gingival inflammation"
      ],
      correct: "B"
    },
    {
      id: 25111,
      question: "What infection is prevalent in infants and young children under age 5 years affecting oral tissues?",
      options: [
        "Candida albicans causing thrush infection",
        "Primary herpetic gingivostomatitis (HSV-1) virus",
        "Epstein-Barr virus causing mononucleosis",
        "Coxsackievirus causing hand-foot-mouth disease"
      ],
      correct: "B"
    },
    {
      id: 25112,
      question: "What percentage of nitrous oxide concentration transitions sedation to moderate sedation in children?",
      options: [
        "30 percent for all pediatric patients",
        "50 percent especially concerning for children",
        "70 percent maximum allowed equipment",
        "80 percent requiring anesthesiologist supervision"
      ],
      correct: "B"
    },
    {
      id: 25113,
      question: "Which teeth are most impacted by dental trauma in children aged 2 to 3 years?",
      options: [
        "Mandibular central incisors from falls",
        "Maxillary incisors due to increased mobility",
        "Primary molars from sports injuries",
        "All primary teeth equally distributed"
      ],
      correct: "B"
    },
    {
      id: 25114,
      question: "What type of mouthguard provides the most protection for children in sports?",
      options: [
        "Stock readymade guards purchased over-counter",
        "Properly fitted custom-made mouthguards professionally fabricated",
        "Boil and bite mouthguards from sporting goods stores",
        "Any mouthguard regardless of fit or type"
      ],
      correct: "B"
    },
    {
      id: 25115,
      question: "At what age do third molars typically erupt?",
      options: [
        "During early adolescence 12 to 14 years",
        "Late adolescence to adulthood 17 to 30 years",
        "Childhood years around 8 to 10 years",
        "Always before age 16 years completion"
      ],
      correct: "B"
    },
    {
      id: 25116,
      question: "What gingival disease may occur during puberty due to increased sex steroid hormones?",
      options: [
        "Acute necrotizing ulcerative gingivitis exclusively",
        "Endogenous sex steroid hormone gingival disease including puberty-associated gingivitis",
        "Chronic periodontitis with bone loss",
        "Gingival hyperplasia from medications only"
      ],
      correct: "B"
    },
    {
      id: 25117,
      question: "Which HPV variant has been linked to oropharyngeal squamous cell cancer in the United States?",
      options: [
        "HPV6 causing benign warts",
        "HPV16 linked to oropharyngeal cancer",
        "HPV11 causing respiratory papillomatosis",
        "HPV18 associated with cervical cancer"
      ],
      correct: "B"
    },
    {
      id: 25118,
      question: "At what age is HPV vaccination recommended to begin for boys and girls?",
      options: [
        "Age 6 to 8 years during childhood",
        "Age 11 or 12 years, or as early as age 9 years",
        "Age 15 to 16 years during adolescence",
        "Age 18 years when legally adult"
      ],
      correct: "B"
    },
    {
      id: 25119,
      question: "What is the optimal fluoride concentration recommended in drinking water by the US Public Health Service?",
      options: [
        "0.3 mg/L to prevent any fluorosis",
        "0.7 mg/L to protect against caries while minimizing fluorosis",
        "1.2 mg/L for maximum caries prevention",
        "2.0 mg/L in high-risk communities"
      ],
      correct: "B"
    },
    {
      id: 25120,
      question: "What percentage of US citizens should have access to fluoridated water supply by 2030?",
      options: [
        "50 percent as a minimum goal",
        "77 percent as the national goal",
        "85 percent for urban populations",
        "100 percent for universal coverage"
      ],
      correct: "B"
    },
    {
      id: 25121,
      question: "When should fluoride supplements be considered for children?",
      options: [
        "For all children regardless of water source",
        "When fluoride concentration in drinking water is below optimal level",
        "Only for children with active dental caries",
        "Never, as they are unnecessary"
      ],
      correct: "B"
    },
    {
      id: 25122,
      question: "What is the fluoride concentration in professionally applied APF gels?",
      options: [
        "0.5% or 5,000 ppm concentration",
        "1.23% or 12,300 ppm concentration",
        "2.26% or 22,600 ppm concentration",
        "5.0% or 50,000 ppm concentration"
      ],
      correct: "B"
    },
    {
      id: 25123,
      question: "How often should fluoride varnish be applied for children at elevated caries risk?",
      options: [
        "Monthly for maximum protection",
        "Every 3 to 6 months professionally",
        "Annually at routine examination",
        "Only once during childhood"
      ],
      correct: "B"
    },
    {
      id: 25124,
      question: "What percentage of fluoride is in sodium fluoride varnish products?",
      options: [
        "1.23% with APF formulation",
        "5% or 22,600 ppm concentration",
        "10% for professional application",
        "0.5% for pediatric patients"
      ],
      correct: "B"
    },
    {
      id: 25125,
      question: "When was silver diamine fluoride (SDF) approved by the FDA for dental use?",
      options: [
        "In 2000 for caries prevention",
        "In 2014 for treating hypersensitivity",
        "In 2018 for cavity treatment",
        "In 2020 for emergency use"
      ],
      correct: "B"
    },
    {
      id: 25126,
      question: "What is a disadvantage of silver diamine fluoride application?",
      options: [
        "Requires multiple visits for application",
        "Area is permanently stained black after application",
        "Causes severe pain during treatment",
        "Only effective on permanent teeth"
      ],
      correct: "B"
    },
    {
      id: 25127,
      question: "What does the DMFT index measure in epidemiologic research?",
      options: [
        "Only missing teeth from extractions",
        "Decayed, missing, filled teeth quantifying dental caries",
        "Developmental defects in enamel formation",
        "Demographic factors and treatment needs"
      ],
      correct: "B"
    },
    {
      id: 25128,
      question: "What is the DMFT score range for permanent dentition without third molars?",
      options: [
        "0 to 20 for primary dentition",
        "0 to 28 for permanent teeth",
        "0 to 32 including wisdom teeth",
        "0 to 16 for adolescents only"
      ],
      correct: "B"
    },
    {
      id: 25129,
      question: "What is the dmft score range for primary dentition in pediatric patients?",
      options: [
        "0 to 12 for anterior teeth",
        "0 to 20 for all primary teeth",
        "0 to 28 for mixed dentition",
        "0 to 32 for complete dentition"
      ],
      correct: "B"
    },
    {
      id: 25130,
      question: "How many surfaces are measured per posterior tooth in the DMFS index?",
      options: [
        "Three surfaces: occlusal, buccal, lingual",
        "Five surfaces: mesial, distal, buccal, lingual, occlusal",
        "Four surfaces excluding occlusal",
        "Two surfaces: proximal and facial"
      ],
      correct: "B"
    },
    {
      id: 25131,
      question: "What is the DMFS score range for permanent dentition without third molars?",
      options: [
        "0 to 88 for primary surfaces",
        "0 to 128 for permanent surfaces",
        "0 to 148 including third molars",
        "0 to 64 for partial dentition"
      ],
      correct: "B"
    },
    {
      id: 25132,
      question: "What behavioral management technique involves demonstrating, explaining, then performing the procedure?",
      options: [
        "Tell-ask-tell for patient understanding",
        "Show-tell-do for gradual introduction",
        "Ask-demonstrate-confirm for learning",
        "Display-explain-execute for cooperation"
      ],
      correct: "B"
    },
    {
      id: 25133,
      question: "What amount of fluoride toothpaste is recommended for children under age 3?",
      options: [
        "Pea-sized amount for adequate coverage",
        "Smear or rice grain amount to minimize ingestion",
        "Full brush head amount for effectiveness",
        "No fluoride toothpaste recommended"
      ],
      correct: "B"
    },
    {
      id: 25134,
      question: "At what age can children typically perform adequate oral hygiene independently?",
      options: [
        "Age 3 years with supervision",
        "Age 6 years with adequate dexterity",
        "Age 4 years in most cases",
        "Age 8 years for all children"
      ],
      correct: "B"
    },
    {
      id: 25135,
      question: "How often should preventive dental visits occur for children?",
      options: [
        "Once yearly for healthy children",
        "At least twice a year minimum",
        "Every 6 months only if high risk",
        "Quarterly for all pediatric patients"
      ],
      correct: "B"
    },
    {
      id: 25136,
      question: "What happens during the eruption of permanent teeth around age 6 to 7 years?",
      options: [
        "All primary teeth exfoliate simultaneously",
        "Mandibular central incisors exfoliate and first permanent molars erupt",
        "Only maxillary teeth begin eruption",
        "Primary molars remain until age 12"
      ],
      correct: "B"
    },
    {
      id: 25137,
      question: "What is the purpose of dental sealants on permanent molars?",
      options: [
        "To whiten teeth esthetically",
        "To protect occlusal surfaces from caries by covering pits and fissures",
        "To straighten misaligned teeth gradually",
        "To prevent gingival recession permanently"
      ],
      correct: "B"
    },
    {
      id: 25138,
      question: "What bacteria are associated with increased estrogen levels during puberty causing periodontal issues?",
      options: [
        "Streptococcus mutans and Lactobacillus species",
        "Prevotella species and Tannerella forsythensis",
        "Aggregatibacter actinomycetemcomitans and Porphyromonas gingivalis",
        "Fusobacterium nucleatum and Treponema denticola"
      ],
      correct: "B"
    },
    {
      id: 25139,
      question: "What oral manifestation may occur during menstrual cycle in adolescents?",
      options: [
        "Permanent tooth mobility and loss",
        "Herpes labialis and aphthous ulcers transiently",
        "Complete gingival recession irreversibly",
        "Tooth fractures from weakened enamel"
      ],
      correct: "B"
    },
    {
      id: 25140,
      question: "What should adolescents avoid during puberty-associated gingivitis to prevent irreversible damage?",
      options: [
        "All dairy products and calcium",
        "Lacking proper self-care and oral hygiene",
        "Attending school or social activities",
        "Consuming any acidic beverages"
      ],
      correct: "B"
    },
    {
      id: 25141,
      question: "What percentage of children under age 3 should use fluoridated toothpaste?",
      options: [
        "None, fluoride is contraindicated",
        "Smear amount twice daily for all children",
        "Full amount for maximum protection",
        "Only children with active caries"
      ],
      correct: "B"
    },
    {
      id: 25142,
      question: "When should children begin drinking from a cup instead of a bottle?",
      options: [
        "By 6 months of age",
        "Around first birthday, weaning by 12 to 14 months",
        "Not until 18 months minimum",
        "By 24 months at latest"
      ],
      correct: "B"
    },
    {
      id: 25143,
      question: "What should caregivers avoid to prevent bacterial transmission to infants?",
      options: [
        "Breastfeeding after 12 months",
        "Sharing eating utensils and cleaning pacifiers in their mouth",
        "Allowing child to self-feed",
        "Providing solid foods before teeth erupt"
      ],
      correct: "B"
    },
    {
      id: 25144,
      question: "What should be done before teeth erupt to promote oral health in infants?",
      options: [
        "Nothing until first tooth appears",
        "Clean gums after each feeding with water-soaked cloth or gauze",
        "Use fluoride gel on gums",
        "Apply topical antibiotics daily"
      ],
      correct: "B"
    },
    {
      id: 25145,
      question: "What community water fluoridation level prevents dental caries while minimizing fluorosis?",
      options: [
        "0.3 mg/L for safety margin",
        "0.7 mg/L optimal concentration recommended",
        "1.5 mg/L for high-risk areas",
        "2.0 mg/L maximum allowable level"
      ],
      correct: "B"
    },
    {
      id: 25146,
      question: "How long should patients avoid eating or drinking after fluoride varnish application?",
      options: [
        "30 minutes minimum waiting period",
        "4 to 6 hours or preferably until next day",
        "1 hour for adequate absorption",
        "24 hours for complete uptake"
      ],
      correct: "B"
    },
    {
      id: 25147,
      question: "What is the application time for fluoride varnish on clinical crown of teeth?",
      options: [
        "30 seconds for quick application",
        "1 to 3 minutes per application",
        "5 to 10 minutes for effectiveness",
        "15 minutes for maximum benefit"
      ],
      correct: "B"
    },
    {
      id: 25148,
      question: "How much fluoride varnish is typically applied as a unit dose?",
      options: [
        "0.1 mL for small children",
        "0.3 to 0.5 mL unit dose",
        "1.0 mL for complete dentition",
        "2.0 mL for adolescents"
      ],
      correct: "B"
    },
    {
      id: 25149,
      question: "What is the maximum amount of APF gel per tray for small children?",
      options: [
        "1 mL to minimize ingestion",
        "2 mL maximum per tray",
        "5 mL for adequate coverage",
        "10 mL for complete treatment"
      ],
      correct: "B"
    },
    {
      id: 25150,
      question: "How long should APF gel remain in trays during professional application?",
      options: [
        "1 minute for adequate exposure",
        "4 minutes for proper treatment",
        "10 minutes for maximum benefit",
        "15 minutes for deep penetration"
      ],
      correct: "B"
    },
    {
      id: 25151,
      question: "What should patients do after fluoride tray removal?",
      options: [
        "Rinse mouth vigorously immediately",
        "Expectorate and avoid eating/drinking for 30 minutes",
        "Brush teeth within 5 minutes",
        "Drink water to distribute fluoride"
      ],
      correct: "B"
    },
    {
      id: 25152,
      question: "At what age should oral health assessment occur before public school matriculation?",
      options: [
        "Age 3 years before preschool",
        "Before or within first year of public school enrollment",
        "Only if dental problems exist",
        "Not required by any states"
      ],
      correct: "B"
    },
    {
      id: 25153,
      question: "What does CAMBRA stand for in dental screening?",
      options: [
        "Comprehensive Assessment Method for Bacterial Risk Analysis",
        "Caries Assessment Management by Risk Assessment",
        "Clinical Application of Microbial Bacterial Risk Algorithm",
        "Community Assessment Model for Bacterial Risk Awareness"
      ],
      correct: "B"
    },
    {
      id: 25154,
      question: "What Fisher-Owens model factor includes family composition and social support?",
      options: [
        "Child-level influences exclusively",
        "Family-level influences in model",
        "Community-level influences only",
        "Environmental factors separately"
      ],
      correct: "B"
    },
    {
      id: 25155,
      question: "What should be avoided in children under 12 months to reduce caries risk?",
      options: [
        "All solid foods completely",
        "Prolonged bottle feeding and nocturnal feedings beyond 12 months",
        "Breastfeeding at any time",
        "Water in any containers"
      ],
      correct: "B"
    },
    {
      id: 25156,
      question: "Which primary teeth typically erupt first around 6 to 12 months?",
      options: [
        "Maxillary central incisors in upper jaw",
        "Mandibular central incisors in lower jaw",
        "First molars bilaterally simultaneously",
        "Lateral incisors on both arches"
      ],
      correct: "B"
    },
    {
      id: 25157,
      question: "What teething symptom should caregivers monitor in infants?",
      options: [
        "High fever above 102°F consistently",
        "Increased biting, drooling, and gum rubbing behavior",
        "Complete loss of appetite permanently",
        "Severe dehydration requiring hospitalization"
      ],
      correct: "B"
    },
    {
      id: 25158,
      question: "What should caregivers avoid using for teething pain relief?",
      options: [
        "Clean cool washcloths for chewing",
        "Teething gels or liquids containing benzocaine",
        "Solid rubber teething rings",
        "Clean refrigerated spoons"
      ],
      correct: "B"
    },
    {
      id: 25159,
      question: "How should toys be cleaned in daycare to prevent HSV-1 transmission?",
      options: [
        "Once weekly with soap only",
        "At least twice daily with diluted bleach solution",
        "Monthly deep cleaning sufficient",
        "Air drying without disinfection"
      ],
      correct: "B"
    },
    {
      id: 25160,
      question: "What age-appropriate injury prevention should be discussed with toddler caregivers?",
      options: [
        "Only sports equipment safety",
        "Car seat safety, open water, stairs, sharp objects, hazardous items, electrical safety",
        "Sunscreen application exclusively",
        "Nutritional supplements only"
      ],
      correct: "B"
    },
    {
      id: 25161,
      question: "When should thumb-sucking typically stop according to normal development?",
      options: [
        "By 12 months of age",
        "Between age 2 and 4 years",
        "Not until age 6 years",
        "By first birthday always"
      ],
      correct: "B"
    },
    {
      id: 25162,
      question: "What nonnutritive oral habits should be discussed with caregivers of toddlers?",
      options: [
        "Proper nutrition and vitamins",
        "Thumb sucking, pacifier habits, bruxism, tongue thrust",
        "Water consumption exclusively",
        "Solid food preferences only"
      ],
      correct: "B"
    },
    {
      id: 25163,
      question: "How can parents prevent transmission of Streptococcus mutans to their infant?",
      options: [
        "Avoid all contact with baby",
        "Seek preventive dental care twice yearly and avoid sharing utensils",
        "Use antibiotics prophylactically",
        "Isolate baby from all family"
      ],
      correct: "B"
    },
    {
      id: 25164,
      question: "What should be discussed regarding dietary habits to prevent ECC?",
      options: [
        "Unlimited juice consumption encouraged",
        "Avoid frequent snacking on cariogenic foods and limit to mealtimes",
        "No restrictions on sugar intake",
        "Constant bottle use acceptable"
      ],
      correct: "B"
    },
    {
      id: 25165,
      question: "What is the current AAPD recommendation for silver diamine fluoride use?",
      options: [
        "Routine use on all primary teeth",
        "Conditional recommendation for cavitated primary teeth with caries management",
        "Not recommended for any use",
        "Only for permanent teeth treatment"
      ],
      correct: "B"
    },
    {
      id: 25166,
      question: "What must be considered before prescribing fluoride supplements to children?",
      options: [
        "Only the child\'s age",
        "Caries risk assessment, fluoride concentration in water, dietary sources, and child\'s age",
        "Insurance coverage exclusively",
        "Parent preference only"
      ],
      correct: "B"
    },
    {
      id: 25167,
      question: "What is a protective factor against dental caries in children?",
      options: [
        "Frequent snacking throughout day",
        "Drinking fluoridated water or taking fluoride supplements",
        "Avoiding all dental visits",
        "Consuming sugary beverages regularly"
      ],
      correct: "B"
    },
    {
      id: 25168,
      question: "What clinical finding immediately places a child at high risk for caries?",
      options: [
        "Healthy pink gingiva present",
        "White spot decalcifications or obvious decay present",
        "Normal tooth spacing observed",
        "No plaque accumulation visible"
      ],
      correct: "B"
    },
    {
      id: 25169,
      question: "What is a risk factor for early childhood caries according to the oral health risk assessment?",
      options: [
        "Established dental home existing",
        "Mother or primary caregiver had active decay in past 12 months",
        "Teeth brushed twice daily",
        "Drinks fluoridated water regularly"
      ],
      correct: "B"
    },
    {
      id: 25170,
      question: "What self-management goal should be discussed with caregivers to prevent caries?",
      options: [
        "Increase juice consumption daily",
        "Wean off bottle and provide healthy snacks",
        "Decrease water intake significantly",
        "Avoid all dental professionals"
      ],
      correct: "B"
    },
    {
      id: 25171,
      question: "What percentage of US population has access to community water fluoridation currently?",
      options: [
        "Less than 50 percent",
        "Approximately 73 percent of the US population",
        "Nearly 90 percent coverage",
        "Complete 100 percent access"
      ],
      correct: "B"
    },
    {
      id: 25172,
      question: "What should dental hygienists document after fluoride varnish application?",
      options: [
        "Only the date of service",
        "Amount applied, brand name, patient consent, complications, and post-treatment instructions",
        "Patient\'s age exclusively",
        "Insurance billing codes only"
      ],
      correct: "B"
    }
  ],
  "2. Pregnancy and Oral Health": [
    {
      id: 25200,
      question: "What is the primary reason pregnancy provides a \"teachable moment\" for dental hygienists?",
      options: [
        "Women are more financially stable during pregnancy",
        "Women are motivated to adopt healthy behaviors for themselves and their future child",
        "Dental insurance coverage improves during pregnancy",
        "Women have more free time for dental appointments"
      ],
      correct: "B"
    },
    {
      id: 25201,
      question: "How is a woman\'s estimated due date calculated?",
      options: [
        "By counting 40 weeks from the first day of her last menstrual period",
        "By counting 36 weeks from conception",
        "By measuring fetal development at the first ultrasound",
        "By counting 42 weeks from the missed period"
      ],
      correct: "A"
    },
    {
      id: 25202,
      question: "During which time period does organogenesis occur?",
      options: [
        "Throughout the entire pregnancy",
        "During the second trimester only",
        "During the first 10 weeks of pregnancy",
        "During the third trimester primarily"
      ],
      correct: "C"
    },
    {
      id: 25203,
      question: "What percentage of US adults 30 years and older have periodontitis?",
      options: [
        "Approximately 25% of adults",
        "Approximately 42% of adults",
        "Approximately 60% of adults",
        "Approximately 15% of adults"
      ],
      correct: "B"
    },
    {
      id: 25204,
      question: "According to the 2017 Cochrane review, what did periodontal treatment during pregnancy demonstrate?",
      options: [
        "Strong evidence of preventing preterm birth with high-quality studies",
        "Definitive reduction in adverse pregnancy outcomes in all cases",
        "No evidence of reducing preterm births and possibly fewer low birth weight babies, though evidence quality was low",
        "Significant harm to the developing fetus during treatment"
      ],
      correct: "C"
    },
    {
      id: 25205,
      question: "What is early childhood caries (ECC) defined as?",
      options: [
        "Cavities occurring only in children over 6 years old",
        "The presence of one or more decayed, missing, or filled tooth surfaces in any primary tooth in a child under 6 years",
        "Only cavitated lesions in permanent teeth of young children",
        "Tooth decay affecting only the anterior primary teeth"
      ],
      correct: "B"
    },
    {
      id: 25206,
      question: "How can mutans streptococci (MS) be transmitted to infants?",
      options: [
        "Only through horizontal transmission from other children",
        "Only through contaminated feeding bottles and utensils",
        "Vertically from primary caregiver to child through saliva and horizontally from other family members or children",
        "Through airborne transmission in daycare settings exclusively"
      ],
      correct: "C"
    },
    {
      id: 25207,
      question: "When does pregnancy gingivitis typically peak?",
      options: [
        "During the first trimester primarily",
        "During the second trimester only",
        "During the third trimester",
        "Immediately after delivery"
      ],
      correct: "C"
    },
    {
      id: 25208,
      question: "What percentage of pregnancies may develop benign oral gingival lesions (pyogenic granuloma)?",
      options: [
        "Approximately 15% of pregnancies",
        "Approximately 25% of pregnancies",
        "Approximately 5% of pregnancies",
        "Approximately 30% of pregnancies"
      ],
      correct: "C"
    },
    {
      id: 25209,
      question: "What causes tooth erosion to be more common during pregnancy?",
      options: [
        "Hormonal changes affecting enamel strength directly",
        "Increased exposure to gastric acid from vomiting or gastric reflux",
        "Reduced calcium absorption during pregnancy",
        "Increased sugar consumption recommended for fetal development"
      ],
      correct: "B"
    },
    {
      id: 25210,
      question: "What is the recommended fluoride concentration in optimally fluoridated water?",
      options: [
        "1.5 parts per million (ppm)",
        "0.3 parts per million (ppm)",
        "0.7 parts per million (ppm)",
        "2.0 parts per million (ppm)"
      ],
      correct: "C"
    },
    {
      id: 25211,
      question: "How often should pregnant women brush their teeth with fluoride toothpaste?",
      options: [
        "Once a day in the morning",
        "Three times a day after meals",
        "Twice a day",
        "Only when experiencing pregnancy gingivitis"
      ],
      correct: "C"
    },
    {
      id: 25212,
      question: "When should caregivers begin oral hygiene practices for infants?",
      options: [
        "When the first tooth erupts at 6-8 months",
        "As soon as the child returns from the hospital or place of delivery",
        "At 12 months of age",
        "When the child can hold a toothbrush independently"
      ],
      correct: "B"
    },
    {
      id: 25213,
      question: "What amount of fluoride toothpaste should be used when the first tooth erupts?",
      options: [
        "A large pea-sized amount for effectiveness",
        "A full brush head of toothpaste",
        "A tiny smear the size of a grain of rice",
        "No toothpaste until age 2 years"
      ],
      correct: "C"
    },
    {
      id: 25214,
      question: "What is the recommended frequency for caregivers to \"lift the lip\" to check for white spot lesions?",
      options: [
        "Once a week to monitor closely",
        "Once a month, suggested on the infant\'s birth date",
        "Daily during tooth brushing",
        "Only when the child complains of pain"
      ],
      correct: "B"
    },
    {
      id: 25215,
      question: "What do white spots along the gum line in infants indicate?",
      options: [
        "Normal tooth development and enamel formation",
        "Teething symptoms that will resolve naturally",
        "Noncavitated dental caries that can be healed with fluoride",
        "Permanent enamel damage requiring extraction"
      ],
      correct: "C"
    },
    {
      id: 25216,
      question: "By what age should infants be weaned from the bottle?",
      options: [
        "By 6 to 8 months",
        "By 18 to 24 months",
        "By 12 to 14 months",
        "By 24 to 30 months"
      ],
      correct: "C"
    },
    {
      id: 25217,
      question: "What is personal health literacy according to Healthy People 2030?",
      options: [
        "The ability to read medical textbooks and journals",
        "The degree to which organizations enable individuals to find health information",
        "The degree to which individuals can find, understand, and use information to inform health-related decisions",
        "The level of formal education completed by patients"
      ],
      correct: "C"
    },
    {
      id: 25218,
      question: "What is organizational health literacy according to Healthy People 2030?",
      options: [
        "The reading level of healthcare organization employees",
        "The degree to which organizations equitably enable individuals to find, understand, and use information and services",
        "The number of health education programs offered by organizations",
        "The complexity of medical terminology used in organizations"
      ],
      correct: "B"
    },
    {
      id: 25219,
      question: "What is the Teach Back Method?",
      options: [
        "A technique where patients teach healthcare providers about their symptoms",
        "A method where providers repeat information multiple times until memorized",
        "A communication method to confirm whether a patient understands by having them explain information back",
        "A documentation system for recording patient education sessions"
      ],
      correct: "C"
    },
    {
      id: 25220,
      question: "When is the best time to schedule pregnant women for dental appointments during early pregnancy?",
      options: [
        "First thing in the morning before breakfast",
        "In the afternoon during the first and early second trimester",
        "Late evening to accommodate work schedules",
        "Only during the third trimester for safety"
      ],
      correct: "B"
    },
    {
      id: 25221,
      question: "How should pregnant women be positioned in the dental chair?",
      options: [
        "Completely flat to improve circulation",
        "With head higher than feet, semireclining with frequent position changes",
        "Sitting completely upright throughout the appointment",
        "On their right side to improve blood flow"
      ],
      correct: "B"
    },
    {
      id: 25222,
      question: "Why should a small pillow be placed under the pregnant woman\'s right hip?",
      options: [
        "To improve comfort during long appointments only",
        "To avoid dizziness or nausea from hypotension",
        "To prevent back pain after the appointment",
        "To facilitate better visualization for the hygienist"
      ],
      correct: "B"
    },
    {
      id: 25223,
      question: "What is gestational diabetes?",
      options: [
        "Diabetes present before pregnancy that worsens during gestation",
        "Diabetes that develops during pregnancy, usually around the 24th week",
        "A temporary condition that only affects the first trimester",
        "Diabetes diagnosed in the infant after birth"
      ],
      correct: "B"
    },
    {
      id: 25224,
      question: "What is the prevalence of gestational diabetes?",
      options: [
        "As low as 2.5% of pregnancies",
        "As high as 15.8% of pregnancies",
        "As high as 9.2% of pregnancies",
        "As low as 0.5% of pregnancies"
      ],
      correct: "C"
    },
    {
      id: 25225,
      question: "What is macrosomia in relation to gestational diabetes?",
      options: [
        "Low birth weight requiring intensive care",
        "Premature birth before 32 weeks gestation",
        "A \"large\" baby resulting from excess glucose and fat storage",
        "Underdeveloped organs in the newborn"
      ],
      correct: "C"
    },
    {
      id: 25226,
      question: "What did the FDA\'s Pregnancy and Lactation Labeling Rule (PLLR) in 2015 change?",
      options: [
        "It added more detailed pregnancy letter categories",
        "It removed pregnancy letter categories (A, B, C, D, X) and requires updated labels",
        "It eliminated all pregnancy warnings from medications",
        "It standardized all medications as safe during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 25227,
      question: "Which analgesic should be avoided during the third trimester of pregnancy?",
      options: [
        "Acetaminophen throughout the trimester",
        "Codeine for short-term pain management",
        "Ibuprofen and aspirin during this period",
        "Morphine for severe pain when necessary"
      ],
      correct: "C"
    },
    {
      id: 25228,
      question: "Which antibiotic should NEVER be used during pregnancy?",
      options: [
        "Amoxicillin for bacterial infections",
        "Penicillin for standard infections",
        "Tetracycline for any indication",
        "Clindamycin for dental infections"
      ],
      correct: "C"
    },
    {
      id: 25229,
      question: "What is the recommended duration for opioid prescriptions during pregnancy when needed?",
      options: [
        "Usually less than 3 days with no refills",
        "One week with automatic refills available",
        "Two weeks to ensure adequate pain control",
        "As long as the patient requests for comfort"
      ],
      correct: "A"
    },
    {
      id: 25230,
      question: "Can local anesthetics with epinephrine be used during pregnancy?",
      options: [
        "Never, as they cross the placenta and harm the fetus",
        "Only during the second trimester with physician approval",
        "Yes, they may be used during pregnancy",
        "Only without epinephrine for safety during pregnancy"
      ],
      correct: "C"
    },
    {
      id: 25231,
      question: "What precaution should be taken when using nitrous oxide on pregnant women?",
      options: [
        "It should never be used during any trimester",
        "Pregnant women require lower levels to achieve sedation; consult with prenatal provider",
        "It can only be used during the first trimester",
        "Higher concentrations are needed for pregnant women due to hormonal changes"
      ],
      correct: "B"
    },
    {
      id: 25232,
      question: "Can chlorhexidine mouth rinse be used during pregnancy?",
      options: [
        "No, it is contraindicated throughout pregnancy",
        "Only during the third trimester",
        "Yes, using alcohol-free products during pregnancy",
        "Only with a prescription from the obstetrician"
      ],
      correct: "C"
    },
    {
      id: 25233,
      question: "What is the ALARA principle in dental radiography?",
      options: [
        "Always Limit All Radiation Applications regardless of need",
        "As Low As Reasonably Achievable to minimize patient exposure",
        "Avoid Low-quality And Repeat Acquisitions for efficiency",
        "Apply Limited Amounts of Radiation Annually per patient"
      ],
      correct: "B"
    },
    {
      id: 25234,
      question: "What percentage of effective radiation dose do dental radiographs account for?",
      options: [
        "Approximately 25% of medical radiation exposure",
        "Approximately 10% of all radiation sources",
        "Approximately 2.5% of medical radiographs and fluoroscopies",
        "Approximately 50% of diagnostic imaging exposure"
      ],
      correct: "C"
    },
    {
      id: 25235,
      question: "When should protective aprons and thyroid collars be used during dental radiography?",
      options: [
        "Only for pregnant patients in all trimesters",
        "Never, as modern equipment eliminates radiation risk",
        "When appropriate as part of good radiologic practice",
        "Only for children under 12 years old"
      ],
      correct: "C"
    },
    {
      id: 25236,
      question: "Which organization issued \"Oral Health Care During Pregnancy: A National Consensus Statement\" in 2012?",
      options: [
        "American Dental Association independently",
        "American College of Obstetricians and Gynecologists in partnership with ADA and other organizations",
        "Centers for Disease Control and Prevention exclusively",
        "World Health Organization for global standards"
      ],
      correct: "B"
    },
    {
      id: 25237,
      question: "What is NPM 13.1 in the Title V National Performance Measures?",
      options: [
        "Percentage of children receiving dental sealants",
        "Percentage of pregnant women receiving prenatal vitamins",
        "Percent of women who had a dental visit during pregnancy",
        "Percentage of infants receiving fluoride varnish"
      ],
      correct: "C"
    },
    {
      id: 25238,
      question: "How many children does Head Start serve each year?",
      options: [
        "Approximately 500,000 children annually",
        "More than 1 million children annually",
        "Approximately 250,000 children annually",
        "More than 5 million children annually"
      ],
      correct: "B"
    },
    {
      id: 25239,
      question: "What age range does Early Head Start serve?",
      options: [
        "Children from birth to 5 years old",
        "Only pregnant women until delivery",
        "Families until a child turns 3 years old",
        "Children from 3 to 6 years old"
      ],
      correct: "C"
    },
    {
      id: 25240,
      question: "What is the WIC program\'s income eligibility requirement?",
      options: [
        "Family income at or below 100% of US poverty level",
        "Family income at or below 250% of US poverty level",
        "Family income at or below 185% of US poverty level",
        "Family income at or below 150% of US poverty level"
      ],
      correct: "C"
    },
    {
      id: 25241,
      question: "How many WIC participants were served monthly in fiscal year 2021?",
      options: [
        "About 2.5 million participants each month",
        "About 10 million participants each month",
        "About 6.2 million participants each month",
        "About 15 million participants each month"
      ],
      correct: "C"
    },
    {
      id: 25242,
      question: "What percentage of all infants in the United States did WIC serve in fiscal year 2021?",
      options: [
        "An estimated 25% of all infants",
        "An estimated 75% of all infants",
        "An estimated 43% of all infants",
        "An estimated 10% of all infants"
      ],
      correct: "C"
    },
    {
      id: 25243,
      question: "What is the Triple Aim in healthcare?",
      options: [
        "Increase revenue, improve satisfaction, and reduce staff",
        "Enhance patient experience, improve health, and decrease costs",
        "Expand services, increase appointments, and reduce wait times",
        "Improve technology, enhance facilities, and increase marketing"
      ],
      correct: "B"
    },
    {
      id: 25244,
      question: "What is a major barrier to interprofessional collaboration between medical and dental providers?",
      options: [
        "Different professional licensing requirements only",
        "Geographic distance between medical and dental offices",
        "Most EHR systems lack fully integrated and compatible medical and dental records",
        "Differences in appointment scheduling systems exclusively"
      ],
      correct: "C"
    },
    {
      id: 25245,
      question: "When did the WIC program become permanent?",
      options: [
        "In 1984 after federal legislation",
        "In 1965 as part of Medicare",
        "In 1974 after starting as a pilot in 1972",
        "In 1990 following state recommendations"
      ],
      correct: "C"
    },
    {
      id: 25246,
      question: "What is the primary focus of MIECHV home visiting programs?",
      options: [
        "Providing dental care directly in homes exclusively",
        "Improving maternal and child health by preventing child abuse and promoting development",
        "Distributing WIC benefits to eligible families",
        "Conducting home-based medical examinations only"
      ],
      correct: "B"
    },
    {
      id: 25247,
      question: "What was Finland\'s reason for providing baby boxes for 75 years?",
      options: [
        "To promote their baby product industry internationally",
        "To provide a safe sleep space and products, contributing to one of the lowest infant mortality rates globally",
        "To replace traditional cribs in hospitals nationwide",
        "To encourage larger families through government incentives"
      ],
      correct: "B"
    },
    {
      id: 25248,
      question: "What oral health content is typically MISSING from baby boxes globally?",
      options: [
        "Information on breastfeeding positions and techniques",
        "Tips for keeping infants caries-free and supplies for disrupting plaque",
        "General infant safety and sleep guidelines",
        "Clothing and bedding for the first months"
      ],
      correct: "B"
    },
    {
      id: 25249,
      question: "What is a key limitation of current WIC program benefits?",
      options: [
        "Participants cannot purchase 100% fruit juice",
        "Participants cannot purchase fluoride toothpaste or toothbrushes",
        "The program does not provide nutritional education",
        "The program excludes postpartum women completely"
      ],
      correct: "B"
    },
    {
      id: 25250,
      question: "According to research, what impact does low health literacy have on oral health outcomes?",
      options: [
        "It has no measurable impact on outcomes",
        "It improves outcomes through increased caution",
        "It negatively impacts oral health outcomes",
        "It only affects medical outcomes, not dental"
      ],
      correct: "C"
    },
    {
      id: 25251,
      question: "What is one reason medical providers may not refer pregnant patients for dental care?",
      options: [
        "They receive financial incentives not to refer",
        "They lack knowledge about the importance and safety of oral healthcare during pregnancy",
        "Dental care is contraindicated during all pregnancies",
        "Professional rivalry between medicine and dentistry"
      ],
      correct: "B"
    },
    {
      id: 25252,
      question: "What grade did the USPSTF assign to prescribing oral fluoride supplementation for children whose water supply is deficient in fluoride?",
      options: [
        "Grade A recommendation (high certainty of substantial benefit)",
        "Grade C recommendation (selectively offer based on circumstances)",
        "Grade B recommendation (high certainty of moderate benefit)",
        "Grade D recommendation (recommend against the service)"
      ],
      correct: "C"
    },
    {
      id: 25253,
      question: "What grade did the USPSTF assign to applying fluoride varnish to primary teeth of infants and children?",
      options: [
        "Grade D recommendation (discourage use)",
        "Grade I statement (insufficient evidence)",
        "Grade B recommendation (offer or provide service)",
        "Grade A recommendation (must provide service)"
      ],
      correct: "C"
    },
    {
      id: 25254,
      question: "What grade did the USPSTF assign to routine dental screening by primary care clinicians for children under 5?",
      options: [
        "Grade B recommendation (clearly beneficial)",
        "Grade A recommendation (strongly recommended)",
        "Grade I statement (insufficient evidence to assess balance of benefits and harms)",
        "Grade C recommendation (offer selectively)"
      ],
      correct: "C"
    },
    {
      id: 25255,
      question: "How many key gaps in maternity care did CMS identify in the Blueprint for Addressing the Maternal Health Crisis?",
      options: [
        "Three key gaps requiring immediate attention",
        "Ten key gaps across all systems",
        "Five key gaps related to coverage, data, quality, workforce, and social supports",
        "Seven key gaps in prenatal care delivery"
      ],
      correct: "C"
    },
    {
      id: 25256,
      question: "According to the White House Blueprint, which populations are up to five times more likely to die from pregnancy-related causes?",
      options: [
        "Women over 40 years old across all ethnicities",
        "Women in rural areas regardless of ethnicity",
        "Black, American Indian, and Alaska Native people compared to White peers",
        "Women with multiple previous pregnancies only"
      ],
      correct: "C"
    },
    {
      id: 25257,
      question: "When was the APHA policy statement on improving access to dental care for pregnant women approved?",
      options: [
        "In January 2015 by the Governing Council",
        "In October 2020 by the Governing Council",
        "In December 2012 following the national consensus",
        "In March 2018 after extensive research"
      ],
      correct: "B"
    },
    {
      id: 25258,
      question: "What does the APHA policy statement include?",
      options: [
        "Only statistical data on pregnancy outcomes",
        "Public health problem description, opposing arguments, and evidence-based strategies with action steps",
        "General recommendations without specific action steps",
        "Exclusively federal-level policy recommendations"
      ],
      correct: "B"
    },
    {
      id: 25259,
      question: "How many Title V National Performance Measures (NPMs) are there for the MCH Block Grant program?",
      options: [
        "10 measures across maternal and child populations",
        "25 measures covering all health areas",
        "15 measures for maternal and child health",
        "5 measures focused only on prenatal care"
      ],
      correct: "C"
    },
    {
      id: 25260,
      question: "What change occurred to the oral health NPM in 2015?",
      options: [
        "It was eliminated from the performance measures entirely",
        "It changed from third-grade dental sealants to dental visits during pregnancy and preventive visits for children 1-17",
        "It expanded to include adult oral health exclusively",
        "It focused solely on fluoride varnish application rates"
      ],
      correct: "B"
    },
    {
      id: 25261,
      question: "What is one component of the \"Pregnancy\" section in the FDA\'s PLLR?",
      options: [
        "Outdated pregnancy letter categories for quick reference",
        "Generic warnings without specific risk information",
        "Risk Summary, Clinical Considerations, and Data subsections",
        "Only animal study results without human data"
      ],
      correct: "C"
    },
    {
      id: 25262,
      question: "When did Healthy People as a national initiative begin?",
      options: [
        "In 1965 with Medicare and Medicaid",
        "In 1990 with the first decade goals",
        "In 1979 with overarching health goals",
        "In 2000 with the new millennium focus"
      ],
      correct: "C"
    },
    {
      id: 25263,
      question: "Which Healthy People 2030 objective focuses on health communication?",
      options: [
        "Reduce the proportion of adults with untreated decay",
        "Increase the proportion of persons who report providers always explained things understandably",
        "Increase dental sealants on molars in children",
        "Reduce consumption of added sugars by people"
      ],
      correct: "B"
    },
    {
      id: 25264,
      question: "What is a key component of preventing ECC according to the document?",
      options: [
        "Avoiding all fluoride until age 2 years",
        "Putting infants to bed with bottles for comfort",
        "Avoiding bedtime bottle feeding and cleaning infant\'s mouth daily",
        "Waiting until age 3 for first dental visit"
      ],
      correct: "C"
    },
    {
      id: 25265,
      question: "What should be done if an infant shows white spots along the gum line?",
      options: [
        "Wait until the first birthday to take action",
        "Take the child to the dentist at once as these can be healed with fluoride",
        "Increase sugar consumption for energy and growth",
        "Stop all oral hygiene practices to avoid irritation"
      ],
      correct: "B"
    },
    {
      id: 25266,
      question: "What is recommended if a pregnant woman vomits due to morning sickness?",
      options: [
        "Brush teeth immediately to remove acid",
        "Rinse mouth with one teaspoon of baking soda in a cup of water and avoid brushing for about an hour",
        "Use mouthwash only without rinsing for effectiveness",
        "Avoid all oral hygiene for the rest of the day"
      ],
      correct: "B"
    },
    {
      id: 25267,
      question: "Which fish should pregnant women avoid due to high mercury content?",
      options: [
        "Salmon, herring, and sardines regularly",
        "Shrimp, canned light tuna, and pollock",
        "King mackerel, shark, and tilefish from Gulf of Mexico",
        "Cod, haddock, and flounder from any source"
      ],
      correct: "C"
    },
    {
      id: 25268,
      question: "How many servings of fish per week can pregnant women safely eat from the \"Best Choices\" list?",
      options: [
        "One serving per week maximum for safety",
        "Five to seven servings per week",
        "Two to three servings per week",
        "Unlimited servings as fish is always healthy"
      ],
      correct: "C"
    },
    {
      id: 25269,
      question: "What advice is given to pregnant women regarding exercise?",
      options: [
        "Avoid all exercise to prevent complications",
        "Exercise regularly with physician\'s approval",
        "Only light stretching is permitted during pregnancy",
        "High-intensity exercise only during the second trimester"
      ],
      correct: "B"
    },
    {
      id: 25270,
      question: "What should pregnant women avoid regarding recreational activities?",
      options: [
        "Swimming and water aerobics at all times",
        "Walking and light jogging throughout pregnancy",
        "Hot tubs and saunas during pregnancy",
        "Prenatal yoga and stretching classes"
      ],
      correct: "C"
    },
    {
      id: 25271,
      question: "What barrier to care for low-income pregnant women involves healthcare providers?",
      options: [
        "Dentists being overly aggressive in treatment recommendations",
        "Difficulty in finding dentists who accept Medicaid and/or pregnant women",
        "Too many dental offices available causing confusion",
        "Excessive evening and weekend hours that conflict with work"
      ],
      correct: "B"
    },
    {
      id: 25272,
      question: "What is a social barrier to dental care for pregnant women?",
      options: [
        "Excessive social support from family members",
        "Lack of transportation and child care",
        "Too much health insurance coverage causing confusion",
        "Overly convenient office hours interfering with work"
      ],
      correct: "B"
    },
    {
      id: 25273,
      question: "What psychological barrier affects pregnant women seeking dental care?",
      options: [
        "Overconfidence in their oral health status",
        "Fear of going to dentist because of past experiences",
        "Excessive enthusiasm for preventive care",
        "Complete trust in all healthcare systems"
      ],
      correct: "B"
    },
    {
      id: 25274,
      question: "What knowledge barrier exists for many pregnant women?",
      options: [
        "Understanding too much about dental procedures",
        "Uncertainty about whether dental care is safe during pregnancy",
        "Excessive oral health literacy levels causing overthinking",
        "Too much information about prenatal care options"
      ],
      correct: "B"
    },
    {
      id: 25275,
      question: "What should dental hygienists do regarding comorbid conditions in pregnant patients?",
      options: [
        "Ignore all medical conditions as they don\'t affect oral health",
        "Consult with prenatal healthcare providers about conditions like diabetes, hypertension, and cardiac disease",
        "Refuse to treat patients with any medical conditions",
        "Only provide education without any clinical treatment"
      ],
      correct: "B"
    },
    {
      id: 25276,
      question: "What can happen if diabetes is poorly controlled during the first trimester?",
      options: [
        "It has no effect on the developing baby",
        "The baby\'s organs forming in the first 8 weeks may be affected, increasing risk of birth defects",
        "Only the mother\'s health is compromised, not the baby\'s",
        "It only affects the baby\'s weight at birth"
      ],
      correct: "B"
    },
    {
      id: 25277,
      question: "What causes the baby\'s pancreas to make extra insulin in gestational diabetes?",
      options: [
        "Medications the mother takes during pregnancy",
        "Glucose crossing the placenta and increasing baby\'s glucose levels",
        "Genetic mutations in the baby\'s pancreas",
        "Lack of nutrition from the mother\'s diet"
      ],
      correct: "B"
    },
    {
      id: 25278,
      question: "What can low blood glucose levels in newborns lead to?",
      options: [
        "Permanent diabetes requiring lifelong treatment immediately",
        "Improved immune system function long-term",
        "Increased risk of breathing problems at birth",
        "Enhanced growth and development in infancy"
      ],
      correct: "C"
    },
    {
      id: 25279,
      question: "What is the bidirectional relationship between oral health and diabetes?",
      options: [
        "Diabetes affects oral health but oral health doesn\'t affect diabetes",
        "Each condition can negatively impact the other",
        "They are completely independent with no interaction",
        "Only medications for diabetes affect oral health"
      ],
      correct: "B"
    },
    {
      id: 25280,
      question: "Which antimicrobial mouth rinses may be used during pregnancy?",
      options: [
        "Only prescription-strength rinses with alcohol content",
        "No antimicrobial rinses are safe during pregnancy",
        "Cetylpyridinium chloride and chlorhexidine using alcohol-free products",
        "Only homemade salt water solutions exclusively"
      ],
      correct: "C"
    },
    {
      id: 25281,
      question: "What image receptor speed should be used following the ALARA principle?",
      options: [
        "D-speed film for traditional quality standards",
        "C-speed film for detailed imaging exclusively",
        "F-speed film or digital compatible with diagnostic task",
        "Any speed as they all provide equal radiation"
      ],
      correct: "C"
    },
    {
      id: 25282,
      question: "What additional protection technique is mentioned for dental radiography?",
      options: [
        "Having the patient hold the film sensor",
        "Collimation of the beam to the size of the receptor",
        "Using the longest exposure time possible for clarity",
        "Taking radiographs from across the room"
      ],
      correct: "B"
    },
    {
      id: 25283,
      question: "What is the purpose of proper film exposure and processing techniques?",
      options: [
        "To increase revenue by using more film",
        "To minimize patient radiation exposure as part of ALARA",
        "To make dental images look more artistic",
        "To extend the life of radiography equipment"
      ],
      correct: "B"
    },
    {
      id: 25284,
      question: "According to the document, what is a critical role for dental hygienists regarding ECC prevention?",
      options: [
        "Only treating dental caries after they develop cavities",
        "Timely delivery of educational messages, skills, and preventive therapies to prevent or reduce ECC",
        "Referring all children to pediatric dentists exclusively",
        "Focusing only on maternal oral health, not infant"
      ],
      correct: "B"
    },
    {
      id: 25285,
      question: "What makes pregnancy an ideal time for interprofessional collaboration?",
      options: [
        "Increased insurance coverage during this period only",
        "The impact of pregnancy on the woman\'s oral health and the opportunity to prevent infant caries",
        "More free time for healthcare appointments regularly",
        "Reduced need for medical care during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 25286,
      question: "Where might dental hygienists find opportunities for interprofessional education?",
      options: [
        "Only in traditional dental office settings exclusively",
        "Teaching or contributing to prenatal classes at medical practices, community health centers, and hospitals",
        "Exclusively through online webinars with no personal contact",
        "Only at dental schools with no community involvement"
      ],
      correct: "B"
    },
    {
      id: 25287,
      question: "What role could dental hygienists play in pediatric medical settings?",
      options: [
        "Replacing pediatricians for all child health services",
        "Collaborating with pediatricians and family physicians to prevent ECC",
        "Only providing emergency dental services on-site",
        "Avoiding any involvement with medical providers"
      ],
      correct: "B"
    },
    {
      id: 25288,
      question: "Where have dental hygienists been successfully embedded for collaboration?",
      options: [
        "Only in hospital emergency departments exclusively",
        "In medical clinics and private practices for integrated care",
        "Exclusively in dental schools with no clinical practice",
        "Only in public health departments with no patient contact"
      ],
      correct: "B"
    },
    {
      id: 25289,
      question: "What type of settings might include WIC programs?",
      options: [
        "Only federal government offices in Washington, DC",
        "City/county health departments, hospitals, schools, mobile clinics, migrant health centers, and Indian Health Service facilities",
        "Exclusively private dental offices with special contracts",
        "Only in urban areas with populations over 1 million"
      ],
      correct: "B"
    },
    {
      id: 25290,
      question: "What percentage of infants are born in communities served by WIC programs?",
      options: [
        "Approximately 15% of all US infants",
        "Approximately 25% of all US infants",
        "Approximately 43% of all US infants",
        "Approximately 60% of all US infants"
      ],
      correct: "C"
    },
    {
      id: 25291,
      question: "What can WIC participants purchase that is a concern for oral health?",
      options: [
        "Fresh vegetables and whole grains exclusively",
        "Fruit/vegetable juice or juice blends that must be 100% juice but often contain high sugar",
        "Only unsweetened beverages and sugar-free products",
        "Fluoride toothpaste and oral hygiene products"
      ],
      correct: "B"
    },
    {
      id: 25292,
      question: "What CAN\'T WIC participants purchase despite oral health needs?",
      options: [
        "Fresh fruits and vegetables for nutrition",
        "Milk and dairy products for calcium",
        "Fluoride toothpaste or toothbrushes for oral hygiene",
        "Whole grain breads and cereals for fiber"
      ],
      correct: "C"
    },
    {
      id: 25293,
      question: "What is the age range for children served by Head Start?",
      options: [
        "Infants from birth to 1 year old",
        "Originally developed for 3- and 4-year-olds",
        "School-age children from 6 to 12 years",
        "Adolescents from 13 to 18 years old"
      ],
      correct: "B"
    },
    {
      id: 25294,
      question: "What has been included in Head Start from the beginning?",
      options: [
        "Only educational and cognitive development programs",
        "Oral health as an integral component of services",
        "Exclusively nutritional assistance without health services",
        "Only parent education classes without child services"
      ],
      correct: "B"
    },
    {
      id: 25295,
      question: "What types of settings provide Head Start services?",
      options: [
        "Only in government-owned buildings and facilities",
        "Schools, child care centers, family care centers, farm worker camps, and tribal communities",
        "Exclusively in urban areas with no rural access",
        "Only through home visiting with no center-based options"
      ],
      correct: "B"
    },
    {
      id: 25296,
      question: "What do some Head Start programs provide besides center-based services?",
      options: [
        "Financial assistance for college savings exclusively",
        "Home visiting services where teachers provide lessons at home",
        "Only transportation to and from school buildings",
        "Dental treatment under general anesthesia on-site"
      ],
      correct: "B"
    },
    {
      id: 25297,
      question: "What role do dental hygienists often play in Head Start programs?",
      options: [
        "Serving as the primary healthcare provider for all needs",
        "Providing oral health education and topical fluoride applications",
        "Only conducting research with no direct patient contact",
        "Managing the entire Head Start program administration"
      ],
      correct: "B"
    },
    {
      id: 25298,
      question: "What is the focus of MIECHV programs?",
      options: [
        "Only preventing communicable diseases in children",
        "Improvement of maternal and child health by preventing child abuse and promoting development",
        "Exclusively providing medical care in the home setting",
        "Only educating parents about nutrition and exercise"
      ],
      correct: "B"
    },
    {
      id: 25299,
      question: "What additional MIECHV program goals are mentioned?",
      options: [
        "Promoting only child development and education exclusively",
        "Improved family economic self-sufficiency and reduction in crime and domestic violence",
        "Only providing emergency medical intervention services",
        "Focusing exclusively on children over 5 years old"
      ],
      correct: "B"
    },
    {
      id: 25300,
      question: "What is currently a limitation regarding oral health in home visiting programs?",
      options: [
        "Too much oral health content overwhelming families",
        "Relatively little oral health content included in home visits",
        "Exclusive focus on oral health ignoring other needs",
        "Mandatory dental treatment requirements for families"
      ],
      correct: "B"
    },
    {
      id: 25301,
      question: "What opportunity exists for dental hygienists in community baby showers?",
      options: [
        "Selling dental products for profit exclusively",
        "Providing oral health education and resources like toothbrushes and fluoride toothpaste",
        "Only observing without any active participation allowed",
        "Replacing medical providers for all prenatal care"
      ],
      correct: "B"
    },
    {
      id: 25302,
      question: "What is missing from baby boxes regarding oral health globally?",
      options: [
        "Too much oral health information overwhelming parents",
        "Tips for keeping infants caries-free and infant washcloths or supplies for disrupting plaque",
        "Information about breastfeeding and infant nutrition",
        "Safe sleep guidelines and infant safety information"
      ],
      correct: "B"
    },
    {
      id: 25303,
      question: "What can dental hygienists advocate for regarding baby boxes?",
      options: [
        "Eliminating baby box programs entirely as unnecessary",
        "Inclusion of appropriate oral health information and supplies",
        "Replacing all medical content with dental information only",
        "Removing all educational materials to reduce costs"
      ],
      correct: "B"
    },
    {
      id: 25304,
      question: "According to Box 46.5 (Critical Thinking Scenario A), what information should Mrs. Brown receive about herself?",
      options: [
        "That she should stop all oral hygiene during pregnancy",
        "Education on improving her plaque control, treating active caries, and managing gingivitis",
        "That dental care should be postponed until after delivery",
        "That her oral health doesn\'t affect her children"
      ],
      correct: "B"
    },
    {
      id: 25305,
      question: "In Scenario A, what should Mrs. Brown be taught about preventing ECC?",
      options: [
        "To wait until children can brush their own teeth",
        "To begin oral cleaning immediately after birth, use fluoride toothpaste when teeth erupt, avoid bedtime bottles, and lift the lip monthly",
        "That dental caries in children is inevitable and unavoidable",
        "To give children bottles at bedtime for comfort"
      ],
      correct: "B"
    },
    {
      id: 25306,
      question: "What communication technique from Scenario A ensures understanding?",
      options: [
        "Using complex medical terminology to sound professional",
        "The Teach Back Method to confirm Mrs. Brown understands",
        "Speaking quickly to cover all information efficiently",
        "Providing written materials without verbal explanation"
      ],
      correct: "B"
    },
    {
      id: 25307,
      question: "In Scenario B, what is Ms. G\'s chief complaint?",
      options: [
        "Generalized tooth pain throughout her entire mouth",
        "Localized pain from a large pyogenic granuloma above teeth Nos. 11 and 12",
        "Sensitivity to cold temperatures when eating ice cream",
        "Bleeding gums during pregnancy without pain"
      ],
      correct: "B"
    },
    {
      id: 25308,
      question: "What clinical findings did Ms. G present with in Scenario B?",
      options: [
        "Perfect oral health with no treatment needed",
        "Bone loss and heavy subgingival calculus despite recent \"cleaning\"",
        "Only the pyogenic granuloma with otherwise healthy periodontium",
        "No radiographic findings of concern for treatment"
      ],
      correct: "B"
    },
    {
      id: 25309,
      question: "What communication challenge exists in Scenario B?",
      options: [
        "Ms. G speaks only English fluently with no barriers",
        "Ms. G speaks Spanish primarily with broken English, requiring translation assistance",
        "Ms. G refuses to communicate with healthcare providers",
        "Ms. G has perfect understanding of all dental terminology"
      ],
      correct: "B"
    },
    {
      id: 25310,
      question: "What should be communicated to Ms. G\'s prenatal care provider in Scenario B?",
      options: [
        "Nothing, as dental and medical care are completely separate",
        "The treatment plan, pyogenic granuloma, periodontal status, and coordination of care",
        "Only the patient\'s insurance information and contact details",
        "A request to postpone all care until after delivery"
      ],
      correct: "B"
    },
    {
      id: 25311,
      question: "In Scenario C (Box 46.12), what is the CEO\'s concern?",
      options: [
        "The cost of providing oral health education programs",
        "An obstetrician has voiced concerns about safety of dental treatment during pregnancy",
        "Too many pregnant women are seeking dental care",
        "The hospital doesn\'t have adequate dental facilities"
      ],
      correct: "B"
    },
    {
      id: 25312,
      question: "What should be prepared for the meeting with obstetricians in Scenario C?",
      options: [
        "A sales presentation for dental services offered",
        "Current evidence-based guidelines on safety of oral healthcare during pregnancy and national consensus statements",
        "Only anecdotal stories without scientific evidence",
        "Financial incentives for referring patients to dentists"
      ],
      correct: "B"
    },
    {
      id: 25313,
      question: "What should the dental hygienist ask obstetricians to do in Scenario C?",
      options: [
        "To provide dental treatment themselves in medical offices",
        "To facilitate women obtaining oral healthcare by educating patients and making referrals",
        "To ignore oral health as outside their scope",
        "To discourage pregnant women from seeking dental care"
      ],
      correct: "B"
    },
    {
      id: 25314,
      question: "What ethical issue is raised in Box 46.8 (Legal, Ethical, and Safety Issues)?",
      options: [
        "Dentists properly following evidence-based practice guidelines",
        "Dentists refusing to treat pregnant women and only scheduling during second trimester",
        "Excessive treatment of pregnant women for profit",
        "Providing too much preventive care during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 25315,
      question: "What insurance concern is mentioned in the Legal/Ethical scenario?",
      options: [
        "Medicaid covers dental services indefinitely after pregnancy",
        "Medicaid covers dental services for pregnant women but only during pregnancy, losing coverage after delivery",
        "Medicaid never covers any dental services for anyone",
        "All pregnant women have private dental insurance automatically"
      ],
      correct: "B"
    },
    {
      id: 25316,
      question: "What resource should guide the dental hygienist in the Legal/Ethical scenario?",
      options: [
        "Personal opinions about pregnancy and dental care only",
        "The ADHA Code of Ethics to guide ethical decision-making",
        "Financial considerations and practice profitability exclusively",
        "State laws without consideration of ethics or safety"
      ],
      correct: "B"
    },
    {
      id: 25317,
      question: "How could the dental hygienist address the situation with colleagues in the Legal/Ethical scenario?",
      options: [
        "By ignoring the policy and treating patients secretly",
        "By sharing current evidence-based guidelines, safety information, and national recommendations",
        "By agreeing with the policy to maintain employment",
        "By only treating patients in the second trimester"
      ],
      correct: "B"
    },
    {
      id: 25318,
      question: "What community role could dental hygienists play according to the Legal/Ethical scenario?",
      options: [
        "Avoiding all community involvement to focus on practice",
        "Promoting importance and safety of oral healthcare during pregnancy in practice and community",
        "Only treating patients in the dental office setting",
        "Discouraging pregnant women from seeking any healthcare"
      ],
      correct: "B"
    }
  ],
  "3. Geriatric Dental Care": [
    {
      id: 25300,
      question: "Between 2010 and 2019, by how much did the number of US individuals 65 years and older increase?",
      options: [
        "By 8.2 million (15.5%) for a total of 45 million",
        "By 14.4 million (34.2%) for a total of 54.1 million",
        "By 20.1 million (50.2%) for a total of 62 million",
        "By 5.5 million (12.8%) for a total of 38 million"
      ],
      correct: "B"
    },
    {
      id: 25301,
      question: "What percentage of the US population did the elderly represent in 2019?",
      options: [
        "12% of the total population",
        "21% of the total population",
        "16% of the total population",
        "25% of the total population"
      ],
      correct: "C"
    },
    {
      id: 25302,
      question: "What percentage of the US population will older adults comprise in 2040 according to projections?",
      options: [
        "18.5% of the population with 65 million older adults",
        "25.2% of the population with 90 million older adults",
        "21.6% of the population with 80.8 million older adults",
        "15.8% of the population with 58 million older adults"
      ],
      correct: "C"
    },
    {
      id: 25303,
      question: "What is the difference between life expectancy and life span?",
      options: [
        "Life expectancy is maximum possible age; life span is average years lived",
        "Life expectancy and life span are identical terms used interchangeably",
        "Life expectancy is average years lived; life span is maximal length of life possible in a species",
        "Life expectancy applies to individuals; life span applies to populations"
      ],
      correct: "C"
    },
    {
      id: 25304,
      question: "What was the life expectancy for individuals born in 1900?",
      options: [
        "47.3 years at birth",
        "62.5 years at birth",
        "55.8 years at birth",
        "38.2 years at birth"
      ],
      correct: "A"
    },
    {
      id: 25305,
      question: "What is the provisional life expectancy for females born in 2021?",
      options: [
        "82.5 years for females",
        "75.8 years for females",
        "79.1 years for females",
        "85.2 years for females"
      ],
      correct: "C"
    },
    {
      id: 25306,
      question: "What is the provisional life expectancy for males born in 2021?",
      options: [
        "68.5 years for males",
        "76.8 years for males",
        "73.2 years for males",
        "70.1 years for males"
      ],
      correct: "C"
    },
    {
      id: 25307,
      question: "How many additional years can individuals who survived to age 65 in 2021 expect to live on average?",
      options: [
        "12.5 more years on average",
        "25.8 more years on average",
        "18.3 more years on average",
        "15.2 more years on average"
      ],
      correct: "C"
    },
    {
      id: 25308,
      question: "What percentage will minority populations represent among the elderly over 65 in 2060?",
      options: [
        "28% of the elderly population",
        "55% of the elderly population",
        "42% of the elderly population",
        "35% of the elderly population"
      ],
      correct: "C"
    },
    {
      id: 25309,
      question: "What is the current sex ratio among adults age 65 and older in 2020?",
      options: [
        "95 males for every 100 females",
        "75 males for every 100 females",
        "81 males for every 100 females",
        "88 males for every 100 females"
      ],
      correct: "C"
    },
    {
      id: 25310,
      question: "What is the projected sex ratio for adults 65 and older in 2060?",
      options: [
        "90 males to 100 females",
        "78 males to 100 females",
        "86 males to 100 females",
        "95 males to 100 females"
      ],
      correct: "C"
    },
    {
      id: 25311,
      question: "What percentage of females accounted for the population over age 65 in 2018?",
      options: [
        "48% of the population over 65",
        "62% of the population over 65",
        "56% of the population over 65",
        "71% of the population over 65"
      ],
      correct: "C"
    },
    {
      id: 25312,
      question: "What is geriatrics?",
      options: [
        "The scientific study of factors affecting normal aging and quality of life",
        "The branch of medicine concerned with illnesses of old age and their treatment",
        "The psychological assessment of elderly patients in clinical settings",
        "The social work discipline focused on elderly community programs"
      ],
      correct: "B"
    },
    {
      id: 25313,
      question: "What is gerontology?",
      options: [
        "The medical specialty treating diseases in people over 80 years old",
        "The dental specialty focused on oral care for elderly populations",
        "The scientific study of factors affecting normal aging and effects of aging on quality of life",
        "The nursing specialty caring for patients in long-term care facilities"
      ],
      correct: "C"
    },
    {
      id: 25314,
      question: "How are the elderly categorized by age into young-old?",
      options: [
        "Between 55 and 64 years of age",
        "Between 70 and 79 years of age",
        "Between 65 and 74 years of age",
        "Between 60 and 69 years of age"
      ],
      correct: "C"
    },
    {
      id: 25315,
      question: "How are the elderly categorized by age into middle-old?",
      options: [
        "Between 70 and 79 years of age",
        "Between 80 and 89 years of age",
        "Between 75 and 84 years of age",
        "Between 65 and 74 years of age"
      ],
      correct: "C"
    },
    {
      id: 25316,
      question: "How are the elderly categorized by age into old-old?",
      options: [
        "85 years and older (85-plus years)",
        "80 years and older (80-plus years)",
        "90 years and older (90-plus years)",
        "95 years and older (95-plus years)"
      ],
      correct: "A"
    },
    {
      id: 25317,
      question: "What is chronologic age?",
      options: [
        "Capability to maintain activity and functional independence",
        "Age as measured by calendar time since birth",
        "Mental age based on cognitive assessment scores",
        "Biological age determined by physical examination findings"
      ],
      correct: "B"
    },
    {
      id: 25318,
      question: "What is functional age?",
      options: [
        "Age based on years of formal education completed",
        "Age determined by number of chronic medical conditions",
        "Age as measured by calendar time since birth",
        "Capability to maintain activity and functional performance"
      ],
      correct: "D"
    },
    {
      id: 25319,
      question: "What are ADLs (activities of daily living)?",
      options: [
        "Complex skills like using telephone, preparing meals, managing money",
        "Abilities fundamental to independent living like bathing, dressing, toileting, feeding",
        "Advanced physical activities like running, climbing, lifting weights",
        "Intellectual activities like reading, writing, problem-solving tasks"
      ],
      correct: "B"
    },
    {
      id: 25320,
      question: "What are IADLs (instrumental activities of daily living)?",
      options: [
        "Basic self-care like bathing and dressing independently",
        "Physical exercises for strength and endurance training",
        "Tasks requiring complex skills like using telephone, preparing meals, managing money",
        "Medical treatments requiring skilled nursing care daily"
      ],
      correct: "C"
    },
    {
      id: 25321,
      question: "According to the 2014 National Health Interview survey, what percentage of adults over 75 required assistance with ADLs?",
      options: [
        "5.2% required assistance with ADLs",
        "15.8% required assistance with ADLs",
        "10.6% required assistance with ADLs",
        "20.3% required assistance with ADLs"
      ],
      correct: "C"
    },
    {
      id: 25322,
      question: "According to the 2014 National Health Interview survey, what percentage of adults over 75 required assistance with IADLs?",
      options: [
        "12.5% required assistance with IADLs",
        "25.2% required assistance with IADLs",
        "18.8% required assistance with IADLs",
        "8.5% required assistance with IADLs"
      ],
      correct: "C"
    },
    {
      id: 25323,
      question: "What is the WHO definition of healthy aging?",
      options: [
        "Absence of all chronic diseases and medications in elderly",
        "The process of developing and maintaining functional ability enabling wellbeing in older age",
        "Living independently without any assistance from family or caregivers",
        "Maintaining perfect physical and mental health throughout aging process"
      ],
      correct: "B"
    },
    {
      id: 25324,
      question: "What were the most common chronic conditions reported by US adults over 65 in 2018?",
      options: [
        "Osteoporosis, dementia, kidney disease, liver disease, asthma",
        "Hypertension, arthritis, heart diseases, cancer, diabetes",
        "Depression, anxiety, COPD, stroke, Parkinson\'s disease",
        "Alzheimer\'s, cataracts, hearing loss, osteoarthritis, macular degeneration"
      ],
      correct: "B"
    },
    {
      id: 25325,
      question: "What percentage of adults 65 and older visited the dentist in 2000?",
      options: [
        "28.5% visited the dentist in 2000",
        "52.8% visited the dentist in 2000",
        "38.3% visited the dentist in 2000",
        "45.2% visited the dentist in 2000"
      ],
      correct: "C"
    },
    {
      id: 25326,
      question: "What percentage of adults 65 and older visited the dentist in 2016?",
      options: [
        "50.5% visited the dentist in 2016",
        "38.2% visited the dentist in 2016",
        "43.3% visited the dentist in 2016",
        "55.8% visited the dentist in 2016"
      ],
      correct: "C"
    },
    {
      id: 25327,
      question: "In 2016, what percentage of elders with insurance had a dental visit?",
      options: [
        "55.2% of insured elders had visits",
        "78.5% of insured elders had visits",
        "68.7% of insured elders had visits",
        "45.8% of insured elders had visits"
      ],
      correct: "C"
    },
    {
      id: 25328,
      question: "In 2016, what percentage of uninsured older adults visited the dentist?",
      options: [
        "52.5% of uninsured visited the dentist",
        "25.8% of uninsured visited the dentist",
        "37.5% of uninsured visited the dentist",
        "15.2% of uninsured visited the dentist"
      ],
      correct: "C"
    },
    {
      id: 25329,
      question: "What is senescence?",
      options: [
        "The pathologic disease process causing dementia in elderly",
        "The term describing normal physiologic process of growing old",
        "The medical specialty treating elderly patients exclusively",
        "The psychological adjustment to retirement and aging"
      ],
      correct: "B"
    },
    {
      id: 25330,
      question: "What explains the brownish-black discoloration of arrested dental caries in older adults?",
      options: [
        "Secondary dentin formation causing internal tooth darkening",
        "Bacterial pigmentation from chronic periodontal infection",
        "Lifelong uptake of stain in enamel lamellae",
        "Medication side effects from long-term antibiotic use"
      ],
      correct: "C"
    },
    {
      id: 25331,
      question: "What compositional changes occur in cementum with aging?",
      options: [
        "Decrease in calcium and phosphate content significantly",
        "Increase in fluoride and magnesium content",
        "Complete loss of organic matrix components",
        "Reduction in all mineral components uniformly"
      ],
      correct: "B"
    },
    {
      id: 25332,
      question: "What is the purpose of secondary cementum deposition?",
      options: [
        "To strengthen roots against periodontal disease progression",
        "To compensate for coronal enamel tooth wear",
        "To seal exposed dentinal tubules from sensitivity",
        "To prevent root surface caries development"
      ],
      correct: "B"
    },
    {
      id: 25333,
      question: "What two independent changes occur in dentin with aging?",
      options: [
        "Pulp chamber enlargement and increased blood supply",
        "Increased permeability and enhanced sensory response",
        "Secondary dentin formation and obturation of dentinal tubules (dentin sclerosis)",
        "Complete mineralization and total nerve degeneration"
      ],
      correct: "C"
    },
    {
      id: 25334,
      question: "What causes tooth erosion commonly seen in the elderly?",
      options: [
        "Excessive use of whitening toothpaste over lifetime",
        "Tooth exposure to dietary acids and acid reflux",
        "Normal age-related enamel thinning processes",
        "Bacterial acid production from poor oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 25335,
      question: "What is the result of severe occlusal attrition in older adults?",
      options: [
        "Complete loss of all tooth structure requiring extraction",
        "Increased susceptibility to dental caries in fissures",
        "Dentin exposures appearing on incisal and occlusal surfaces",
        "Enhanced enamel strength and resistance to decay"
      ],
      correct: "C"
    },
    {
      id: 25336,
      question: "Why is cervical and root surface abrasion common in today\'s older adults?",
      options: [
        "Modern soft-bristle toothbrushes causing increased wear patterns",
        "Past use of stiff toothbrushes and abrasive toothpaste",
        "Genetic predisposition to thin enamel in cervical areas",
        "Age-related weakening of tooth structure at gumline"
      ],
      correct: "B"
    },
    {
      id: 25337,
      question: "What was the rate of edentulousness in those 65 years and older in 1960?",
      options: [
        "Approximately 35% were edentulous in 1960",
        "Approximately 65% were edentulous in 1960",
        "Approximately 50% were edentulous in 1960",
        "Approximately 25% were edentulous in 1960"
      ],
      correct: "C"
    },
    {
      id: 25338,
      question: "What was the rate of edentulousness in those 65 years and older in 2002?",
      options: [
        "18% were edentulous in 2002",
        "35% were edentulous in 2002",
        "24% were edentulous in 2002",
        "42% were edentulous in 2002"
      ],
      correct: "C"
    },
    {
      id: 25339,
      question: "What is the rate of edentulousness in those 65 years and older in 2021?",
      options: [
        "8% are edentulous in 2021",
        "20% are edentulous in 2021",
        "13% are edentulous in 2021",
        "25% are edentulous in 2021"
      ],
      correct: "C"
    },
    {
      id: 25340,
      question: "What percentage of older adults living below the poverty line are edentulous?",
      options: [
        "24% living below poverty are edentulous",
        "45% living below poverty are edentulous",
        "34% living below poverty are edentulous",
        "18% living below poverty are edentulous"
      ],
      correct: "C"
    },
    {
      id: 25341,
      question: "What percentage of older adults living above the poverty line are edentulous?",
      options: [
        "5% above poverty are edentulous",
        "18% above poverty are edentulous",
        "11% above poverty are edentulous",
        "22% above poverty are edentulous"
      ],
      correct: "C"
    },
    {
      id: 25342,
      question: "How many times more likely are non-Hispanic Black older adults to be edentulous compared to non-Hispanic White adults?",
      options: [
        "Four times more likely (31% vs 15%)",
        "Three times more likely (45% vs 15%)",
        "Twice as likely (31% vs 15%)",
        "Five times more likely (75% vs 15%)"
      ],
      correct: "C"
    },
    {
      id: 25343,
      question: "What is the average number of teeth that older adults have?",
      options: [
        "15.5 teeth on average",
        "25.8 teeth on average",
        "20.7 teeth on average",
        "12.2 teeth on average"
      ],
      correct: "C"
    },
    {
      id: 25344,
      question: "How many teeth do older adults living in poverty have on average?",
      options: [
        "12.5 teeth on average",
        "22.8 teeth on average",
        "17.6 teeth on average",
        "8.2 teeth on average"
      ],
      correct: "C"
    },
    {
      id: 25345,
      question: "How many teeth do older adults with incomes above poverty guidelines have on average?",
      options: [
        "25.8 teeth on average",
        "18.5 teeth on average",
        "22.2 teeth on average",
        "28.5 teeth on average"
      ],
      correct: "C"
    },
    {
      id: 25346,
      question: "What percentage of all older adults have experienced dental caries throughout their lifetime?",
      options: [
        "82% have experienced caries",
        "75% have experienced caries",
        "96% have experienced caries",
        "68% have experienced caries"
      ],
      correct: "C"
    },
    {
      id: 25347,
      question: "What fraction of older adults currently have untreated tooth decay?",
      options: [
        "1 in 10 older adults",
        "1 in 4 older adults",
        "1 in 6 older adults",
        "1 in 3 older adults"
      ],
      correct: "C"
    },
    {
      id: 25348,
      question: "What percentage of non-Hispanic Black older adults have untreated decay?",
      options: [
        "18% have untreated decay",
        "42% have untreated decay",
        "29% have untreated decay",
        "12% have untreated decay"
      ],
      correct: "C"
    },
    {
      id: 25349,
      question: "What percentage of Mexican American older adults have untreated decay?",
      options: [
        "25% have untreated decay",
        "48% have untreated decay",
        "36% have untreated decay",
        "15% have untreated decay"
      ],
      correct: "C"
    },
    {
      id: 25350,
      question: "What percentage of non-Hispanic White elders have untreated decay?",
      options: [
        "8% have untreated decay",
        "22% have untreated decay",
        "14% have untreated decay",
        "28% have untreated decay"
      ],
      correct: "C"
    },
    {
      id: 25351,
      question: "How much more likely are elders in poverty to have untreated tooth decay compared to those above poverty?",
      options: [
        "Twice as likely (33% vs 10%)",
        "Five times as likely (50% vs 10%)",
        "At least three times more likely (33% vs 10%)",
        "Four times as likely (40% vs 10%)"
      ],
      correct: "C"
    },
    {
      id: 25352,
      question: "What fraction of elders have root caries?",
      options: [
        "One in ten elders",
        "One in four elders",
        "One in six elders",
        "One in three elders"
      ],
      correct: "C"
    },
    {
      id: 25353,
      question: "What are the local oral factors contributing to root caries?",
      options: [
        "High fluoride exposure and strong enamel structure",
        "Exposed root surfaces and tooth longevity",
        "Excessive saliva production and pH imbalance",
        "Overuse of antimicrobial agents and antibiotics"
      ],
      correct: "B"
    },
    {
      id: 25354,
      question: "What are the aging-related factors contributing to root caries?",
      options: [
        "Increased immune function and enhanced healing capacity",
        "Strengthened tooth structure and improved enamel quality",
        "Changes in salivary quantity/composition, inability to complete oral hygiene, diminished chewing, chronic conditions",
        "Enhanced motor skills and improved manual dexterity"
      ],
      correct: "C"
    },
    {
      id: 25355,
      question: "What are predictors of caries in older adults?",
      options: [
        "Excellent oral hygiene and regular fluoride use",
        "Strong enamel and absence of previous restorations",
        "Elevated caries-related bacteria, plaque biofilm, restored decay, xerostomia, gingival recession",
        "High salivary flow and optimal pH balance"
      ],
      correct: "C"
    },
    {
      id: 25356,
      question: "What four interrelated factors are essential for caries prevention in older adults?",
      options: [
        "Regular dental visits, expensive treatments, denture use, antibiotic therapy",
        "Daily biofilm removal, sugar reduction, topical fluoride/antimicrobials, silver diamine fluoride",
        "Mouth rinses only, dietary supplements, laser therapy, extraction",
        "Annual cleanings, medication changes, surgical intervention, implants"
      ],
      correct: "B"
    },
    {
      id: 25357,
      question: "What percentage of silver diamine fluoride is used for noninvasive caries treatment?",
      options: [
        "5% silver diamine fluoride",
        "20% silver diamine fluoride",
        "38% silver diamine fluoride",
        "50% silver diamine fluoride"
      ],
      correct: "C"
    },
    {
      id: 25358,
      question: "What is a common cause of xerostomia in older adults?",
      options: [
        "Excessive vitamin C consumption daily",
        "Side effect of many prescription and over-the-counter medications",
        "Normal age-related changes in all individuals",
        "Increased water intake throughout the day"
      ],
      correct: "B"
    },
    {
      id: 25359,
      question: "Which medications commonly cause xerostomia?",
      options: [
        "Vitamins, supplements, probiotics, herbal teas",
        "Antihypertensives, antipsychotics, antidepressants, muscle relaxants, antihistamines, laxatives",
        "Aspirin, ibuprofen, acetaminophen, naproxen",
        "Antibiotics, antivirals, antifungals, antiparasitics"
      ],
      correct: "B"
    },
    {
      id: 25360,
      question: "What systemic disease most notably diminishes saliva?",
      options: [
        "Diabetes mellitus type 2",
        "Hypertension and heart disease",
        "Sjögren syndrome",
        "Rheumatoid arthritis"
      ],
      correct: "C"
    },
    {
      id: 25361,
      question: "What important role does saliva play in oral health?",
      options: [
        "It only provides lubrication for swallowing food",
        "It provides minerals for enamel remineralization to reduce and repair decay",
        "It prevents all forms of oral cancer development",
        "It eliminates the need for toothbrushing entirely"
      ],
      correct: "B"
    },
    {
      id: 25362,
      question: "What are the consequences of diminished salivary flow?",
      options: [
        "Improved taste perception and enhanced digestion",
        "Stronger teeth and reduced need for dental care",
        "Altered taste, plaque formation, dental caries, dry inflamed mucosa",
        "Better denture retention and improved speech patterns"
      ],
      correct: "C"
    },
    {
      id: 25363,
      question: "What palliative care is recommended for xerostomia management?",
      options: [
        "Limiting all fluid intake to concentrate saliva",
        "Using only prescription medications for treatment",
        "Saliva substitutes, oral lubricants, xylitol products, mouth rinses, frequent water intake",
        "Eliminating all sugar-free products from diet"
      ],
      correct: "C"
    },
    {
      id: 25364,
      question: "What medications can stimulate salivary flow for xerostomia?",
      options: [
        "Aspirin and ibuprofen taken daily",
        "Antibiotics and antifungals as needed",
        "Cevimeline (Evoxac) or systemic pilocarpine tablets (Salagen)",
        "Antihistamines and decongestants regularly"
      ],
      correct: "C"
    },
    {
      id: 25365,
      question: "What percentage of US adults over age 30 have periodontitis according to 2018 data?",
      options: [
        "28.5% have periodontitis",
        "55.2% have periodontitis",
        "42.2% have periodontitis",
        "18.8% have periodontitis"
      ],
      correct: "C"
    },
    {
      id: 25366,
      question: "What percentage of adults 65 years and older show signs of periodontitis?",
      options: [
        "45.2% show signs of periodontitis",
        "75.8% show signs of periodontitis",
        "59.8% show signs of periodontitis",
        "32.5% show signs of periodontitis"
      ],
      correct: "C"
    },
    {
      id: 25367,
      question: "What percentage of adults ages 30 to 44 years show signs of periodontitis?",
      options: [
        "18.5% show signs of periodontitis",
        "42.8% show signs of periodontitis",
        "29.5% show signs of periodontitis",
        "12.2% show signs of periodontitis"
      ],
      correct: "C"
    },
    {
      id: 25368,
      question: "What is immunosenescence?",
      options: [
        "Enhanced immune function with advanced age",
        "Greater susceptibility to periodontal infection from repeated immune challenges throughout life",
        "Complete loss of all immune system components",
        "Improved resistance to all infections in elderly"
      ],
      correct: "B"
    },
    {
      id: 25369,
      question: "What age-related changes occur in gingival epithelium?",
      options: [
        "Thickening, increased keratinization, decreased cell density",
        "No changes occur with aging process",
        "Thinning of epithelium, diminished keratinization, increased cellular density",
        "Complete regeneration and enhanced healing capacity"
      ],
      correct: "C"
    },
    {
      id: 25370,
      question: "What changes occur in gingival connective tissue with aging?",
      options: [
        "Increased cellular elements and decreased fibrous substance",
        "Enhanced vascularity and improved nerve function",
        "Reduced cellular elements and increased fibrous intercellular substance",
        "Complete tissue replacement every decade"
      ],
      correct: "C"
    },
    {
      id: 25371,
      question: "What changes occur in nerves and vessels of the gingiva with aging?",
      options: [
        "Increased nerves and enhanced blood flow throughout",
        "Complete regeneration of all nervous tissue regularly",
        "Reduced number of nerves with degeneration and arteriosclerotic changes in vessels",
        "No significant changes in any components"
      ],
      correct: "C"
    },
    {
      id: 25372,
      question: "What bone changes occur with aging in healthy persons?",
      options: [
        "Severe crestal bone loss requiring treatment",
        "Complete loss of all alveolar bone support",
        "Increased porosity, decreased cortical width, but minimal crestal bone loss",
        "Enhanced bone density and strength throughout"
      ],
      correct: "C"
    },
    {
      id: 25373,
      question: "What percentage of older adults are most commonly affected by osteoporosis?",
      options: [
        "Elderly males more than females",
        "All genders equally affected",
        "Elderly females most commonly affected",
        "Only postmenopausal women under 60"
      ],
      correct: "C"
    },
    {
      id: 25374,
      question: "How does osteoporosis affect the alveolar bone?",
      options: [
        "It strengthens bone and improves healing capacity",
        "It decreases bone mass and increases bone porosity",
        "It has no effect on oral structures",
        "It only affects long bones, not facial bones"
      ],
      correct: "B"
    },
    {
      id: 25375,
      question: "What should dental hygienists monitor in patients taking bisphosphonate drugs?",
      options: [
        "Blood pressure and heart rate only",
        "Body weight and temperature exclusively",
        "Risk and prognosis for periodontal disease and ability to wear prosthetics",
        "Vision and hearing changes primarily"
      ],
      correct: "C"
    },
    {
      id: 25376,
      question: "What oral mucosal changes occur with aging in the absence of disease?",
      options: [
        "Severe atrophy requiring immediate treatment intervention",
        "Complete tissue breakdown and loss of function",
        "Oral mucosal status comparable to younger adults",
        "Dramatic changes requiring extensive medical management"
      ],
      correct: "C"
    },
    {
      id: 25377,
      question: "What causes oral mucosa to appear dry and drawn in some older adults?",
      options: [
        "Excessive vitamin intake and supplementation",
        "Normal aging process affecting all individuals",
        "Dehydration and loss of elasticity within tissues",
        "Improved skin tone and enhanced collagen production"
      ],
      correct: "C"
    },
    {
      id: 25378,
      question: "What is angular cheilitis?",
      options: [
        "Inflammation of the tongue with red patches",
        "Swelling of the lips from allergic reaction",
        "Fissuring at angles of mouth with cracks, erythema, ulcerations",
        "Benign tumor growth on the lip border"
      ],
      correct: "C"
    },
    {
      id: 25379,
      question: "What are the causative factors of angular cheilitis?",
      options: [
        "Excessive sun exposure and vitamin toxicity",
        "Viral infections and bacterial contamination only",
        "Moistness from drooling, vitamin B2 deficiency, Candida albicans infection",
        "Autoimmune disorders and genetic predisposition"
      ],
      correct: "C"
    },
    {
      id: 25380,
      question: "What percentage of older individuals who wear dentures have chronic atrophic candidiasis?",
      options: [
        "As many as 35% of denture wearers",
        "As many as 85% of denture wearers",
        "As many as 65% of denture wearers",
        "As many as 15% of denture wearers"
      ],
      correct: "C"
    },
    {
      id: 25381,
      question: "What factors contribute to chronic atrophic candidiasis?",
      options: [
        "Excellent denture hygiene and proper fit",
        "Wearing dentures only during meals",
        "Poor prosthesis fit with chronic trauma and retention during sleeping promoting bacterial/fungal growth",
        "Using antimicrobial solutions too frequently"
      ],
      correct: "C"
    },
    {
      id: 25382,
      question: "What is denture-induced fibrous hyperplasia?",
      options: [
        "Normal gingival tissue response to dentures",
        "Cancerous growth requiring immediate excision",
        "Single or multiple elongated folds near border of ill-fitting dentures",
        "Beneficial tissue adaptation improving retention"
      ],
      correct: "C"
    },
    {
      id: 25383,
      question: "How many times more likely are males to have oropharyngeal squamous cell cancer (OPC) than females?",
      options: [
        "2.0 times more OPC than females",
        "5.5 times more OPC than females",
        "3.5 times more OPC than females",
        "1.5 times more OPC than females"
      ],
      correct: "C"
    },
    {
      id: 25384,
      question: "What has caused the changing profile of oral cancer in the past 10 years?",
      options: [
        "Decreased tobacco use in all populations",
        "Improved oral hygiene practices universally",
        "Prevalence of HPV-caused oropharyngeal squamous cell cancer",
        "Reduced alcohol consumption nationwide"
      ],
      correct: "C"
    },
    {
      id: 25385,
      question: "What tongue changes occur with aging?",
      options: [
        "Increase in number and sensitivity of papillae",
        "Enhanced taste perception for all flavors",
        "Decrease in number and sensitivity of papillae",
        "Complete regeneration of all taste buds"
      ],
      correct: "C"
    },
    {
      id: 25386,
      question: "What are sublingual varicosities?",
      options: [
        "Cancerous lesions requiring immediate treatment",
        "Painful ulcerations indicating systemic disease",
        "Deep red or bluish-black dilated vessels on ventral tongue surface",
        "White patches indicating precancerous changes"
      ],
      correct: "C"
    },
    {
      id: 25387,
      question: "What is atrophic glossitis a symptom of?",
      options: [
        "Vitamin D deficiency and calcium depletion",
        "Excessive protein intake and overhydration",
        "Anemia due to iron deficiencies",
        "Hyperthyroidism and metabolic disorders"
      ],
      correct: "C"
    },
    {
      id: 25388,
      question: "How does the tongue appear in atrophic glossitis?",
      options: [
        "Enlarged with deep fissures and yellow coating",
        "Normal pink color with healthy papillae",
        "Smooth, shiny, and denuded appearance",
        "Bright red with raised bumpy surface"
      ],
      correct: "C"
    },
    {
      id: 25389,
      question: "What is the actual cause of reduced salivary flow in older adults?",
      options: [
        "Normal aging process affecting all elderly equally",
        "Genetic predisposition from family history",
        "Systemic disease, radiation therapy, tumors, or medications",
        "Decreased water intake and dehydration only"
      ],
      correct: "C"
    },
    {
      id: 25390,
      question: "What percentage of people with Sjögren syndrome are older than 50 years?",
      options: [
        "Approximately 35% are over 50",
        "Approximately 85% are over 50",
        "Approximately 60% are over 50",
        "Approximately 25% are over 50"
      ],
      correct: "C"
    },
    {
      id: 25391,
      question: "How does the oral mucosa appear in Sjögren syndrome?",
      options: [
        "Excessively wet with pooling saliva",
        "Normal pink and moist appearance",
        "Extremely dry with ropy saliva",
        "Bright red and inflamed throughout"
      ],
      correct: "C"
    },
    {
      id: 25392,
      question: "How does the tongue appear initially in Sjögren syndrome?",
      options: [
        "Completely normal with no changes visible",
        "Swollen with white coating throughout",
        "Marked atrophy of papillae, later becoming smooth and lobulated",
        "Enlarged with deep red coloration"
      ],
      correct: "C"
    },
    {
      id: 25393,
      question: "What percentage of all prescription and over-the-counter drugs are used by older adults?",
      options: [
        "Approximately one-fifth of all drugs",
        "Approximately one-half of all drugs",
        "Approximately one-third of all drugs",
        "Approximately one-quarter of all drugs"
      ],
      correct: "C"
    },
    {
      id: 25394,
      question: "What is polypharmacy?",
      options: [
        "Using only one medication for all conditions",
        "Avoiding all prescription medications entirely",
        "Prescribing multiple drugs to manage many medical conditions",
        "Taking over-the-counter drugs exclusively"
      ],
      correct: "C"
    },
    {
      id: 25395,
      question: "How many therapeutic agents does the average older adult take?",
      options: [
        "More than one therapeutic agent",
        "More than seven therapeutic agents",
        "More than three therapeutic agents",
        "More than ten therapeutic agents"
      ],
      correct: "C"
    },
    {
      id: 25396,
      question: "How many drugs do institutionalized elderly use at the same time on average?",
      options: [
        "Two to three drugs simultaneously",
        "Ten to twelve drugs simultaneously",
        "Five to seven drugs simultaneously",
        "One to two drugs simultaneously"
      ],
      correct: "C"
    },
    {
      id: 25397,
      question: "What drugs are most frequently used by older adults?",
      options: [
        "Antibiotics, antivirals, antifungals, antiparasitics, antimalarials",
        "Analgesics, diuretics, oral hypoglycemics, antihypertensives, antidepressants, sedatives",
        "Vitamins, minerals, probiotics, herbal supplements, homeopathic remedies",
        "Stimulants, muscle builders, appetite suppressants, weight loss, energy boosters"
      ],
      correct: "B"
    },
    {
      id: 25398,
      question: "What anticonvulsant may cause gingival hyperplasia as a side effect?",
      options: [
        "Gabapentin for seizure control",
        "Valproic acid for epilepsy",
        "Phenytoin as anticonvulsant therapy",
        "Carbamazepine for nerve pain"
      ],
      correct: "C"
    },
    {
      id: 25399,
      question: "What cardiovascular drug may exhibit gingival enlargement?",
      options: [
        "Metoprolol beta blocker",
        "Lisinopril ACE inhibitor",
        "Nifedipine calcium channel blocker",
        "Warfarin anticoagulant therapy"
      ],
      correct: "C"
    },
    {
      id: 25400,
      question: "What immunosuppressant may cause gingival enlargement?",
      options: [
        "Methotrexate for autoimmune conditions",
        "Prednisone corticosteroid therapy",
        "Cyclosporine immunosuppressant medication",
        "Azathioprine immune system suppressor"
      ],
      correct: "C"
    },
    {
      id: 25401,
      question: "What should dental hygienists observe first when assessing older adults?",
      options: [
        "Dental charting and radiographic findings",
        "Medical history documentation exclusively",
        "Gait and balance in reception area",
        "Vital signs in treatment room"
      ],
      correct: "C"
    },
    {
      id: 25402,
      question: "Why is it important to observe gait and balance in older adults?",
      options: [
        "To determine insurance coverage status",
        "To assess cognitive function exclusively",
        "Because some may require assistance to treatment area, especially if unsteady or visually impaired",
        "To evaluate cardiovascular fitness level"
      ],
      correct: "C"
    },
    {
      id: 25403,
      question: "What accommodation should the dental operatory provide for safety?",
      options: [
        "Bright fluorescent lighting throughout",
        "Loud background music playing",
        "Sufficient space for wheelchair access and room for patient\'s wheelchair",
        "Multiple treatment chairs simultaneously"
      ],
      correct: "C"
    },
    {
      id: 25404,
      question: "What is preferable for most procedures with wheelchair-bound patients?",
      options: [
        "Transferring patient to dental chair always",
        "Reclining wheelchair completely flat",
        "Keeping patient in wheelchair with portable or swivel head rest",
        "Standing patient up for treatment"
      ],
      correct: "C"
    },
    {
      id: 25405,
      question: "What accommodation helps visually impaired patients complete written forms?",
      options: [
        "Verbal completion of forms by staff",
        "Online electronic forms only",
        "Large-print health history forms",
        "Audio recording of responses"
      ],
      correct: "C"
    },
    {
      id: 25406,
      question: "How should hearing-impaired older patients be addressed?",
      options: [
        "Through written notes exclusively",
        "By speaking to family members only",
        "Directly with face mask removed and background noise eliminated",
        "Using sign language interpreters always"
      ],
      correct: "C"
    },
    {
      id: 25407,
      question: "Why should older adults accompanied by others be addressed directly?",
      options: [
        "To comply with privacy laws only",
        "To save time during appointments",
        "To create respectful, independent environment",
        "To avoid legal complications"
      ],
      correct: "C"
    },
    {
      id: 25408,
      question: "What percentage of individuals 55 years or older experience mental health issues according to CDC?",
      options: [
        "10% experience mental health concerns",
        "35% experience mental health concerns",
        "20% experience anxiety, depression, and/or cognitive impairment",
        "50% experience mental health concerns"
      ],
      correct: "C"
    },
    {
      id: 25409,
      question: "What mental health conditions should dental hygienists assess in older adults?",
      options: [
        "Only severe psychosis requiring hospitalization",
        "Personality disorders exclusively",
        "Anxiety, depression, and/or cognitive impairment",
        "Eating disorders primarily"
      ],
      correct: "C"
    },
    {
      id: 25410,
      question: "What association has recent research identified regarding periodontal pathogens?",
      options: [
        "Link between periodontal bacteria and liver disease",
        "Connection between oral bacteria and kidney failure",
        "Association between specific periodontal pathogens and Alzheimer disease",
        "Relationship between gingivitis and diabetes exclusively"
      ],
      correct: "C"
    },
    {
      id: 25411,
      question: "What should be included in vital signs assessment for older adults?",
      options: [
        "Height and weight only",
        "Blood glucose levels exclusively",
        "Respiration, pulse, blood pressure, temperature if indicated",
        "Oxygen saturation alone"
      ],
      correct: "C"
    },
    {
      id: 25412,
      question: "What can the extraoral examination reveal in older adults?",
      options: [
        "Only dental caries and periodontal disease",
        "Internal organ dysfunction exclusively",
        "Abnormalities in skin, lymph nodes, salivary glands, underlying muscles",
        "Blood pressure and heart rate only"
      ],
      correct: "C"
    },
    {
      id: 25413,
      question: "Why is the temporomandibular joint palpated during examination?",
      options: [
        "To assess bone density exclusively",
        "To measure blood pressure accurately",
        "To check for crepitation, tenderness, or limitations in movement",
        "To determine cognitive function level"
      ],
      correct: "C"
    },
    {
      id: 25414,
      question: "What condition might prevent a patient with arthritis from fully opening their mouth?",
      options: [
        "Dental anxiety and fear only",
        "Medication side effects exclusively",
        "Arthritis affecting temporomandibular joint function",
        "Excessive muscle strength"
      ],
      correct: "C"
    },
    {
      id: 25415,
      question: "What is assessed regarding saliva during examination?",
      options: [
        "Color and odor only",
        "pH level exclusively",
        "Quantity and quality",
        "Temperature alone"
      ],
      correct: "C"
    },
    {
      id: 25416,
      question: "What diagnostic aids are used as indicated for older adults?",
      options: [
        "Only visual examination without tools",
        "Verbal questioning exclusively",
        "Radiographs and study models as appropriate",
        "Blood tests and urinalysis only"
      ],
      correct: "C"
    },
    {
      id: 25417,
      question: "What oral self-assessment should older adults perform monthly?",
      options: [
        "Professional cleaning at dental office",
        "Measurement of all pocket depths",
        "Look for lesions that are painless and don\'t heal within 2 weeks",
        "Complete dietary analysis documentation"
      ],
      correct: "C"
    },
    {
      id: 25418,
      question: "Why should nutritional status be evaluated in older adults?",
      options: [
        "To increase office revenue through sales",
        "To comply with insurance requirements",
        "Because of physiologic and psychosocial complexities affecting dietary patterns",
        "To fill time during appointments"
      ],
      correct: "C"
    },
    {
      id: 25419,
      question: "What dietary assessment tool should be requested from patients?",
      options: [
        "Week-long detailed food diary",
        "Monthly nutrition log",
        "1-day diet diary as part of health history",
        "Annual dietary analysis"
      ],
      correct: "C"
    },
    {
      id: 25420,
      question: "What might dietary patterns reveal about older adults living alone?",
      options: [
        "Excessive food preparation and cooking",
        "Perfect nutritional balance always",
        "Avoidance of nutritious foods due to decreased oral function or inability/unwillingness to cook",
        "Increased restaurant dining frequently"
      ],
      correct: "C"
    },
    {
      id: 25421,
      question: "When are short morning appointments recommended for older adults?",
      options: [
        "To accommodate staff schedules only",
        "To increase number of patients seen",
        "Because many have lower stress tolerance and tire more easily",
        "To reduce operating costs"
      ],
      correct: "C"
    },
    {
      id: 25422,
      question: "What should be provided to help remind patients of appointments?",
      options: [
        "Verbal reminder only at checkout",
        "Email notification exclusively",
        "Written note of date and time to help patient and assist caregivers",
        "Text message one hour before"
      ],
      correct: "C"
    },
    {
      id: 25423,
      question: "What makes dental hygiene care planning more complex for older adults?",
      options: [
        "They require less care than younger patients",
        "They have perfect oral health generally",
        "Vast majority have at least one chronic condition and complex dental/periodontal conditions",
        "They need only annual examinations"
      ],
      correct: "C"
    },
    {
      id: 25424,
      question: "What is the recommended maximum appointment time for older adults including transportation?",
      options: [
        "Four hours maximum total time",
        "Thirty minutes maximum total time",
        "Two hours maximum total time",
        "Six hours maximum total time"
      ],
      correct: "C"
    },
    {
      id: 25425,
      question: "What legal consideration exists for elderly patients regarding consent?",
      options: [
        "All elderly can provide informed consent",
        "Family always makes all decisions",
        "Patient may not be capable of providing informed consent; get permission from physician/family/facility",
        "Verbal consent is always sufficient"
      ],
      correct: "C"
    },
    {
      id: 25426,
      question: "What should be forwarded to long-term care facilities after appointments?",
      options: [
        "Nothing; facilities don\'t need information",
        "Bill for services only",
        "Documentation of care provided and follow-up instructions",
        "Appointment schedule for next year"
      ],
      correct: "C"
    },
    {
      id: 25427,
      question: "Why should dental hygienists consult with physicians for older adults?",
      options: [
        "To increase treatment costs",
        "To delay necessary care",
        "Because many have multitude of chronic health conditions",
        "To avoid providing treatment"
      ],
      correct: "C"
    },
    {
      id: 25428,
      question: "How much trauma to gingiva should occur during instrumentation?",
      options: [
        "Moderate trauma to stimulate healing",
        "Maximum trauma for effectiveness",
        "As little trauma as possible due to reduced healing capabilities",
        "Significant trauma to remove all deposits"
      ],
      correct: "C"
    },
    {
      id: 25429,
      question: "Why might retraction of oral tissues be uncomfortable for older adults?",
      options: [
        "Increased tissue elasticity and moisture",
        "Enhanced sensory perception",
        "Loss of elasticity of lips/oral mucosa and xerostomia",
        "Excessive salivary flow"
      ],
      correct: "C"
    },
    {
      id: 25430,
      question: "Why might older adults need more frequent periodontal maintenance visits?",
      options: [
        "To generate more revenue for practice",
        "To fill appointment schedules",
        "History of periodontal disease requiring closer monitoring",
        "To socialize with office staff"
      ],
      correct: "C"
    },
    {
      id: 25431,
      question: "What antimicrobial products are recommended for older adults?",
      options: [
        "None; only mechanical removal needed",
        "Antibiotics exclusively",
        "Stannous fluoride dentifrice, essential oil mouth rinse, or 0.12% chlorhexidine rinse",
        "Hydrogen peroxide only"
      ],
      correct: "C"
    },
    {
      id: 25432,
      question: "What home fluoride product is recommended for all older individuals with teeth?",
      options: [
        "No fluoride products needed",
        "Fluoride supplements only",
        "Fluoride dentifrice plus daily 0.05% sodium fluoride rinse",
        "Professional applications exclusively"
      ],
      correct: "C"
    },
    {
      id: 25433,
      question: "What fluoride application method is best for patients with severe xerostomia?",
      options: [
        "Fluoride toothpaste only",
        "No fluoride needed",
        "Tray method with unflavored fluoride gel for 5 minutes twice daily",
        "Weekly fluoride varnish"
      ],
      correct: "C"
    },
    {
      id: 25434,
      question: "What products contain both fluoride and xylitol for xerostomia?",
      options: [
        "Prescription medications only",
        "No products contain both",
        "Several over-the-counter saliva substitutes",
        "Antibiotics exclusively"
      ],
      correct: "C"
    },
    {
      id: 25435,
      question: "Why should the dental chair be returned to upright position slowly?",
      options: [
        "To prevent equipment damage",
        "To extend appointment time",
        "To avoid problems with postural hypotension",
        "To follow office protocols only"
      ],
      correct: "C"
    },
    {
      id: 25436,
      question: "How long should patients sit upright before dismissal?",
      options: [
        "Immediately stand and leave",
        "Remain reclined throughout",
        "Sit up for a short time before dismissal",
        "Stay seated for one hour"
      ],
      correct: "C"
    },
    {
      id: 25437,
      question: "Why should older patients be reevaluated more frequently and carefully?",
      options: [
        "To increase office revenue only",
        "To fill appointment schedules",
        "Because of physiologic changes, chronic conditions, and pathologic changes in this age group",
        "To comply with insurance requirements"
      ],
      correct: "C"
    },
    {
      id: 25438,
      question: "Why is longer time needed to assess soft tissue debridement results?",
      options: [
        "To charge higher fees",
        "To schedule more appointments",
        "Because of slower and decreased potential for tissue healing",
        "To avoid seeing other patients"
      ],
      correct: "C"
    },
    {
      id: 25439,
      question: "What evaluation methods document healing and plan interventions?",
      options: [
        "Visual observation only",
        "Patient complaints exclusively",
        "Bleeding and plaque indices and pocket depth recording",
        "Radiographs alone"
      ],
      correct: "C"
    },
    {
      id: 25440,
      question: "Why are more frequent maintenance intervals recommended for older patients?",
      options: [
        "To generate more practice income",
        "To keep patients dependent",
        "To evaluate changes in functional abilities, nutrition, and occurrence of new disease",
        "To meet office production goals"
      ],
      correct: "C"
    },
    {
      id: 25441,
      question: "What percentage of the elderly population were institutionalized in 2020?",
      options: [
        "Approximately 12.5% of elderly",
        "Approximately 18.8% of elderly",
        "Approximately 4.5% of elderly",
        "Approximately 25.2% of elderly"
      ],
      correct: "C"
    },
    {
      id: 25442,
      question: "What percentage of homebound, semidependent elderly was there in 2020?",
      options: [
        "5% in 2020",
        "22% in 2020",
        "13% in 2020",
        "28% in 2020"
      ],
      correct: "C"
    },
    {
      id: 25443,
      question: "What does increased homebound elderly population signal?",
      options: [
        "Improved community support systems",
        "Better healthcare access overall",
        "Heightened risk of social isolation, unmet care needs including oral health, high mortality",
        "Enhanced quality of life for all"
      ],
      correct: "C"
    },
    {
      id: 25444,
      question: "Why has dental care been neglected in long-term care facilities historically?",
      options: [
        "Excellent oral health among residents",
        "Too much emphasis on dental care",
        "Dental professionals not active due to attitudes, low financial return, practice act limitations",
        "Excessive dental services already provided"
      ],
      correct: "C"
    },
    {
      id: 25445,
      question: "How many states permitted direct access to dental hygiene services in 2021?",
      options: [
        "25 states permitted direct access",
        "50 states permitted direct access",
        "42 states permitted direct access",
        "10 states permitted direct access"
      ],
      correct: "C"
    },
    {
      id: 25446,
      question: "What does direct access to dental hygiene services mean?",
      options: [
        "Patients pay directly without insurance",
        "Dental hygienists work only in hospitals",
        "Dental hygienists provide care without specific authorization or supervision of a dentist",
        "Dentists must be present for all procedures"
      ],
      correct: "C"
    },
    {
      id: 25447,
      question: "What activities do direct-access dental hygienists complete?",
      options: [
        "Surgical procedures and prescribing medications",
        "Diagnosing all medical conditions",
        "Clinical care, in-service education, denture marking, fluoride applications, care plans, quality assurance",
        "Orthodontic treatment exclusively"
      ],
      correct: "C"
    },
    {
      id: 25448,
      question: "What is the Brief Oral Health Status Examination (BOHSE)?",
      options: [
        "Quick visual screening only",
        "Complete periodontal charting",
        "Tool to systematically evaluate oral health at facility entrance and routinely during care",
        "Annual radiographic assessment"
      ],
      correct: "C"
    },
    {
      id: 25449,
      question: "Where can dental hygienists provide in-service education programs?",
      options: [
        "Only in universities and colleges",
        "Exclusively in dental offices",
        "For staff and/or family members in facilities",
        "Never in institutional settings"
      ],
      correct: "C"
    }
  ],
  "4. Palliative Oral Care": [
    {
      id: 25400,
      question: "What is palliative care defined as according to the document?",
      options: [
        "Care provided only in the final days of life for terminal patients",
        "Active holistic care of individuals with serious health-related suffering across all ages",
        "Medical intervention exclusively for cancer patients in hospitals",
        "Pain management services delivered only by physicians"
      ],
      correct: "B"
    },
    {
      id: 25401,
      question: "What is end-of-life oral care considered to be?",
      options: [
        "A completely separate entity from palliative oral care",
        "The first stage of palliative care before serious illness",
        "The subset of palliative oral care occurring as person is actively dying",
        "Only the care provided in hospice facilities exclusively"
      ],
      correct: "C"
    },
    {
      id: 25402,
      question: "When does palliative medical care begin according to the document?",
      options: [
        "Only in the final month before death occurs",
        "After a person is diagnosed with a life-limiting situation preventing oral self-care",
        "When the person enters a long-term care facility",
        "Exclusively when cancer treatment has failed completely"
      ],
      correct: "B"
    },
    {
      id: 25403,
      question: "What is palliative dental hygiene oral care?",
      options: [
        "Emergency dental treatment for terminally ill patients only",
        "Standard dental hygiene procedures without any modifications",
        "Providing compassion, support, and care for oral health through chronic illness to end of life",
        "Dental hygiene services covered by all insurance plans"
      ],
      correct: "C"
    },
    {
      id: 25404,
      question: "What is noninvasive debridement in palliative dental hygiene?",
      options: [
        "Using ultrasonic and aerosol generation tools exclusively",
        "Only removing calculus with scalers and curettes",
        "Removal of soft deposits and biofilm using oral physiotherapy tools, not scalers or ultrasonics",
        "Surgical procedures performed under general anesthesia"
      ],
      correct: "C"
    },
    {
      id: 25405,
      question: "What are oral physiotherapy tools?",
      options: [
        "Scalers, curettes, and ultrasonic instruments only",
        "Brushes for all surfaces, floss, stimulators, and tongue cleaners",
        "Surgical instruments used in periodontal therapy",
        "Electronic devices for measuring pocket depths"
      ],
      correct: "B"
    },
    {
      id: 25406,
      question: "What percentage of the world population will be aged 65 years or over by 2050?",
      options: [
        "One in ten people globally",
        "One in four people globally",
        "One in six people globally",
        "One in eight people globally"
      ],
      correct: "C"
    },
    {
      id: 25407,
      question: "What population is one of the fastest growing age demographics expected to triple by 2046?",
      options: [
        "Population 65 to 74 years old",
        "Population 75 to 84 years old",
        "Population 85 and older",
        "Population 55 to 64 years old"
      ],
      correct: "C"
    },
    {
      id: 25408,
      question: "What frailties can impact a person\'s oral hygiene?",
      options: [
        "Only physical disabilities like paralysis",
        "Arthritis, cognitive and physical deficits, diminished sight and hearing",
        "Exclusively dental conditions like tooth loss",
        "Only mental health conditions like depression"
      ],
      correct: "B"
    },
    {
      id: 25409,
      question: "What frailties can occur in the mouth with aging?",
      options: [
        "Increased mucosal elasticity and tissue regeneration",
        "Enhanced tactile sensitivity and blood vessel growth",
        "Age-related loss of mucosal elasticity, submucosal tissue, and tactile sensitivity",
        "Complete elimination of all secondary dentin deposits"
      ],
      correct: "C"
    },
    {
      id: 25410,
      question: "What happens within the pulp of vital teeth as frailty increases?",
      options: [
        "Increase in blood vessels and cells for repair",
        "Complete regeneration of all pulpal tissues",
        "Decrease in blood vessels and cells with increased secondary dentin, leading to dying teeth",
        "Enhanced sensory nerve function and response"
      ],
      correct: "C"
    },
    {
      id: 25411,
      question: "What is a major challenge in palliative dental hygiene oral care related to funding?",
      options: [
        "Excessive government funding causing overutilization",
        "Seniors and people with disabilities having minimal access to dental insurance coverage",
        "All seniors receiving comprehensive dental benefits",
        "Dental insurance covering all palliative services fully"
      ],
      correct: "B"
    },
    {
      id: 25412,
      question: "Why do dental insurance programs pose a challenge?",
      options: [
        "They cover too many services for dependent persons",
        "They reimburse dental hygienists at excessive rates",
        "They do not have appropriate billing codes to reimburse therapeutic services",
        "They provide unlimited benefits without restrictions"
      ],
      correct: "C"
    },
    {
      id: 25413,
      question: "Who usually makes policy decisions about mouth care in facilities?",
      options: [
        "Dental hygienists as primary decision makers",
        "Patients and their families exclusively",
        "Physicians and nurses, rarely including dental hygienists",
        "Insurance companies and administrators only"
      ],
      correct: "C"
    },
    {
      id: 25414,
      question: "What is a problem with direct care staff assigned to daily mouth care?",
      options: [
        "They receive too much education on oral care",
        "They have minimal relevant education and lack competency for effective oral care",
        "They are overqualified for providing basic care",
        "They refuse to provide any oral care services"
      ],
      correct: "B"
    },
    {
      id: 25415,
      question: "What populations are especially at risk for oral problems?",
      options: [
        "Young adults living independently in communities",
        "Children attending regular school programs",
        "People in long-term care or experiencing long hospitalizations who are frail and dependent",
        "Healthy seniors living independently without assistance"
      ],
      correct: "C"
    },
    {
      id: 25416,
      question: "What can cause xerostomia and impact oral health in institutionalized persons?",
      options: [
        "Excessive water intake throughout the day",
        "Limited medication use and healthy diets",
        "Systemic health breakdown and multiple prescription and nonprescription medications",
        "Regular exercise and adequate sleep patterns"
      ],
      correct: "C"
    },
    {
      id: 25417,
      question: "What dietary pattern means the mouth is always somewhat acidic?",
      options: [
        "Eating three balanced meals daily only",
        "Fasting for extended periods regularly",
        "Offering food continuously throughout the day",
        "Consuming only alkaline foods and beverages"
      ],
      correct: "C"
    },
    {
      id: 25418,
      question: "What problematic practice occurs with medications in care facilities?",
      options: [
        "Medications are given with plain water only",
        "All medications are administered intravenously",
        "Medications are crushed and put into sugar-laden products without oral care afterward",
        "Medications are never given to residents"
      ],
      correct: "C"
    },
    {
      id: 25419,
      question: "What may result from onset of dementia regarding oral health?",
      options: [
        "Improved oral hygiene and nutritious food choices",
        "Enhanced ability to maintain denture cleanliness",
        "Less likely to select nutritious foods and keep mouth, teeth, dentures clean",
        "Complete independence in all oral care activities"
      ],
      correct: "C"
    },
    {
      id: 25420,
      question: "What oral conditions may result from poor care in dependent persons?",
      options: [
        "Perfect oral health with no complications",
        "Strengthened enamel and healthy gingiva",
        "Dental caries, gingival wounds, mucositis, and candidiasis",
        "Reduced need for professional dental services"
      ],
      correct: "C"
    },
    {
      id: 25421,
      question: "What are multiple causes of xerostomia listed in the document?",
      options: [
        "Excessive salivary production and overhydration",
        "Medications, radiation therapy, Sjögren syndrome, diabetes, HIV/AIDS",
        "Perfect health and balanced nutrition only",
        "Regular dental visits and excellent oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 25422,
      question: "What do medications disturb that affects oral health?",
      options: [
        "The immune system exclusively",
        "The buffering capacity of saliva needed to neutralize acidic pH",
        "Only the digestive system function",
        "The cardiovascular system primarily"
      ],
      correct: "B"
    },
    {
      id: 25423,
      question: "What therapies and equipment can cause dry mouth?",
      options: [
        "Regular toothbrushing with fluoride toothpaste",
        "Drinking adequate water throughout the day",
        "Tube feeding, masks, inhalers, respiratory therapy, oxygen, CPAP masks",
        "Eating fresh fruits and vegetables regularly"
      ],
      correct: "C"
    },
    {
      id: 25424,
      question: "What should be the fluid of choice to optimize oral hydration?",
      options: [
        "Sugary fruit juices and sodas",
        "Coffee and caffeinated beverages",
        "Water as the primary fluid",
        "Alcoholic beverages exclusively"
      ],
      correct: "C"
    },
    {
      id: 25425,
      question: "Why should caffeine and alcohol be avoided in high-risk persons?",
      options: [
        "They increase salivary production excessively",
        "They dry the mouth, worsening xerostomia",
        "They have no effect on oral health",
        "They strengthen tooth enamel significantly"
      ],
      correct: "B"
    },
    {
      id: 25426,
      question: "What do sweetened fluids create in the mouth?",
      options: [
        "An alkaline environment protecting teeth",
        "Enhanced salivary flow and remineralization",
        "An acidic environment contributing to carious lesions",
        "Neutral pH with no effect on teeth"
      ],
      correct: "C"
    },
    {
      id: 25427,
      question: "Why should diabetic versions of supplement drinks be chosen?",
      options: [
        "They taste better than regular versions",
        "They are less expensive than regular supplements",
        "Regular supplements high in sugar cause imbalances promoting rapid decay in dry mouth",
        "They contain more vitamins and minerals"
      ],
      correct: "C"
    },
    {
      id: 25428,
      question: "What is mucositis?",
      options: [
        "A benign condition with no symptoms",
        "A condition causing burning, tingling, pain hindering ability to talk, eat, swallow",
        "Only a cosmetic concern without discomfort",
        "A condition that only affects children"
      ],
      correct: "B"
    },
    {
      id: 25429,
      question: "What can secondary infections of weakened mucosa cause?",
      options: [
        "Improved healing and tissue strength",
        "No significant health consequences",
        "Virulent and painful infections causing interruption to cancer therapy",
        "Enhanced immune response and recovery"
      ],
      correct: "C"
    },
    {
      id: 25430,
      question: "What happens to oral mucosa in chronic mucositis?",
      options: [
        "It thickens and gains elasticity with age",
        "It regenerates completely every month",
        "It thins and loses elasticity, showing frictional keratosis from chronic trauma",
        "It remains unchanged throughout life"
      ],
      correct: "C"
    },
    {
      id: 25431,
      question: "What is Candida albicans?",
      options: [
        "A bacterial infection in the stomach",
        "A viral infection of the respiratory system",
        "A natural oral cavity inhabitant responsible for most candidiasis cases",
        "A parasitic infection in the intestines"
      ],
      correct: "C"
    },
    {
      id: 25432,
      question: "What is the main cause of oral candidiasis?",
      options: [
        "Excessive use of fluoride products",
        "Drinking too much water daily",
        "Imbalance in oral flora and host immunity",
        "Perfect oral hygiene practices"
      ],
      correct: "C"
    },
    {
      id: 25433,
      question: "What are symptoms of oral candidiasis?",
      options: [
        "Improved taste perception and appetite",
        "Strengthened oral tissues and immunity",
        "Pain, bleeding, burning mouth, inability to taste, malnutrition, impaired quality of life",
        "Enhanced healing and tissue regeneration"
      ],
      correct: "C"
    },
    {
      id: 25434,
      question: "What is pseudomembranous candidiasis commonly called?",
      options: [
        "Angular cheilitis exclusively",
        "\"Thrush\" with white/yellowish patches",
        "Erythematous candidiasis only",
        "Hyperplastic candidiasis primarily"
      ],
      correct: "B"
    },
    {
      id: 25435,
      question: "How does pseudomembranous candidiasis present clinically?",
      options: [
        "Red lesions only on hard palate",
        "White patches that cannot be removed",
        "White or yellowish patches that can be easily wiped off leaving inflamed, bleeding tissue",
        "Brown discoloration of tooth enamel"
      ],
      correct: "C"
    },
    {
      id: 25436,
      question: "Where can angular cheilitis present?",
      options: [
        "Only on the tongue surface",
        "On the buccal mucosa exclusively",
        "As white and red fissures at the commissures of the mouth",
        "On the hard palate only"
      ],
      correct: "C"
    },
    {
      id: 25437,
      question: "What deficiencies are associated with angular cheilitis?",
      options: [
        "Vitamin D and calcium only",
        "Excessive vitamin intake causing toxicity",
        "Folic acid, iron, riboflavin (B2), thiamine, cobalamin (B12)",
        "Protein and essential amino acids"
      ],
      correct: "C"
    },
    {
      id: 25438,
      question: "What can happen if oral candidiasis is left untreated?",
      options: [
        "It resolves spontaneously without consequences",
        "It improves oral health significantly",
        "It can progress systemically and increase mortality",
        "It has no effect on overall health"
      ],
      correct: "C"
    },
    {
      id: 25439,
      question: "What is alarming candidiasis in the last days often a sign of?",
      options: [
        "Complete recovery and improved health",
        "Beginning of healing process",
        "Death is imminent",
        "Need for increased nutrition only"
      ],
      correct: "C"
    },
    {
      id: 25440,
      question: "What is dysphagia?",
      options: [
        "Excessive salivary production in elderly",
        "Difficulty swallowing food and/or fluids",
        "Enhanced ability to chew and swallow",
        "Improved nutritional status in aging"
      ],
      correct: "B"
    },
    {
      id: 25441,
      question: "What causes dysphagia?",
      options: [
        "Strengthening of swallowing muscles",
        "Enhanced coordination of swallowing reflex",
        "Weakening of muscles associated with swallowing",
        "Improved neural control of swallowing"
      ],
      correct: "C"
    },
    {
      id: 25442,
      question: "What can dysphagia lead to?",
      options: [
        "Enhanced hydration and weight gain",
        "Improved nutritional status",
        "Dehydration, malnutrition, weight loss",
        "Strengthened immune function"
      ],
      correct: "C"
    },
    {
      id: 25443,
      question: "What is dysphagia a major risk factor for?",
      options: [
        "Improved respiratory function",
        "Enhanced lung capacity",
        "Airway obstruction and aspiration pneumonia",
        "Better oxygen saturation"
      ],
      correct: "C"
    },
    {
      id: 25444,
      question: "What can low salivary flow associated with dysphagia lead to?",
      options: [
        "Improved oral health and immunity",
        "Enhanced protection from infections",
        "Aspiration pneumonia from inhaling gram-negative anaerobes from mouth",
        "Strengthened respiratory defenses"
      ],
      correct: "C"
    },
    {
      id: 25445,
      question: "What does evidence suggest about mechanical removal of debris and biofilm?",
      options: [
        "It has no effect on pneumonia rates",
        "It increases aspiration pneumonia risk",
        "It can reduce incidence of aspiration pneumonia in at-risk children and frail elders",
        "It only benefits young healthy adults"
      ],
      correct: "C"
    },
    {
      id: 25446,
      question: "What may denture wearing during the night do?",
      options: [
        "Improve oral health significantly",
        "Reduce all oral infections completely",
        "Double the risk of aspiration pneumonia",
        "Enhance salivary production"
      ],
      correct: "C"
    },
    {
      id: 25447,
      question: "What conditions is dysphagia often seen in?",
      options: [
        "Only in young healthy individuals",
        "People with perfect cognitive function",
        "Persons with Parkinson disease, stroke, advanced dementia, head and neck cancers",
        "Athletes with excellent physical conditioning"
      ],
      correct: "C"
    },
    {
      id: 25448,
      question: "What should dental hygienists be aware of with dysphagia patients?",
      options: [
        "Enhanced swallowing ability and safety",
        "Improved nutritional intake always",
        "Pocketing of food, airway obstruction risk, aspiration pneumonia",
        "Complete absence of oral bacteria"
      ],
      correct: "C"
    },
    {
      id: 25449,
      question: "What has chlorhexidine gluconate solution (0.12%) been shown to do?",
      options: [
        "Increase risk of aspiration pneumonia",
        "Worsen oral bacterial colonization",
        "Reduce the risk of aspiration pneumonia in geriatric persons",
        "Have no effect on oral pathogens"
      ],
      correct: "C"
    },
    {
      id: 25450,
      question: "What may help improve swallowing abilities and safety?",
      options: [
        "No modifications to routine necessary",
        "Avoiding all assistance with eating",
        "Dietary modifications or postural changes",
        "Eliminating all fluids from diet"
      ],
      correct: "C"
    },
    {
      id: 25451,
      question: "Who assesses clinical swallowing that dental hygienists may collaborate with?",
      options: [
        "Only dentists and dental specialists",
        "Physical therapists exclusively",
        "Speech-language pathologist and/or dietitian",
        "Occupational therapists only"
      ],
      correct: "C"
    },
    {
      id: 25452,
      question: "What is the main cause of pneumonia according to the document?",
      options: [
        "Viral infections from outside sources",
        "Environmental pollutants exclusively",
        "Aspiration of oral and throat secretions",
        "Bacterial infections from skin"
      ],
      correct: "C"
    },
    {
      id: 25453,
      question: "What is pneumonia identified as in personal care homes?",
      options: [
        "A minor concern with little impact",
        "Easily treatable with no consequences",
        "The leading cause of death",
        "Rare occurrence in these settings"
      ],
      correct: "C"
    },
    {
      id: 25454,
      question: "What correlates with aspiration pneumonia according to the document?",
      options: [
        "Excellent oral hygiene and health",
        "Perfect swallowing function",
        "Swallowing disorders, impaired cough reflex, periodontal disease, poor plaque control, dry mouth",
        "Strong immune system and vitality"
      ],
      correct: "C"
    },
    {
      id: 25455,
      question: "What teeth-related factor increases aspiration pneumonia risk?",
      options: [
        "Having no teeth remaining",
        "Perfect dental restorations",
        "Having natural teeth, especially with untreated dental caries",
        "Excellent oral hygiene practices"
      ],
      correct: "C"
    },
    {
      id: 25456,
      question: "What principle guides palliative care regarding death and dying?",
      options: [
        "Death should be avoided at all costs",
        "Dying is a medical failure to prevent",
        "Death, dying, grief, and bereavement are normal parts of life",
        "Death should never be discussed openly"
      ],
      correct: "C"
    },
    {
      id: 25457,
      question: "What does palliative care recognize according to guiding principles?",
      options: [
        "All people have identical needs and values",
        "Cultural differences are insignificant",
        "Recognizes and values diversity",
        "One approach works for all situations"
      ],
      correct: "C"
    },
    {
      id: 25458,
      question: "What should palliative care be according to the principles?",
      options: [
        "Available only to wealthy individuals",
        "Provided only in hospitals",
        "High quality and evidence based",
        "Based solely on tradition without research"
      ],
      correct: "C"
    },
    {
      id: 25459,
      question: "What is palliative care according to the principles?",
      options: [
        "The responsibility of one profession only",
        "Only provided by physicians",
        "A shared responsibility",
        "Not requiring interprofessional collaboration"
      ],
      correct: "C"
    },
    {
      id: 25460,
      question: "What dental hygiene intervention is recommended for mucositis?",
      options: [
        "Avoiding all oral hygiene completely",
        "Using only alcohol-based products",
        "Consistent hydration and proper oral hygiene",
        "Eliminating all fluid intake"
      ],
      correct: "C"
    },
    {
      id: 25461,
      question: "What should be avoided for mucositis patients?",
      options: [
        "Water and bland foods",
        "Gentle oral care",
        "Spicy foods, alcohol, and tobacco use",
        "Soothing rinses"
      ],
      correct: "C"
    },
    {
      id: 25462,
      question: "What type of rinse is recommended for mucositis?",
      options: [
        "Alcohol-based commercial mouthwash",
        "Highly concentrated salt solution",
        "Soothing baking soda, saline, and water rinse",
        "Undiluted hydrogen peroxide"
      ],
      correct: "C"
    },
    {
      id: 25463,
      question: "What is recommended for denture wearers with candidiasis?",
      options: [
        "Wearing dentures 24 hours daily",
        "Never cleaning dentures",
        "Daily denture cleaning and removing dentures while sleeping",
        "Replacing dentures weekly"
      ],
      correct: "C"
    },
    {
      id: 25464,
      question: "How long should patients wait after topical antifungal treatment?",
      options: [
        "5 minutes before eating/drinking",
        "1 hour before eating/drinking",
        "Do not eat or drink for 20 minutes",
        "No waiting period required"
      ],
      correct: "C"
    },
    {
      id: 25465,
      question: "What should be replaced when treating candidiasis?",
      options: [
        "All dental restorations",
        "Nothing needs replacing",
        "Denture container and toothbrush",
        "All oral care products monthly"
      ],
      correct: "C"
    },
    {
      id: 25466,
      question: "What sign indicates xerostomia upon examination?",
      options: [
        "Excessive pooling of saliva on floor of mouth",
        "Overactive salivary glands",
        "No pool of saliva on floor of mouth",
        "Abundant watery saliva present"
      ],
      correct: "C"
    },
    {
      id: 25467,
      question: "What products should be avoided for xerostomia?",
      options: [
        "Water and sugar-free products",
        "Fluoride toothpaste",
        "Products containing alcohol, lemon, glycerin, and petroleum",
        "Saliva substitutes"
      ],
      correct: "C"
    },
    {
      id: 25468,
      question: "What should be used to increase hydration for xerostomia?",
      options: [
        "Caffeinated beverages exclusively",
        "Alcoholic drinks regularly",
        "Water, ice chips, sugar-free ice pops, sugar-free gum, high-moisture foods",
        "Sugary sodas and juices"
      ],
      correct: "C"
    },
    {
      id: 25469,
      question: "What should be applied to lips for xerostomia?",
      options: [
        "Petroleum-based products only",
        "No moisturizers needed",
        "Water-based lubricants",
        "Alcohol-based solutions"
      ],
      correct: "C"
    },
    {
      id: 25470,
      question: "What rinse frequency is recommended for xerostomia management?",
      options: [
        "Once per week for 1 month",
        "Once daily for 2 weeks",
        "Baking soda and saline rinse every 1 to 3 hours for 1 week",
        "Every 12 hours for 3 days"
      ],
      correct: "C"
    },
    {
      id: 25471,
      question: "What angle should the head of bed be elevated for dysphagia patients?",
      options: [
        "Completely flat position",
        "15° angle minimum",
        "At least 30° angle",
        "60° angle minimum"
      ],
      correct: "C"
    },
    {
      id: 25472,
      question: "What head position is recommended for dysphagia patients?",
      options: [
        "Extended backward position",
        "Tilted to the side",
        "Neutral to slightly downward position",
        "Hyperextended upward"
      ],
      correct: "C"
    },
    {
      id: 25473,
      question: "What toothpaste ingredient should be avoided for dysphagia patients?",
      options: [
        "Fluoride compounds",
        "Flavoring agents",
        "Detergent or surfactant like sodium lauryl sulfate",
        "Abrasive particles"
      ],
      correct: "C"
    },
    {
      id: 25474,
      question: "What technique is recommended for dysphagia patients?",
      options: [
        "Traditional toothpaste application",
        "No brushing at all",
        "\"Dip and brush\" with fluoridated or chlorhexidine rinse",
        "Dry brushing only"
      ],
      correct: "C"
    },
    {
      id: 25475,
      question: "What are local factors predisposing to oral candidiasis?",
      options: [
        "Excellent oral hygiene exclusively",
        "Abundant saliva production",
        "Poor oral hygiene, xerostomia, wearing dentures, tissue trauma, smoking",
        "Regular dental visits only"
      ],
      correct: "C"
    },
    {
      id: 25476,
      question: "What medical factors predispose to oral candidiasis?",
      options: [
        "Perfect immune function",
        "No medication use",
        "Immunosuppression, corticosteroids, broad-spectrum antibiotics, diabetes, HIV/AIDS, chemotherapy",
        "Excellent nutritional status only"
      ],
      correct: "C"
    },
    {
      id: 25477,
      question: "What is the first route of antifungal treatment for oral candidiasis?",
      options: [
        "Systemic oral medications",
        "Intravenous antibiotics",
        "Topical antifungal agents",
        "Surgical intervention"
      ],
      correct: "C"
    },
    {
      id: 25478,
      question: "What is an example of a topical antifungal agent?",
      options: [
        "Oral antibiotics only",
        "Antiviral medications",
        "Nystatin suspension or lozenges",
        "Pain medications"
      ],
      correct: "C"
    },
    {
      id: 25479,
      question: "When are systemic antifungal agents used?",
      options: [
        "As the first-line treatment always",
        "For all fungal infections",
        "As the second route when topical agents fail",
        "Never indicated for oral candidiasis"
      ],
      correct: "C"
    },
    {
      id: 25480,
      question: "What is an example of a systemic antifungal agent?",
      options: [
        "Topical creams only",
        "Antibiotic ointments",
        "Fluconazole capsules",
        "Antiviral tablets"
      ],
      correct: "C"
    },
    {
      id: 25481,
      question: "How should dentures be treated for oral candidiasis?",
      options: [
        "Never cleaned or disinfected",
        "Replaced weekly",
        "Thoroughly cleaned, disinfected daily, stored in appropriate solution overnight",
        "Worn continuously without removal"
      ],
      correct: "C"
    },
    {
      id: 25482,
      question: "What solution can dentures be stored in overnight?",
      options: [
        "Hot water only",
        "Soap and water",
        "Water, mouth rinse, antifungal agent, diluted sodium hypochlorite, or chlorhexidine solution",
        "Saliva or artificial saliva"
      ],
      correct: "C"
    },
    {
      id: 25483,
      question: "What did the COVID-19 pandemic highlight in long-term care?",
      options: [
        "Excellent oral care standards everywhere",
        "Adequate dental hygienist staffing",
        "Oral care\'s low priority; lack of care caused infection and tooth loss",
        "Perfect infection control protocols"
      ],
      correct: "C"
    },
    {
      id: 25484,
      question: "What did the Canadian Armed Forces identify in Ontario long-term care homes?",
      options: [
        "Excellent mouth care practices",
        "Adequate dental hygienist presence",
        "Poor mouth care issues",
        "Perfect standards of oral hygiene"
      ],
      correct: "C"
    },
    {
      id: 25485,
      question: "What is the current status of dental hygienists in long-term care facilities?",
      options: [
        "Always identified as essential workers",
        "Included in all healthcare teams",
        "Generally not identified as essential workers",
        "Mandatory staff in every facility"
      ],
      correct: "C"
    },
    {
      id: 25486,
      question: "What must dental hygienists work with professional associations to do?",
      options: [
        "Reduce their scope of practice",
        "Limit services to office settings only",
        "Advocate for legislative changes enabling work in all healthcare settings",
        "Eliminate palliative care services"
      ],
      correct: "C"
    },
    {
      id: 25487,
      question: "What challenge does palliative dental hygiene oral care often bring?",
      options: [
        "Excessive insurance coverage",
        "Too many consent forms available",
        "Obtaining informed consent for assessment and treatment",
        "Unlimited time for procedures"
      ],
      correct: "C"
    },
    {
      id: 25488,
      question: "Who becomes responsible for consent as a person declines?",
      options: [
        "The dental hygienist exclusively",
        "Any family member present",
        "Family, substitute decision maker (SDM), or power of attorney (POA)",
        "Long-term care facility administrator"
      ],
      correct: "C"
    },
    {
      id: 25489,
      question: "What can prepare dental hygienists to work with cognitive impairment and responsive behaviors?",
      options: [
        "No special training needed",
        "Only medical degree required",
        "Gentle Persuasive Approach courses",
        "Basic dental hygiene education only"
      ],
      correct: "C"
    },
    {
      id: 25490,
      question: "What is critical to determine when obtaining consent?",
      options: [
        "The patient\'s insurance coverage",
        "The facility\'s visiting hours",
        "Who is the person\'s power of attorney",
        "The patient\'s favorite food"
      ],
      correct: "C"
    },
    {
      id: 25491,
      question: "What communication skills are necessary for palliative dental hygiene?",
      options: [
        "Only written communication",
        "One-way directives only",
        "Ability to communicate with healthcare managers, nursing, all staff about daily activities",
        "No communication needed"
      ],
      correct: "C"
    },
    {
      id: 25492,
      question: "What must dental hygienists discuss and clarify with person, POA, and family?",
      options: [
        "Only billing and payment issues",
        "Facility rules and regulations",
        "Relevant issues after reviewing medications, medical issues, cognitive level, diet, prior treatment",
        "Insurance coverage exclusively"
      ],
      correct: "C"
    },
    {
      id: 25493,
      question: "What must be reviewed in institutional settings before assessment?",
      options: [
        "Only the current day\'s schedule",
        "Facility policies exclusively",
        "Previous documentation related to oral health",
        "Insurance authorization forms only"
      ],
      correct: "C"
    },
    {
      id: 25494,
      question: "Who should be present at assessment when necessary?",
      options: [
        "Only the dental hygienist",
        "Multiple dental professionals",
        "Family member or primary caregiver",
        "No one else is needed"
      ],
      correct: "C"
    },
    {
      id: 25495,
      question: "What models are applicable to palliative dental hygiene oral care?",
      options: [
        "Only medical models of care",
        "Nursing models exclusively",
        "Dental Hygiene Human Needs and Oral Health Quality of Life models",
        "Physician-centered models only"
      ],
      correct: "C"
    },
    {
      id: 25496,
      question: "What is important to assess in frail persons?",
      options: [
        "Only dental conditions",
        "Financial status exclusively",
        "Overall health including frailties, unhealthy mouth, visual/cognitive impairment, dexterity, depression",
        "Insurance coverage only"
      ],
      correct: "C"
    },
    {
      id: 25497,
      question: "What must dental hygienists access prior to oral/dental assessment?",
      options: [
        "Only current medications list",
        "Insurance authorization",
        "Person\'s clinical records pertaining to oral health",
        "Facility admission paperwork"
      ],
      correct: "C"
    },
    {
      id: 25498,
      question: "What does an in-depth review include?",
      options: [
        "Only dental history",
        "Current complaints exclusively",
        "Medical history, medications, behaviors, oral assessments, RAI-MDS, nutrition, swallowing, oral care plan",
        "Insurance coverage only"
      ],
      correct: "C"
    },
    {
      id: 25499,
      question: "What is RAI-MDS?",
      options: [
        "A new experimental treatment protocol",
        "An insurance billing system",
        "Internationally recognized assessment tool used in healthcare settings",
        "A medication administration system"
      ],
      correct: "C"
    },
    {
      id: 25500,
      question: "What risk assessment questions should dental hygienists ask?",
      options: [
        "Only about insurance coverage",
        "About facility policies exclusively",
        "About nutritional supplements, high-sugar drinks, crushed medications in sweetened products, soft diet, carbohydrate exposure",
        "About visiting hours only"
      ],
      correct: "C"
    },
    {
      id: 25501,
      question: "When does responsibility for oral health shift to other caregivers?",
      options: [
        "Never shifts from the person",
        "Only after death",
        "When person becomes dependent for toileting and eating, likely requiring oral care assistance",
        "Only in hospital settings"
      ],
      correct: "C"
    },
    {
      id: 25502,
      question: "What does the assessment of extraoral structures determine?",
      options: [
        "Only tooth conditions",
        "Insurance coverage needs",
        "Integrity of face, head, neck, and lips",
        "Medication requirements"
      ],
      correct: "C"
    },
    {
      id: 25503,
      question: "What is commonly found in the mouth during palliative assessment?",
      options: [
        "Perfect oral hygiene always",
        "No debris or concerns",
        "Abundant debris contributing to caries and gingival inflammation",
        "Excessive salivary flow"
      ],
      correct: "C"
    },
    {
      id: 25504,
      question: "What is the diagnosis phase described as?",
      options: [
        "Completed only once initially",
        "Static and unchanging",
        "Ongoing and ever-changing depending on the person",
        "Not necessary in palliative care"
      ],
      correct: "C"
    },
    {
      id: 25505,
      question: "What is critical in the diagnosis phase?",
      options: [
        "Insurance authorization",
        "Facility approval only",
        "Identification of conditions and needs to determine best care for oral comfort and quality of life",
        "Scheduling convenience"
      ],
      correct: "C"
    },
    {
      id: 25506,
      question: "What is palliative dental hygiene oral care introduced to do?",
      options: [
        "Provide only emergency treatment",
        "Replace all dental care",
        "Keep mouth clean/comfortable, manage disease, preserve tooth structure, minimize inflammation, maintain mucous membrane integrity",
        "Eliminate all dental treatment"
      ],
      correct: "C"
    },
    {
      id: 25507,
      question: "What may be high priorities in palliative care planning?",
      options: [
        "Cosmetic improvements exclusively",
        "Orthodontic corrections",
        "Pain management and maintenance of hydration",
        "Teeth whitening procedures"
      ],
      correct: "C"
    },
    {
      id: 25508,
      question: "What is necessary to help person and/or POA make decisions?",
      options: [
        "Providing only one treatment option",
        "Making all decisions for them",
        "Discussion about goals of care and risks/benefits of potential treatment options",
        "No discussion needed"
      ],
      correct: "C"
    },
    {
      id: 25509,
      question: "What is insufficient for dependent persons?",
      options: [
        "Weekly dental hygiene visits",
        "Daily oral care assistance",
        "Traditional dental hygiene schedule of two to three visits per year",
        "Professional care twice monthly"
      ],
      correct: "C"
    },
    {
      id: 25510,
      question: "How often may palliative dental hygiene care be done?",
      options: [
        "Only once per year",
        "Every 6 months only",
        "Every week or two times per month depending on requirements and finances",
        "Only once in lifetime"
      ],
      correct: "C"
    },
    {
      id: 25511,
      question: "Where is oral care provided in palliative settings?",
      options: [
        "Only in dental offices",
        "Exclusively in hospitals",
        "Where person resides, in their environment",
        "Only in operating rooms"
      ],
      correct: "C"
    },
    {
      id: 25512,
      question: "Where can the dental hygienist provide care for comfort and cooperation?",
      options: [
        "Only in dental chair",
        "Exclusively standing position",
        "At bedside, wheelchair, or other comfortable location",
        "Only in treatment room"
      ],
      correct: "C"
    },
    {
      id: 25513,
      question: "Why may bathroom mirrors be problematic for people with cognitive impairments?",
      options: [
        "Mirrors are too small",
        "Lighting is inadequate",
        "They often don\'t recognize themselves and become disturbed",
        "Mirrors are too high"
      ],
      correct: "C"
    },
    {
      id: 25514,
      question: "What can help set a positive atmosphere during care?",
      options: [
        "Loud conversations",
        "Bright fluorescent lights",
        "Music and other distractions",
        "Complete silence"
      ],
      correct: "C"
    },
    {
      id: 25515,
      question: "What should be applied first during palliative oral care?",
      options: [
        "Toothpaste liberally",
        "Fluoride varnish",
        "Nonpetroleum moisturizer to dry lips",
        "Chlorhexidine rinse"
      ],
      correct: "C"
    },
    {
      id: 25516,
      question: "What should the mouth be sanitized with initially?",
      options: [
        "Plain water only",
        "Toothpaste solution",
        "Antimicrobial rinse like chlorhexidine",
        "Alcohol-based mouthwash"
      ],
      correct: "C"
    },
    {
      id: 25517,
      question: "What can be used to safely remove large amounts of loose debris?",
      options: [
        "Scalers and curettes",
        "Ultrasonic instruments",
        "Untreated disposable sponge swab",
        "Air polishing devices"
      ],
      correct: "C"
    },
    {
      id: 25518,
      question: "Why should lemon glycerin swabs be avoided?",
      options: [
        "They are too expensive",
        "They are unavailable",
        "They are drying",
        "They are too large"
      ],
      correct: "C"
    },
    {
      id: 25519,
      question: "What caution exists with sponge swabs?",
      options: [
        "They are too small",
        "They clean too effectively",
        "Sponge can be bitten off and become choking hazard",
        "They are too rough"
      ],
      correct: "C"
    },
    {
      id: 25520,
      question: "What is usually sufficient to remove remaining debris?",
      options: [
        "Ultrasonic scalers only",
        "High-speed handpieces",
        "Oral physiotherapy tools",
        "Surgical instruments"
      ],
      correct: "C"
    },
    {
      id: 25521,
      question: "Why is toothpaste contraindicated in palliative care?",
      options: [
        "It is too expensive",
        "It is unavailable",
        "It requires person to spit and is choking hazard",
        "It is too abrasive"
      ],
      correct: "C"
    },
    {
      id: 25522,
      question: "What is the \'dip and brush\' technique?",
      options: [
        "Soaking dentures overnight",
        "Using dry brushing only",
        "Dipping oral physiotherapy tools into chlorhexidine rinse while using them",
        "Applying toothpaste to wet brush"
      ],
      correct: "C"
    },
    {
      id: 25523,
      question: "What is the two-toothbrush technique used for?",
      options: [
        "Cleaning two people simultaneously",
        "Doubling cleaning effectiveness",
        "Using handle of one brush as mouth prop while other is working tool",
        "Providing backup brush option"
      ],
      correct: "C"
    },
    {
      id: 25524,
      question: "What therapies are applied to asymptomatic teeth no longer biologically sound?",
      options: [
        "Extraction immediately",
        "No treatment provided",
        "Interim Stabilization Therapy (IST) including silver diamine fluoride, zinc oxide fluoride, glass ionomers",
        "Full crown restorations"
      ],
      correct: "C"
    },
    {
      id: 25525,
      question: "When is collaboration with dentist of record recommended?",
      options: [
        "Never necessary",
        "Only in emergencies",
        "If tooth is salvageable",
        "For all procedures always"
      ],
      correct: "C"
    },
    {
      id: 25526,
      question: "What must be done to determine if calculus removal is appropriate?",
      options: [
        "Always remove all calculus",
        "Never remove any calculus",
        "Risk-benefit analysis to determine if removal causes more harm than good",
        "Only patient preference matters"
      ],
      correct: "C"
    },
    {
      id: 25527,
      question: "Why might calculus removal be contraindicated in some patients?",
      options: [
        "It is never contraindicated",
        "It is too expensive",
        "In compromised healing, can cause unstable tissue response; safety hazard with unpredictable behaviors",
        "It is too time-consuming"
      ],
      correct: "C"
    },
    {
      id: 25528,
      question: "What instruments are used if calculus is to be removed?",
      options: [
        "Ultrasonic scalers exclusively",
        "Air polishing devices",
        "Manual curettes",
        "Rotary instruments"
      ],
      correct: "C"
    },
    {
      id: 25529,
      question: "What must dental hygienists ensure regarding instruments?",
      options: [
        "They can be disposed of",
        "They never need cleaning",
        "Proper transport for reprocessing and adherence to regulatory requirements",
        "They can be reused without sterilization"
      ],
      correct: "C"
    },
    {
      id: 25530,
      question: "What changes throughout palliative dental hygiene care?",
      options: [
        "Nothing ever changes",
        "Only the location of care",
        "Physical and cognitive abilities of dependent persons",
        "Insurance coverage exclusively"
      ],
      correct: "C"
    },
    {
      id: 25531,
      question: "What is important to continually do in palliative care?",
      options: [
        "Maintain same plan indefinitely",
        "Never modify goals",
        "Evaluate and modify care plan, adjust goals and outcomes",
        "Focus only on initial assessment"
      ],
      correct: "C"
    },
    {
      id: 25532,
      question: "What should evaluation include?",
      options: [
        "Only clinical outcomes",
        "Financial considerations exclusively",
        "Whether education of persons, families, and staff has been effective",
        "Only patient satisfaction scores"
      ],
      correct: "C"
    },
    {
      id: 25533,
      question: "How should documentation be completed?",
      options: [
        "Informal notes only",
        "No documentation needed",
        "Chronological account of services according to Standards for Clinical Practice",
        "Any format acceptable"
      ],
      correct: "C"
    },
    {
      id: 25534,
      question: "What should documentation include?",
      options: [
        "Only billing information",
        "Appointment times only",
        "Dental hygiene process of care and discussions with family and caregivers",
        "Insurance claims exclusively"
      ],
      correct: "C"
    },
    {
      id: 25535,
      question: "Where should a copy of assessment and recommendations be left?",
      options: [
        "Only in dental hygienist\'s records",
        "With the patient exclusively",
        "With the facility",
        "No copies are needed"
      ],
      correct: "C"
    },
    {
      id: 25536,
      question: "What does the dental hygienist recognize about frailty?",
      options: [
        "It never impacts oral care",
        "It is irrelevant to treatment",
        "When increasing physical frailty and cognitive/physical decline requires palliative dental hygiene oral care",
        "It only affects mobility"
      ],
      correct: "C"
    },
    {
      id: 25537,
      question: "What is inevitable and not curable?",
      options: [
        "All chronic diseases",
        "Dental caries and periodontal disease",
        "Dying is inevitable and death is not curable",
        "All infections and illnesses"
      ],
      correct: "C"
    },
    {
      id: 25538,
      question: "What does palliative dental hygiene oral care enhance?",
      options: [
        "Only physical appearance",
        "Financial status exclusively",
        "Person\'s health and wellbeing to end of life",
        "Dental insurance benefits"
      ],
      correct: "C"
    },
    {
      id: 25539,
      question: "What will gain momentum for dental hygienists?",
      options: [
        "Limiting services to office settings",
        "Reducing scope of practice",
        "Pathways to providing preventive oral health services as integral part of healthcare teams",
        "Eliminating palliative care services"
      ],
      correct: "C"
    }
  ],
  "5. Child Abuse and Family Violence": [
    {
      id: 25500,
      question: "Who are mandated reporters for child abuse and neglect according to the document?",
      options: [
        "Only physicians and nurses in clinical settings",
        "Teachers and school administrators exclusively",
        "Dental hygienists for child abuse, vulnerable adults, and human trafficking victims",
        "Social workers and law enforcement officers only"
      ],
      correct: "C"
    },
    {
      id: 25501,
      question: "What term is used to define abuse and neglect of human victims?",
      options: [
        "Family dysfunction",
        "Maltreatment",
        "Domestic violence",
        "Child endangerment"
      ],
      correct: "B"
    },
    {
      id: 25502,
      question: "What is the emphasis of the Mid-Atlantic P.A.N.D.A. program?",
      options: [
        "Providing dental treatment to abuse victims exclusively",
        "Training law enforcement in forensic dentistry",
        "Recognize, refer, and report findings to appropriate agencies",
        "Establishing shelters for abused children"
      ],
      correct: "C"
    },
    {
      id: 25503,
      question: "Which legislation originally acknowledged concerns about physical abuse of children in 1974?",
      options: [
        "Child Abuse Prevention and Treatment Act (CAPTA)",
        "Justice for Victims of Trafficking Act",
        "Comprehensive Addiction and Recovery Act",
        "Trafficking Victims Protection Act"
      ],
      correct: "A"
    },
    {
      id: 25504,
      question: "What is the most common type of child maltreatment today?",
      options: [
        "Physical abuse",
        "Sexual abuse",
        "Neglect",
        "Psychological maltreatment"
      ],
      correct: "C"
    },
    {
      id: 25505,
      question: "When did CAPTA begin using the term \"child maltreatment\"?",
      options: [
        "1974",
        "1980",
        "1988",
        "2010"
      ],
      correct: "B"
    },
    {
      id: 25506,
      question: "What percentage of child maltreatment victims were neglected in 2020?",
      options: [
        "56.2%",
        "68.5%",
        "76.1%",
        "82.3%"
      ],
      correct: "C"
    },
    {
      id: 25507,
      question: "What percentage of child maltreatment victims were physically abused in 2020?",
      options: [
        "9.8%",
        "12.3%",
        "16.5%",
        "22.1%"
      ],
      correct: "C"
    },
    {
      id: 25508,
      question: "What percentage of child maltreatment victims were sexually abused in 2020?",
      options: [
        "5.2%",
        "7.8%",
        "9.4%",
        "12.6%"
      ],
      correct: "C"
    },
    {
      id: 25509,
      question: "How many children died from abuse and neglect in the United States in 2020?",
      options: [
        "950",
        "1350",
        "1750",
        "2150"
      ],
      correct: "C"
    },
    {
      id: 25510,
      question: "What percentage of child fatalities were younger than age 3 in 2020?",
      options: [
        "52%",
        "60%",
        "68%",
        "75%"
      ],
      correct: "C"
    },
    {
      id: 25511,
      question: "What is the national victim rate per 1000 children in the population?",
      options: [
        "5.2 victims per 1000",
        "6.8 victims per 1000",
        "8.4 victims per 1000",
        "10.1 victims per 1000"
      ],
      correct: "C"
    },
    {
      id: 25512,
      question: "What is the highest victimization rate among children younger than 1 year old?",
      options: [
        "18.3 per 1000",
        "21.7 per 1000",
        "25.1 per 1000",
        "28.9 per 1000"
      ],
      correct: "C"
    },
    {
      id: 25513,
      question: "Which population has the highest victimization rate?",
      options: [
        "African American children at 18.2 per 1000",
        "Hispanic children at 12.5 per 1000",
        "American Indian or Alaska Native children at 15.5 per 1000",
        "Asian children at 8.3 per 1000"
      ],
      correct: "C"
    },
    {
      id: 25514,
      question: "What pediatric proverb refers to sentinel findings in nonambulatory infants?",
      options: [
        "\"Babies who cry have something to say\"",
        "\"Small children have fragile bones\"",
        "\"Those who don\'t cruise rarely bruise\"",
        "\"Infants heal faster than adults\""
      ],
      correct: "C"
    },
    {
      id: 25515,
      question: "What has replaced the term \"shaken baby syndrome\"?",
      options: [
        "Infant head injury syndrome",
        "Pediatric brain trauma",
        "Abusive head trauma",
        "Neonatal concussion syndrome"
      ],
      correct: "C"
    },
    {
      id: 25516,
      question: "What is the leading cause of serious or fatal brain injuries in children under age 2?",
      options: [
        "Motor vehicle accidents",
        "Falls from heights",
        "Abusive head trauma",
        "Sports-related injuries"
      ],
      correct: "C"
    },
    {
      id: 25517,
      question: "What percentage of child abuse cases involve craniofacial, head, face, and neck injuries?",
      options: [
        "Less than one-quarter",
        "Approximately one-third",
        "More than one-half",
        "Nearly three-quarters"
      ],
      correct: "C"
    },
    {
      id: 25518,
      question: "What intercanine distance in bite marks suggests an adult human bite?",
      options: [
        "Less than 2.0 cm",
        "Between 2.0 and 2.5 cm",
        "Greater than 3.0 cm",
        "Exactly 2.5 cm"
      ],
      correct: "C"
    },
    {
      id: 25519,
      question: "What other term is used for caregiver-fabricated illness in a child?",
      options: [
        "Pediatric fraud syndrome",
        "Developmental delay disorder",
        "Munchausen syndrome by proxy",
        "Childhood psychosomatic disorder"
      ],
      correct: "C"
    },
    {
      id: 25520,
      question: "What are condyloma acuminatum in the oral cavity?",
      options: [
        "Bacterial infections from poor hygiene",
        "Traumatic lesions from forced feeding",
        "Venereal warts indicating possible sexual abuse",
        "Fungal infections from immunosuppression"
      ],
      correct: "C"
    },
    {
      id: 25521,
      question: "Which oral condition is pathognomonic of sexual abuse in prepubertal children?",
      options: [
        "Herpetic gingivostomatitis",
        "Oral candidiasis",
        "Pharyngeal, oral, and perioral gonorrhea",
        "Recurrent aphthous ulcers"
      ],
      correct: "C"
    },
    {
      id: 25522,
      question: "What do palatal petechiae potentially indicate?",
      options: [
        "Vitamin deficiency",
        "Bleeding disorder",
        "Forced oral sex",
        "Allergic reaction"
      ],
      correct: "C"
    },
    {
      id: 25523,
      question: "What percentage of youths have been electronically bullied nationally?",
      options: [
        "8%",
        "11%",
        "15%",
        "22%"
      ],
      correct: "C"
    },
    {
      id: 25524,
      question: "What percentage of youths have been bullied on school property?",
      options: [
        "13%",
        "16%",
        "19%",
        "24%"
      ],
      correct: "C"
    },
    {
      id: 25525,
      question: "What does the American Academy of Pediatric Dentistry define as dental neglect?",
      options: [
        "Inability to afford dental care",
        "Fear of dental treatment",
        "Willful failure to seek and follow through with treatment",
        "Geographic barriers to dental access"
      ],
      correct: "C"
    },
    {
      id: 25526,
      question: "What genetic condition is marked by extremely loose joints and hyperelastic skin?",
      options: [
        "Sturge-Weber syndrome",
        "Idiopathic thrombocytopenic purpura",
        "Ehlers-Danlos syndrome",
        "Marfan syndrome"
      ],
      correct: "C"
    },
    {
      id: 25527,
      question: "What is Sturge-Weber syndrome characterized by?",
      options: [
        "Easy bruising and bleeding disorders",
        "Loose joints and fragile skin",
        "Port-wine stain birthmark and nervous system problems",
        "Skeletal abnormalities and heart defects"
      ],
      correct: "C"
    },
    {
      id: 25528,
      question: "What is idiopathic thrombocytopenic purpura (ITP)?",
      options: [
        "Connective tissue disorder with joint problems",
        "Genetic neurological condition with seizures",
        "Bleeding disorder where immune system destroys platelets",
        "Infectious disease causing skin lesions"
      ],
      correct: "C"
    },
    {
      id: 25529,
      question: "What cultural practice involves warmed cups placed on the back?",
      options: [
        "Coining",
        "Scraping (gua sha)",
        "Cupping",
        "Moxibustion"
      ],
      correct: "C"
    },
    {
      id: 25530,
      question: "What should be documented if child maltreatment is suspected?",
      options: [
        "Only physical findings without conversations",
        "Assumptions about the perpetrator\'s identity",
        "All clinical/behavioral findings and conversations with full names and quotes",
        "General impressions without specific details"
      ],
      correct: "C"
    },
    {
      id: 25531,
      question: "What is the association between child maltreatment and IPV?",
      options: [
        "No connection has been established",
        "They occur in completely different populations",
        "Victims of child maltreatment are at risk for IPV victimization",
        "Child maltreatment protects against future IPV"
      ],
      correct: "C"
    },
    {
      id: 25532,
      question: "What percentage of females were under age 25 when first encountering IPV?",
      options: [
        "52.3%",
        "64.7%",
        "71.1%",
        "78.9%"
      ],
      correct: "C"
    },
    {
      id: 25533,
      question: "What percentage of males were under age 25 when first encountering IPV?",
      options: [
        "45.2%",
        "51.6%",
        "58.8%",
        "66.3%"
      ],
      correct: "C"
    },
    {
      id: 25534,
      question: "What is reproductive coercion in IPV?",
      options: [
        "Joint decision-making about family planning",
        "Medical advice about contraception",
        "Abusive partner controlling reproductive or sexual health",
        "Legal restrictions on reproductive choices"
      ],
      correct: "C"
    },
    {
      id: 25535,
      question: "How many times more likely are victims with one nonfatal strangulation to die by homicide?",
      options: [
        "Three times more likely",
        "Five times more likely",
        "Seven times more likely",
        "Nine times more likely"
      ],
      correct: "C"
    },
    {
      id: 25536,
      question: "What should oral health professionals provide in restrooms for IPV victims?",
      options: [
        "Free dental care coupons",
        "Legal advice pamphlets",
        "Community-based IPV resources where victims can read them privately",
        "Surveillance cameras for safety"
      ],
      correct: "C"
    },
    {
      id: 25537,
      question: "What encompasses elder abuse?",
      options: [
        "Only physical abuse by family members",
        "Only financial exploitation by strangers",
        "Abuse, neglect, and exploitation including contractor scams and self-neglect",
        "Only neglect in institutional settings"
      ],
      correct: "C"
    },
    {
      id: 25538,
      question: "What is domestic elder adult abuse?",
      options: [
        "Abuse by paid caregivers in facilities",
        "Self-neglect by the elderly person",
        "Maltreatment by someone with a close or special relationship",
        "Financial scams by telephone solicitors"
      ],
      correct: "C"
    },
    {
      id: 25539,
      question: "Where does institutional elder abuse occur?",
      options: [
        "In the elder\'s private home",
        "At adult day care centers only",
        "In residential facilities like nursing homes and group homes",
        "At senior community centers"
      ],
      correct: "C"
    },
    {
      id: 25540,
      question: "What is self-neglect in older adults?",
      options: [
        "Abuse perpetrated by family members",
        "Failure of caregivers to provide care",
        "Harm from person\'s own behaviors rather than others\' actions",
        "Financial exploitation by strangers"
      ],
      correct: "C"
    },
    {
      id: 25541,
      question: "Who are vulnerable adults?",
      options: [
        "All adults over age 65",
        "Adults with temporary illnesses",
        "Individuals over 18 with substantial impairment limiting self-care without assistance",
        "Adults living in poverty"
      ],
      correct: "C"
    },
    {
      id: 25542,
      question: "What is the defining element of human trafficking?",
      options: [
        "Physical transport across international borders",
        "Illegal immigration status",
        "Exploitation of humans for profit",
        "Kidnapping by strangers"
      ],
      correct: "C"
    },
    {
      id: 25543,
      question: "When did the Justice for Victims of Trafficking Act amend CAPTA definitions?",
      options: [
        "2010",
        "2013",
        "2015",
        "2018"
      ],
      correct: "C"
    },
    {
      id: 25544,
      question: "What is sex trafficking according to US law?",
      options: [
        "Consensual adult entertainment work",
        "International marriage arrangements",
        "Inducing victim by force, fraud, or coercion into commercial sex act",
        "Legal prostitution in licensed establishments"
      ],
      correct: "C"
    },
    {
      id: 25545,
      question: "What is the difference between human trafficking and human smuggling?",
      options: [
        "There is no difference between the terms",
        "Smuggling is always violent; trafficking is not",
        "Smuggling relationship ends at destination; trafficking relationship continues for profit",
        "Smuggling involves children; trafficking involves adults"
      ],
      correct: "C"
    },
    {
      id: 25546,
      question: "What do traffickers often keep from victims to prevent escape?",
      options: [
        "Clothing and shoes",
        "Cell phones only",
        "Personal identification papers",
        "Food and water"
      ],
      correct: "C"
    },
    {
      id: 25547,
      question: "What health problems may labor trafficking victims experience?",
      options: [
        "Only minor injuries requiring no treatment",
        "Primarily dental problems exclusively",
        "Loss of body parts, head injuries, persistent cough, lacerations",
        "Only psychological problems without physical injury"
      ],
      correct: "C"
    },
    {
      id: 25548,
      question: "What problems may sex trafficking victims specifically experience?",
      options: [
        "Only sexually transmitted diseases",
        "Only substance abuse issues",
        "Headaches, memory problems, gynecologic problems, STDs, multiple pregnancies",
        "Only minor bruising"
      ],
      correct: "C"
    },
    {
      id: 25549,
      question: "What is a cardinal red flag for human trafficking in healthcare settings?",
      options: [
        "Patient arriving alone for appointment",
        "Patient speaking a foreign language",
        "Third-party refusing to leave room and allow patient interaction alone",
        "Patient paying with cash"
      ],
      correct: "C"
    },
    {
      id: 25550,
      question: "Who operates the National Human Trafficking Hotline?",
      options: [
        "Federal Bureau of Investigation",
        "Department of Homeland Security",
        "Polaris supported by Administration for Children and Families",
        "National Center for Missing and Exploited Children"
      ],
      correct: "C"
    },
    {
      id: 25551,
      question: "What should dental professionals NOT do when suspecting trafficking?",
      options: [
        "Report to appropriate authorities",
        "Document observations carefully",
        "Inquire about trafficking-specific details or make promises to patient",
        "Assess patient safety"
      ],
      correct: "C"
    },
    {
      id: 25552,
      question: "What protects mandated reporters who report in good faith?",
      options: [
        "Professional liability insurance",
        "Employment contracts",
        "State-established immunity laws from civil or criminal penalties",
        "Dental board regulations"
      ],
      correct: "C"
    },
    {
      id: 25553,
      question: "What is the penalty for failure to report suspected child abuse?",
      options: [
        "Warning letter for first offense",
        "Continuing education requirement",
        "Misdemeanor punishable by fine and/or imprisonment in most states",
        "Automatic license revocation"
      ],
      correct: "C"
    },
    {
      id: 25554,
      question: "What agency receives child maltreatment reports and investigates cases?",
      options: [
        "Department of Education",
        "Local police department only",
        "Child Protective Services (CPS)",
        "Federal Bureau of Investigation"
      ],
      correct: "C"
    },
    {
      id: 25555,
      question: "What agencies help elder adults unable to care for daily needs?",
      options: [
        "Child Protective Services",
        "Department of Motor Vehicles",
        "Adult Protective Services",
        "Social Security Administration"
      ],
      correct: "C"
    },
    {
      id: 25556,
      question: "What should the dental hygiene record document?",
      options: [
        "Opinions about who committed abuse",
        "Assumptions without evidence",
        "Objectively all findings and disclosures made by client",
        "Hearsay from other patients"
      ],
      correct: "C"
    },
    {
      id: 25557,
      question: "What do adverse childhood experiences (ACEs) include?",
      options: [
        "Minor childhood illnesses and injuries",
        "Normal developmental challenges",
        "Abuse, neglect, and traumatic events before age 18 affecting lifetime health",
        "Academic struggles in school"
      ],
      correct: "C"
    },
    {
      id: 25558,
      question: "What examples are given of social determinants affecting children?",
      options: [
        "Having too many toys and privileges",
        "Attending high-quality schools",
        "Impaired caregiver, substance use, mental health problems, unsafe conditions, poverty",
        "Living in suburban neighborhoods"
      ],
      correct: "C"
    },
    {
      id: 25559,
      question: "Why are dental hygienists uniquely positioned to identify abuse?",
      options: [
        "They have more training than physicians",
        "They see patients less frequently",
        "Frequency of visits allows trusting relationships and thorough assessments",
        "They have legal authority to investigate"
      ],
      correct: "C"
    },
    {
      id: 25560,
      question: "Why might abusers return to the same oral healthcare professional?",
      options: [
        "Dental offices are closer than medical offices",
        "Dental care is less expensive",
        "Abusers may avoid same physician but return to same dentist",
        "Dental offices don\'t report abuse"
      ],
      correct: "C"
    },
    {
      id: 25561,
      question: "What does abuse include according to the document?",
      options: [
        "Only physical harm to victims",
        "Only sexual exploitation",
        "Physical, sexual, emotional, or verbal harm or any combination",
        "Only verbal harassment"
      ],
      correct: "C"
    },
    {
      id: 25562,
      question: "What does neglect encompass?",
      options: [
        "Only physical needs like food and shelter",
        "Only medical care needs",
        "Failure to provide care, support, nutrition, health, hygiene, prescriptions, therapies",
        "Only educational needs"
      ],
      correct: "C"
    },
    {
      id: 25563,
      question: "What is the cycle of child maltreatment in families?",
      options: [
        "All maltreated children become abusers",
        "Maltreatment never repeats across generations",
        "Maltreated children are at high risk for maltreating their children",
        "Only boys become abusers if maltreated"
      ],
      correct: "C"
    },
    {
      id: 25564,
      question: "When did NCANDS add sex trafficking as a maltreatment type?",
      options: [
        "2015",
        "2016",
        "2018",
        "2020"
      ],
      correct: "C"
    },
    {
      id: 25565,
      question: "What may children with special needs have regarding maltreatment?",
      options: [
        "Complete protection from abuse",
        "Lower victimization risk",
        "Higher victimization risk than children without special needs",
        "Same risk as all children"
      ],
      correct: "C"
    },
    {
      id: 25566,
      question: "What do pattern bruises on victims\' skin indicate?",
      options: [
        "Genetic bleeding disorders",
        "Normal childhood injuries",
        "Objects used by perpetrators that leave identifying marks",
        "Allergic reactions"
      ],
      correct: "C"
    },
    {
      id: 25567,
      question: "How do human bite marks differ from animal bites?",
      options: [
        "Animal bites are always more severe",
        "Human bites are always painless",
        "Human bites compress flesh; animals tear flesh causing irregular breaks",
        "Animal bites never break the skin"
      ],
      correct: "C"
    },
    {
      id: 25568,
      question: "How can adult perpetrators be identified from bite marks?",
      options: [
        "By visual examination only",
        "By the size of the bite alone",
        "By DNA in oral epithelial cells deposited from bite marks",
        "Bite marks cannot identify perpetrators"
      ],
      correct: "C"
    },
    {
      id: 25569,
      question: "What is the mechanism of abuse in caregiver-fabricated illness?",
      options: [
        "Direct physical violence against child",
        "Deliberate starvation and neglect",
        "Excessive healthcare evaluations and treatments",
        "Complete denial of medical care"
      ],
      correct: "C"
    },
    {
      id: 25570,
      question: "What are long-term symptoms of sexual abuse?",
      options: [
        "No lasting effects after childhood",
        "Only physical health problems",
        "Anxiety, fear, PTSD, and sometimes arrested development",
        "Only behavioral problems at school"
      ],
      correct: "C"
    },
    {
      id: 25571,
      question: "What mental well-being changes occur from emotional maltreatment?",
      options: [
        "Improved self-confidence and resilience",
        "Enhanced social skills",
        "Anxiety, low mood, aggression, deficits in social skills",
        "Better academic performance"
      ],
      correct: "C"
    },
    {
      id: 25572,
      question: "What is parental emotional abuse a risk factor for?",
      options: [
        "Better coping mechanisms",
        "Enhanced family relationships",
        "Serious mental health problems and more severe PTSD symptoms",
        "Improved emotional regulation"
      ],
      correct: "C"
    },
    {
      id: 25573,
      question: "What defines the aggressive behavior of bullying?",
      options: [
        "Single isolated incidents",
        "Accidental conflicts between peers",
        "Repetition, intentionality, and imbalance of power",
        "Mutual disagreements"
      ],
      correct: "C"
    },
    {
      id: 25574,
      question: "Where does bullying continue according to the document?",
      options: [
        "Only in elementary schools",
        "Only face-to-face settings",
        "Schools, cyberspace, workplace in variety of settings",
        "Only on social media"
      ],
      correct: "C"
    },
    {
      id: 25575,
      question: "What would nurturing caretakers do for an injured child?",
      options: [
        "Wait to see if injury heals",
        "Treat injuries at home only",
        "Not hesitate to seek immediate medical or dental treatment",
        "Blame the child for being clumsy"
      ],
      correct: "C"
    },
    {
      id: 25576,
      question: "What are perpetrators more likely to do regarding treatment?",
      options: [
        "Seek care from multiple specialists",
        "Demand immediate emergency care",
        "Be less forthcoming about injuries and delay seeking treatment intentionally",
        "Provide detailed accurate histories"
      ],
      correct: "C"
    },
    {
      id: 25577,
      question: "What barriers perpetuate dental neglect globally?",
      options: [
        "Too many dentists available",
        "Excessive dental insurance coverage",
        "Poverty, marginalization, geographic constraints, poor oral health literacy",
        "Too much emphasis on oral health"
      ],
      correct: "C"
    },
    {
      id: 25578,
      question: "What may abused children exhibit regarding behavior?",
      options: [
        "Consistently happy and outgoing demeanor",
        "Enhanced cooperation with adults",
        "Passive/withdrawn behavior, poor self-image, hostility, lack of cooperation",
        "Excellent academic performance"
      ],
      correct: "C"
    },
    {
      id: 25579,
      question: "What are caregiver risk factors for child maltreatment?",
      options: [
        "High income and education",
        "Large support networks",
        "Alcohol and drug abuse and intimate partner violence",
        "Employment stability"
      ],
      correct: "C"
    },
    {
      id: 25580,
      question: "What is the goal of good parenting?",
      options: [
        "Strict discipline and obedience",
        "Academic excellence above all",
        "Enabling child to grow with satisfaction, security, and self-respect",
        "Preventing all childhood injuries"
      ],
      correct: "C"
    },
    {
      id: 25581,
      question: "What are warning signs of nonnurturing environments?",
      options: [
        "Allowing age-appropriate independence",
        "Encouraging social activities",
        "Overly critical or strict parents and extremely isolated families",
        "Regular family outings"
      ],
      correct: "C"
    },
    {
      id: 25582,
      question: "When do accidental injuries normally heal?",
      options: [
        "In various stages due to repeated occurrences",
        "More slowly than abuse injuries",
        "At the same time if sustained simultaneously",
        "Accidental injuries never fully heal"
      ],
      correct: "C"
    },
    {
      id: 25583,
      question: "Where do accidental injuries normally occur on the body?",
      options: [
        "On nonbony areas like neck and trunk",
        "Equally distributed over entire body",
        "Over bony protuberances like knees and elbows",
        "Only on the head and face"
      ],
      correct: "C"
    },
    {
      id: 25584,
      question: "Where do injuries from abuse often occur?",
      options: [
        "Only on hands and feet",
        "Over bony protuberances exclusively",
        "On surfaces away from bony protuberances like neck, head, trunk",
        "Only internal organs"
      ],
      correct: "C"
    },
    {
      id: 25585,
      question: "What should healthcare providers assess regarding injuries?",
      options: [
        "Only the color of bruises",
        "Only the size of wounds",
        "Location, size, shape, and mode of injuries using professional judgment",
        "Only the age of the patient"
      ],
      correct: "C"
    },
    {
      id: 25586,
      question: "What questions should be asked in suspected child maltreatment cases?",
      options: [
        "Who will pay for treatment",
        "What insurance covers the child",
        "Do histories match; is there consistency with injury, timeline, explanation",
        "Where does the child attend school"
      ],
      correct: "C"
    },
    {
      id: 25587,
      question: "When should parents and caregivers be approached separately?",
      options: [
        "Never during the assessment process",
        "Only if the child requests it",
        "Always in private without the child or others present",
        "Only in the dental operatory"
      ],
      correct: "C"
    },
    {
      id: 25588,
      question: "What should you remind adults if discussing suspicions?",
      options: [
        "They may be arrested immediately",
        "The child will be removed from home",
        "You are concerned about welfare and well-being of all patients",
        "You will call police during appointment"
      ],
      correct: "C"
    },
    {
      id: 25589,
      question: "What should documentation include according to the document?",
      options: [
        "Only photographs without written records",
        "Only verbal statements without clinical findings",
        "Text, photographs, and pertinent information as official legal record",
        "Only radiographs without notes"
      ],
      correct: "C"
    },
    {
      id: 25590,
      question: "What should be separated in documentation?",
      options: [
        "Child\'s information from parent\'s information",
        "Medical history from dental history",
        "Facts from opinion",
        "Current findings from past findings"
      ],
      correct: "C"
    },
    {
      id: 25591,
      question: "What consent should be obtained for suspected maltreatment cases?",
      options: [
        "Special consent for reporting to authorities",
        "No consent is needed for documentation",
        "Usual consent for clinical photographic and radiographic needs",
        "Written consent from law enforcement"
      ],
      correct: "C"
    },
    {
      id: 25592,
      question: "What should be documented regarding CPS?",
      options: [
        "Nothing about reporting",
        "Only the phone number called",
        "The report made to local CPS agency",
        "Only the time of the call"
      ],
      correct: "C"
    },
    {
      id: 25593,
      question: "What power and control tactics overlap between bullying and IPV?",
      options: [
        "There is no overlap between them",
        "Only physical violence",
        "Aggressor exerting power over weaker individual, stalking, cyberstalking",
        "Only verbal harassment"
      ],
      correct: "C"
    },
    {
      id: 25594,
      question: "What is IPV defined as?",
      options: [
        "Only physical violence between strangers",
        "Only sexual assault by acquaintances",
        "Pattern of abusive behavior to gain or maintain power and control",
        "Only emotional abuse in marriages"
      ],
      correct: "C"
    },
    {
      id: 25595,
      question: "What types of couples can experience IPV?",
      options: [
        "Only married heterosexual couples",
        "Only dating teenagers",
        "Heterosexual or same-sex couples and dating relationships",
        "Only couples living together"
      ],
      correct: "C"
    },
    {
      id: 25596,
      question: "What proportion of US adults have experienced sexual violence, stalking, or IPV?",
      options: [
        "A small minority of the population",
        "Only females have these experiences",
        "Substantial proportion of female and male adults",
        "Only adults in urban areas"
      ],
      correct: "C"
    },
    {
      id: 25597,
      question: "What physical health consequences can result from IPV?",
      options: [
        "Only minor bruising",
        "Only psychological problems",
        "Lacerations, fractures, head trauma, STIs, chronic pain, unintended pregnancies",
        "Only temporary injuries"
      ],
      correct: "C"
    },
    {
      id: 25598,
      question: "What mental health consequences result from IPV?",
      options: [
        "Enhanced self-esteem",
        "Better coping skills",
        "Depression, anxiety, PTSD, suicide risk, poor self-esteem, memory loss",
        "Improved relationships"
      ],
      correct: "C"
    },
    {
      id: 25599,
      question: "What pregnancy outcomes are associated with IPV?",
      options: [
        "Better maternal health",
        "Easier deliveries",
        "Preterm birth, low birth weight, decreased gestational age, miscarriage",
        "Healthier babies"
      ],
      correct: "C"
    },
    {
      id: 25600,
      question: "What are leading causes of pregnancy-associated deaths in many US cities?",
      options: [
        "Complications of delivery",
        "Infections",
        "Suicide and violent homicide",
        "Hemorrhage"
      ],
      correct: "C"
    },
    {
      id: 25601,
      question: "When do intimate partner homicides of pregnant females commonly occur?",
      options: [
        "In the third trimester",
        "During labor and delivery",
        "In early stages of pregnancy",
        "Postpartum period only"
      ],
      correct: "C"
    },
    {
      id: 25602,
      question: "What should always be assessed regarding IPV screening?",
      options: [
        "Insurance coverage for treatment",
        "Legal representation available",
        "Safety of patient and refer to local resources",
        "Immigration status"
      ],
      correct: "C"
    },
    {
      id: 25603,
      question: "What is the risk for victims with one previous nonfatal strangulation?",
      options: [
        "Same risk as those never strangled",
        "Slightly elevated risk",
        "Seven times more likely to die by homicide",
        "Protected from future violence"
      ],
      correct: "C"
    },
    {
      id: 25604,
      question: "What should you do if patient denies abuse but you suspect IPV?",
      options: [
        "Pursue questioning aggressively",
        "Contact family members immediately",
        "Never put yourself or patient in jeopardy by forcing issue",
        "Call police during appointment"
      ],
      correct: "C"
    },
    {
      id: 25605,
      question: "What encompasses elder abuse broadly?",
      options: [
        "Only physical harm by caregivers",
        "Only financial exploitation",
        "Abuse, neglect, exploitation, contractor scams, self-neglect",
        "Only institutional neglect"
      ],
      correct: "C"
    },
    {
      id: 25606,
      question: "Who are perpetrators of institutional elder abuse?",
      options: [
        "Family members only",
        "Other residents",
        "Staff, professionals, or caregivers paid to provide care",
        "Visiting friends"
      ],
      correct: "C"
    },
    {
      id: 25607,
      question: "What is most common in elder adult maltreatment reports?",
      options: [
        "Physical abuse",
        "Sexual abuse",
        "Neglect",
        "Financial exploitation"
      ],
      correct: "C"
    },
    {
      id: 25608,
      question: "When is vulnerability to severe neglect highest in older adults?",
      options: [
        "When they are financially independent",
        "When they have large social networks",
        "When care needs increase, impairment is greater, income is lower",
        "When they live with family"
      ],
      correct: "C"
    },
    {
      id: 25609,
      question: "What forms of maltreatment are included in elder adult maltreatment?",
      options: [
        "Only physical and emotional abuse",
        "Only neglect and abandonment",
        "Physical, financial, emotional, sexual abuse, neglect, abandonment",
        "Only self-neglect"
      ],
      correct: "C"
    },
    {
      id: 25610,
      question: "What is self-neglect in older adults the result of?",
      options: [
        "Abuse by family members",
        "Caregiver abandonment",
        "Older adult\'s failure to address own self-care needs",
        "Institutional policies"
      ],
      correct: "C"
    },
    {
      id: 25611,
      question: "What makes maltreated older adults reluctant to report perpetrators?",
      options: [
        "Fear of losing independence only",
        "Embarrassment about situation only",
        "Dependency, loneliness, self-blame, guilt, fear, hopelessness, shame",
        "Concern about legal costs only"
      ],
      correct: "C"
    },
    {
      id: 25612,
      question: "What is mandated in every state regarding vulnerable adults?",
      options: [
        "Providing free healthcare",
        "Special housing arrangements",
        "Reporting abuse and neglect",
        "Financial assistance programs"
      ],
      correct: "C"
    },
    {
      id: 25613,
      question: "What amended the Trafficking Victims Protection Act in 2017?",
      options: [
        "CAPTA Reauthorization Act",
        "Justice for Victims of Trafficking Act",
        "Trafficking Victims Protection Reauthorization (TVPR) Act",
        "Comprehensive Addiction and Recovery Act"
      ],
      correct: "C"
    },
    {
      id: 25614,
      question: "What are the two types of human trafficking defined in US law?",
      options: [
        "Domestic and international trafficking",
        "Adult and child trafficking",
        "Sex trafficking and labor trafficking through force, fraud, or coercion",
        "Voluntary and involuntary trafficking"
      ],
      correct: "C"
    },
    {
      id: 25615,
      question: "Why do traffickers move victims to unknown places?",
      options: [
        "To find better employment opportunities",
        "To provide better living conditions",
        "To disorient, isolate from family/friends, and maintain control",
        "To comply with legal requirements"
      ],
      correct: "C"
    },
    {
      id: 25616,
      question: "What ensures trafficked individuals cannot form relationships?",
      options: [
        "Language barriers only",
        "Financial constraints only",
        "Limiting community connectivity and superficial public contact",
        "Geographic distance only"
      ],
      correct: "C"
    },
    {
      id: 25617,
      question: "What health issues result from violence in trafficking victims?",
      options: [
        "Only minor injuries",
        "Only psychological trauma",
        "Injuries from violence, trauma, infections of head/neck, dental/oral tissues",
        "Only sexually transmitted diseases"
      ],
      correct: "C"
    },
    {
      id: 25618,
      question: "What problems do labor trafficking victims experience?",
      options: [
        "Only financial problems",
        "Only minor fatigue",
        "Loss of body parts, head injuries, cough, lacerations, exhaustion",
        "Only legal problems"
      ],
      correct: "C"
    },
    {
      id: 25619,
      question: "What do tracked individuals often have regarding health?",
      options: [
        "Excellent health maintenance",
        "Regular preventive care",
        "Neglected issues like uncontrolled asthma, hypertension, diabetes, caries",
        "Complete medical insurance"
      ],
      correct: "C"
    },
    {
      id: 25620,
      question: "Why are trackers interested in cosmetic dental services?",
      options: [
        "To improve victim\'s self-esteem",
        "For victim\'s personal health",
        "To make victim more attractive to increase sales and profit",
        "To comply with health regulations"
      ],
      correct: "C"
    },
    {
      id: 25621,
      question: "Why do victims rarely self-identify and report victimization?",
      options: [
        "They enjoy the situation",
        "They don\'t know it\'s wrong",
        "Extensive power, control, and psychologic entrapment by traffickers",
        "They have legal immigration status"
      ],
      correct: "C"
    },
    {
      id: 25622,
      question: "What is a cardinal red flag in healthcare settings for trafficking?",
      options: [
        "Patient speaking foreign language",
        "Patient appearing nervous",
        "Third-party refusing to leave room and allow patient interaction alone",
        "Patient requesting specific services"
      ],
      correct: "C"
    },
    {
      id: 25623,
      question: "What is another sign tracker is not concerned with victim\'s health?",
      options: [
        "Arriving late to appointments",
        "Asking many questions",
        "Denying interpreter services in contradiction to professional recommendations",
        "Paying cash for services"
      ],
      correct: "C"
    },
    {
      id: 25624,
      question: "What should dental hygienists NOT do regarding trafficking?",
      options: [
        "Report suspicions to authorities",
        "Document observations",
        "Inquire about trafficking details, make promises, divulge address, offer to harbor person",
        "Assess for signs of abuse"
      ],
      correct: "C"
    },
    {
      id: 25625,
      question: "What approach should be used during screening for trafficking?",
      options: [
        "Aggressive questioning approach",
        "Judgmental interviewing style",
        "Trauma-informed approach building trust and demonstrating sensitivity",
        "Law enforcement interrogation techniques"
      ],
      correct: "C"
    },
    {
      id: 25626,
      question: "How many languages is the National Human Trafficking Hotline available in?",
      options: [
        "50 languages",
        "100 languages",
        "Over 200 languages",
        "English and Spanish only"
      ],
      correct: "C"
    },
    {
      id: 25627,
      question: "What should dental professionals be aware of regarding trafficked adults?",
      options: [
        "All will accept help immediately",
        "They have no fear of consequences",
        "Resistance to help may stem from fear of retaliation",
        "They can easily escape on their own"
      ],
      correct: "C"
    },
    {
      id: 25628,
      question: "What do state-established immunity laws protect?",
      options: [
        "Abusers from prosecution",
        "Victims from retaliation",
        "Reporters from civil or criminal penalties for good faith reports",
        "Healthcare facilities from lawsuits"
      ],
      correct: "C"
    },
    {
      id: 25629,
      question: "What is the duty of oral healthcare professionals if they suspect abuse?",
      options: [
        "Gather complete evidence to build case",
        "Investigate thoroughly before reporting",
        "Report suspicions to appropriate authority and document observations",
        "Confront suspected abuser directly"
      ],
      correct: "C"
    },
    {
      id: 25630,
      question: "What must the patient record document as a legal document?",
      options: [
        "Subjective opinions and assumptions",
        "Hearsay and rumors",
        "Objectively all findings and disclosures made by client",
        "Predicted future outcomes"
      ],
      correct: "C"
    },
    {
      id: 25631,
      question: "What agency provides intervention and treatment when maltreatment occurred?",
      options: [
        "Department of Education",
        "Health Department",
        "Child Protective Services (CPS)",
        "Department of Motor Vehicles"
      ],
      correct: "C"
    },
    {
      id: 25632,
      question: "Where is CPS frequently located?",
      options: [
        "Police departments",
        "Hospitals",
        "Within governmental social service agencies",
        "Schools"
      ],
      correct: "C"
    },
    {
      id: 25633,
      question: "Who do Adult Protective Services help?",
      options: [
        "All adults over 18",
        "Only low-income adults",
        "Elder adults and those unable to care for daily needs",
        "Only adults with disabilities"
      ],
      correct: "C"
    },
    {
      id: 25634,
      question: "What should you refer to for reporting requirements for elders and IPV?",
      options: [
        "Federal guidelines only",
        "Hospital policies",
        "Your state licensing board",
        "Professional association"
      ],
      correct: "C"
    },
    {
      id: 25635,
      question: "What hotline number can you call to report suspected abuse as emergency?",
      options: [
        "211",
        "311",
        "9-1-1",
        "811"
      ],
      correct: "C"
    }
  ],
  "6. Disability and Access to Care": [
    {
      id: 25600,
      question: "According to the Americans with Disabilities Act of 1990, which of the following best defines an individual with a disability?",
      options: [
        "A person who requires specialized medical equipment at all times",
        "A person who has a physical or mental impairment that substantially limits one or more major life activities",
        "A person who is unable to work in any capacity",
        "A person who lives in an institutional care facility"
      ],
      correct: "B"
    },
    {
      id: 25601,
      question: "What percentage of people in the United States are affected by disabilities?",
      options: [
        "Approximately 10% or 1 in 10 people",
        "Approximately 15% or 1 in 7 people",
        "Approximately 26% or 1 in 4 people",
        "Approximately 35% or 1 in 3 people"
      ],
      correct: "C"
    },
    {
      id: 25602,
      question: "Which of the following is an example of proper people-first language?",
      options: [
        "The disabled person in the wheelchair",
        "A handicapped individual with mobility issues",
        "Person with a disability who uses a wheelchair",
        "The wheelchair-bound patient with special needs"
      ],
      correct: "C"
    },
    {
      id: 25603,
      question: "The International Classification of Functioning, Disability and Health (ICF) framework aims to shift the model of health from which approach to which approach?",
      options: [
        "From a biopsychosocial model to an exclusive medical model",
        "From a social model to a purely biological model",
        "From an exclusive medical model to a biopsychosocial model",
        "From a psychological model to a purely physical model"
      ],
      correct: "C"
    },
    {
      id: 25604,
      question: "Which dimension of disability refers to difficulty in performing activities such as basic activities of daily living?",
      options: [
        "Participation restriction",
        "Activity limitation",
        "Environmental barrier",
        "Functional impairment"
      ],
      correct: "B"
    },
    {
      id: 25605,
      question: "What does DALY stand for in the context of measuring disability impact?",
      options: [
        "Disability Adjusted Life Years",
        "Daily Activity Limitation Years",
        "Disability Assessment and Limitation Yield",
        "Developmental Adjustment of Life Yields"
      ],
      correct: "A"
    },
    {
      id: 25606,
      question: "Which of the following is NOT listed as a major life activity in the ADA definition?",
      options: [
        "Self-care and walking",
        "Hearing and seeing",
        "Employment and income generation",
        "Learning and thinking"
      ],
      correct: "C"
    },
    {
      id: 25607,
      question: "Congenital disabilities are best described as:",
      options: [
        "Disabilities acquired after age 65 years",
        "Disabilities present at birth, which may or may not be genetic",
        "Disabilities resulting only from traumatic injury",
        "Disabilities diagnosed before age 22 that affect daily functioning"
      ],
      correct: "B"
    },
    {
      id: 25608,
      question: "Which federal act achieved the most significant outcomes in removing barriers for people with disabilities by guaranteeing non-discrimination?",
      options: [
        "The Patient Protection and Affordable Care Act",
        "The New Freedom Initiative of 2001",
        "Section 504 of the Rehabilitation Act of 1973 and the ADA",
        "The Olmstead Decision of 1999"
      ],
      correct: "C"
    },
    {
      id: 25609,
      question: "What is the primary reason adults with disabilities are three times more likely to have heart disease, stroke, diabetes, or cancer?",
      options: [
        "Genetic predisposition associated with disability conditions",
        "Health inequities and barriers to quality healthcare access",
        "Mandatory medication side effects",
        "Reduced physical activity requirements"
      ],
      correct: "B"
    },
    {
      id: 25610,
      question: "Which of the following is considered a health policy barrier for people with disabilities?",
      options: [
        "Limited training of healthcare providers",
        "Patient fear and embarrassment",
        "Affordability of healthcare services",
        "Communication difficulties"
      ],
      correct: "C"
    },
    {
      id: 25611,
      question: "What does \"reasonable accommodations\" refer to in employment contexts?",
      options: [
        "Special parking spaces reserved for employees with disabilities",
        "Modifications to a job or work environment enabling qualified individuals with disabilities to perform essential job functions",
        "Reduced work hours for all employees with any health condition",
        "Financial assistance provided by employers for medical expenses"
      ],
      correct: "B"
    },
    {
      id: 25612,
      question: "Disability inclusion refers to:",
      options: [
        "Mandatory employment quotas for people with disabilities",
        "Allowing people with disabilities to take advantage of the same health promotion and prevention activities as others",
        "Providing free healthcare services to all individuals with disabilities",
        "Creating separate health programs specifically designed only for people with disabilities"
      ],
      correct: "B"
    },
    {
      id: 25613,
      question: "Which of the following is an example of an attitudinal barrier faced by people with disabilities?",
      options: [
        "Lack of wheelchair ramps in buildings",
        "Stereotyping, stigma, prejudice, and discrimination",
        "High cost of assistive devices",
        "Limited public transportation options"
      ],
      correct: "B"
    },
    {
      id: 25614,
      question: "What communication adaptation should dental hygienists use for patients with visual impairments?",
      options: [
        "Speaking louder and more slowly",
        "Using manual interpretation like American Sign Language",
        "Using larger-sized printed health promotion messages",
        "Providing educational videos with captioning"
      ],
      correct: "C"
    },
    {
      id: 25615,
      question: "According to the ADA, which of the following must have barrier-free design?",
      options: [
        "Only new buildings constructed after 1990",
        "Only government-owned facilities",
        "All public facilities regardless of size or age",
        "Only healthcare facilities with more than 50 employees"
      ],
      correct: "C"
    },
    {
      id: 25616,
      question: "What is a significant transportation barrier for people with disabilities?",
      options: [
        "All public transportation systems completely lack accessibility features",
        "Difficulty with scheduling, fare payment, navigation, and weather exposure at boarding stops",
        "Federal regulations prohibit people with disabilities from using public transit",
        "Public transportation is unavailable in all urban areas"
      ],
      correct: "B"
    },
    {
      id: 25617,
      question: "Which type of assistive device helps replace, correct, or support a particular body part or function?",
      options: [
        "Mobility assistive equipment only",
        "Communication aids exclusively",
        "Prosthetic device",
        "Cognitive aids primarily"
      ],
      correct: "C"
    },
    {
      id: 25618,
      question: "When assessing a patient\'s ability to use oral self-care devices, what does \"range of motion\" evaluation determine?",
      options: [
        "How quickly the patient can move their hands",
        "The patient\'s ability to reach the oral cavity with arms and hands",
        "The strength of the patient\'s jaw muscles",
        "The patient\'s cognitive understanding of brushing techniques"
      ],
      correct: "B"
    },
    {
      id: 25619,
      question: "What is the ideal characteristic when customizing oral self-care assistive devices?",
      options: [
        "They should be expensive to ensure quality",
        "They should be lightweight, easy to use, readily available, and inexpensive",
        "They should be made only by occupational therapists",
        "They should be permanent and non-interchangeable"
      ],
      correct: "B"
    },
    {
      id: 25620,
      question: "Which material can be used to supplement a toothbrush handle for patients with limited grip strength?",
      options: [
        "Metal rods exclusively",
        "Glass attachments only",
        "Bicycle grips, styrofoam molds, or crafted compounds",
        "Rubber bands wrapped around the handle"
      ],
      correct: "C"
    },
    {
      id: 25621,
      question: "What does \"protective stabilization\" refer to in healthcare delivery?",
      options: [
        "Physical therapy exercises to improve patient balance",
        "Methods, devices, or equipment that immobilize or reduce a patient\'s ability to move freely",
        "Psychological counseling for anxious patients",
        "Medication used to calm patients before procedures"
      ],
      correct: "B"
    },
    {
      id: 25622,
      question: "Active stabilization involves:",
      options: [
        "Using mechanical devices like papoose boards",
        "Physical immobilization by another person such as a parent or healthcare professional",
        "Allowing the patient to stabilize themselves",
        "Using only pharmacological sedation"
      ],
      correct: "B"
    },
    {
      id: 25623,
      question: "Which of the following is an indication for using protective stabilization?",
      options: [
        "All patients with disabilities regardless of cooperation level",
        "Cooperative nonsedated patients requiring routine care",
        "A patient requiring immediate diagnosis who cannot cooperate due to medical, physical, or behavioral conditions",
        "Patients requesting protective stabilization for comfort"
      ],
      correct: "C"
    },
    {
      id: 25624,
      question: "What is a contraindication for protective stabilization?",
      options: [
        "Patients who experience uncontrolled movements during treatment",
        "Cooperative nonsedated patients",
        "Sedated patients who become uncooperative",
        "Patients requiring emergent care with safety risks"
      ],
      correct: "B"
    },
    {
      id: 25625,
      question: "Before using protective stabilization, what must healthcare professionals obtain?",
      options: [
        "Written permission from the facility administrator only",
        "Verbal agreement from any family member",
        "Informed consent with explanation of indications, benefits, risks, and alternatives",
        "Approval from the patient\'s insurance company"
      ],
      correct: "C"
    },
    {
      id: 25626,
      question: "What should be documented in the patient\'s record regarding protective stabilization?",
      options: [
        "Only the duration of application",
        "Indication, type used, informed consent, duration, behavior evaluation, outcomes, and future management implications",
        "Just the consent form signature",
        "Only any negative outcomes that occurred"
      ],
      correct: "B"
    },
    {
      id: 25627,
      question: "When using a mouth prop, what technique minimizes trauma to the patient?",
      options: [
        "Single fulcrum on the chin only",
        "Double fulcrum technique",
        "No fulcrum necessary",
        "Triple fulcrum on multiple teeth"
      ],
      correct: "B"
    },
    {
      id: 25628,
      question: "What should dental hygienists do before using a mouth prop?",
      options: [
        "Immediately insert it without examination",
        "Inspect the oral cavity for mobile teeth to prevent aspiration risks",
        "Apply topical anesthetic to all teeth",
        "Have the patient rinse with mouthwash"
      ],
      correct: "B"
    },
    {
      id: 25629,
      question: "Which mouth prop strength should be used first when indicated?",
      options: [
        "The hardest strength available",
        "Medium strength for all patients",
        "Soft mouth prop, upgrading if necessary",
        "Random selection based on availability"
      ],
      correct: "C"
    },
    {
      id: 25630,
      question: "What is the \"tell-show-do\" behavioral guidance technique?",
      options: [
        "Showing a video without explanation, then performing the procedure",
        "Verbally explaining procedures, demonstrating aspects, then completing the procedure without deviation",
        "Telling the patient to cooperate, showing consequences, then doing the treatment",
        "Asking the patient to tell you what they know, showing them they\'re wrong, then doing it correctly"
      ],
      correct: "B"
    },
    {
      id: 25631,
      question: "Which basic behavioral guidance technique involves rewarding desired behaviors to strengthen their recurrence?",
      options: [
        "Voice control",
        "Distraction",
        "Positive reinforcement and descriptive praise",
        "Memory restructuring"
      ],
      correct: "C"
    },
    {
      id: 25632,
      question: "When transferring a patient from a wheelchair, the dental chair should ideally be positioned:",
      options: [
        "At the same height as or slightly lower than the wheelchair",
        "Significantly higher than the wheelchair",
        "At the highest possible position",
        "In a fully reclined position"
      ],
      correct: "A"
    },
    {
      id: 25633,
      question: "What safety measure should be taken before wheelchair transfer?",
      options: [
        "Remove all dental equipment from the operatory",
        "Ensure the wheelchair locks into position",
        "Sedate the patient first",
        "Have at least five people present"
      ],
      correct: "B"
    },
    {
      id: 25634,
      question: "When performing a one-person wheelchair transfer, where should the patient\'s feet be positioned?",
      options: [
        "On the footrests of the wheelchair",
        "Together and held in place on either side by the operator\'s feet",
        "Dangling freely off the wheelchair",
        "Extended straight out in front"
      ],
      correct: "B"
    },
    {
      id: 25635,
      question: "During a two-person wheelchair transfer, who should coordinate the lift?",
      options: [
        "The patient should count and coordinate",
        "Any random person in the room",
        "The operator supporting the patient\'s torso who is lifting the most weight",
        "The operator holding the patient\'s legs"
      ],
      correct: "C"
    },
    {
      id: 25636,
      question: "What is the purpose of a transfer belt during wheelchair transfers?",
      options: [
        "To secure the patient to the wheelchair permanently",
        "To provide a designated location to hold the patient and prevent falls",
        "To measure the patient\'s waist size",
        "To restrict all patient movement"
      ],
      correct: "B"
    },
    {
      id: 25637,
      question: "When is a sliding board most useful during wheelchair transfers?",
      options: [
        "For all patients regardless of ability",
        "For patients with favorable upper body strength or who are overweight",
        "Only for pediatric patients",
        "When the patient refuses to cooperate"
      ],
      correct: "B"
    },
    {
      id: 25638,
      question: "To reduce aspiration risk during dental hygiene care, how should patients with disabilities be positioned?",
      options: [
        "In a fully supine flat position",
        "In a sitting position or as close to upright as possible",
        "On their side in a lateral position",
        "In a prone position face-down"
      ],
      correct: "B"
    },
    {
      id: 25639,
      question: "What alternative method can be used instead of the air-water syringe for patients at high aspiration risk?",
      options: [
        "Increased water irrigation",
        "Wet gauze towelettes to cleanse debris",
        "Dry brushing only with no moisture",
        "High-speed suction without any water"
      ],
      correct: "B"
    },
    {
      id: 25640,
      question: "Pressure injuries in people who use wheelchairs typically occur on which body sites?",
      options: [
        "Arms and hands exclusively",
        "Head and neck regions only",
        "Buttocks, shoulders, back, heels, and sacral tissues",
        "Chest and abdomen primarily"
      ],
      correct: "C"
    },
    {
      id: 25641,
      question: "How often should patients with disabilities be repositioned during dental care to prevent pressure injuries?",
      options: [
        "Every 5 minutes",
        "Every 20 minutes approximately",
        "Every 60 minutes",
        "Only once at the beginning and end"
      ],
      correct: "B"
    },
    {
      id: 25642,
      question: "If a patient cannot be transferred to the dental chair, what is an acceptable alternative?",
      options: [
        "Postpone all dental care indefinitely",
        "Provide dental treatment with the patient in the wheelchair and provider standing",
        "Refer the patient to a hospital operating room for all care",
        "Refuse to treat the patient"
      ],
      correct: "B"
    },
    {
      id: 25643,
      question: "Which device can be used in the dental setting to transfer patients who can stand unaided or with minimal assistance?",
      options: [
        "Papoose board only",
        "Standard sliding board exclusively",
        "Arjo Sara Stedy®",
        "Beanbag chair"
      ],
      correct: "C"
    },
    {
      id: 25644,
      question: "What should dental hygienists do if a patient experiences muscle spasms during transfer?",
      options: [
        "Continue the transfer without modification",
        "Use supportive pillows or beanbags and implement stress reduction protocols",
        "Immediately call emergency services",
        "Force the patient into position quickly"
      ],
      correct: "B"
    },
    {
      id: 25645,
      question: "The Plak-Vac Oral Suction Toothbrush is particularly beneficial for:",
      options: [
        "All patients regardless of condition",
        "Patients in hospitals or extended care facilities who need suction during brushing",
        "Only pediatric patients under age 5",
        "Patients who refuse traditional toothbrushes"
      ],
      correct: "B"
    },
    {
      id: 25646,
      question: "When assessing a patient\'s cognitive application for oral self-care, what should dental hygienists evaluate?",
      options: [
        "The patient\'s educational background and degrees",
        "The patient\'s ability to respond accurately to verbal commands and instructions",
        "The patient\'s income level",
        "The patient\'s family medical history"
      ],
      correct: "B"
    },
    {
      id: 25647,
      question: "What should dental hygienists provide to caregivers of patients who cannot perform oral self-care?",
      options: [
        "Written instructions only without demonstration",
        "Assessment of willingness to provide care, skill level evaluation, instruction, and address concerns",
        "A list of dental products to purchase",
        "Referral to another healthcare provider"
      ],
      correct: "B"
    },
    {
      id: 25648,
      question: "Which professional should dental hygienists work with interprofessionally to create customized oral self-care devices?",
      options: [
        "Physical therapist exclusively",
        "Occupational therapist",
        "Speech language pathologist only",
        "Pharmacist primarily"
      ],
      correct: "B"
    },
    {
      id: 25649,
      question: "Memory restructuring as a behavioral guidance technique involves:",
      options: [
        "Helping patients forget traumatic dental experiences completely",
        "Restructuring negative event memories into positive memories using suggested information after the event",
        "Testing the patient\'s ability to remember appointment times",
        "Requiring patients to memorize oral hygiene instructions"
      ],
      correct: "B"
    },
    {
      id: 25650,
      question: "What is the ask-tell-ask behavioral guidance technique?",
      options: [
        "Asking the patient\'s age, telling them the procedure, asking for payment",
        "Inquiring about the visit, explaining procedures, and inquiring again if the patient understands",
        "Asking permission, telling the patient to cooperate, asking them to leave if they don\'t",
        "Asking about insurance, telling the cost, asking for immediate payment"
      ],
      correct: "B"
    },
    {
      id: 25651,
      question: "Which legislation protects patients with disabilities against discriminatory practices by health insurance companies?",
      options: [
        "The Rehabilitation Act of 1973 exclusively",
        "The Olmstead Decision of 1999",
        "The Patient Bill of Rights under the Affordable Care Act",
        "The New Freedom Initiative of 2001"
      ],
      correct: "C"
    },
    {
      id: 25652,
      question: "Developmental disabilities are diagnosed before what age?",
      options: [
        "Before age 5 years",
        "Before age 12 years",
        "Before age 22 years",
        "Before age 30 years"
      ],
      correct: "C"
    },
    {
      id: 25653,
      question: "Which of the following is classified as a cardiovascular-related medical disability?",
      options: [
        "Fibromyalgia and gout",
        "Asthma and chronic bronchitis",
        "Angina and congenital heart defects",
        "Diabetes and hypoglycemia"
      ],
      correct: "C"
    },
    {
      id: 25654,
      question: "Examples of orthopedic-related disorders include:",
      options: [
        "HIV and mononucleosis",
        "Asthma and sleep apnea",
        "Rheumatoid arthritis and osteoporosis",
        "Epilepsy and migraine headaches"
      ],
      correct: "C"
    },
    {
      id: 25655,
      question: "Which of the following is categorized as a degenerative nervous system disorder?",
      options: [
        "Anxiety and depression",
        "Alzheimer disease and Parkinson disease",
        "Cerebral palsy and autism",
        "Diabetes and hyperthyroidism"
      ],
      correct: "B"
    },
    {
      id: 25656,
      question: "Military service disabilities may include:",
      options: [
        "Only physical injuries like limb amputation",
        "Limb amputation, eye injuries, hearing loss, neuralgia, traumatic brain injury, and cancer",
        "Exclusively mental health conditions",
        "Only conditions caused by combat exposure"
      ],
      correct: "B"
    },
    {
      id: 25657,
      question: "The ADA Amendment Act of 2008 broadened the scope of major life activities to include:",
      options: [
        "Employment and earning income",
        "Driving and operating vehicles",
        "Operation of major bodily functions like circulation and reproduction",
        "Recreational activities and hobbies"
      ],
      correct: "C"
    },
    {
      id: 25658,
      question: "What is a common misconception about individuals with disabilities?",
      options: [
        "They represent a diverse spectrum with different needs",
        "Most are capable of living in the community alone or with assistance",
        "They are sick, dependent, debilitated, or live in institutions",
        "Disabilities can be hidden or apparent on observation"
      ],
      correct: "C"
    },
    {
      id: 25659,
      question: "Which term should be avoided when referring to people with disabilities because it is considered insensitive?",
      options: [
        "Person with a disability",
        "Individual with special healthcare needs",
        "Handicapped",
        "Person with cognitive impairment"
      ],
      correct: "C"
    },
    {
      id: 25660,
      question: "What percentage of people with disabilities does disability affect worldwide?",
      options: [
        "Approximately 500 million people",
        "More than 1 billion people",
        "Approximately 250 million people",
        "Fewer than 100 million people"
      ],
      correct: "B"
    },
    {
      id: 25661,
      question: "According to the chapter, which is the most common barrier to healthcare for patients with disabilities?",
      options: [
        "Fear and embarrassment",
        "Lack of training of healthcare providers",
        "Access to healthcare",
        "Patient communication difficulties"
      ],
      correct: "C"
    },
    {
      id: 25662,
      question: "Why do some healthcare professionals choose not to treat patients with disabilities?",
      options: [
        "Legal liability concerns exclusively",
        "Medicare and Medicaid reimbursements not equivalent to typical fee schedules and extra time required",
        "They are prohibited by their professional licenses",
        "Lack of appropriate treatment rooms"
      ],
      correct: "B"
    },
    {
      id: 25663,
      question: "What should dental hygienists use for patients with auditory impairments?",
      options: [
        "Larger-sized printed materials",
        "Educational videos with captioning and manual interpretation like American Sign Language",
        "Speaking more loudly only",
        "Written instructions exclusively"
      ],
      correct: "B"
    },
    {
      id: 25664,
      question: "A building that is truly barrier-free must include:",
      options: [
        "Only wheelchair ramps at the entrance",
        "Only accessible restrooms inside",
        "Elevators, accessible restrooms, ramps, and electronically operated doors",
        "Designated parking spaces only"
      ],
      correct: "C"
    },
    {
      id: 25665,
      question: "Who is responsible for ensuring removal of barriers in existing buildings used as public accommodations?",
      options: [
        "Only the federal government",
        "Local disability advocacy groups",
        "People who own, lease, sublet, or operate places of public accommodation",
        "The patients with disabilities themselves"
      ],
      correct: "C"
    },
    {
      id: 25666,
      question: "What is an example of an assistive device for cognition?",
      options: [
        "Hearing aids and amplified telephones",
        "White cane and GPS navigation",
        "Task lists, picture schedules, and timer reminders",
        "Wheelchairs and crutches"
      ],
      correct: "C"
    },
    {
      id: 25667,
      question: "Examples of visual assistive devices include:",
      options: [
        "Communication cards with symbols",
        "Eyeglasses, magnifiers, and Braille systems",
        "Headphones and hearing loops",
        "Corner chairs and standing frames"
      ],
      correct: "B"
    },
    {
      id: 25668,
      question: "Mobility assistive equipment (MAE) examples include:",
      options: [
        "Only manual wheelchairs",
        "Walking sticks, crutches, canes, walkers, wheelchairs, scooters, prosthetics, and orthoses",
        "Eyeglasses and hearing aids",
        "Communication devices exclusively"
      ],
      correct: "B"
    },
    {
      id: 25669,
      question: "What challenge do people with disabilities face regarding mass transportation?",
      options: [
        "It is completely unavailable to them by law",
        "Difficulty interpreting schedules, finding fare, waiting in weather, boarding correct vehicle, and tracking stops",
        "They are prohibited from using all forms of public transit",
        "Mass transportation is only available in rural areas"
      ],
      correct: "B"
    },
    {
      id: 25670,
      question: "Why might families choose to provide care at home rather than institutionalize a person with severe disabilities?",
      options: [
        "Institutional care is always lower quality",
        "All institutions have closed permanently",
        "Long-term institutionalized care is too great a financial burden",
        "Home care is legally required"
      ],
      correct: "C"
    },
    {
      id: 25671,
      question: "What does the chapter recommend if asked to reproduce a removable facial prosthesis?",
      options: [
        "Remove it immediately upon patient arrival",
        "Remove only during assessment or when indicated, as patients may feel more comfortable with it in place",
        "Never remove it under any circumstances",
        "Photograph it extensively before removal"
      ],
      correct: "B"
    },
    {
      id: 25672,
      question: "When using rubber dam isolation for patients with disabilities, it is NOT recommended for:",
      options: [
        "Any patient who requests it",
        "Patients with significant dysphagia, compromised airway, or those who are aggressive/uncooperative",
        "Patients with mild anxiety",
        "Pediatric patients under age 12"
      ],
      correct: "B"
    },
    {
      id: 25673,
      question: "If a mouth prop inadvertently dislodges a mobile tooth that cannot be found, what is indicated?",
      options: [
        "Wait 24 hours to see if it appears",
        "A chest X-ray to rule out aspiration",
        "Immediate surgery",
        "No action is necessary"
      ],
      correct: "B"
    },
    {
      id: 25674,
      question: "Protective stabilization devices should be removed quickly in patients prone to:",
      options: [
        "Anxiety",
        "Seizures",
        "High blood pressure",
        "Diabetes"
      ],
      correct: "B"
    },
    {
      id: 25675,
      question: "What should be done with special padding from a wheelchair during transfer to the dental chair?",
      options: [
        "Leave it in the wheelchair",
        "Discard it before transfer",
        "Transfer it to the dental chair for patient comfort",
        "Send it to be cleaned"
      ],
      correct: "C"
    },
    {
      id: 25676,
      question: "The ideal position for the operator\'s hands when holding a mouth prop is:",
      options: [
        "With the hand on the same side as treatment",
        "With the hand opposite to the half of the mouth receiving treatment",
        "With both hands simultaneously",
        "Randomly with either hand"
      ],
      correct: "B"
    },
    {
      id: 25677,
      question: "When protecting the lower lip during mouth prop insertion, what technique should be used?",
      options: [
        "Apply lip balm first",
        "Gently pull the lower lip forward using index finger and thumb",
        "Have the patient bite down on gauze",
        "Use a lip retractor exclusively"
      ],
      correct: "B"
    },
    {
      id: 25678,
      question: "Where should a mouth prop be positioned in the patient\'s mouth?",
      options: [
        "Between the anterior teeth only",
        "Between the patient\'s posterior teeth which are built to withstand biting pressure",
        "On the tongue",
        "Against the soft palate"
      ],
      correct: "B"
    },
    {
      id: 25679,
      question: "What establishes the first fulcrum when using a mouth prop with double fulcrum technique?",
      options: [
        "The pinky finger on the patient\'s chin",
        "The ring finger on the gingiva buccal to the mandibular anterior sextant",
        "The thumb on the patient\'s cheek",
        "The index finger on the patient\'s forehead"
      ],
      correct: "B"
    },
    {
      id: 25680,
      question: "During a wheelchair transfer, what should the patient\'s head position be?",
      options: [
        "Looking straight ahead at the dental chair",
        "Resting over the operator\'s shoulder looking in the opposite direction of transfer",
        "Tilted back as far as possible",
        "Turned to watch the transfer process"
      ],
      correct: "B"
    },
    {
      id: 25681,
      question: "What lifting technique should dental hygienists use to prevent back injury during transfers?",
      options: [
        "Lift with the back while keeping legs straight",
        "Twist the back while lifting",
        "Lift with the legs while keeping the back straight",
        "Use only arm strength"
      ],
      correct: "C"
    },
    {
      id: 25682,
      question: "How should operators position their feet during a wheelchair transfer for good balance?",
      options: [
        "Close together",
        "Separated for good balance",
        "On tiptoes only",
        "Crossed at the ankles"
      ],
      correct: "B"
    },
    {
      id: 25683,
      question: "What should the operator do if the patient begins to fall during a transfer using a transfer belt?",
      options: [
        "Let go immediately",
        "Hold the designated location on the transfer belt",
        "Grab the patient\'s arms",
        "Step back quickly"
      ],
      correct: "B"
    },
    {
      id: 25684,
      question: "During a two-person lift, when should both operators lift the patient?",
      options: [
        "Whenever each operator feels ready",
        "At a prearranged signal coordinated by one person",
        "Simultaneously without communication",
        "One at a time in sequence"
      ],
      correct: "B"
    },
    {
      id: 25685,
      question: "After lowering a patient into the dental chair, when should the transfer belt be released?",
      options: [
        "Immediately before the patient touches the chair",
        "Not until the patient is placed securely in the chair",
        "During the lowering process",
        "Before the lift begins"
      ],
      correct: "B"
    },
    {
      id: 25686,
      question: "What should be done with the armrest of the dental chair after transfer?",
      options: [
        "Leave it removed permanently",
        "Reposition it for patient safety",
        "Discard it as unnecessary",
        "Store it in another room"
      ],
      correct: "B"
    },
    {
      id: 25687,
      question: "If a patient in a wheelchair is too tired or weak to transfer, what should be done?",
      options: [
        "Insist on transfer regardless",
        "Cancel the appointment",
        "Provide care with the patient in the wheelchair",
        "Refer to emergency services"
      ],
      correct: "C"
    },
    {
      id: 25688,
      question: "What can provide additional head support for a patient remaining in a wheelchair during care?",
      options: [
        "No support is necessary",
        "A portable headrest or turning the wheelchair so the head leans against the dental chair\'s headrest",
        "Having the patient hold their own head",
        "Using only pillows on the lap"
      ],
      correct: "B"
    },
    {
      id: 25689,
      question: "Beanbag chairs placed in the dental chair can provide additional support for patients with:",
      options: [
        "Perfect posture and balance",
        "Unstable joints and limbs",
        "No physical impairments",
        "Only pediatric patients"
      ],
      correct: "B"
    },
    {
      id: 25690,
      question: "When sitting at the 12 o\'clock position, how can the dental hygienist provide head stabilization?",
      options: [
        "Ask the patient to hold still",
        "Wrap the nondominant arm around the patient\'s head firmly under the chin",
        "Use only verbal commands",
        "No stabilization is possible from this position"
      ],
      correct: "B"
    },
    {
      id: 25691,
      question: "What can be placed on either side of the patient\'s head for additional support?",
      options: [
        "Dental instruments",
        "Small pillows, neck rolls, or rolled bath sheets",
        "Heavy textbooks",
        "Treatment equipment"
      ],
      correct: "B"
    },
    {
      id: 25692,
      question: "To prevent aspiration of materials during care, adequate suctioning should be maintained with:",
      options: [
        "The dental hygienist working alone",
        "The aid of other healthcare professionals when increased salivation or fluids are present",
        "No assistance ever needed",
        "Only automated suction devices"
      ],
      correct: "B"
    },
    {
      id: 25693,
      question: "What type of dentifrice can be a safe alternative for patients with neuromuscular or behavioral impairments?",
      options: [
        "Only prescription-strength fluoride",
        "Ingestible dentifrice",
        "Bleaching agents",
        "Abrasive polishing paste"
      ],
      correct: "B"
    },
    {
      id: 25694,
      question: "The voice control behavioral guidance technique involves:",
      options: [
        "Whispering to calm the patient",
        "Deliberate alterations of voice volume, tone, or pace to influence behavior",
        "Complete silence during treatment",
        "Speaking in a monotone voice only"
      ],
      correct: "B"
    },
    {
      id: 25695,
      question: "Distraction as a behavioral guidance technique can include:",
      options: [
        "Ignoring the patient completely",
        "Giving the patient a short break during stressful procedures",
        "Making loud noises",
        "Turning off all lights"
      ],
      correct: "B"
    },
    {
      id: 25696,
      question: "Direct observation as a behavioral guidance technique involves:",
      options: [
        "Staring at the patient continuously",
        "Showing the patient a video or permitting observation of a cooperative patient undergoing treatment",
        "Observing the patient without their knowledge",
        "Having the patient watch surgery videos"
      ],
      correct: "B"
    },
    {
      id: 25697,
      question: "Positive pre-visit imagery involves:",
      options: [
        "Having the patient imagine negative outcomes",
        "Showing positive images of dentistry in the waiting area before the appointment",
        "Displaying frightening images to prepare patients",
        "Showing no images at all"
      ],
      correct: "B"
    },
    {
      id: 25698,
      question: "Nonverbal communication as a behavioral guidance technique includes:",
      options: [
        "Never making eye contact",
        "Appropriate contact, posture, facial expression, and body language",
        "Crossing arms and turning away from patient",
        "Maintaining complete physical distance"
      ],
      correct: "B"
    },
    {
      id: 25699,
      question: "Parental presence or absence can be used to:",
      options: [
        "Punish uncooperative patients",
        "Gain cooperation for treatment while considering parents\' desires",
        "Always exclude parents regardless of circumstances",
        "Replace proper behavior guidance techniques"
      ],
      correct: "B"
    },
    {
      id: 25700,
      question: "What should healthcare professionals uphold when using protective stabilization?",
      options: [
        "Use the most restrictive techniques first",
        "Professional ethics and minimally restrictive techniques",
        "Maximum restraint for all patients",
        "No restrictions on technique selection"
      ],
      correct: "B"
    },
    {
      id: 25701,
      question: "Advanced formal education before using protective stabilization is:",
      options: [
        "Optional and not necessary",
        "Required for safe implementation",
        "Only needed for physicians",
        "Discouraged by regulatory bodies"
      ],
      correct: "B"
    },
    {
      id: 25702,
      question: "Healthcare professionals must closely attend to patients undergoing wheelchair transfers to:",
      options: [
        "Bill for additional time",
        "Prevent the risk for falling and injury",
        "Comply with documentation requirements only",
        "Supervise other staff members"
      ],
      correct: "B"
    },
    {
      id: 25703,
      question: "What should be used to redistribute pressure and prevent complications during wheelchair transfers?",
      options: [
        "Metal supports only",
        "Beanbags and pillows",
        "Hard wooden blocks",
        "No support is needed"
      ],
      correct: "B"
    },
    {
      id: 25704,
      question: "If informed consent cannot be obtained from a patient with cognitive impairment, consent should be obtained from:",
      options: [
        "Any staff member present",
        "Parents, legal guardians, or caregivers",
        "The dental hygienist\'s supervisor",
        "No consent is necessary"
      ],
      correct: "B"
    },
    {
      id: 25705,
      question: "Patients with disabilities are at increased risk for:",
      options: [
        "Never experiencing any health issues",
        "Being victims of violence, abuse, and/or neglect",
        "Receiving excessive healthcare services",
        "Having unlimited financial resources"
      ],
      correct: "B"
    },
    {
      id: 25706,
      question: "Healthcare professionals are obligated to:",
      options: [
        "Ignore signs of abuse to maintain privacy",
        "Report suspected cases of abuse and neglect to proper authorities",
        "Handle all abuse cases internally",
        "Wait for patients to report abuse themselves"
      ],
      correct: "B"
    },
    {
      id: 25707,
      question: "Original copies of written correspondence from other healthcare professionals should be:",
      options: [
        "Discarded after reading",
        "Maintained in the patient\'s chart",
        "Sent back to the original sender",
        "Kept separate from patient records"
      ],
      correct: "B"
    },
    {
      id: 25708,
      question: "If an adult patient is ambulatory, high-functioning, and without cognitive impairment, consent must be obtained:",
      options: [
        "From any family member",
        "Directly from the patient",
        "From the patient\'s employer",
        "From the healthcare facility administrator"
      ],
      correct: "B"
    },
    {
      id: 25709,
      question: "Patients should be:",
      options: [
        "Excluded from conversations with their caregivers",
        "Active participants in all conversations with caregivers",
        "Kept uninformed about their treatment",
        "Represented only by caregivers"
      ],
      correct: "B"
    },
    {
      id: 25710,
      question: "Healthcare professionals cannot discriminate against people with disabilities in:",
      options: [
        "Private homes only",
        "Places of public accommodation such as medical and dental establishments",
        "Only government facilities",
        "Educational institutions exclusively"
      ],
      correct: "B"
    },
    {
      id: 25711,
      question: "The ADA requires healthcare professionals to:",
      options: [
        "Provide treatment for free to all patients with disabilities",
        "Have alternative forms of communication including auxiliary aids and services",
        "Hire only staff members with disabilities",
        "Refuse treatment to patients who are difficult to communicate with"
      ],
      correct: "B"
    },
    {
      id: 25712,
      question: "How many people worldwide are affected by disability?",
      options: [
        "Approximately 500 million",
        "More than 1 billion",
        "Fewer than 100 million",
        "Exactly 750 million"
      ],
      correct: "B"
    }
  ],
  "7. Intellectual and Developmental Disabilities": [
    {
      id: 25700,
      question: "According to the DSM-5, what percentage of the world population is diagnosed with intellectual disability (ID)?",
      options: [
        "1% to 3%",
        "5% to 7%",
        "10% to 12%",
        "15% to 18%"
      ],
      correct: "A"
    },
    {
      id: 25701,
      question: "An intellectual disability must occur before what age?",
      options: [
        "Before age 12 years",
        "Before age 18 years",
        "Before age 21 years",
        "Before age 25 years"
      ],
      correct: "B"
    },
    {
      id: 25702,
      question: "Individuals with intellectual disabilities typically have an IQ of less than:",
      options: [
        "Less than 50",
        "Less than 60",
        "Less than 70",
        "Less than 80"
      ],
      correct: "C"
    },
    {
      id: 25703,
      question: "What is the average IQ range for the general population?",
      options: [
        "Between 70 and 90",
        "Between 81 and 108",
        "Between 90 and 120",
        "Between 100 and 130"
      ],
      correct: "B"
    },
    {
      id: 25704,
      question: "Mild intellectual disability represents approximately what percentage of the ID population?",
      options: [
        "Approximately 65%",
        "Approximately 75%",
        "Approximately 85%",
        "Approximately 95%"
      ],
      correct: "C"
    },
    {
      id: 25705,
      question: "What is the IQ range for mild intellectual disability?",
      options: [
        "Approximately 30 to 49",
        "Approximately 40 to 59",
        "Approximately 50 to 69",
        "Approximately 60 to 79"
      ],
      correct: "C"
    },
    {
      id: 25706,
      question: "Individuals with mild ID are designated as:",
      options: [
        "Trainable in basic self-care only",
        "Educable and able to acquire academic skills",
        "Requiring continuous supervision for all tasks",
        "Unable to live independently under any circumstances"
      ],
      correct: "B"
    },
    {
      id: 25707,
      question: "What is the IQ range for moderate intellectual disability?",
      options: [
        "Approximately 20 to 35",
        "Approximately 30 to 45",
        "Approximately 36 to 49",
        "Approximately 40 to 55"
      ],
      correct: "C"
    },
    {
      id: 25708,
      question: "Persons with moderate ID can acquire academic skills up to approximately what grade level?",
      options: [
        "Kindergarten level",
        "First-grade level",
        "Second-grade level",
        "Third-grade level"
      ],
      correct: "C"
    },
    {
      id: 25709,
      question: "What teaching method is most effective for patients with moderate ID?",
      options: [
        "Lecture-based instruction",
        "Written materials only",
        "Show-and-tell method",
        "Abstract conceptual learning"
      ],
      correct: "C"
    },
    {
      id: 25710,
      question: "What is the IQ range for severe intellectual disability?",
      options: [
        "Approximately 10 to 25",
        "Approximately 20 to 35",
        "Approximately 30 to 45",
        "Approximately 40 to 55"
      ],
      correct: "B"
    },
    {
      id: 25711,
      question: "Individuals with severe ID learn best through:",
      options: [
        "Abstract reasoning exercises",
        "Habit training with continuous repetition",
        "Independent study methods",
        "Written instructional materials"
      ],
      correct: "B"
    },
    {
      id: 25712,
      question: "What is the IQ level for profound intellectual disability?",
      options: [
        "Less than 10",
        "Less than 15",
        "Less than 20",
        "Less than 25"
      ],
      correct: "C"
    },
    {
      id: 25713,
      question: "People with profound ID are:",
      options: [
        "Capable of independent living with minimal support",
        "Able to work in sheltered workshop environments",
        "Incapable of total self-care and require continual supervision",
        "Able to perform all self-care with verbal prompting only"
      ],
      correct: "C"
    },
    {
      id: 25714,
      question: "Approximately what percentage of IDs have genetic biologic factors as their cause?",
      options: [
        "Approximately 5%",
        "Approximately 15%",
        "Approximately 25%",
        "Approximately 35%"
      ],
      correct: "B"
    },
    {
      id: 25715,
      question: "Down syndrome is an example of which type of chromosomal disturbance?",
      options: [
        "Metabolic disorder affecting 5% of ID cases",
        "Chromosomal disturbance affecting 10% of ID cases",
        "Psychosocial factor affecting 15% of ID cases",
        "Postnatal cause affecting 20% of ID cases"
      ],
      correct: "B"
    },
    {
      id: 25716,
      question: "Phenylketonuria causes intellectual disability through:",
      options: [
        "Chromosomal deletion during conception",
        "Oxygen deprivation during birth",
        "Abnormal accumulation of phenylalanine toxic to the brain",
        "Infection during the prenatal period"
      ],
      correct: "C"
    },
    {
      id: 25717,
      question: "What is the most common type of ID due to genetic factors?",
      options: [
        "Down syndrome",
        "Prader-Willi syndrome",
        "Fragile X syndrome",
        "Phenylketonuria"
      ],
      correct: "C"
    },
    {
      id: 25718,
      question: "Fragile X syndrome causes changes in which gene?",
      options: [
        "Chromosome 21 gene",
        "Chromosome 15 gene",
        "Fragile X messenger ribonucleoprotein gene",
        "Phenylalanine hydroxylase gene"
      ],
      correct: "C"
    },
    {
      id: 25719,
      question: "Prader-Willi syndrome occurs from deletion of part of which chromosome?",
      options: [
        "Chromosome 13",
        "Chromosome 15",
        "Chromosome 18",
        "Chromosome 21"
      ],
      correct: "B"
    },
    {
      id: 25720,
      question: "What percentage of IDs occur during the prenatal period?",
      options: [
        "Approximately 22%",
        "Approximately 32%",
        "Approximately 42%",
        "Approximately 52%"
      ],
      correct: "B"
    },
    {
      id: 25721,
      question: "Which of the following is a prenatal cause of intellectual disability?",
      options: [
        "Premature birth and hypoxemia",
        "Head trauma during delivery",
        "Maternal rubella infection",
        "Childhood meningitis"
      ],
      correct: "C"
    },
    {
      id: 25722,
      question: "Fetal alcohol spectrum disorder occurs due to:",
      options: [
        "Genetic chromosomal abnormality",
        "Exposure to alcohol before birth",
        "Maternal infection during pregnancy",
        "Birth trauma and hypoxemia"
      ],
      correct: "B"
    },
    {
      id: 25723,
      question: "The term \"perinatal\" refers to:",
      options: [
        "The time before conception",
        "The first trimester of pregnancy only",
        "The time immediately before, during, and after birth",
        "The first year after birth"
      ],
      correct: "C"
    },
    {
      id: 25724,
      question: "Which of the following is a perinatal cause of intellectual disability?",
      options: [
        "Maternal rubella infection",
        "Fetal alcohol exposure",
        "Hypoxemia due to intracranial hemorrhage",
        "Childhood encephalitis"
      ],
      correct: "C"
    },
    {
      id: 25725,
      question: "Kernicterus causes intellectual disability through:",
      options: [
        "Oxygen deprivation to the brain",
        "Toxic accumulation of bilirubin in the brain",
        "Viral infection of brain tissue",
        "Chromosomal abnormality"
      ],
      correct: "B"
    },
    {
      id: 25726,
      question: "What percentage of IDs occur during the postnatal period?",
      options: [
        "Approximately 2%",
        "Approximately 4%",
        "Approximately 6%",
        "Approximately 8%"
      ],
      correct: "B"
    },
    {
      id: 25727,
      question: "Which of the following is a postnatal cause of intellectual disability?",
      options: [
        "Maternal diabetes",
        "Premature birth",
        "Brain infections like meningitis",
        "Fetal alcohol exposure"
      ],
      correct: "C"
    },
    {
      id: 25728,
      question: "Psychosocial causes of ID include:",
      options: [
        "Chromosomal abnormalities present at birth",
        "Maternal infections during pregnancy",
        "Environment void of sensory and intellectual stimulation",
        "Birth trauma and oxygen deprivation"
      ],
      correct: "C"
    },
    {
      id: 25729,
      question: "Persons with ID typically demonstrate which health-related ability characteristic?",
      options: [
        "Enhanced physical stamina and advanced development",
        "Less physical stamina and delayed physical development",
        "Normal physical development with advanced speech",
        "Enhanced motor coordination and vision"
      ],
      correct: "B"
    },
    {
      id: 25730,
      question: "Which mental and motor ability is characteristic of persons with ID?",
      options: [
        "Enhanced memory and concentration abilities",
        "Advanced abstract reasoning skills",
        "Short memories and inability to concentrate",
        "Superior organizational and adaptive skills"
      ],
      correct: "C"
    },
    {
      id: 25731,
      question: "Persons with ID are typically more adept with:",
      options: [
        "Abstract experiences than concrete experiences",
        "Academic skills than manual skills",
        "Conceptual learning than hands-on activities",
        "Manual skills than academic skills"
      ],
      correct: "D"
    },
    {
      id: 25732,
      question: "In social and emotional abilities, persons with ID are typically:",
      options: [
        "Leaders rather than followers",
        "Followers rather than leaders",
        "Independent decision makers",
        "Resistant to imitating others"
      ],
      correct: "B"
    },
    {
      id: 25733,
      question: "Self-injurious behaviors (SIBs) include:",
      options: [
        "Seeking attention through appropriate means",
        "Head banging, self-biting, and bruxism",
        "Enhanced communication skills",
        "Cooperative social interactions"
      ],
      correct: "B"
    },
    {
      id: 25734,
      question: "SIB has been viewed as:",
      options: [
        "A permanent developmental milestone",
        "An early developmental stress response that disappears in typically developing children",
        "Normal behavior in all children",
        "A learned behavior from caregivers"
      ],
      correct: "B"
    },
    {
      id: 25735,
      question: "What oral manifestation is commonly associated with bruxism in persons with ID?",
      options: [
        "Enhanced enamel formation",
        "Tooth surface abrasion and attrition",
        "Accelerated tooth eruption",
        "Increased salivary flow"
      ],
      correct: "B"
    },
    {
      id: 25736,
      question: "Bruxism is linked to:",
      options: [
        "Enhanced physical development",
        "Improved sleep patterns",
        "Anxiety and emotional distress",
        "Increased calcium intake"
      ],
      correct: "C"
    },
    {
      id: 25737,
      question: "By what age does wear from bruxism become significant enough to require restorative measures?",
      options: [
        "By age 10 to 19 years",
        "By age 20 to 29 years",
        "By age 30 to 49 years",
        "By age 50 to 60 years"
      ],
      correct: "C"
    },
    {
      id: 25738,
      question: "What percentage of individuals with ID experience dental caries?",
      options: [
        "Approximately 12%",
        "Approximately 22%",
        "Approximately 32%",
        "Approximately 42%"
      ],
      correct: "C"
    },
    {
      id: 25739,
      question: "What percentage of individuals with ID experience periodontitis?",
      options: [
        "Approximately 60%",
        "Approximately 70%",
        "Approximately 80%",
        "Approximately 90%"
      ],
      correct: "C"
    },
    {
      id: 25740,
      question: "Periodontal disease and untreated dental caries in persons with ID are attributed to:",
      options: [
        "Enhanced immune system function",
        "Lack of professional care, funds, poor oral hygiene, and caregiver knowledge",
        "Genetic resistance to bacterial infections",
        "Excessive fluoride exposure"
      ],
      correct: "B"
    },
    {
      id: 25741,
      question: "What is the most commonly used behavioral treatment for SIB?",
      options: [
        "Punishment and isolation",
        "Medication-only approach",
        "Differential reinforcement of another behavior",
        "Ignoring all behaviors completely"
      ],
      correct: "C"
    },
    {
      id: 25742,
      question: "What should dental hygienists give patients holding during procedures to prevent mouth-striking SIB?",
      options: [
        "Sharp instruments to maintain focus",
        "Nothing, as hands should be restrained",
        "Cotton rolls, mirrors, or something to assemble",
        "Food items to keep them occupied"
      ],
      correct: "C"
    },
    {
      id: 25743,
      question: "Which type of reward is considered a social reward for patients with ID?",
      options: [
        "Money and material possessions",
        "Attention, smiles, hugs, and praise",
        "Food and clothing items",
        "Electronic devices and toys"
      ],
      correct: "B"
    },
    {
      id: 25744,
      question: "Activity rewards for patients with ID include:",
      options: [
        "Verbal praise and affection only",
        "Monetary compensation",
        "Watching television, playing games, or going to a party",
        "Medical treatments and therapies"
      ],
      correct: "C"
    },
    {
      id: 25745,
      question: "When assessing patients with ID, dental hygienists should collect data about:",
      options: [
        "Only the patient\'s financial status",
        "Skills of daily living, self-care potential, and cooperation level",
        "Only the caregiver\'s educational background",
        "The patient\'s employment history exclusively"
      ],
      correct: "B"
    },
    {
      id: 25746,
      question: "What oral hygiene device is particularly beneficial for patients in hospitals or extended care facilities?",
      options: [
        "Standard manual toothbrush only",
        "Plak-Vac Oral Suction Toothbrush",
        "Unwaxed dental floss exclusively",
        "Wooden interdental stimulators"
      ],
      correct: "B"
    },
    {
      id: 25747,
      question: "For patients with mild ID, which oral hygiene aids can be used?",
      options: [
        "No aids are appropriate",
        "Only manual toothbrushes",
        "Oral irrigators, interdental aids, and disclosing tablets",
        "Professional cleaning instruments only"
      ],
      correct: "C"
    },
    {
      id: 25748,
      question: "Patients with moderate ID can usually manipulate:",
      options: [
        "Complex manual dexterity instruments",
        "A power toothbrush with repetitive training",
        "No oral hygiene devices independently",
        "Only dental floss without assistance"
      ],
      correct: "B"
    },
    {
      id: 25749,
      question: "For patients with severe ID, emphasis is on:",
      options: [
        "Complete independence in all oral care",
        "As much self-care as possible with caregiver follow-up",
        "No patient involvement in oral care",
        "Professional care only without home care"
      ],
      correct: "B"
    },
    {
      id: 25750,
      question: "Patients with profound ID depend on caregivers for oral cleansing and require emphasis on:",
      options: [
        "Independent skill development exclusively",
        "Academic learning of oral hygiene concepts",
        "Acceptance of oral hygiene procedures through nonverbal communication",
        "Competitive performance with peers"
      ],
      correct: "C"
    },
    {
      id: 25751,
      question: "Research shows those with severe and profound ID may require:",
      options: [
        "Only routine dental care in standard settings",
        "No professional dental care",
        "Professional care under general anesthesia",
        "Self-administered care without supervision"
      ],
      correct: "C"
    },
    {
      id: 25752,
      question: "When working with patients with hearing impairments, what type of cues work best?",
      options: [
        "Auditory cues exclusively",
        "Visual cues",
        "Olfactory cues only",
        "No cues are effective"
      ],
      correct: "B"
    },
    {
      id: 25753,
      question: "For patients who are visually impaired, which cues are most effective?",
      options: [
        "Visual cues only",
        "No cues work effectively",
        "Tactile and auditory cues",
        "Written instructions exclusively"
      ],
      correct: "C"
    },
    {
      id: 25754,
      question: "How can a hypersensitive gag reflex be managed?",
      options: [
        "Placing patient flat and using excessive toothpaste",
        "Placing patient in semisupine position and eliminating toothpaste use",
        "Using only horizontal patient positioning",
        "Increasing the amount of water used"
      ],
      correct: "B"
    },
    {
      id: 25755,
      question: "When problems arise during oral care, dental hygienists should:",
      options: [
        "Discontinue all care permanently",
        "Force the patient to continue",
        "Repeat an earlier achievement level to meet freedom from fear",
        "Refer to emergency services immediately"
      ],
      correct: "C"
    },
    {
      id: 25756,
      question: "Down syndrome occurs in approximately how many live births?",
      options: [
        "1 out of every 500 live births",
        "1 out of every 650 live births",
        "1 out of every 772 live births",
        "1 out of every 1000 live births"
      ],
      correct: "C"
    },
    {
      id: 25757,
      question: "How many babies are diagnosed with Down syndrome each year in the United States?",
      options: [
        "Approximately 3100 babies",
        "Approximately 4100 babies",
        "Approximately 5100 babies",
        "Approximately 6100 babies"
      ],
      correct: "C"
    },
    {
      id: 25758,
      question: "The life expectancy of an individual with Down syndrome is approximately:",
      options: [
        "Approximately 40 years of age",
        "Approximately 50 years of age",
        "Approximately 60 years of age",
        "Approximately 70 years of age"
      ],
      correct: "C"
    },
    {
      id: 25759,
      question: "Trisomy 21 results from:",
      options: [
        "Deletion of chromosome 21",
        "Failure of chromosome 21 pair to segregate during egg or sperm formation",
        "Addition of chromosome 15",
        "Translocation of chromosome 14"
      ],
      correct: "B"
    },
    {
      id: 25760,
      question: "Trisomy 21 occurs in what percentage of people with Down syndrome?",
      options: [
        "Approximately 75%",
        "Approximately 85%",
        "Approximately 95%",
        "Approximately 100%"
      ],
      correct: "C"
    },
    {
      id: 25761,
      question: "Because of high fertility rates in younger women, what percentage of babies with Down syndrome are born to mothers under age 35?",
      options: [
        "Approximately 31%",
        "Approximately 41%",
        "Approximately 51%",
        "Approximately 61%"
      ],
      correct: "C"
    },
    {
      id: 25762,
      question: "Translocation in Down syndrome occurs when:",
      options: [
        "An entire extra chromosome 21 is present",
        "A piece of chromosome 21 breaks off and attaches to another chromosome",
        "Part of chromosome 15 is deleted",
        "Chromosomes fail to separate during formation"
      ],
      correct: "B"
    },
    {
      id: 25763,
      question: "Translocation most commonly involves chromosome 21 attaching to which chromosome?",
      options: [
        "Chromosome 13",
        "Chromosome 14",
        "Chromosome 15",
        "Chromosome 18"
      ],
      correct: "B"
    },
    {
      id: 25764,
      question: "Translocation occurs in what percentage of children with Down syndrome?",
      options: [
        "Approximately 1%",
        "Approximately 2%",
        "Approximately 3%",
        "Approximately 5%"
      ],
      correct: "C"
    },
    {
      id: 25765,
      question: "Mosaicism occurs in what percentage of children with Down syndrome?",
      options: [
        "Approximately 1%",
        "Approximately 2%",
        "Approximately 5%",
        "Approximately 10%"
      ],
      correct: "B"
    },
    {
      id: 25766,
      question: "Mosaicism in Down syndrome results from:",
      options: [
        "Maternal age over 35 years",
        "An error in one of the first cell divisions shortly after conception",
        "Exposure to environmental toxins",
        "Viral infection during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 25767,
      question: "The person\'s head with Down syndrome is usually:",
      options: [
        "Enlarged with increased anterior-posterior diameter",
        "Normal size with typical proportions",
        "Small and shortened in anterior-posterior diameter",
        "Elongated from forehead to crown"
      ],
      correct: "C"
    },
    {
      id: 25768,
      question: "The eyes of persons with Down syndrome have:",
      options: [
        "Downward slant without folds",
        "Upward slant and prominent epicanthal folds",
        "Normal appearance without distinguishing features",
        "Wide-set appearance without Brushfield spots"
      ],
      correct: "B"
    },
    {
      id: 25769,
      question: "Brushfield spots are found in which part of the eye?",
      options: [
        "The cornea",
        "The retina",
        "The iris",
        "The sclera"
      ],
      correct: "C"
    },
    {
      id: 25770,
      question: "The nose in persons with Down syndrome is typically:",
      options: [
        "Enlarged with prominent bridge",
        "Normal in size and structure",
        "Recessed, reduced in size, with upturned nostrils",
        "Elongated with downturned nostrils"
      ],
      correct: "C"
    },
    {
      id: 25771,
      question: "The most frequently observed characteristic of Down syndrome is:",
      options: [
        "Enlarged facial features",
        "Flat facial profile",
        "Protruding forehead",
        "Elongated nose"
      ],
      correct: "B"
    },
    {
      id: 25772,
      question: "Persons with Down syndrome tend to be:",
      options: [
        "Tall and underweight",
        "Average height and weight",
        "Short and overweight",
        "Tall and overweight"
      ],
      correct: "C"
    },
    {
      id: 25773,
      question: "The IQ range for persons with Down syndrome is typically:",
      options: [
        "Between 10 and 50",
        "Between 20 and 85",
        "Between 30 and 95",
        "Between 40 and 100"
      ],
      correct: "B"
    },
    {
      id: 25774,
      question: "What percentage of children with Down syndrome have congenital heart disease?",
      options: [
        "20% to 30%",
        "30% to 40%",
        "40% to 60%",
        "60% to 80%"
      ],
      correct: "C"
    },
    {
      id: 25775,
      question: "The most common congenital heart defect in Down syndrome detected by echocardiogram is:",
      options: [
        "Ventricular septal defects only",
        "Atrioventricular septal defects",
        "Patent ductus arteriosus only",
        "Atrial septal defects only"
      ],
      correct: "B"
    },
    {
      id: 25776,
      question: "Pulmonary artery hypertension in Down syndrome is characterized by:",
      options: [
        "Dilation of blood vessels in the lungs",
        "Decreased blood flow to the lungs",
        "Constriction of blood vessels in the lungs",
        "Normal pressure in pulmonary circulation"
      ],
      correct: "C"
    },
    {
      id: 25777,
      question: "When providing care for patients with Down syndrome and cardiac abnormalities, dental hygienists may need to provide:",
      options: [
        "No special considerations",
        "Prophylactic antibiotic premedication when indicated",
        "Antiviral medications before treatment",
        "Sedation for all procedures"
      ],
      correct: "B"
    },
    {
      id: 25778,
      question: "Atlantoaxial instability is found in what percentage of younger individuals with Down syndrome?",
      options: [
        "5% to 10%",
        "10% to 20%",
        "20% to 30%",
        "30% to 40%"
      ],
      correct: "B"
    },
    {
      id: 25779,
      question: "Atlantoaxial instability is characterized by:",
      options: [
        "Decreased mobility in the shoulder joint",
        "Abnormal increase in mobility between the first two cervical vertebrae",
        "Fusion of cervical vertebrae",
        "Decreased range of motion in the neck"
      ],
      correct: "B"
    },
    {
      id: 25780,
      question: "Symptoms of atlantoaxial instability include:",
      options: [
        "Enhanced flexibility and strength",
        "Neck pain, abnormal gait, and limited neck movement",
        "Improved coordination and balance",
        "Increased muscle tone and reflexes"
      ],
      correct: "B"
    },
    {
      id: 25781,
      question: "As many as what percentage of older individuals with Down syndrome have thyroid disorders?",
      options: [
        "Approximately 14%",
        "Approximately 24%",
        "Approximately 34%",
        "Approximately 44%"
      ],
      correct: "B"
    },
    {
      id: 25782,
      question: "The most common thyroid disorder in Down syndrome is:",
      options: [
        "Hyperthyroidism",
        "Hypothyroidism",
        "Thyroid cancer",
        "Goiter"
      ],
      correct: "B"
    },
    {
      id: 25783,
      question: "Classic symptoms of hypothyroidism include:",
      options: [
        "Weight loss, increased energy, and rapid growth",
        "Delayed growth, short stature, obesity, and lethargy",
        "Enhanced metabolism and hyperactivity",
        "Increased body temperature and anxiety"
      ],
      correct: "B"
    },
    {
      id: 25784,
      question: "Hearing loss in persons with Down syndrome is often caused by:",
      options: [
        "Genetic nerve damage exclusively",
        "Persistent fluid in middle ear and chronic ear infections",
        "Exposure to loud noises",
        "Medication side effects only"
      ],
      correct: "B"
    },
    {
      id: 25785,
      question: "At what age do generalized tonic-clonic seizures become more frequent in persons with Down syndrome?",
      options: [
        "Age 10 to 15 years",
        "Age 15 to 20 years",
        "Age 20 to 30 years",
        "Age 30 to 40 years"
      ],
      correct: "C"
    },
    {
      id: 25786,
      question: "Gingival enlargement in persons with Down syndrome is particularly significant when caused by:",
      options: [
        "Poor oral hygiene alone",
        "Medications for seizure control",
        "Nutritional deficiencies only",
        "Genetic factors exclusively"
      ],
      correct: "B"
    },
    {
      id: 25787,
      question: "Adults with Down syndrome older than 40 years of age almost universally show anatomic changes similar to:",
      options: [
        "Parkinson disease",
        "Multiple sclerosis",
        "Alzheimer disease",
        "Huntington disease"
      ],
      correct: "C"
    },
    {
      id: 25788,
      question: "The tongue of a person with Down syndrome often appears enlarged due to:",
      options: [
        "True macroglossia from muscle hypertrophy",
        "Underdeveloped maxilla and small oral cavity space",
        "Excessive tongue growth",
        "Inflammation from infection"
      ],
      correct: "B"
    },
    {
      id: 25789,
      question: "Tongue fissures are observed in what percentage of persons with Down syndrome?",
      options: [
        "17% to 30%",
        "27% to 40%",
        "37% to 60%",
        "47% to 70%"
      ],
      correct: "C"
    },
    {
      id: 25790,
      question: "Good daily oral hygiene for persons with Down syndrome should include:",
      options: [
        "Brushing teeth once daily without additional products",
        "Tongue brushing and antimicrobial dentifrice/mouth rinse",
        "Only professional cleaning without home care",
        "No tongue cleaning to avoid discomfort"
      ],
      correct: "B"
    },
    {
      id: 25791,
      question: "Approximately what percentage of persons with Down syndrome have obstructive sleep apnea?",
      options: [
        "Approximately 25%",
        "Approximately 35%",
        "Approximately 45%",
        "Approximately 55%"
      ],
      correct: "C"
    },
    {
      id: 25792,
      question: "Obstructive sleep apnea in Down syndrome results from:",
      options: [
        "Enhanced muscle tone and large airways",
        "Flattened midfaces, narrowed nasopharyngeal areas, and enlarged tongues",
        "Normal facial structure with behavioral issues",
        "Genetic factors unrelated to anatomy"
      ],
      correct: "B"
    },
    {
      id: 25793,
      question: "In children with Down syndrome, all teeth except which ones are typically reduced in size?",
      options: [
        "Mandibular canines and premolars",
        "Maxillary first molars and mandibular incisors",
        "Maxillary canines and premolars",
        "Mandibular molars exclusively"
      ],
      correct: "B"
    },
    {
      id: 25794,
      question: "The most frequently affected permanent teeth in the maxillary arch of persons with Down syndrome are:",
      options: [
        "Central incisors and canines only",
        "Second molars, lateral incisors, canines, and first molars",
        "Premolars exclusively",
        "Third molars only"
      ],
      correct: "B"
    },
    {
      id: 25795,
      question: "In the mandibular arch of persons with Down syndrome, which teeth are most commonly affected by size reduction?",
      options: [
        "Incisors and canines",
        "First and second premolars",
        "First and second molars",
        "Third molars only"
      ],
      correct: "B"
    },
    {
      id: 25796,
      question: "Tetracycline staining in persons with Down syndrome may be evident as a result of:",
      options: [
        "Poor oral hygiene practices",
        "Genetic enamel defects only",
        "Early childhood infections requiring antibiotic therapy",
        "Excessive fluoride exposure"
      ],
      correct: "C"
    },
    {
      id: 25797,
      question: "The increased incidence of congenitally missing permanent teeth in Down syndrome is:",
      options: [
        "5% to 15%",
        "15% to 25%",
        "25% to 50%",
        "50% to 75%"
      ],
      correct: "C"
    },
    {
      id: 25798,
      question: "The most frequently missing permanent teeth in persons with Down syndrome are:",
      options: [
        "Maxillary central incisors",
        "Mandibular second premolars and lateral incisors",
        "Maxillary canines",
        "Mandibular first molars"
      ],
      correct: "B"
    },
    {
      id: 25799,
      question: "Malocclusion seen frequently in Down syndrome includes:",
      options: [
        "Maxillary overjet and anterior crossbite",
        "Mandibular overjet and posterior crossbite",
        "Perfect occlusion with no deviations",
        "Only anterior open bite"
      ],
      correct: "B"
    },
    {
      id: 25800,
      question: "Why is correction of malocclusion usually not indicated in Down syndrome?",
      options: [
        "It is always successful and recommended",
        "Earlier tissue breakdown may occur due to underdeveloped maxilla",
        "Patients always refuse orthodontic treatment",
        "Malocclusion improves naturally with age"
      ],
      correct: "B"
    },
    {
      id: 25801,
      question: "When does periodontal disease typically begin in individuals with Down syndrome?",
      options: [
        "As early as age 2 years",
        "As early as age 6 years",
        "As early as age 12 years",
        "As early as age 18 years"
      ],
      correct: "B"
    },
    {
      id: 25802,
      question: "By adulthood, what percentage of people with Down syndrome are affected by periodontal disease?",
      options: [
        "Approximately 50%",
        "Approximately 70%",
        "Nearly all (close to 100%)",
        "Approximately 30%"
      ],
      correct: "C"
    },
    {
      id: 25803,
      question: "The high incidence of periodontal disease in Down syndrome is a function of:",
      options: [
        "Poor oral hygiene alone",
        "Associated immunodeficiency and impaired host defense",
        "Excessive plaque accumulation only",
        "Genetic factors exclusively"
      ],
      correct: "B"
    },
    {
      id: 25804,
      question: "Tooth loss attributed to periodontal disease occurs in what percentage of individuals with Down syndrome?",
      options: [
        "About 20%",
        "About 30%",
        "About 40%",
        "About 50%"
      ],
      correct: "D"
    },
    {
      id: 25805,
      question: "Generally, persons with Down syndrome are:",
      options: [
        "Aggressive and difficult to manage",
        "Content and affectionate",
        "Withdrawn and uncommunicative",
        "Hostile toward caregivers"
      ],
      correct: "B"
    },
    {
      id: 25806,
      question: "When assessing patients with Down syndrome, dental hygienists should:",
      options: [
        "Assume all patients have the same abilities",
        "Observe behavioral patterns and evaluate responses",
        "Only speak with the caregiver",
        "Provide treatment without assessment"
      ],
      correct: "B"
    },
    {
      id: 25807,
      question: "If patients with Down syndrome are unmanageable, it is usually because of:",
      options: [
        "Inherent behavioral problems only",
        "Fear, traumatic experiences, or cognitive limitations",
        "Genetic factors exclusively",
        "Caregiver encouragement of negative behavior"
      ],
      correct: "B"
    },
    {
      id: 25808,
      question: "When care for Down syndrome patients requires general anesthetic, the dental hygienist should:",
      options: [
        "Provide minimal care to reduce time",
        "Meet all possible needs while patient is anesthetized",
        "Only perform emergency procedures",
        "Avoid all preventive services"
      ],
      correct: "B"
    },
    {
      id: 25809,
      question: "Autism spectrum disorders (ASDs) affect how a person:",
      options: [
        "Only interacts with objects",
        "Interacts, communicates, relates, plays, imagines, and learns",
        "Only performs academic tasks",
        "Only responds to physical stimuli"
      ],
      correct: "B"
    },
    {
      id: 25810,
      question: "What percentage of those with Down syndrome also have ASD?",
      options: [
        "6% to 8%",
        "10% to 12%",
        "16% to 18%",
        "26% to 28%"
      ],
      correct: "C"
    },
    {
      id: 25811,
      question: "The CDC\'s ADDM Network found that ASD prevalence is:",
      options: [
        "1 in every 88 eight-year-old children",
        "1 in every 68 eight-year-old children",
        "1 in every 44 eight-year-old children",
        "1 in every 24 eight-year-old children"
      ],
      correct: "C"
    },
    {
      id: 25812,
      question: "Males have approximately how many times higher incidence of ASDs than females?",
      options: [
        "Two times higher",
        "Three times higher",
        "Four times higher",
        "Five times higher"
      ],
      correct: "C"
    },
    {
      id: 25813,
      question: "About what fraction of children with ASD also have intellectual disability?",
      options: [
        "About one-quarter",
        "About one-third",
        "About one-half",
        "About two-thirds"
      ],
      correct: "B"
    },
    {
      id: 25814,
      question: "Autistic disorder (classic autism) is characterized by:",
      options: [
        "Mild impairment with normal language",
        "Difficulty talking, relating to others, and compulsive behaviors",
        "Only social awkwardness",
        "Only developmental delays"
      ],
      correct: "B"
    },
    {
      id: 25815,
      question: "Asperger syndrome is characterized by:",
      options: [
        "Severe language and cognitive impairments",
        "Impairment in social interactions without significant language problems",
        "Complete inability to communicate",
        "Physical disabilities primarily"
      ],
      correct: "B"
    },
    {
      id: 25816,
      question: "Individuals with Asperger syndrome:",
      options: [
        "Are socially adept and empathetic",
        "Are socially awkward and lack empathy",
        "Have superior social skills",
        "Prefer constant eye contact"
      ],
      correct: "B"
    },
    {
      id: 25817,
      question: "Rett syndrome is found almost exclusively in:",
      options: [
        "Males",
        "Females",
        "Equally in males and females",
        "Only in identical twins"
      ],
      correct: "B"
    },
    {
      id: 25818,
      question: "Rett syndrome appears between:",
      options: [
        "6 and 18 months after normal development",
        "18 and 24 months after normal development",
        "24 and 36 months after normal development",
        "Immediately at birth"
      ],
      correct: "A"
    },
    {
      id: 25819,
      question: "Rett syndrome is characterized by:",
      options: [
        "Enhanced head growth and development",
        "Poor head growth and regression of mental/social development",
        "Normal development throughout life",
        "Only physical impairments"
      ],
      correct: "B"
    },
    {
      id: 25820,
      question: "Childhood disintegrative disorder develops in children who:",
      options: [
        "Never develop normally",
        "Initially seem normal then lose skills after 2 years",
        "Have abnormalities from birth",
        "Only have speech delays"
      ],
      correct: "B"
    },
    {
      id: 25821,
      question: "PDD-NOS is characterized by:",
      options: [
        "Meeting all criteria for specific autism diagnosis",
        "Some but not all classic autism signs present",
        "No impairment in communication",
        "Enhanced social interaction skills"
      ],
      correct: "B"
    },
    {
      id: 25822,
      question: "The most common form of behavioral therapy for ASD is:",
      options: [
        "Psychoanalytic therapy",
        "Applied Behavior Analysis (ABA)",
        "Medication-only approach",
        "Isolation therapy"
      ],
      correct: "B"
    },
    {
      id: 25823,
      question: "Applied Behavior Analysis (ABA) aims to:",
      options: [
        "Ignore all behaviors",
        "Promote desired behaviors and discourage undesired behaviors",
        "Punish all negative behaviors",
        "Eliminate all stimulation"
      ],
      correct: "B"
    },
    {
      id: 25824,
      question: "The most commonly prescribed stimulant medication for ASD is:",
      options: [
        "Diphenhydramine",
        "Thioridazine",
        "Methylphenidate (Ritalin)",
        "Phenytoin"
      ],
      correct: "C"
    },
    {
      id: 25825,
      question: "Risperidone is prescribed for ASD to:",
      options: [
        "Cure the disorder completely",
        "Improve behavior",
        "Only reduce seizures",
        "Enhance academic performance"
      ],
      correct: "B"
    },
    {
      id: 25826,
      question: "By what age can ASD symptoms typically be realized?",
      options: [
        "By 6 months of age",
        "By 12 months of age",
        "By 18 months of age",
        "By 24 months of age"
      ],
      correct: "C"
    },
    {
      id: 25827,
      question: "By what age can a reliable ASD diagnosis be made by a medical professional?",
      options: [
        "By age 1 year",
        "By age 2 years",
        "By age 3 years",
        "By age 4 years"
      ],
      correct: "B"
    },
    {
      id: 25828,
      question: "The first characteristic sign of ASD is:",
      options: [
        "Delayed motor development",
        "Few or no big smiles or engaging expressions by 6 months",
        "Inability to sit up by 6 months",
        "Delayed tooth eruption"
      ],
      correct: "B"
    },
    {
      id: 25829,
      question: "For ASD diagnosis according to DSM-5, developmental monitoring assesses for delays in:",
      options: [
        "Physical growth only",
        "Communication, interaction, and restricted interests/repetitive behaviors",
        "Only academic skills",
        "Only motor development"
      ],
      correct: "B"
    },
    {
      id: 25830,
      question: "The M-CHAT was developed by:",
      options: [
        "The CDC",
        "The AAP",
        "Autism Speaks",
        "The WHO"
      ],
      correct: "C"
    },
    {
      id: 25831,
      question: "The AAP recommends children be screened for ASD during which well visits?",
      options: [
        "12- and 18-month visits",
        "18- and 24-month visits",
        "24- and 36-month visits",
        "6- and 12-month visits"
      ],
      correct: "B"
    },
    {
      id: 25832,
      question: "Language in children with ASD consists primarily of:",
      options: [
        "Complex sentence structures",
        "Naming nouns and adjectives meaninglessly",
        "Advanced conversational skills",
        "Appropriate pronoun usage"
      ],
      correct: "B"
    },
    {
      id: 25833,
      question: "Echolalia refers to:",
      options: [
        "Enhanced language development",
        "Meaninglessly imitating what is heard",
        "Normal speech development",
        "Advanced vocabulary skills"
      ],
      correct: "B"
    },
    {
      id: 25834,
      question: "Children with ASD learn to speak of themselves in first person around what age?",
      options: [
        "Around age 2 years",
        "Around age 4 years",
        "Around age 6 years",
        "Around age 8 years"
      ],
      correct: "C"
    },
    {
      id: 25835,
      question: "Children with ASD are more interested in objects than people because:",
      options: [
        "Objects are more colorful",
        "Objects rarely change, not threatening the child",
        "People are frightening",
        "They have visual impairments"
      ],
      correct: "B"
    },
    {
      id: 25836,
      question: "Children with ASD fear:",
      options: [
        "People doing things to them",
        "Objects that people acquire, not the people themselves",
        "Only loud noises",
        "Only bright lights"
      ],
      correct: "B"
    },
    {
      id: 25837,
      question: "By age 5 or 6 years, language in children with ASD becomes more communicative because:",
      options: [
        "They receive medication",
        "They have experienced several patterns",
        "Their brain structure changes",
        "They receive surgery"
      ],
      correct: "B"
    },
    {
      id: 25838,
      question: "By age 6 or 8 years, children with ASD:",
      options: [
        "Play cooperatively in groups",
        "Play alongside other children (parallel play)",
        "Avoid all other children completely",
        "Lead group activities"
      ],
      correct: "B"
    },
    {
      id: 25839,
      question: "Only what percentage of patients with ASD will live and work independently?",
      options: [
        "A small percentage",
        "About half",
        "The majority",
        "Nearly all"
      ],
      correct: "A"
    },
    {
      id: 25840,
      question: "Persons with ASD exhibit which specific oral findings?",
      options: [
        "Always severe caries",
        "No specific oral findings",
        "Always periodontal disease",
        "Always missing teeth"
      ],
      correct: "B"
    },
    {
      id: 25841,
      question: "Infants with ASD may find eating difficult, leading to:",
      options: [
        "Enhanced nutrition",
        "Vomiting and limited food selection",
        "Accelerated growth",
        "Improved oral health"
      ],
      correct: "B"
    },
    {
      id: 25842,
      question: "If food selection in ASD includes regular sucrose intake, what may be a major concern?",
      options: [
        "Tooth discoloration",
        "Dental caries",
        "Enhanced enamel formation",
        "Accelerated eruption"
      ],
      correct: "B"
    },
    {
      id: 25843,
      question: "Psychotropic medications for ASD may cause:",
      options: [
        "Increased salivation",
        "Decreased salivation",
        "Enhanced oral health",
        "Improved motor function"
      ],
      correct: "B"
    },
    {
      id: 25844,
      question: "When psychotropic medications cause decreased salivation, patients may benefit from:",
      options: [
        "Reduced water intake",
        "Saliva substitutes and xylitol products",
        "Acidic beverages",
        "No intervention needed"
      ],
      correct: "B"
    },
    {
      id: 25845,
      question: "Individuals with ASD often have heavy accumulations of debris because of:",
      options: [
        "Excessive water consumption",
        "Dietary fixation and pouching food",
        "Enhanced oral hygiene",
        "Genetic factors only"
      ],
      correct: "B"
    },
    {
      id: 25846,
      question: "The management of patients with ASD incorporates how many approaches?",
      options: [
        "One approach",
        "Two approaches",
        "Three approaches",
        "Four approaches"
      ],
      correct: "C"
    },
    {
      id: 25847,
      question: "The three approaches to managing patients with ASD are:",
      options: [
        "Medication, surgery, and isolation",
        "Communication, behavioral modification, and pharmacologic therapies",
        "Restraint, sedation, and hospitalization",
        "Education, punishment, and rewards"
      ],
      correct: "B"
    },
    {
      id: 25848,
      question: "Patients with ASD may require conditioning before dental care due to:",
      options: [
        "Genetic factors",
        "Foreign sounds, smells, and sights causing sensory overload",
        "Always being uncooperative",
        "Medication requirements"
      ],
      correct: "B"
    },
    {
      id: 25849,
      question: "Sensory overload in children with ASD can lead to:",
      options: [
        "Enhanced cooperation",
        "Aggression, emotional outbursts, and SIBs",
        "Improved communication",
        "Better focus and attention"
      ],
      correct: "B"
    },
    {
      id: 25850,
      question: "Instructional video clips for children with ASD should be watched for at least:",
      options: [
        "5 to 10 seconds to be effective",
        "10 to 26 seconds to be effective",
        "30 to 60 seconds to be effective",
        "1 to 2 minutes to be effective"
      ],
      correct: "B"
    },
    {
      id: 25851,
      question: "The Picture Exchange Communication System (PECS) is beneficial for:",
      options: [
        "All patients regardless of condition",
        "Children with more severe forms of ASD",
        "Only children without ASD",
        "Only adults with mild ASD"
      ],
      correct: "B"
    },
    {
      id: 25852,
      question: "Social stories read prior to dental visits can help children with ASD:",
      options: [
        "Only if they have no intellectual disability",
        "Understand what takes place during appointments",
        "Only if combined with sedation",
        "Never; they are ineffective"
      ],
      correct: "B"
    },
    {
      id: 25853,
      question: "The reception area for patients with ASD should be:",
      options: [
        "Busy with many people and activities",
        "Quiet with as few people as possible",
        "Brightly lit with loud music",
        "Decorated with flashing lights"
      ],
      correct: "B"
    },
    {
      id: 25854,
      question: "Appointments for patients with ASD should be:",
      options: [
        "Extended to allow unlimited time",
        "Short and organized",
        "Unstructured and flexible",
        "Scheduled irregularly"
      ],
      correct: "B"
    },
    {
      id: 25855,
      question: "If a patient with ASD needs to return, appointments should:",
      options: [
        "Vary in day, time, and staff",
        "Remain on same day, time, and with same staff",
        "Be unscheduled",
        "Only occur when problems arise"
      ],
      correct: "B"
    },
    {
      id: 25856,
      question: "When developing oral self-care behaviors for patients with ID, dental hygienists teach at:",
      options: [
        "The patient\'s chronologic age level",
        "The patient\'s mental age level",
        "An advanced academic level",
        "The caregiver\'s educational level"
      ],
      correct: "B"
    },
    {
      id: 25857,
      question: "A consistent challenge for patients with ID is:",
      options: [
        "Brushing too long",
        "Brushing long enough",
        "Using too much toothpaste",
        "Flossing too frequently"
      ],
      correct: "B"
    },
    {
      id: 25858,
      question: "An egg timer or power toothbrush with built-in timer can help patients:",
      options: [
        "Reduce brushing time",
        "Lengthen brushing time",
        "Avoid brushing completely",
        "Brush faster"
      ],
      correct: "B"
    },
    {
      id: 25859,
      question: "Power toothbrushes are ideal for patients with:",
      options: [
        "Perfect motor control",
        "Grip problems and limited fine-motor control",
        "No physical limitations",
        "Advanced dexterity"
      ],
      correct: "B"
    },
    {
      id: 25860,
      question: "Power toothbrushes enable persons with minimal motor control to:",
      options: [
        "Avoid oral care completely",
        "Perform oral self-care independently",
        "Require more assistance",
        "Depend solely on professionals"
      ],
      correct: "B"
    },
    {
      id: 25861,
      question: "Interdental cleaning devices with long handles are recommended to:",
      options: [
        "Make cleaning more difficult",
        "Protect fingers from biting and reach posterior areas",
        "Prevent all interdental cleaning",
        "Only be used by professionals"
      ],
      correct: "B"
    },
    {
      id: 25862,
      question: "Oral irrigators are generally recommended for patients with ID to:",
      options: [
        "Replace all other oral hygiene methods",
        "Deliver prescribed antimicrobial agents",
        "Be used instead of toothbrushing",
        "Clean teeth without supervision"
      ],
      correct: "B"
    },
    {
      id: 25863,
      question: "The use of 0.12% chlorhexidine gluconate mouth rinse is prescribed to:",
      options: [
        "Whiten teeth",
        "Help control oral biofilm and gingivitis",
        "Replace toothbrushing",
        "Cure periodontal disease"
      ],
      correct: "B"
    },
    {
      id: 25864,
      question: "Chlorhexidine can be administered via:",
      options: [
        "Only professional application",
        "Oral irrigator, spray, or swab",
        "Only as a gel",
        "Only in pill form"
      ],
      correct: "B"
    },
    {
      id: 25865,
      question: "Chlorhexidine is absorbed through the gastrointestinal system, meaning:",
      options: [
        "It must never be swallowed",
        "No harm is caused by swallowing small amounts",
        "It is toxic if ingested",
        "Only adults can use it"
      ],
      correct: "B"
    },
    {
      id: 25866,
      question: "Home fluoride application is commonly done:",
      options: [
        "Instead of toothbrushing",
        "With a toothbrush after toothbrushing",
        "Only at professional visits",
        "Once monthly only"
      ],
      correct: "B"
    },
    {
      id: 25867,
      question: "Therapeutic doses of xylitol gum and mints can substitute for:",
      options: [
        "All meals",
        "Candy and for behavior modification",
        "Toothbrushing",
        "Professional care"
      ],
      correct: "B"
    },
    {
      id: 25868,
      question: "Many persons with ID, Down syndrome, or ASD learn better from:",
      options: [
        "Auditory teaching only",
        "Visual rather than auditory teaching",
        "Written instructions exclusively",
        "Verbal lectures only"
      ],
      correct: "B"
    },
    {
      id: 25869,
      question: "Instruction for patients with ID should include:",
      options: [
        "Only written materials",
        "Pictures, models, and diagrams",
        "Complex technical language",
        "Abstract concepts only"
      ],
      correct: "B"
    },
    {
      id: 25870,
      question: "Written instructions for patients with emergent literacy skills should include:",
      options: [
        "Technical terminology only",
        "Pictures underneath written instructions",
        "No visual aids",
        "Complex sentence structures"
      ],
      correct: "B"
    },
    {
      id: 25871,
      question: "During provision of health services, discrimination against persons with disabilities is:",
      options: [
        "Sometimes acceptable",
        "Illegal and unethical",
        "Encouraged for safety",
        "Required by law"
      ],
      correct: "B"
    },
    {
      id: 25872,
      question: "Many dental practices do not treat patients with disabilities based on:",
      options: [
        "Excessive compensation",
        "Lack of knowledge, equipment, and inadequate compensation",
        "Too many requests for treatment",
        "Legal requirements to refuse"
      ],
      correct: "B"
    }
  ],
  "8. Orofacial Cleft Conditions": [
    {
      id: 25800,
      question: "Orofacial clefts are the _____ most prevalent congenital disability in the United States.",
      options: [
        "Second",
        "Third",
        "Fourth",
        "Fifth"
      ],
      correct: "B"
    },
    {
      id: 25801,
      question: "Approximately how many infants are affected by orofacial clefts annually in the United States?",
      options: [
        "Approximately 4000 infants",
        "Approximately 5000 infants",
        "Approximately 6000 infants",
        "Approximately 7000 infants"
      ],
      correct: "C"
    },
    {
      id: 25802,
      question: "What is the prevalence of orofacial clefts in infants?",
      options: [
        "One in 500 infants",
        "One in 750 infants",
        "One in 1000 infants",
        "One in 1500 infants"
      ],
      correct: "C"
    },
    {
      id: 25803,
      question: "Which type of cleft is most common?",
      options: [
        "Cleft lip only",
        "Cleft palate only",
        "Cleft lip with palate",
        "All types occur equally"
      ],
      correct: "C"
    },
    {
      id: 25804,
      question: "Cleft lip with palate affects approximately:",
      options: [
        "1 in 1563 infants",
        "1 in 1687 infants",
        "1 in 2807 infants",
        "1 in 3000 infants"
      ],
      correct: "A"
    },
    {
      id: 25805,
      question: "Cleft palate only affects approximately:",
      options: [
        "1 in 1563 infants",
        "1 in 1687 infants",
        "1 in 2807 infants",
        "1 in 3000 infants"
      ],
      correct: "B"
    },
    {
      id: 25806,
      question: "Cleft lip only affects approximately:",
      options: [
        "1 in 1563 infants",
        "1 in 1687 infants",
        "1 in 2807 infants",
        "1 in 3000 infants"
      ],
      correct: "C"
    },
    {
      id: 25807,
      question: "Which racial or ethnic group has the highest prevalence of orofacial clefts?",
      options: [
        "African Americans or Blacks",
        "Non-Hispanic Whites",
        "Non-Hispanic American Indians or Alaska Natives",
        "Non-Hispanic Asians or Pacific Islanders"
      ],
      correct: "C"
    },
    {
      id: 25808,
      question: "Which racial or ethnic group has the lowest prevalence of orofacial clefts?",
      options: [
        "African Americans or Blacks",
        "Non-Hispanic Whites",
        "Hispanics",
        "Non-Hispanic Asians or Pacific Islanders"
      ],
      correct: "A"
    },
    {
      id: 25809,
      question: "Orofacial clefts are more predominant among:",
      options: [
        "Female infants than male infants",
        "Male infants than female infants",
        "Equally in both genders",
        "Neither gender shows predominance"
      ],
      correct: "B"
    },
    {
      id: 25810,
      question: "Regarding the type of orofacial cleft, males are more likely to exhibit:",
      options: [
        "Cleft palate only without cleft lip",
        "Cleft lip only without palate",
        "Cleft involving both lip and palate",
        "No gender difference exists"
      ],
      correct: "C"
    },
    {
      id: 25811,
      question: "There is a female predominance for:",
      options: [
        "Cleft lip and palate combined",
        "Cleft lip only",
        "Only cleft palate without cleft lip",
        "All types of clefts"
      ],
      correct: "C"
    },
    {
      id: 25812,
      question: "Nonsyndromic clefts are characterized by:",
      options: [
        "Association with other congenital disorders",
        "No other related health problems",
        "Always involving genetic syndromes",
        "Multiple organ system involvement"
      ],
      correct: "B"
    },
    {
      id: 25813,
      question: "Syndromic clefts are characterized by:",
      options: [
        "No other health problems present",
        "Association with other congenital disorders or syndromes",
        "Only affecting the oral cavity",
        "Never involving genetic factors"
      ],
      correct: "B"
    },
    {
      id: 25814,
      question: "Clefts are associated with more than how many syndromes?",
      options: [
        "More than 100 syndromes",
        "More than 300 syndromes",
        "More than 500 syndromes",
        "More than 700 syndromes"
      ],
      correct: "C"
    },
    {
      id: 25815,
      question: "Pierre Robin sequence is characterized by three distinct features:",
      options: [
        "Cleft lip, macroglossia, and airway obstruction",
        "Cleft palate, micrognathia, and glossoptosis",
        "Cleft lip, micrognathia, and macroglossia",
        "Cleft palate, macroglossia, and hypernasal speech"
      ],
      correct: "B"
    },
    {
      id: 25816,
      question: "Micrognathia refers to:",
      options: [
        "Enlarged tongue",
        "Small mandible",
        "Large maxilla",
        "Narrow palate"
      ],
      correct: "B"
    },
    {
      id: 25817,
      question: "Glossoptosis refers to:",
      options: [
        "Enlarged tongue",
        "Small mandible",
        "Airway obstruction caused by tongue displacement",
        "Absence of tongue movement"
      ],
      correct: "C"
    },
    {
      id: 25818,
      question: "A teratogen is:",
      options: [
        "A genetic mutation causing clefts",
        "An agent that can cause congenital abnormalities in developing embryo or fetus",
        "A syndrome associated with clefts",
        "A surgical procedure to repair clefts"
      ],
      correct: "B"
    },
    {
      id: 25819,
      question: "Which of the following is a known teratogen increasing risk for orofacial clefts?",
      options: [
        "Adequate folic acid intake",
        "Maternal smoking",
        "Early prenatal care",
        "Maternal higher education"
      ],
      correct: "B"
    },
    {
      id: 25820,
      question: "Which of the following maternal factors increases the risk for orofacial clefts?",
      options: [
        "Bachelor\'s degree or higher education",
        "Early prenatal care initiation",
        "Pregestational or gestational diabetes",
        "Adequate nutritional intake"
      ],
      correct: "C"
    },
    {
      id: 25821,
      question: "Which nutritional deficiency is associated with increased risk for orofacial clefts?",
      options: [
        "Vitamin C deficiency",
        "Calcium deficiency",
        "Lack of folic acid or zinc",
        "Iron deficiency"
      ],
      correct: "C"
    },
    {
      id: 25822,
      question: "Which environmental factors are identified as protective and reduce the risk of orofacial clefts?",
      options: [
        "Maternal smoking and alcohol consumption",
        "Use of WIC or being Medicaid recipient",
        "Maternal education level of bachelor\'s degree and early prenatal care",
        "Anticonvulsant medication use and obesity"
      ],
      correct: "C"
    },
    {
      id: 25823,
      question: "Environmental factors elevating cleft risk include maternal indicators of:",
      options: [
        "Higher socioeconomic status",
        "Advanced education",
        "Lower socioeconomic status",
        "Early prenatal care"
      ],
      correct: "C"
    },
    {
      id: 25824,
      question: "Cheiloschisis refers to:",
      options: [
        "A cleft of the palate",
        "A cleft of the upper lip",
        "A cleft of the tongue",
        "A cleft of the uvula"
      ],
      correct: "B"
    },
    {
      id: 25825,
      question: "Palatoschisis refers to:",
      options: [
        "A cleft of the palate",
        "A cleft of the upper lip",
        "A cleft of the tongue",
        "A cleft of the alveolus"
      ],
      correct: "A"
    },
    {
      id: 25826,
      question: "Development of the lip and palate occurs during which trimester of pregnancy?",
      options: [
        "Early to middle portion of first trimester",
        "Late first to early second trimester",
        "Middle to late second trimester",
        "Third trimester"
      ],
      correct: "A"
    },
    {
      id: 25827,
      question: "A cleft of the upper lip begins during which week of fetal development?",
      options: [
        "Third week",
        "Fifth week",
        "Seventh week",
        "Ninth week"
      ],
      correct: "B"
    },
    {
      id: 25828,
      question: "Formation of the philtrum is complete by which week of pregnancy?",
      options: [
        "Eighth week",
        "Tenth week",
        "Twelfth week",
        "Fourteenth week"
      ],
      correct: "B"
    },
    {
      id: 25829,
      question: "The philtrum is formed by fusion of:",
      options: [
        "Lateral nasal and maxillary processes",
        "Medial nasal and maxillary processes",
        "Median palatine and lateral palatine processes",
        "Maxillary and mandibular processes"
      ],
      correct: "B"
    },
    {
      id: 25830,
      question: "The palate begins to form at the end of which week of fetal development?",
      options: [
        "Third week",
        "Fifth week",
        "Seventh week",
        "Ninth week"
      ],
      correct: "B"
    },
    {
      id: 25831,
      question: "Formation of the palate is complete by which week of pregnancy?",
      options: [
        "Tenth week",
        "Twelfth week",
        "Fourteenth week",
        "Sixteenth week"
      ],
      correct: "B"
    },
    {
      id: 25832,
      question: "The median palatine process comprises:",
      options: [
        "Only the maxillary processes",
        "Median nasal process and maxillary processes",
        "Only the lateral palatine processes",
        "Mandibular and maxillary processes"
      ],
      correct: "B"
    },
    {
      id: 25833,
      question: "The lateral palatine processes are:",
      options: [
        "External aspects of the maxillary process",
        "Internal aspects of the maxillary process",
        "Parts of the mandibular process",
        "Components of the nasal septum"
      ],
      correct: "B"
    },
    {
      id: 25834,
      question: "During palatal development, the lateral palatine processes are initially positioned:",
      options: [
        "Horizontally from the beginning",
        "Upward initially, then move downward",
        "Downward initially, then elevated horizontally",
        "Laterally without vertical movement"
      ],
      correct: "C"
    },
    {
      id: 25835,
      question: "Failure of lateral palatine processes to fuse might be attributed to:",
      options: [
        "Early horizontal movement only",
        "Late horizontal movement, rupture after fusion, or blocking factors",
        "Premature fusion",
        "Absence of the processes"
      ],
      correct: "B"
    },
    {
      id: 25836,
      question: "Which conditions can block or affect the movement of the lateral palatine shelves?",
      options: [
        "Microglossia and maxillary enlargement",
        "Micrognathia and macroglossia",
        "Mandibular prognathism and small tongue",
        "Normal tongue and jaw size"
      ],
      correct: "B"
    },
    {
      id: 25837,
      question: "Macroglossia refers to:",
      options: [
        "Small tongue",
        "Enlarged tongue",
        "Absent tongue",
        "Bifurcated tongue"
      ],
      correct: "B"
    },
    {
      id: 25838,
      question: "Palatal development progresses:",
      options: [
        "From posterior to anterior",
        "From anterior to posterior",
        "Simultaneously throughout",
        "From lateral to medial only"
      ],
      correct: "B"
    },
    {
      id: 25839,
      question: "Orofacial clefts may be:",
      options: [
        "Only unilateral",
        "Only bilateral",
        "Unilateral or bilateral",
        "Neither unilateral nor bilateral"
      ],
      correct: "C"
    },
    {
      id: 25840,
      question: "The depth of tissue involvement in clefts is referred to as:",
      options: [
        "Unilateral or bilateral",
        "Incomplete or complete",
        "Anterior or posterior",
        "Primary or secondary"
      ],
      correct: "B"
    },
    {
      id: 25841,
      question: "The severity of clefts ranges from least severe to most severe:",
      options: [
        "Complete bilateral cleft to incomplete unilateral cleft lip",
        "Cleft palate only to complete bilateral cleft lip and palate",
        "Incomplete unilateral cleft lip to complete bilateral cleft lip and palate",
        "Bifid uvula to complete palate involvement"
      ],
      correct: "C"
    },
    {
      id: 25842,
      question: "An incomplete cleft lip is described as:",
      options: [
        "Extending into the nostrils",
        "Notch of any depth not invading hard structures or nostrils",
        "Involving the alveolar bone",
        "Always bilateral"
      ],
      correct: "B"
    },
    {
      id: 25843,
      question: "A complete cleft lip:",
      options: [
        "Does not involve bone structures",
        "Involves alveolar bone and primary palate, extends into nostrils",
        "Only affects soft tissue",
        "Never extends to the nose"
      ],
      correct: "B"
    },
    {
      id: 25844,
      question: "A complete cleft palate involves:",
      options: [
        "Only the soft palate",
        "Only the hard palate",
        "Anterior (primary) and posterior (secondary) palate",
        "Neither primary nor secondary palate"
      ],
      correct: "C"
    },
    {
      id: 25845,
      question: "The anterior (primary) palate is located:",
      options: [
        "Posterior to the incisive foramen",
        "Anterior to the incisive foramen",
        "At the uvula only",
        "In the soft palate region"
      ],
      correct: "B"
    },
    {
      id: 25846,
      question: "The posterior (secondary) palate:",
      options: [
        "Is anterior to the incisive foramen",
        "Extends posterior to incisive foramen and involves hard and soft palate",
        "Only involves the uvula",
        "Does not include the soft palate"
      ],
      correct: "B"
    },
    {
      id: 25847,
      question: "A bifid uvula is:",
      options: [
        "A complete cleft palate",
        "An incomplete cleft palate with cleft of uvula",
        "A unilateral cleft lip",
        "A bilateral cleft palate"
      ],
      correct: "B"
    },
    {
      id: 25848,
      question: "A submucosal cleft:",
      options: [
        "Always involves the lip",
        "Lacks muscle or bone fusion, yet soft tissue is present",
        "Is always visible externally",
        "Never affects speech"
      ],
      correct: "B"
    },
    {
      id: 25849,
      question: "Cleft lip repair (cheiloplasty) typically occurs:",
      options: [
        "Within the first 12 months",
        "Between 18 and 24 months",
        "After 2 years of age",
        "Immediately after birth"
      ],
      correct: "A"
    },
    {
      id: 25850,
      question: "Cleft lip repair often occurs between:",
      options: [
        "1 and 2 months of age",
        "3 and 6 months of age",
        "9 and 12 months of age",
        "12 and 18 months of age"
      ],
      correct: "B"
    },
    {
      id: 25851,
      question: "Closure of a cleft palate (palatoplasty) transpires between:",
      options: [
        "3 and 6 months of age",
        "6 and 9 months of age",
        "9 and 18 months of age",
        "18 and 24 months of age"
      ],
      correct: "C"
    },
    {
      id: 25852,
      question: "A nasoalveolar molding (NAM) appliance is used to:",
      options: [
        "Prevent feeding difficulties only",
        "Reshape the nose and primary palate bone for favorable surgical outcome",
        "Correct speech problems",
        "Replace missing teeth"
      ],
      correct: "B"
    },
    {
      id: 25853,
      question: "Elastomeric taping is used to:",
      options: [
        "Replace surgical intervention",
        "Help decrease cleft lip width",
        "Prevent ear infections",
        "Improve hearing"
      ],
      correct: "B"
    },
    {
      id: 25854,
      question: "The \"rule of 10\" for determining when a healthy baby can undergo elective surgery includes:",
      options: [
        "10 days of age, 10 oz. in weight, hemoglobin >10",
        "10 weeks of age, 10 lb. in weight, hemoglobin >10 g/dL",
        "10 months of age, 10 kg in weight, hemoglobin >10",
        "10 days old, 10 inches long, hemoglobin >10"
      ],
      correct: "B"
    },
    {
      id: 25855,
      question: "Early orofacial cleft treatments help:",
      options: [
        "Only cosmetic appearance",
        "Speech development",
        "Prevent all complications",
        "Eliminate need for dental care"
      ],
      correct: "B"
    },
    {
      id: 25856,
      question: "Early surgeries for orofacial clefts can affect:",
      options: [
        "Only speech development",
        "Only appearance",
        "Subsequent facial growth and development",
        "Only tooth eruption"
      ],
      correct: "C"
    },
    {
      id: 25857,
      question: "Orthognathic surgery involves:",
      options: [
        "Only orthodontic treatment",
        "Corrective surgery of jaw and face to alter relationship of teeth and bones",
        "Only speech therapy",
        "Removal of teeth only"
      ],
      correct: "B"
    },
    {
      id: 25858,
      question: "Secondary surgeries after primary orofacial cleft surgery may be indicated for:",
      options: [
        "Only cosmetic concerns",
        "Maxillary deficiency, malocclusion, and lip/nasal deformities",
        "Only speech problems",
        "Only hearing problems"
      ],
      correct: "B"
    },
    {
      id: 25859,
      question: "The interprofessional team for managing orofacial clefts includes:",
      options: [
        "Only dental professionals",
        "Only medical professionals",
        "Plastic surgeon, pediatrician, dentists, orthodontist, and multiple specialists",
        "Only surgeons and nurses"
      ],
      correct: "C"
    },
    {
      id: 25860,
      question: "Which specialist performs lip and palatal repair and closure?",
      options: [
        "Pediatrician only",
        "Oral and maxillofacial surgeon and plastic surgeon",
        "Orthodontist only",
        "Speech pathologist only"
      ],
      correct: "B"
    },
    {
      id: 25861,
      question: "Which specialist diagnoses syndromes and establishes risk for future pregnancies?",
      options: [
        "Pediatrician",
        "Plastic surgeon",
        "Geneticist or genetic counselor",
        "Speech pathologist"
      ],
      correct: "C"
    },
    {
      id: 25862,
      question: "Which specialist addresses lack of fluid drainage in the ear?",
      options: [
        "Audiologist",
        "Speech pathologist",
        "Otolaryngologist",
        "Pediatrician"
      ],
      correct: "C"
    },
    {
      id: 25863,
      question: "Which specialist performs hearing tests to determine hearing impairments?",
      options: [
        "Otolaryngologist",
        "Audiologist",
        "Speech pathologist",
        "Pediatrician"
      ],
      correct: "B"
    },
    {
      id: 25864,
      question: "Which specialist retrains or develops articulation skills?",
      options: [
        "Audiologist",
        "Otolaryngologist",
        "Speech pathologist",
        "Prosthodontist"
      ],
      correct: "C"
    },
    {
      id: 25865,
      question: "Which specialist fabricates prostheses (obturators) such as speech bulbs or palatal lifts?",
      options: [
        "Orthodontist",
        "Prosthodontist",
        "Pediatric dentist",
        "Oral surgeon"
      ],
      correct: "B"
    },
    {
      id: 25866,
      question: "Which specialist aligns the dentition?",
      options: [
        "Prosthodontist",
        "Pediatric dentist",
        "Orthodontist",
        "Oral surgeon"
      ],
      correct: "C"
    },
    {
      id: 25867,
      question: "Dental hygienists\' role in interprofessional collaboration includes:",
      options: [
        "Only providing cleanings",
        "Oral screenings, risk assessment, and oral health education",
        "Only surgical assistance",
        "Only orthodontic adjustments"
      ],
      correct: "B"
    },
    {
      id: 25868,
      question: "Feeding problems are most often associated with:",
      options: [
        "Cleft lip only",
        "Cleft palate",
        "Bifid uvula only",
        "Submucosal cleft only"
      ],
      correct: "B"
    },
    {
      id: 25869,
      question: "Infants with cleft palate have difficulty producing:",
      options: [
        "Positive pressure for sucking",
        "Negative pressure needed to suck milk",
        "Any tongue movement",
        "Swallowing reflex"
      ],
      correct: "B"
    },
    {
      id: 25870,
      question: "In infants with cleft palate, the musculature is:",
      options: [
        "Normal and properly oriented",
        "Underdeveloped or not properly oriented for effective sucking",
        "Overdeveloped",
        "Absent completely"
      ],
      correct: "B"
    },
    {
      id: 25871,
      question: "Feeding complications in infants with cleft palate include:",
      options: [
        "Enhanced feeding efficiency",
        "Nasal regurgitation, long feeding times, difficulty coordinating swallowing",
        "Excessive weight gain",
        "No complications occur"
      ],
      correct: "B"
    },
    {
      id: 25872,
      question: "Interventions that improve feeding for infants with cleft palate include:",
      options: [
        "Using rigid bottles or spoons",
        "Squeezable bottle or syringe",
        "Standard feeding bottles only",
        "No intervention needed"
      ],
      correct: "B"
    },
    {
      id: 25873,
      question: "The most common problem in children with orofacial clefts is:",
      options: [
        "Tooth decay",
        "Speech problems only",
        "Middle ear infection",
        "Malocclusion only"
      ],
      correct: "C"
    },
    {
      id: 25874,
      question: "Middle ear infections in children with orofacial clefts result from:",
      options: [
        "Excessive ear wax",
        "Lack of ventilation from eustachian tubes",
        "Viral infections only",
        "Genetic factors only"
      ],
      correct: "B"
    },
    {
      id: 25875,
      question: "Which muscles control the opening of the eustachian tubes?",
      options: [
        "Tongue muscles",
        "Facial muscles",
        "Palatal muscles",
        "Neck muscles"
      ],
      correct: "C"
    },
    {
      id: 25876,
      question: "Chronic ear infections can result in:",
      options: [
        "Enhanced hearing ability",
        "Hearing impairments from permanent damage to auditory sensory nerves",
        "No long-term effects",
        "Improved speech development"
      ],
      correct: "B"
    },
    {
      id: 25877,
      question: "Velopharyngeal dysfunction (VPD) occurs when:",
      options: [
        "The soft palate properly closes against pharyngeal wall",
        "Closure does not occur between soft palate and pharyngeal wall",
        "The tongue blocks the airway",
        "The lips do not seal"
      ],
      correct: "B"
    },
    {
      id: 25878,
      question: "VPD may cause a patient to have:",
      options: [
        "Hyponasal speech",
        "Hypernasal speech",
        "Normal speech",
        "No speech at all"
      ],
      correct: "B"
    },
    {
      id: 25879,
      question: "During normal speech, the muscles of the soft palate:",
      options: [
        "Remain stationary",
        "Elevate and draw posteriorly to pharyngeal wall for closure",
        "Move forward only",
        "Do not participate in speech"
      ],
      correct: "B"
    },
    {
      id: 25880,
      question: "Treatment for VPD may involve:",
      options: [
        "Only observation",
        "Surgery, special speech device, speech therapy, or combination",
        "Only medications",
        "No treatment available"
      ],
      correct: "B"
    },
    {
      id: 25881,
      question: "The most common type of malocclusion in individuals with cleft palates is:",
      options: [
        "Class I malocclusion",
        "Class II malocclusion",
        "Class III malocclusion",
        "No malocclusion occurs"
      ],
      correct: "C"
    },
    {
      id: 25882,
      question: "Malocclusion in cleft palate patients can result from:",
      options: [
        "Only genetic factors",
        "Missing teeth or stunted maxillary growth",
        "Excessive maxillary growth",
        "Normal development"
      ],
      correct: "B"
    },
    {
      id: 25883,
      question: "Maxillary growth is constricted in cleft patients due to:",
      options: [
        "Normal healing process",
        "Scar tissue formation after primary surgeries",
        "Excessive bone growth",
        "Orthodontic treatment"
      ],
      correct: "B"
    },
    {
      id: 25884,
      question: "Dental problems that may be present in cleft patients include:",
      options: [
        "Only caries",
        "Congenitally missing teeth and supernumerary teeth",
        "Only periodontal disease",
        "No dental problems occur"
      ],
      correct: "B"
    },
    {
      id: 25885,
      question: "Because of the cleft location, which teeth may be absent or severely displaced?",
      options: [
        "Central incisors and first molars",
        "Lateral incisor and canine",
        "Second molars and third molars",
        "All teeth are always present"
      ],
      correct: "B"
    },
    {
      id: 25886,
      question: "Teeth in cleft patients may be:",
      options: [
        "Always normal in morphology",
        "Morphologically deformed, hypoplastic, or hypomineralized",
        "Always larger than normal",
        "Never affected"
      ],
      correct: "B"
    },
    {
      id: 25887,
      question: "Nasal architecture can be deformed if a cleft:",
      options: [
        "Only involves the palate",
        "Involving the lip extends into the floor of the nose",
        "Is incomplete",
        "Is submucosal only"
      ],
      correct: "B"
    },
    {
      id: 25888,
      question: "Children with orofacial clefts have significantly higher decayed surfaces than:",
      options: [
        "Adults with clefts",
        "Children without clefts",
        "Elderly patients",
        "Adolescents with clefts"
      ],
      correct: "B"
    },
    {
      id: 25889,
      question: "Caries prevalence is more evident in which dentition among patients with orofacial clefts?",
      options: [
        "Permanent dentition",
        "Mixed dentition",
        "Primary dentition",
        "Equally in all dentitions"
      ],
      correct: "C"
    },
    {
      id: 25890,
      question: "In primary dentition, caries is particularly evident in which teeth of cleft patients?",
      options: [
        "Mandibular molars only",
        "Maxillary incisors, teeth adjacent to cleft, and molars",
        "Only third molars",
        "Canines exclusively"
      ],
      correct: "B"
    },
    {
      id: 25891,
      question: "Patients with cleft palate have higher caries risk because of:",
      options: [
        "Enhanced salivary flow",
        "Longer oral clearance time, fermentable sugars, decreased salivary flow",
        "Improved oral hygiene",
        "Less biofilm accumulation"
      ],
      correct: "B"
    },
    {
      id: 25892,
      question: "Which factor contributes to increased caries risk in cleft palate patients?",
      options: [
        "Increased salivary flow",
        "Nasal breathing",
        "Mouth breathing",
        "Enhanced self-cleansing"
      ],
      correct: "C"
    },
    {
      id: 25893,
      question: "The tenacious nature of nasal fluid in cleft patients:",
      options: [
        "Decreases biofilm adherence",
        "Promotes the adherence of oral biofilm",
        "Has no effect on oral health",
        "Improves oral clearance"
      ],
      correct: "B"
    },
    {
      id: 25894,
      question: "Parental factors contributing to increased caries risk in cleft patients include:",
      options: [
        "Excessive dietary counseling",
        "Insufficient dietary counseling and reduced oral health knowledge",
        "Too much oral health knowledge",
        "Excessive toothbrushing"
      ],
      correct: "B"
    },
    {
      id: 25895,
      question: "Orthodontic treatment in cleft patients increases caries risk because:",
      options: [
        "It improves oral hygiene",
        "More surface irregularities retain food and biofilm",
        "It decreases biofilm accumulation",
        "It enhances self-cleansing"
      ],
      correct: "B"
    },
    {
      id: 25896,
      question: "Intraoral appliances (obturators) increase caries risk because they:",
      options: [
        "Improve oral hygiene",
        "Retain food and biofilm",
        "Enhance salivary flow",
        "Decrease substrate retention"
      ],
      correct: "B"
    },
    {
      id: 25897,
      question: "Orofacial clefts presence significantly increases the risk for:",
      options: [
        "Only caries",
        "Higher dental biofilm accumulation, gingivitis, and periodontitis",
        "Only gingivitis",
        "No oral health problems"
      ],
      correct: "B"
    },
    {
      id: 25898,
      question: "Chronic tissue irritation from ill-fitting prostheses can lead to:",
      options: [
        "Improved tissue health",
        "Hyperplastic tissue response and recessed gingiva",
        "No tissue changes",
        "Enhanced gingival attachment"
      ],
      correct: "B"
    },
    {
      id: 25899,
      question: "Preventive measures for cleft patients include:",
      options: [
        "Only professional cleaning",
        "Dietary counseling, frequent hygiene recall, fluoride therapy, sealants",
        "Only fluoride therapy",
        "No preventive measures needed"
      ],
      correct: "B"
    },
    {
      id: 25900,
      question: "Children with orofacial clefts could benefit from hygiene appointments:",
      options: [
        "Once yearly only",
        "Every 6 months only",
        "Every 3 or 4 months",
        "Every 2 years"
      ],
      correct: "C"
    },
    {
      id: 25901,
      question: "Increased recall intervals for cleft patients aid the hygienist in:",
      options: [
        "Only billing purposes",
        "Assessments, reinforcing homecare, biofilm reduction, fluoride therapy",
        "Only fluoride application",
        "Reducing appointment frequency"
      ],
      correct: "B"
    },
    {
      id: 25902,
      question: "Systemic fluoride therapy for cleft patients may include:",
      options: [
        "Only fluoride varnish",
        "Supplemental tablets and drops",
        "Only fluoride toothpaste",
        "No systemic fluoride"
      ],
      correct: "B"
    },
    {
      id: 25903,
      question: "Systemic fluoride may be indicated for cleft patients because:",
      options: [
        "They always have excess fluoride",
        "Enamel disturbances are possible during tooth development",
        "They never need fluoride",
        "Enamel is always perfect"
      ],
      correct: "B"
    },
    {
      id: 25904,
      question: "Which toothbrushing technique is most appropriate for children with clefts?",
      options: [
        "Bass technique only",
        "Fones technique and sulcular technique",
        "Modified Stillman technique only",
        "No specific technique recommended"
      ],
      correct: "B"
    },
    {
      id: 25905,
      question: "A power toothbrush is helpful for cleft patients because:",
      options: [
        "It is less effective than manual",
        "Teeth may be difficult to access due to less elasticity of repaired lip",
        "It is never recommended",
        "Manual brushing is always better"
      ],
      correct: "B"
    },
    {
      id: 25906,
      question: "A small brush head size is helpful for cleft patients due to:",
      options: [
        "Larger oral cavity",
        "Anatomy of cleft and fear of brushing around cleft area",
        "No specific reason",
        "Excessive tooth size"
      ],
      correct: "B"
    },
    {
      id: 25907,
      question: "Crowding of dentition in cleft patients:",
      options: [
        "Improves self-cleansing",
        "Restricts toothbrush and self-cleansing ability",
        "Has no effect on oral hygiene",
        "Enhances oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 25908,
      question: "Daily care for intraoral speech prostheses and obturators is similar to care of:",
      options: [
        "Fixed bridges only",
        "Partial and complete dentures",
        "Orthodontic appliances only",
        "No care needed"
      ],
      correct: "B"
    },
    {
      id: 25909,
      question: "Communication challenges with cleft patients may include:",
      options: [
        "Enhanced speech clarity",
        "Difficulty understanding hypernasal speech",
        "No challenges occur",
        "Perfect articulation always"
      ],
      correct: "B"
    },
    {
      id: 25910,
      question: "Managing communication challenges with cleft patients can be aided by:",
      options: [
        "Speaking quickly and loudly",
        "Focused listening, slowed speech, clear articulation, visible gestures",
        "Avoiding eye contact",
        "Using only written communication"
      ],
      correct: "B"
    },
    {
      id: 25911,
      question: "Early prenatal diagnosis of orofacial clefts:",
      options: [
        "Is never possible",
        "Aids parent or caregiver in planning care",
        "Has no benefits",
        "Only occurs after birth"
      ],
      correct: "B"
    },
    {
      id: 25912,
      question: "A cleft diagnosis may elicit emotional responses such as:",
      options: [
        "Only happiness and joy",
        "Disbelief, confusion, fear, shock, grief, guilt, sadness, anxiety",
        "No emotional response",
        "Only mild concern"
      ],
      correct: "B"
    },
    {
      id: 25913,
      question: "The hygienist should provide education to parents regarding:",
      options: [
        "Only dental treatment costs",
        "Potential dental complications, feeding difficulties, timing of care",
        "Only surgical procedures",
        "No education needed"
      ],
      correct: "B"
    },
    {
      id: 25914,
      question: "Appropriate healthcare and psychologic support for families with cleft children may lead to:",
      options: [
        "No change in quality of life",
        "Improvement in quality of life",
        "Decreased quality of life",
        "No effect on family"
      ],
      correct: "B"
    },
    {
      id: 25915,
      question: "Dental hygienists can offer professional continuing education to other healthcare providers about:",
      options: [
        "Only surgical techniques",
        "Risk factors, prevention, oral hygiene methods, importance of visits",
        "Only orthodontic procedures",
        "No education needed"
      ],
      correct: "B"
    },
    {
      id: 25916,
      question: "When caring for patients with orofacial clefts, dental hygienists should look for signs of:",
      options: [
        "Only dental caries",
        "Physical abuse during oral examination",
        "Only periodontal disease",
        "No special considerations"
      ],
      correct: "B"
    },
    {
      id: 25917,
      question: "Abuse is more common in:",
      options: [
        "Children without disabilities",
        "Children with developmental disabilities",
        "Only adults",
        "Elderly patients only"
      ],
      correct: "B"
    },
    {
      id: 25918,
      question: "Abuse in children often exhibits:",
      options: [
        "No visible signs",
        "Oral trauma",
        "Only behavioral changes",
        "No oral manifestations"
      ],
      correct: "B"
    },
    {
      id: 25919,
      question: "Suspected abuse must be reported to:",
      options: [
        "No one",
        "Child Protective Services as required by law",
        "Only parents",
        "School officials only"
      ],
      correct: "B"
    },
    {
      id: 25920,
      question: "Educating patients and caregivers about fluoride and dietary counseling is essential to:",
      options: [
        "Increase healthcare costs",
        "Prevent and reduce caries risk and reduce high healthcare costs",
        "Only improve appearance",
        "No particular reason"
      ],
      correct: "B"
    }
  ],
  "9. Neurologic Disabilities": [
    {
      id: 25900,
      question: "Tremors are classified by whether they occur during rest or action and are further categorized according to:",
      options: [
        "Frequency, amplitude, and body part affected",
        "Patient age, gender, and medical history",
        "Duration, severity, and location only",
        "Treatment response, prognosis, and etiology"
      ],
      correct: "A"
    },
    {
      id: 25901,
      question: "Rest tremors are classified as such because they:",
      options: [
        "Only occur during sleep periods",
        "Occur when muscles are at rest",
        "Disappear with medication",
        "Are less severe than action tremors"
      ],
      correct: "B"
    },
    {
      id: 25902,
      question: "The pill-rolling tremor commonly seen in Parkinson disease involves:",
      options: [
        "The entire hand and wrist",
        "The thumb and forefinger",
        "All fingers equally",
        "The palm and thumb"
      ],
      correct: "B"
    },
    {
      id: 25903,
      question: "Essential tremor disorder is classified as which type of tremor?",
      options: [
        "Action tremor",
        "Rest tremor",
        "Intention tremor",
        "Postural tremor"
      ],
      correct: "A"
    },
    {
      id: 25904,
      question: "Over 7 million people in the United States are diagnosed with:",
      options: [
        "Parkinson disease",
        "Multiple sclerosis",
        "Essential tremor disorder",
        "Huntington disease"
      ],
      correct: "C"
    },
    {
      id: 25905,
      question: "Parkinson disease is characterized by the progressive loss of neurons in the:",
      options: [
        "Cerebellum",
        "Substantia nigra of the midbrain",
        "Frontal lobe cortex",
        "Temporal lobe"
      ],
      correct: "B"
    },
    {
      id: 25906,
      question: "The incidence of Parkinson disease is higher among:",
      options: [
        "Females than males",
        "Males than females",
        "Equally in both genders",
        "Children under age 10"
      ],
      correct: "B"
    },
    {
      id: 25907,
      question: "The majority of people diagnosed with Parkinson disease are over age:",
      options: [
        "50 years",
        "55 years",
        "60 years",
        "65 years"
      ],
      correct: "C"
    },
    {
      id: 25908,
      question: "Dopamine serves as a neurotransmitter in the:",
      options: [
        "Basal ganglia",
        "Cerebellum",
        "Spinal cord",
        "Peripheral nerves"
      ],
      correct: "A"
    },
    {
      id: 25909,
      question: "The most effective treatment for Parkinson disease is:",
      options: [
        "Physical therapy alone",
        "Dopamine replacement using levodopa",
        "Surgical intervention",
        "Dietary modifications"
      ],
      correct: "B"
    },
    {
      id: 25910,
      question: "Levodopa is almost always given in combination with:",
      options: [
        "Dopamine",
        "Serotonin",
        "Carbidopa",
        "Epinephrine"
      ],
      correct: "C"
    },
    {
      id: 25911,
      question: "Carbidopa is used to:",
      options: [
        "Replace dopamine in the brain",
        "Prevent nausea and enhance levodopa effect",
        "Reduce tremors directly",
        "Improve muscle rigidity"
      ],
      correct: "B"
    },
    {
      id: 25912,
      question: "The cardinal manifestations of Parkinson disease are:",
      options: [
        "Tremor, fever, and confusion",
        "Rigidity, akinesia, and tremor",
        "Weakness, numbness, and tingling",
        "Memory loss, confusion, and dementia"
      ],
      correct: "B"
    },
    {
      id: 25913,
      question: "Akinesia refers to:",
      options: [
        "Impaired muscle movement",
        "Increased muscle tone",
        "Rapid muscle contractions",
        "Loss of muscle mass"
      ],
      correct: "A"
    },
    {
      id: 25914,
      question: "Bradykinesia refers to:",
      options: [
        "Rapid movement",
        "Movement slowness",
        "Muscle stiffness",
        "Involuntary movement"
      ],
      correct: "B"
    },
    {
      id: 25915,
      question: "The characteristic gait of Parkinson disease patients includes:",
      options: [
        "Wide-based, unsteady steps",
        "Short, shuffling steps",
        "Long, exaggerated strides",
        "Normal, coordinated walking"
      ],
      correct: "B"
    },
    {
      id: 25916,
      question: "\"Masked face\" in Parkinson disease refers to:",
      options: [
        "Facial swelling and edema",
        "Lack of facial expression and animation",
        "Facial asymmetry",
        "Abnormal facial movements"
      ],
      correct: "B"
    },
    {
      id: 25917,
      question: "The \"fly-catcher\" tongue is a manifestation of:",
      options: [
        "Multiple sclerosis",
        "Parkinson disease",
        "Cerebral palsy",
        "Huntington disease"
      ],
      correct: "B"
    },
    {
      id: 25918,
      question: "Dysphagia in Parkinson disease refers to:",
      options: [
        "Difficulty breathing",
        "Impaired swallowing",
        "Slurred speech",
        "Difficulty walking"
      ],
      correct: "B"
    },
    {
      id: 25919,
      question: "Appointments for Parkinson disease patients should be scheduled:",
      options: [
        "60 to 90 minutes after a meal",
        "First thing in the morning",
        "Late in the afternoon",
        "Immediately before meals"
      ],
      correct: "A"
    },
    {
      id: 25920,
      question: "Cerebral palsy is caused by:",
      options: [
        "Genetic mutations only",
        "Damage to motor areas of immature brain",
        "Viral infections in adulthood",
        "Metabolic disorders"
      ],
      correct: "B"
    },
    {
      id: 25921,
      question: "Cerebral palsy is the second most common neurologic impairment in childhood following:",
      options: [
        "Epilepsy",
        "Autism spectrum disorders",
        "Intellectual and developmental disability",
        "Spina bifida"
      ],
      correct: "C"
    },
    {
      id: 25922,
      question: "Common risk factors for cerebral palsy occurring prior to birth include:",
      options: [
        "Childhood vaccinations",
        "Maternal diabetes and bleeding",
        "Paternal health conditions",
        "Sibling medical history"
      ],
      correct: "B"
    },
    {
      id: 25923,
      question: "Common risk factors for cerebral palsy occurring during or after birth include:",
      options: [
        "Premature birth and low birth weight",
        "Advanced maternal age only",
        "Multiple births only",
        "Genetic factors only"
      ],
      correct: "A"
    },
    {
      id: 25924,
      question: "Cerebral palsy is most prevalent in:",
      options: [
        "Females born at term",
        "Males, especially those born prematurely",
        "Equally in males and females",
        "Full-term infants only"
      ],
      correct: "B"
    },
    {
      id: 25925,
      question: "In cerebral palsy, monoplegia affects:",
      options: [
        "One limb",
        "Two limbs",
        "Three limbs",
        "Four limbs"
      ],
      correct: "A"
    },
    {
      id: 25926,
      question: "In cerebral palsy, diplegia affects:",
      options: [
        "One limb",
        "Two limbs, usually both legs",
        "Three limbs",
        "Four limbs"
      ],
      correct: "B"
    },
    {
      id: 25927,
      question: "In cerebral palsy, quadriplegia affects:",
      options: [
        "One limb",
        "Two limbs",
        "Three limbs",
        "Four limbs"
      ],
      correct: "D"
    },
    {
      id: 25928,
      question: "Hemiplegia in cerebral palsy affects:",
      options: [
        "One side of the body",
        "Lower limbs only",
        "Upper limbs only",
        "Alternating sides"
      ],
      correct: "A"
    },
    {
      id: 25929,
      question: "The spastic type of cerebral palsy is characterized by:",
      options: [
        "Uncontrolled writhing movements",
        "Spasticity leading to stiffness and contractures",
        "Poor balance only",
        "Seizure activity"
      ],
      correct: "B"
    },
    {
      id: 25930,
      question: "The spastic type of cerebral palsy results from damage to the:",
      options: [
        "Basal ganglia",
        "Cerebellum",
        "Motor area (frontal lobe) of cerebral cortex",
        "Temporal lobe"
      ],
      correct: "C"
    },
    {
      id: 25931,
      question: "The athetoid or dyskinetic type of cerebral palsy is characterized by:",
      options: [
        "Muscle stiffness only",
        "Slow, writhing, uncontrolled movements",
        "Rapid, jerking movements",
        "Complete paralysis"
      ],
      correct: "B"
    },
    {
      id: 25932,
      question: "The athetoid type of cerebral palsy results from damage to the:",
      options: [
        "Frontal lobe",
        "Basal ganglia",
        "Cerebellum",
        "Spinal cord"
      ],
      correct: "B"
    },
    {
      id: 25933,
      question: "Dysarthria in cerebral palsy refers to:",
      options: [
        "Difficulty swallowing",
        "Difficulties with articulation",
        "Hearing impairment",
        "Visual problems"
      ],
      correct: "B"
    },
    {
      id: 25934,
      question: "The ataxic type of cerebral palsy is associated with:",
      options: [
        "Muscle spasticity",
        "Problems in balance, coordination, and depth perception",
        "Uncontrolled movements",
        "Complete paralysis"
      ],
      correct: "B"
    },
    {
      id: 25935,
      question: "The ataxic type of cerebral palsy is caused by damage to the:",
      options: [
        "Frontal lobe",
        "Basal ganglia",
        "Cerebellum",
        "Brainstem"
      ],
      correct: "C"
    },
    {
      id: 25936,
      question: "The most common mixed form of cerebral palsy is:",
      options: [
        "Ataxic-dyskinetic",
        "Spastic-athetoid",
        "Spastic-ataxic",
        "Dyskinetic-ataxic"
      ],
      correct: "B"
    },
    {
      id: 25937,
      question: "Gastroesophageal reflux disease (GERD) occurrence in patients with cerebral palsy is estimated to be as high as:",
      options: [
        "25%",
        "50%",
        "75%",
        "90%"
      ],
      correct: "C"
    },
    {
      id: 25938,
      question: "The tonic labyrinthine reflex in cerebral palsy is triggered by:",
      options: [
        "Loud noises",
        "Tilting head backward so neck loses support",
        "Turning head to one side",
        "Bright lights"
      ],
      correct: "B"
    },
    {
      id: 25939,
      question: "To prevent the tonic labyrinthine reflex, the clinician should:",
      options: [
        "Keep head supported and flexed",
        "Tilt chair back fully",
        "Turn patient\'s head to side",
        "Use bright overhead lights"
      ],
      correct: "A"
    },
    {
      id: 25940,
      question: "The asymmetric tonic neck reflex is triggered by:",
      options: [
        "Tilting head backward",
        "Turning head to one side, away from midline",
        "Loud noises",
        "Head support"
      ],
      correct: "B"
    },
    {
      id: 25941,
      question: "The startle reflex in cerebral palsy is triggered by:",
      options: [
        "Gentle touch",
        "Surprising stimuli such as lights, movement, noises",
        "Slow movements",
        "Quiet environments"
      ],
      correct: "B"
    },
    {
      id: 25942,
      question: "Multiple sclerosis typically begins in:",
      options: [
        "Childhood",
        "Early adulthood",
        "Middle age (50-60 years)",
        "Old age (over 70 years)"
      ],
      correct: "B"
    },
    {
      id: 25943,
      question: "The majority of multiple sclerosis diagnoses occur between ages:",
      options: [
        "10 and 20",
        "20 and 50",
        "50 and 70",
        "70 and 90"
      ],
      correct: "B"
    },
    {
      id: 25944,
      question: "Multiple sclerosis affects females:",
      options: [
        "Less frequently than males",
        "About the same as males",
        "More frequently, as much as three times more than males",
        "Only in rare cases"
      ],
      correct: "C"
    },
    {
      id: 25945,
      question: "Multiple sclerosis is more common in:",
      options: [
        "Tropical climates",
        "Equatorial regions",
        "Cold and temperate climates of higher latitudes",
        "All climates equally"
      ],
      correct: "C"
    },
    {
      id: 25946,
      question: "The most common form of multiple sclerosis is:",
      options: [
        "Clinically Isolated Syndrome",
        "Relapsing-remitting MS",
        "Secondary progressive MS",
        "Primary progressive MS"
      ],
      correct: "B"
    },
    {
      id: 25947,
      question: "Over 85% of multiple sclerosis patients are diagnosed initially with:",
      options: [
        "Clinically Isolated Syndrome",
        "Relapsing-remitting MS",
        "Secondary progressive MS",
        "Primary progressive MS"
      ],
      correct: "B"
    },
    {
      id: 25948,
      question: "Vitamin D deficiency is now known to be:",
      options: [
        "Unrelated to MS risk",
        "A risk factor for MS",
        "A protective factor against MS",
        "A symptom of MS"
      ],
      correct: "B"
    },
    {
      id: 25949,
      question: "A 41% increase in the odds of developing MS occurs when a person\'s BMI moves from:",
      options: [
        "Normal to overweight",
        "Overweight to obese",
        "Underweight to normal",
        "Obese to morbidly obese"
      ],
      correct: "B"
    },
    {
      id: 25950,
      question: "Epstein-Barr virus has been implicated as a leading cause of MS, with risk increasing more than:",
      options: [
        "10%",
        "20%",
        "30%",
        "40%"
      ],
      correct: "C"
    },
    {
      id: 25951,
      question: "The main disease characteristic of multiple sclerosis is:",
      options: [
        "Increased myelin production",
        "Presence of demyelinated nerve axons",
        "Excessive dopamine",
        "Calcium deposits"
      ],
      correct: "B"
    },
    {
      id: 25952,
      question: "Demyelinated plaques in MS are often found around the:",
      options: [
        "Peripheral nerves",
        "Lateral brain ventricles",
        "Spinal nerve roots",
        "Cranial nerves"
      ],
      correct: "B"
    },
    {
      id: 25953,
      question: "Motor symptoms in multiple sclerosis include:",
      options: [
        "Enhanced coordination",
        "Muscular weakness and spasticity",
        "Increased muscle mass",
        "Improved reflexes"
      ],
      correct: "B"
    },
    {
      id: 25954,
      question: "Visual disturbances in multiple sclerosis may be:",
      options: [
        "Rare occurrences",
        "The first symptoms",
        "Only in advanced stages",
        "Never present"
      ],
      correct: "B"
    },
    {
      id: 25955,
      question: "Patients with multiple sclerosis generally rate their overall oral health as:",
      options: [
        "Excellent",
        "Good",
        "Fair to poor",
        "Variable with no pattern"
      ],
      correct: "C"
    },
    {
      id: 25956,
      question: "Appointments for MS patients should be scheduled:",
      options: [
        "Late in the day",
        "In the morning",
        "During lunch hours",
        "In the evening"
      ],
      correct: "B"
    },
    {
      id: 25957,
      question: "The room temperature for MS patients should be kept:",
      options: [
        "Warm",
        "Cool",
        "Hot",
        "Variable"
      ],
      correct: "B"
    },
    {
      id: 25958,
      question: "Amyotrophic lateral sclerosis is also known as:",
      options: [
        "Parkinson disease",
        "Lou Gehrig disease",
        "Huntington disease",
        "Alzheimer disease"
      ],
      correct: "B"
    },
    {
      id: 25959,
      question: "Sporadic ALS accounts for what percentage of cases:",
      options: [
        "50% to 60%",
        "70% to 80%",
        "90% to 95%",
        "Nearly 100%"
      ],
      correct: "C"
    },
    {
      id: 25960,
      question: "Familial ALS accounts for what percentage of cases:",
      options: [
        "5% to 10%",
        "15% to 20%",
        "25% to 30%",
        "35% to 40%"
      ],
      correct: "A"
    },
    {
      id: 25961,
      question: "Sporadic ALS generally affects individuals who are:",
      options: [
        "25 to 35 years of age",
        "35 to 45 years of age",
        "45 to 55 years of age",
        "55 to 65 years of age"
      ],
      correct: "D"
    },
    {
      id: 25962,
      question: "ALS patients have a typical life expectancy after diagnosis of:",
      options: [
        "1 to 2 years",
        "3 to 5 years",
        "6 to 8 years",
        "9 to 11 years"
      ],
      correct: "B"
    },
    {
      id: 25963,
      question: "Aspiration pneumonia is a leading cause of death for patients with:",
      options: [
        "Parkinson disease",
        "Multiple sclerosis",
        "ALS",
        "Cerebral palsy"
      ],
      correct: "C"
    },
    {
      id: 25964,
      question: "ALS patients should be placed in which position to prevent aspiration:",
      options: [
        "Fully reclined",
        "Semisupine or upright",
        "Trendelenburg",
        "Flat supine"
      ],
      correct: "B"
    },
    {
      id: 25965,
      question: "Sialorrhea in ALS patients refers to:",
      options: [
        "Dry mouth",
        "Excessive saliva",
        "Difficulty swallowing",
        "Tooth grinding"
      ],
      correct: "B"
    },
    {
      id: 25966,
      question: "Huntington disease results from degeneration of neurons within the:",
      options: [
        "Cerebellum",
        "Basal ganglia",
        "Frontal lobe",
        "Temporal lobe"
      ],
      correct: "B"
    },
    {
      id: 25967,
      question: "Huntington disease is characterized by rapid, jerky involuntary movements called:",
      options: [
        "Tremors",
        "Spasticity",
        "Chorea",
        "Ataxia"
      ],
      correct: "C"
    },
    {
      id: 25968,
      question: "Currently, there are approximately how many individuals living with Huntington disease in the United States:",
      options: [
        "21,000",
        "31,000",
        "41,000",
        "51,000"
      ],
      correct: "C"
    },
    {
      id: 25969,
      question: "Huntington disease is inherited through a mutation on chromosome:",
      options: [
        "2",
        "4",
        "6",
        "8"
      ],
      correct: "B"
    },
    {
      id: 25970,
      question: "Each child of a parent with Huntington disease has what chance of developing the disease:",
      options: [
        "25%",
        "50%",
        "75%",
        "100%"
      ],
      correct: "B"
    },
    {
      id: 25971,
      question: "The symptoms of Huntington disease usually begin during:",
      options: [
        "Childhood",
        "Adolescence",
        "Middle age (ages 30-50)",
        "Old age (over 70)"
      ],
      correct: "C"
    },
    {
      id: 25972,
      question: "Patients with Huntington disease are at high risk for:",
      options: [
        "Enhanced swallowing ability",
        "Swallowing impairment and severe dysphagia",
        "Improved coordination",
        "Increased appetite"
      ],
      correct: "B"
    },
    {
      id: 25973,
      question: "Common causes of death in Huntington disease include:",
      options: [
        "Heart failure only",
        "Kidney failure",
        "Choking, injuries from falls, or pneumonia",
        "Liver disease"
      ],
      correct: "C"
    },
    {
      id: 25974,
      question: "Xerostomia associated with Huntington disease is due to:",
      options: [
        "Disease process itself",
        "Antidepressant and antipsychotic medications",
        "Poor fluid intake",
        "Genetic factors"
      ],
      correct: "B"
    },
    {
      id: 25975,
      question: "Traumatic brain injury may be caused by:",
      options: [
        "Genetic factors only",
        "Blow or jolt to the head",
        "Metabolic disorders",
        "Viral infections"
      ],
      correct: "B"
    },
    {
      id: 25976,
      question: "The gold standard for diagnosis of TBI is:",
      options: [
        "CT scan",
        "MRI",
        "Clinical interview",
        "Blood tests"
      ],
      correct: "C"
    },
    {
      id: 25977,
      question: "TBI severity is classified as:",
      options: [
        "Mild or severe only",
        "Mild, moderate, or severe",
        "Minor or major only",
        "Grade 1, 2, or 3"
      ],
      correct: "B"
    },
    {
      id: 25978,
      question: "The most common causes of TBI hospitalization are:",
      options: [
        "Sports injuries and assault",
        "Unintentional falls and motor vehicle accidents",
        "Workplace injuries",
        "Domestic violence"
      ],
      correct: "B"
    },
    {
      id: 25979,
      question: "The age group most often affected by TBI are adults aged:",
      options: [
        "18 to 30 years",
        "31 to 50 years",
        "51 to 74 years",
        "75 years and older"
      ],
      correct: "D"
    },
    {
      id: 25980,
      question: "Males have TBI rates compared to females that are:",
      options: [
        "About equal",
        "Slightly lower",
        "Significantly higher",
        "Much lower"
      ],
      correct: "C"
    },
    {
      id: 25981,
      question: "PTSD is a disorder that develops following:",
      options: [
        "Only physical trauma",
        "Only emotional trauma",
        "Either physical or emotional trauma",
        "Genetic predisposition"
      ],
      correct: "C"
    },
    {
      id: 25982,
      question: "Cognitive behavioral therapy is effective for:",
      options: [
        "Improving cognition in TBI",
        "Curing TBI completely",
        "Preventing all complications",
        "Reversing brain damage"
      ],
      correct: "A"
    },
    {
      id: 25983,
      question: "The spinal cord lies within the:",
      options: [
        "Cranium",
        "Vertebral column",
        "Rib cage",
        "Pelvic cavity"
      ],
      correct: "B"
    },
    {
      id: 25984,
      question: "There are how many pairs of spinal nerves that arise along the spinal cord:",
      options: [
        "21",
        "26",
        "31",
        "36"
      ],
      correct: "C"
    },
    {
      id: 25985,
      question: "The most superior spinal nerve pairs are:",
      options: [
        "8 cervical pairs",
        "12 thoracic pairs",
        "5 lumbar pairs",
        "5 sacral pairs"
      ],
      correct: "A"
    },
    {
      id: 25986,
      question: "Spinal cord injury is caused primarily by:",
      options: [
        "Disease processes",
        "Motor vehicle accidents",
        "Sports injuries",
        "Falls in elderly"
      ],
      correct: "B"
    },
    {
      id: 25987,
      question: "About what percentage of SCI patients are male:",
      options: [
        "60%",
        "70%",
        "80%",
        "90%"
      ],
      correct: "C"
    },
    {
      id: 25988,
      question: "A complete spinal cord injury indicates:",
      options: [
        "Partial sensation below injury",
        "Loss of almost all sensation and movement control below SCI",
        "Full recovery expected",
        "Minor symptoms only"
      ],
      correct: "B"
    },
    {
      id: 25989,
      question: "An incomplete spinal cord injury:",
      options: [
        "Has no symptoms",
        "Retains some sensory and motor function below affected area",
        "Only affects sensation",
        "Only affects movement"
      ],
      correct: "B"
    },
    {
      id: 25990,
      question: "Paraplegia describes involvement of:",
      options: [
        "One limb only",
        "Trunk, legs, and pelvic organs",
        "Arms and hands",
        "Upper body only"
      ],
      correct: "B"
    },
    {
      id: 25991,
      question: "Tetraplegia (quadriplegia) also involves:",
      options: [
        "Only the legs",
        "Only the trunk",
        "The arms and hands",
        "Neck muscles only"
      ],
      correct: "C"
    },
    {
      id: 25992,
      question: "The use of mouth-held appliances like mouthsticks may cause:",
      options: [
        "Improved oral health",
        "Trauma to hard and soft oral tissues",
        "Better oral hygiene",
        "No oral effects"
      ],
      correct: "B"
    },
    {
      id: 25993,
      question: "A seizure is a sudden, uncontrolled burst of electrical activity in the:",
      options: [
        "Heart",
        "Brain",
        "Spinal cord",
        "Peripheral nerves"
      ],
      correct: "B"
    },
    {
      id: 25994,
      question: "A seizure typically has a duration of:",
      options: [
        "5 to 10 seconds",
        "30 seconds to 2 minutes",
        "5 to 10 minutes",
        "15 to 20 minutes"
      ],
      correct: "B"
    },
    {
      id: 25995,
      question: "A seizure is considered a medical emergency if it lasts:",
      options: [
        "1 minute or longer",
        "2 minutes or longer",
        "5 minutes or longer",
        "10 minutes or longer"
      ],
      correct: "C"
    },
    {
      id: 25996,
      question: "The three major classifications for seizure types are:",
      options: [
        "Minor, moderate, and major",
        "Focal onset, generalized onset, or unknown onset",
        "Primary, secondary, and tertiary",
        "Acute, chronic, and episodic"
      ],
      correct: "B"
    },
    {
      id: 25997,
      question: "Focal seizures are caused by abnormal electrical activity in:",
      options: [
        "One area of the brain",
        "Both hemispheres",
        "The entire brain",
        "The brainstem only"
      ],
      correct: "A"
    },
    {
      id: 25998,
      question: "Generalized seizures involve:",
      options: [
        "One side of brain",
        "Diffuse areas of the brain",
        "Only the frontal lobe",
        "Only the cerebellum"
      ],
      correct: "B"
    },
    {
      id: 25999,
      question: "A diagnosis of epilepsy is related to:",
      options: [
        "One seizure of any type",
        "Two or more seizures at least 24 hours apart with unknown onset",
        "Family history only",
        "Abnormal EEG only"
      ],
      correct: "B"
    },
    {
      id: 26000,
      question: "Epilepsy is ranked as the:",
      options: [
        "Second most common neurological disorder",
        "Third most common neurological disorder",
        "Fourth most common neurological disorder",
        "Fifth most common neurological disorder"
      ],
      correct: "C"
    },
    {
      id: 26001,
      question: "Tonic-clonic seizures were formerly called:",
      options: [
        "Petit mal",
        "Grand mal",
        "Absence seizures",
        "Focal seizures"
      ],
      correct: "B"
    },
    {
      id: 26002,
      question: "In the tonic phase of a tonic-clonic seizure, muscles undergo:",
      options: [
        "Relaxation",
        "Stiffening contractions",
        "Rhythmic jerking",
        "No movement"
      ],
      correct: "B"
    },
    {
      id: 26003,
      question: "In the clonic phase of a tonic-clonic seizure, there is:",
      options: [
        "Complete paralysis",
        "Rhythmic jerking of all four extremities",
        "Muscle stiffening only",
        "Loss of consciousness only"
      ],
      correct: "B"
    },
    {
      id: 26004,
      question: "The typical duration of a tonic-clonic seizure is:",
      options: [
        "5 to 15 seconds",
        "1 to 3 minutes",
        "5 to 10 minutes",
        "15 to 20 minutes"
      ],
      correct: "B"
    },
    {
      id: 26005,
      question: "Status Epilepticus is a life-threatening emergency that occurs when:",
      options: [
        "One seizure occurs",
        "Three seizures in a row without regaining consciousness between them",
        "Seizure lasts less than 2 minutes",
        "Patient has an aura"
      ],
      correct: "B"
    },
    {
      id: 26006,
      question: "Absence seizures were formerly called:",
      options: [
        "Grand mal",
        "Petit mal",
        "Focal seizures",
        "Atonic seizures"
      ],
      correct: "B"
    },
    {
      id: 26007,
      question: "Absence seizures are common in children aged:",
      options: [
        "0 to 3 years",
        "4 to 14 years",
        "15 to 20 years",
        "Over 21 years"
      ],
      correct: "B"
    },
    {
      id: 26008,
      question: "The duration of absence seizures is usually:",
      options: [
        "1 to 5 seconds",
        "10 to 20 seconds",
        "30 to 60 seconds",
        "1 to 2 minutes"
      ],
      correct: "B"
    },
    {
      id: 26009,
      question: "Phenytoin may cause:",
      options: [
        "Tooth whitening",
        "Severe gingival enlargement",
        "Enamel strengthening",
        "Reduced salivation"
      ],
      correct: "B"
    },
    {
      id: 26010,
      question: "Phenytoin-induced gingival enlargement occurs in approximately:",
      options: [
        "One-quarter of patients",
        "Half of patients",
        "Three-quarters of patients",
        "All patients"
      ],
      correct: "B"
    },
    {
      id: 26011,
      question: "Nitrous oxide and oxygen sedation for epilepsy patients is:",
      options: [
        "Highly recommended",
        "Not recommended",
        "Always required",
        "Optional in all cases"
      ],
      correct: "B"
    },
    {
      id: 26012,
      question: "For patients with epilepsy, appointments should be made:",
      options: [
        "Late in the day",
        "Early in the day",
        "During lunch hours",
        "In the evening"
      ],
      correct: "B"
    },
    {
      id: 26013,
      question: "Motor nerve damage in peripheral neuropathies results in:",
      options: [
        "Enhanced reflexes",
        "Muscle weakness, twitching, atrophy",
        "Increased sensation",
        "Improved coordination"
      ],
      correct: "B"
    },
    {
      id: 26014,
      question: "Sensory nerve damage in peripheral neuropathies may cause:",
      options: [
        "Improved sensation",
        "Pain, numbness, and tingling",
        "Enhanced temperature sensation",
        "Better proprioception"
      ],
      correct: "B"
    },
    {
      id: 26015,
      question: "The most common cause of peripheral neuropathy is:",
      options: [
        "Trauma",
        "Metabolic disorders, particularly diabetes mellitus",
        "Infections",
        "Genetic disorders"
      ],
      correct: "B"
    },
    {
      id: 26016,
      question: "Bell palsy is also known as:",
      options: [
        "Trigeminal neuralgia",
        "Idiopathic facial paralysis",
        "Facial tremor",
        "Facial spasm"
      ],
      correct: "B"
    },
    {
      id: 26017,
      question: "The onset of Bell palsy is:",
      options: [
        "Gradual over weeks",
        "Acute, usually unilateral, and temporary",
        "Always bilateral",
        "Chronic and permanent"
      ],
      correct: "B"
    },
    {
      id: 26018,
      question: "Scientists believe Bell palsy occurs because the facial nerve becomes inflamed due to:",
      options: [
        "Bacterial infection",
        "Viral infection",
        "Fungal infection",
        "Parasitic infection"
      ],
      correct: "B"
    },
    {
      id: 26019,
      question: "Bell palsy is most common in the:",
      options: [
        "5 to 15 year age group",
        "15 to 45 year age group",
        "50 to 60 year age group",
        "Over 70 age group"
      ],
      correct: "B"
    },
    {
      id: 26020,
      question: "The facial nerve is cranial nerve:",
      options: [
        "V",
        "VII",
        "IX",
        "X"
      ],
      correct: "B"
    },
    {
      id: 26021,
      question: "In Bell palsy, facial distortion typically begins and reaches peak within:",
      options: [
        "12 to 24 hours",
        "48 to 72 hours",
        "5 to 7 days",
        "2 to 3 weeks"
      ],
      correct: "B"
    },
    {
      id: 26022,
      question: "Approximately what percentage of Bell palsy patients experience improvement within 3 weeks:",
      options: [
        "50%",
        "65%",
        "75%",
        "85%"
      ],
      correct: "D"
    },
    {
      id: 26023,
      question: "Oral corticosteroids for Bell palsy appear to be of greatest benefit when started within:",
      options: [
        "24 hours of onset",
        "48 hours of onset",
        "72 hours of onset",
        "1 week of onset"
      ],
      correct: "C"
    },
    {
      id: 26024,
      question: "Trigeminal neuralgia is a neuropathy of cranial nerve:",
      options: [
        "III",
        "V",
        "VII",
        "IX"
      ],
      correct: "B"
    },
    {
      id: 26025,
      question: "Trigeminal neuralgia is seen more often in:",
      options: [
        "Males",
        "Females",
        "Equally in both genders",
        "Children"
      ],
      correct: "B"
    },
    {
      id: 26026,
      question: "Most cases of trigeminal neuralgia occur over the age of:",
      options: [
        "30",
        "40",
        "50",
        "60"
      ],
      correct: "C"
    },
    {
      id: 26027,
      question: "The cause of trigeminal neuralgia is thought to be:",
      options: [
        "Bacterial infection",
        "Pressure from blood vessel against trigeminal nerve",
        "Viral inflammation",
        "Autoimmune response"
      ],
      correct: "B"
    },
    {
      id: 26028,
      question: "Type 1 trigeminal neuralgia causes episodes of pain that may last:",
      options: [
        "A few seconds or up to 2 minutes",
        "5 to 10 minutes",
        "15 to 30 minutes",
        "Hours"
      ],
      correct: "A"
    },
    {
      id: 26029,
      question: "Type 2 trigeminal neuralgia is characterized by:",
      options: [
        "Severe, sudden shocking pain",
        "More constant but less intense aching pain",
        "No pain at all",
        "Pain only when eating"
      ],
      correct: "B"
    },
    {
      id: 26030,
      question: "Trigeminal neuralgia symptoms usually occur in areas innervated by the trigeminal nerve, including:",
      options: [
        "Forehead only",
        "Cheek, jaw, teeth, gums, and lips",
        "Neck and shoulders",
        "Ears only"
      ],
      correct: "B"
    },
    {
      id: 26031,
      question: "The maxillary and mandibular branches of trigeminal nerve are affected:",
      options: [
        "Less often than ophthalmic branch",
        "About equally as ophthalmic branch",
        "More often than ophthalmic branch",
        "Never affected"
      ],
      correct: "C"
    },
    {
      id: 26032,
      question: "Trigeminal neuralgia can be triggered by:",
      options: [
        "Only severe trauma",
        "Even mild vibrations or light contact",
        "Nothing external",
        "Only during sleep"
      ],
      correct: "B"
    },
    {
      id: 26033,
      question: "Common triggers for trigeminal neuralgia include:",
      options: [
        "Deep breathing",
        "Speaking, eating, or brushing teeth",
        "Lying down",
        "Closing eyes"
      ],
      correct: "B"
    },
    {
      id: 26034,
      question: "Dementia is characterized by:",
      options: [
        "Temporary confusion",
        "Progressive intellectual decline",
        "Acute memory loss",
        "Physical disability only"
      ],
      correct: "B"
    },
    {
      id: 26035,
      question: "The onset of dementia is usually:",
      options: [
        "Sudden and dramatic",
        "Insidious",
        "Following trauma",
        "During childhood"
      ],
      correct: "B"
    },
    {
      id: 26036,
      question: "The incidence of most dementias rises substantially with:",
      options: [
        "Stress levels",
        "Increasing age",
        "Physical activity",
        "Social isolation"
      ],
      correct: "B"
    },
    {
      id: 26037,
      question: "Major risk factors for dementia are:",
      options: [
        "Diet and exercise only",
        "Age and genetics/family history",
        "Environmental factors only",
        "Occupational hazards"
      ],
      correct: "B"
    },
    {
      id: 26038,
      question: "Alzheimer disease is the most common cause of:",
      options: [
        "Stroke",
        "Dementia",
        "Seizures",
        "Paralysis"
      ],
      correct: "B"
    },
    {
      id: 26039,
      question: "Alzheimer disease is the seventh leading cause of death in the:",
      options: [
        "Canada",
        "United States",
        "United Kingdom",
        "Australia"
      ],
      correct: "B"
    },
    {
      id: 26040,
      question: "Alzheimer disease is the fifth leading cause of death among individuals over age:",
      options: [
        "55",
        "60",
        "65",
        "70"
      ],
      correct: "C"
    },
    {
      id: 26041,
      question: "The most significant risk factor for Alzheimer disease is:",
      options: [
        "Diet",
        "Age",
        "Exercise level",
        "Education"
      ],
      correct: "B"
    },
    {
      id: 26042,
      question: "Beta-amyloid plaques in Alzheimer disease are abnormal clumps of:",
      options: [
        "Calcium deposits",
        "Beta-amyloid protein and degenerating neurons",
        "Blood cells",
        "Scar tissue"
      ],
      correct: "B"
    },
    {
      id: 26043,
      question: "Neurofibrillary tangles in Alzheimer disease are:",
      options: [
        "Normal brain structures",
        "Irregular knots of cytoskeletal intermediate filaments",
        "Blood vessel abnormalities",
        "Bone deposits"
      ],
      correct: "B"
    },
    {
      id: 26044,
      question: "Porphyromonas gingivalis has been identified in brain tissue of:",
      options: [
        "Healthy individuals",
        "Alzheimer disease patients",
        "Stroke patients only",
        "No patients"
      ],
      correct: "B"
    },
    {
      id: 26045,
      question: "Gingipains are proteases secreted by:",
      options: [
        "All oral bacteria",
        "Porphyromonas gingivalis",
        "Streptococcus mutans",
        "Candida albicans"
      ],
      correct: "B"
    },
    {
      id: 26046,
      question: "Currently, the FDA has approved how many drugs for treatment of Alzheimer disease:",
      options: [
        "Three",
        "Four",
        "Five",
        "Six"
      ],
      correct: "D"
    },
    {
      id: 26047,
      question: "Aducanumab works to:",
      options: [
        "Increase dopamine",
        "Reduce beta-amyloid plaques",
        "Improve memory directly",
        "Cure the disease"
      ],
      correct: "B"
    },
    {
      id: 26048,
      question: "The average duration from earliest Alzheimer symptoms to death is:",
      options: [
        "3 years",
        "5 years",
        "8 years",
        "12 years"
      ],
      correct: "C"
    },
    {
      id: 26049,
      question: "Patients with Alzheimer disease have more gingival disease and caries mainly because of:",
      options: [
        "Genetic factors",
        "Poor oral hygiene from significant neglect",
        "Medication side effects only",
        "Dietary changes"
      ],
      correct: "B"
    },
    {
      id: 26050,
      question: "For Alzheimer patients, appointments should be scheduled:",
      options: [
        "Late in the day",
        "Early in the day when office is not busy",
        "During busy times",
        "In the evening"
      ],
      correct: "B"
    },
    {
      id: 26051,
      question: "Cerebrovascular accident (CVA) occurs when there is:",
      options: [
        "Gradual blood flow decrease",
        "Abrupt interruption of oxygenated blood to brain",
        "Temporary blood pressure drop",
        "Minor circulation changes"
      ],
      correct: "B"
    },
    {
      id: 26052,
      question: "Strokes are the leading cause of death in the United States:",
      options: [
        "Third",
        "Fourth",
        "Fifth",
        "Sixth"
      ],
      correct: "C"
    },
    {
      id: 26053,
      question: "The major risk factor for CVA is:",
      options: [
        "Diabetes",
        "Hypertension",
        "High cholesterol",
        "Obesity"
      ],
      correct: "B"
    },
    {
      id: 26054,
      question: "Hypertension increases the chance of experiencing a stroke by:",
      options: [
        "1 to 2 times",
        "2 to 4 times",
        "5 to 6 times",
        "7 to 8 times"
      ],
      correct: "B"
    },
    {
      id: 26055,
      question: "Smoking multiplies the chance of having a stroke by:",
      options: [
        "Two",
        "Three",
        "Four",
        "Five"
      ],
      correct: "A"
    },
    {
      id: 26056,
      question: "The most common type of CVA is:",
      options: [
        "Hemorrhagic stroke",
        "Ischemic stroke",
        "Embolic stroke",
        "Lacunar stroke"
      ],
      correct: "B"
    },
    {
      id: 26057,
      question: "An embolism is:",
      options: [
        "Clot that develops in brain vessel",
        "Blood clot that travels to brain from another part of body",
        "Ruptured blood vessel",
        "Narrowed artery"
      ],
      correct: "B"
    },
    {
      id: 26058,
      question: "Thrombosis refers to:",
      options: [
        "Blood clot traveling from elsewhere",
        "Clot that develops within blood vessel of brain or neck",
        "Ruptured vessel",
        "Arterial narrowing"
      ],
      correct: "B"
    },
    {
      id: 26059,
      question: "Stenosis is:",
      options: [
        "Blood clot formation",
        "Vessel rupture",
        "Severe narrowing of an artery",
        "Increased blood flow"
      ],
      correct: "C"
    },
    {
      id: 26060,
      question: "Hemorrhagic stroke results from:",
      options: [
        "Blood clot blocking vessel",
        "Rupture of brain vessel and leakage of blood",
        "Arterial narrowing",
        "Decreased blood pressure"
      ],
      correct: "B"
    },
    {
      id: 26061,
      question: "An aneurysm is:",
      options: [
        "Blood clot",
        "Bulge in artery due to weakness in blood vessel wall",
        "Narrowed vessel",
        "Ruptured capillary"
      ],
      correct: "B"
    },
    {
      id: 26062,
      question: "A TIA (transient ischemic attack) is a focal neurologic deficit that persists for less than:",
      options: [
        "6 hours",
        "12 hours",
        "24 hours",
        "48 hours"
      ],
      correct: "C"
    },
    {
      id: 26063,
      question: "Most TIAs last less than:",
      options: [
        "5 minutes",
        "10 minutes",
        "30 minutes",
        "1 hour"
      ],
      correct: "B"
    },
    {
      id: 26064,
      question: "What percentage of people will have a major stroke within 3 months of having a TIA:",
      options: [
        "5% to 10%",
        "10% to 15%",
        "20% to 25%",
        "30% to 35%"
      ],
      correct: "B"
    },
    {
      id: 26065,
      question: "The left side of the brain controls motor and sensory input for:",
      options: [
        "Left side of body",
        "Right side of body",
        "Both sides equally",
        "Neither side"
      ],
      correct: "B"
    },
    {
      id: 26066,
      question: "Apraxia is:",
      options: [
        "Muscle paralysis",
        "Inability to perform purposeful movements",
        "Loss of sensation",
        "Visual impairment"
      ],
      correct: "B"
    },
    {
      id: 26067,
      question: "Aphasia after stroke is manifested by:",
      options: [
        "Muscle weakness only",
        "Disturbances in comprehension and expression",
        "Visual problems only",
        "Hearing loss"
      ],
      correct: "B"
    },
    {
      id: 26068,
      question: "The most common affective disturbance after stroke is:",
      options: [
        "Anxiety",
        "Depression",
        "Mania",
        "Psychosis"
      ],
      correct: "B"
    },
    {
      id: 26069,
      question: "The acronym FAST for identifying stroke stands for:",
      options: [
        "Fever, Anxiety, Sweating, Tremor",
        "Face drooping, Arm weakness, Speech difficulty, Time to call 911",
        "Fatigue, Ataxia, Sensory loss, Treatment",
        "Facial pain, Arm numbness, Seizure, Time"
      ],
      correct: "B"
    },
    {
      id: 26070,
      question: "Treatments for stroke are most effective when initiated within:",
      options: [
        "1 hour",
        "3 hours",
        "6 hours",
        "12 hours"
      ],
      correct: "B"
    },
    {
      id: 26071,
      question: "Blood pressure of 180 mmHg systolic and/or 120 mmHg diastolic or higher is considered:",
      options: [
        "Normal",
        "Stage 1 hypertension",
        "Stage 2 hypertension",
        "Hypertension crisis"
      ],
      correct: "D"
    },
    {
      id: 26072,
      question: "Right-sided brain damage causes paralysis of:",
      options: [
        "Right side of body",
        "Left side of body",
        "Both sides equally",
        "No paralysis"
      ],
      correct: "B"
    },
    {
      id: 26073,
      question: "Left-sided brain damage causes:",
      options: [
        "Spatial deficits",
        "Language and speech problems",
        "Quick, impulsive behavior",
        "Visual problems only"
      ],
      correct: "B"
    },
    {
      id: 26074,
      question: "Patients with right-sided brain damage may exhibit:",
      options: [
        "Speech problems",
        "Spatial or perceptual deficits",
        "Slow, cautious behavior",
        "Decreased auditory memory"
      ],
      correct: "B"
    },
    {
      id: 26075,
      question: "Patients with left-sided brain damage may exhibit:",
      options: [
        "Quick, impulsive behavior",
        "Slow, cautious, disorganized behavior",
        "Spatial deficits",
        "Memory for events only"
      ],
      correct: "B"
    }
  ]
,
  "1. Pediatric and Adolescent Care (Case Study)": [
    {
      id: 26076,
      question: "What is the PRIMARY reason for establishing a dental home by 12 months of age?",
      options: [
        "To ensure proper tooth eruption patterns are monitored throughout childhood development",
        "To establish ongoing comprehensive oral healthcare and promote healthy behaviors early",
        "To identify genetic conditions that may affect oral health in later years",
        "To provide fluoride treatments before the child develops dental caries risk"
      ],
      correct: "B"
    },
    {
      id: 26077,
      question: "According to the Fisher-Owens model, which factor is MOST directly contributing to Marcus's current oral health condition?",
      options: [
        "Community-level influences related to access to fluoridated water systems",
        "Family-level influences including health behaviors and dietary practices",
        "Genetic and biologic endowment affecting enamel development patterns",
        "Physical environment factors affecting the child's exposure to cariogenic bacteria"
      ],
      correct: "B"
    },
    {
      id: 26078,
      question: "Which recommendation is MOST appropriate for managing Sofia's teething symptoms?",
      options: [
        "Apply teething gel containing benzocaine to numb the affected gingival areas",
        "Provide clean, cool washcloths or solid teething rings for the child to chew",
        "Give the child a teething necklace to wear throughout the day and night",
        "Offer warm beverages in a bottle to soothe the inflamed gingival tissues"
      ],
      correct: "B"
    },
    {
      id: 26079,
      question: "What type of bacterial transmission is occurring in this scenario?",
      options: [
        "Environmental transmission through contaminated surfaces in the home setting",
        "Horizontal transmission between the child and other children at daycare",
        "Vertical transmission from the mother to child through salivary contact",
        "Secondary transmission through airborne pathogens during close contact"
      ],
      correct: "C"
    },
    {
      id: 26080,
      question: "What is the PRIMARY concern regarding enamel developmental defects in primary dentition?",
      options: [
        "They indicate underlying systemic diseases requiring immediate medical referral",
        "They create retention areas for plaque, increasing dental caries risk significantly",
        "They will automatically transfer to permanent teeth during tooth development",
        "They suggest nutritional deficiencies that must be corrected through supplementation"
      ],
      correct: "B"
    },
    {
      id: 26081,
      question: "According to ADA guidelines, what fluoride supplement dosage is recommended for these children?",
      options: [
        "0.25 mg fluoride daily based on their age and water fluoride concentration",
        "0.50 mg fluoride daily to compensate for the low community water levels",
        "1.0 mg fluoride daily since they are past their first year of life",
        "No supplementation needed until permanent teeth begin to erupt around age six"
      ],
      correct: "A"
    },
    {
      id: 26082,
      question: "What preventive intervention is MOST appropriate at this appointment?",
      options: [
        "Application of fluoride varnish only to strengthen the newly erupted enamel",
        "Prophylactic antibiotic therapy to prevent bacterial colonization of the molars",
        "Placement of dental sealants to protect the occlusal surfaces from caries",
        "Prescription of fluoride supplements to enhance systemic fluoride exposure"
      ],
      correct: "C"
    },
    {
      id: 26083,
      question: "Which classification BEST describes Nina's gingival condition?",
      options: [
        "Necrotizing ulcerative gingivitis caused by opportunistic bacterial infection",
        "Drug-influenced gingival enlargement related to hormonal contraceptive use",
        "Endogenous sex steroid hormone gingival disease modified by systemic factors",
        "Chronic periodontitis with attachment loss due to inadequate oral hygiene"
      ],
      correct: "C"
    },
    {
      id: 26084,
      question: "Based on these findings, how should Ethan's caries risk be classified?",
      options: [
        "Low risk because he is still in the primary dentition stage of development",
        "Moderate risk requiring enhanced preventive measures and dietary counseling",
        "High risk due to the presence of multiple risk factors and clinical findings",
        "Questionable risk pending further diagnostic radiographs and clinical testing"
      ],
      correct: "C"
    },
    {
      id: 26085,
      question: "Which practice should the hygienist recommend to PREVENT vertical transmission of cariogenic bacteria?",
      options: [
        "Share eating utensils with the infant to build immune system tolerance",
        "Clean the pacifier in the parent's mouth before giving it to the baby",
        "Seek regular preventive dental care and avoid sharing utensils with the infant",
        "Test the temperature of food by tasting it before feeding the baby"
      ],
      correct: "C"
    },
    {
      id: 26086,
      question: "What is Isabella's dmft score?",
      options: [
        "7, representing only the decayed and filled teeth in the primary dentition",
        "9, representing the sum of all decayed, missing, and filled primary teeth",
        "11, including both affected primary teeth and permanent molars",
        "5, counting only the currently active carious lesions requiring treatment"
      ],
      correct: "B"
    },
    {
      id: 26087,
      question: "What recommendation should the hygienist make regarding athletic mouthguard use?",
      options: [
        "Continue using the stock mouthguard as it provides adequate protection for sports",
        "Switch to a boil-and-bite mouthguard for slightly improved fit and protection",
        "Obtain a custom-fitted mouthguard for optimal protection during sports activities",
        "Use the mouthguard only during football since basketball has lower injury risk"
      ],
      correct: "C"
    },
    {
      id: 26088,
      question: "What is the MOST appropriate guidance regarding Sophia's thumb-sucking habit?",
      options: [
        "Immediate intervention is necessary to prevent permanent malocclusion development",
        "This is a normal soothing mechanism; most children stop between ages 2-4 years",
        "Apply bitter-tasting solutions to the thumb to discourage the habit immediately",
        "Use restraining devices at night to physically prevent thumb access to mouth"
      ],
      correct: "B"
    },
    {
      id: 26089,
      question: "What concentration and frequency of fluoride varnish application is recommended?",
      options: [
        "1.23% APF varnish applied every 3 months for children in this age group",
        "2.26% sodium fluoride varnish applied every 3-6 months for at-risk children",
        "5% sodium fluoride varnish applied only once yearly for moderate-risk children",
        "0.5% fluoride varnish applied every 12 months for children with primary dentition"
      ],
      correct: "B"
    },
    {
      id: 26090,
      question: "What is the FIRST symptom of acute fluoride toxicity the hygienist should inform the parent to monitor?",
      options: [
        "Immediate respiratory distress requiring emergency medical intervention",
        "Gastrointestinal irritation including nausea, vomiting, and abdominal pain",
        "Cardiac arrhythmias and significant changes in blood pressure levels",
        "Central nervous system depression leading to confusion and disorientation"
      ],
      correct: "B"
    },
    {
      id: 26091,
      question: "According to best practices, at what age should children be weaned from the bottle?",
      options: [
        "6-8 months when solid foods are first introduced into the diet",
        "12-14 months to prevent prolonged bottle use and associated caries risk",
        "18-20 months when the child has developed sufficient motor coordination",
        "24-30 months after all primary teeth have erupted into the oral cavity"
      ],
      correct: "B"
    },
    {
      id: 26092,
      question: "Which statement is MOST accurate regarding e-cigarette use in adolescents?",
      options: [
        "E-cigarettes are FDA-approved cessation devices safe for teenage use",
        "Vaping contains no nicotine and poses minimal health risks to adolescents",
        "E-cigarettes are unsafe, contain nicotine, and increase cigarette smoking risk",
        "Occasional vaping has no long-term health consequences for this age group"
      ],
      correct: "C"
    },
    {
      id: 26093,
      question: "What is the MOST likely cause of Liam's delayed tooth eruption?",
      options: [
        "Genetic factors related to familial patterns of late tooth development",
        "Endocrine factors associated with his hypothyroidism diagnosis",
        "Oral space limitations preventing normal eruption of primary teeth",
        "Nutritional deficiencies affecting calcium and phosphorus metabolism"
      ],
      correct: "B"
    },
    {
      id: 26094,
      question: "What is the MOST likely mode of transmission for this infection?",
      options: [
        "Airborne transmission from infected individuals in public settings",
        "Vertical transmission during delivery from maternal genital infection",
        "Sharing toys, towels, or toothbrushes with infected individuals",
        "Contaminated food or water sources in the home environment"
      ],
      correct: "C"
    },
    {
      id: 26095,
      question: "How should the tooth with both a restoration and new decay be recorded in the DMFT index?",
      options: [
        "Counted as one decayed tooth (D) only, since active disease takes precedence",
        "Counted as one filled tooth (F) only, since the restoration was placed first",
        "Counted as both D and F, adding two points to the total DMFT score",
        "Excluded from the DMFT calculation due to the mixed disease presentation"
      ],
      correct: "A"
    },
    {
      id: 26096,
      question: "What is the MAXIMUM amount of fluoride gel that should be placed in each tray?",
      options: [
        "2 mL per tray since the child weighs less than 60 pounds",
        "4 mL per tray as the child is over 44 pounds body weight",
        "6 mL per tray to ensure complete coverage of all tooth surfaces",
        "8 mL per tray for maximum fluoride uptake in high-risk children"
      ],
      correct: "B"
    },
    {
      id: 26097,
      question: "Which teeth are MOST susceptible to decay at Mason's age according to decay susceptibility patterns?",
      options: [
        "Mandibular first molars which erupt earliest in the primary dentition",
        "Maxillary central and lateral incisors due to nocturnal feeding patterns",
        "All posterior teeth equally regardless of eruption timing or location",
        "Mandibular anterior teeth due to pooling of liquids in the floor of mouth"
      ],
      correct: "B"
    },
    {
      id: 26098,
      question: "What amount of fluoridated toothpaste should be recommended for Harper?",
      options: [
        "A smear or rice grain-sized amount until the child reaches age 6 years",
        "A pea-sized amount now that the child is over 3 years of age",
        "A full brush head amount to ensure adequate fluoride exposure daily",
        "No fluoridated toothpaste until the child can reliably expectorate"
      ],
      correct: "B"
    },
    {
      id: 26099,
      question: "According to CDC recommendations, what should the hygienist communicate about HPV vaccination?",
      options: [
        "HPV vaccination is only recommended for males to prevent oral cancer transmission",
        "Vaccination is unnecessary after age 15 as HPV exposure has likely occurred",
        "HPV vaccination is recommended for individuals through age 26 years for prevention",
        "The vaccine only prevents genital HPV and has no effect on oral HPV transmission"
      ],
      correct: "C"
    },
    {
      id: 26100,
      question: "What is the CURRENT recommended optimal fluoride concentration in community water supplies?",
      options: [
        "0.3 mg/L to minimize any risk of dental fluorosis in children",
        "0.7 mg/L to protect against caries while minimizing fluorosis",
        "1.2 mg/L to provide maximum caries prevention in all age groups",
        "2.0 mg/L in communities with high dental caries prevalence rates"
      ],
      correct: "B"
    },
    {
      id: 26101,
      question: "What resource should the hygienist recommend for determining fluoride levels in community water?",
      options: [
        "Contact the child's pediatrician for information about local water fluoride levels",
        "Purchase home water testing kits from the pharmacy for immediate results",
        "Contact the CDC or state public health department for community fluoride data",
        "Assume all city water is optimally fluoridated and requires no verification"
      ],
      correct: "C"
    },
    {
      id: 26102,
      question: "What is the MOST critical preventive strategy to recommend for Elijah?",
      options: [
        "Prescribe high-dose fluoride supplements regardless of water fluoridation status",
        "Schedule monthly professional fluoride applications starting at 12 months of age",
        "Treat the mother's active decay and educate about preventing bacterial transmission",
        "Delay establishing a dental home until the child has more teeth erupted"
      ],
      correct: "C"
    },
    {
      id: 26103,
      question: "What instruction is MOST important to give the parents following fluoride varnish application?",
      options: [
        "Have the child rinse vigorously with water immediately after application",
        "Avoid hard foods, hot beverages, brushing, and flossing for 4-6 hours minimum",
        "Brush and floss the child's teeth within 30 minutes to spread the varnish",
        "Apply additional over-the-counter fluoride gel at home within 2 hours"
      ],
      correct: "B"
    },
    {
      id: 26104,
      question: "When calculating Alex's DMFS index, how many surfaces are measured per posterior tooth?",
      options: [
        "Three surfaces including mesial, distal, and occlusal",
        "Four surfaces including buccal, lingual, mesial, and distal",
        "Five surfaces including mesial, distal, buccal, lingual, and occlusal",
        "Six surfaces to include all anatomical aspects of posterior teeth"
      ],
      correct: "C"
    },
    {
      id: 26105,
      question: "What is the PRIMARY purpose of the show-tell-do behavioral guidance technique?",
      options: [
        "To physically restrain uncooperative children during necessary dental procedures",
        "To explain procedures in age-appropriate language and demonstrate before performing",
        "To use sedation medications to reduce anxiety in all pediatric dental patients",
        "To allow parents to perform dental procedures while the clinician provides verbal guidance"
      ],
      correct: "B"
    },
    {
      id: 26106,
      question: "What is a PRIMARY consideration when recommending SDF treatment for cavitated primary teeth?",
      options: [
        "SDF permanently stains the treated area black, which may be esthetically undesirable",
        "SDF application requires general anesthesia for proper placement in young children",
        "SDF is only effective on permanent teeth and should not be used in primary dentition",
        "SDF eliminates the need for any follow-up dental visits or oral hygiene practices"
      ],
      correct: "A"
    },
    {
      id: 26107,
      question: "What guidance should the hygienist provide regarding toothpaste selection for Ava?",
      options: [
        "Continue using fluoride-free toothpaste until age 6 to completely prevent fluorosis risk",
        "Use a smear amount of fluoridated toothpaste to prevent caries while minimizing fluorosis risk",
        "Apply adult-strength fluoride toothpaste since optimal water fluoridation is already present",
        "Alternate between fluoridated and non-fluoridated toothpaste throughout the week"
      ],
      correct: "B"
    },
    {
      id: 26108,
      question: "What is Caleb's DMFS score?",
      options: [
        "3, representing one surface decayed, one filled, and one tooth missing",
        "4, accounting for all affected surfaces including the missing tooth",
        "6, counting multiple surfaces for the missing molar tooth",
        "8, including all surfaces of affected teeth in the calculation"
      ],
      correct: "B"
    },
    {
      id: 26109,
      question: "Which anticipatory guidance topic is MOST appropriate for this age group regarding injury prevention?",
      options: [
        "Proper mouthguard fitting for organized sports participation",
        "Safety measures including car seats, stairs, and household hazards",
        "Orthodontic evaluation for bite relationship and alignment concerns",
        "Third molar assessment and potential impaction risk factors"
      ],
      correct: "B"
    },
    {
      id: 26110,
      question: "Which primary teeth typically exfoliate FIRST in the normal eruption sequence?",
      options: [
        "Maxillary central incisors around age 6-7 years",
        "Mandibular central incisors around age 6-7 years",
        "Mandibular first molars around age 9-10 years",
        "Maxillary lateral incisors around age 7-8 years"
      ],
      correct: "B"
    },
    {
      id: 26111,
      question: "According to the Academy of Sports Dentistry, in which types of sports are mouthguards encouraged?",
      options: [
        "Only in contact sports like football, hockey, and boxing",
        "Only in sports with documented high rates of facial injury",
        "In all collision and contact sports for optimal injury prevention",
        "Only in organized school-sponsored competitive athletic programs"
      ],
      correct: "C"
    },
    {
      id: 26112,
      question: "What information should the hygienist provide about prolonged breastfeeding beyond 12 months?",
      options: [
        "Breastfeeding beyond 12 months has no relationship to dental caries development",
        "Nocturnal and frequent breastfeeding beyond 12 months may increase caries risk",
        "Breastfeeding should stop immediately at 12 months to prevent enamel damage",
        "Extended breastfeeding provides natural fluoride and prevents all dental caries"
      ],
      correct: "B"
    },
    {
      id: 26113,
      question: "At what age do children typically have the dexterity to brush effectively without caregiver follow-up?",
      options: [
        "Age 3 when children develop fine motor control for toothbrush manipulation",
        "Age 6 when children have the coordination to reach all tooth surfaces adequately",
        "Age 8 when permanent teeth are erupting and children understand caries concepts",
        "Age 10 when children have fully developed manual dexterity and responsibility"
      ],
      correct: "B"
    },
    {
      id: 26114,
      question: "What is the MOST likely explanation for Christopher's transient oral changes?",
      options: [
        "Early-onset aggressive periodontitis requiring immediate antibiotic therapy",
        "Altered host response related to increased sex steroid hormone levels during puberty",
        "Severe vitamin deficiency causing systemic effects on oral tissues",
        "Undiagnosed autoimmune disorder affecting multiple body systems"
      ],
      correct: "B"
    },
    {
      id: 26115,
      question: "What is the PRIMARY goal of improving oral health literacy among caregivers?",
      options: [
        "To ensure all parents can read and understand complex dental terminology",
        "To enable caregivers to evaluate, understand, and use oral health information for good decisions",
        "To require parents to attend dental school-level courses on oral disease processes",
        "To mandate that all oral health information be provided in written format only"
      ],
      correct: "B"
    },
    {
      id: 26116,
      question: "What clinical finding automatically classifies a child as HIGH risk for caries?",
      options: [
        "Visible plaque accumulation on anterior teeth only",
        "Presence of white spot lesions or obvious decay",
        "Gingivitis with mild gingival bleeding on probing",
        "History of previous dental visits within the past year"
      ],
      correct: "B"
    },
    {
      id: 26117,
      question: "What oral care recommendation is MOST appropriate for this pre-dentate infant?",
      options: [
        "Begin brushing with fluoride toothpaste as soon as any teeth are visible",
        "Thoroughly clean gums after each feeding with a water-soaked washcloth",
        "No oral care is needed until the first tooth erupts into the mouth",
        "Apply fluoride varnish monthly to prevent early childhood caries development"
      ],
      correct: "B"
    },
    {
      id: 26118,
      question: "What adolescent oral health concern is reflected in Madison's behavior?",
      options: [
        "Pathologic dental anxiety requiring behavioral intervention",
        "Early signs of body dysmorphic disorder needing psychological referral",
        "Normal aesthetic appearance desires common in adolescent development",
        "Indication of underlying eating disorder requiring immediate assessment"
      ],
      correct: "C"
    },
    {
      id: 26119,
      question: "What is the recommended application time for professionally applied APF gel?",
      options: [
        "1 minute to minimize patient discomfort and fluoride exposure",
        "2 minutes for adequate fluoride uptake in permanent dentition",
        "4 minutes for optimal fluoride incorporation into tooth enamel",
        "10 minutes for maximum caries prevention in high-risk patients"
      ],
      correct: "C"
    },
    {
      id: 26120,
      question: "What is the PRIMARY concern with frequent snacking on cariogenic foods throughout the day?",
      options: [
        "Increased caloric intake leading to childhood obesity and related health problems",
        "Development of food allergies and sensitivities affecting overall health status",
        "Frequent sugar intake prevents acid neutralization, increasing caries risk significantly",
        "Choking hazards associated with chewy snacks in young children under supervision"
      ],
      correct: "C"
    },
    {
      id: 26121,
      question: "Which behavioral guidance technique involves asking the patient questions, providing information, and then having the patient explain the information back?",
      options: [
        "Show-tell-do technique for demonstrating procedures",
        "Positive reinforcement of desired behaviors",
        "Teach-back method for assessing understanding",
        "Motivational interviewing for behavioral change"
      ],
      correct: "C"
    },
    {
      id: 26122,
      question: "What protective factor should be documented in Jordan's oral health risk assessment?",
      options: [
        "Medicaid eligibility providing access to dental care services",
        "Participation in the school lunch program indicating nutritional support",
        "Presence of deep pits and fissures allowing better plaque retention",
        "Current enrollment in school providing structured daily routine"
      ],
      correct: "A"
    },
    {
      id: 26123,
      question: "What is the MOST appropriate response regarding delayed tooth eruption at 9 months?",
      options: [
        "This is significantly delayed; refer immediately for genetic testing",
        "This is within normal range; first teeth typically erupt between 5-8 months but can vary",
        "This indicates serious endocrine disorder requiring urgent medical evaluation",
        "This is expected; primary teeth don't normally erupt until 12-15 months of age"
      ],
      correct: "B"
    },
    {
      id: 26124,
      question: "Which healthcare professionals have the MOST frequent interactions with young children and caregivers, making them well-positioned to promote early dental visits?",
      options: [
        "School nurses, teachers, and athletic coaches in educational settings",
        "Midwives, obstetricians, pediatricians, and WIC program personnel",
        "Physical therapists, occupational therapists, and speech pathologists",
        "Pharmacists, optometrists, and audiologists in community settings"
      ],
      correct: "B"
    },
    {
      id: 26125,
      question: "Which epidemiologic index is MOST appropriate for measuring dental caries prevalence in permanent teeth?",
      options: [
        "Community Periodontal Index (CPI) for assessing periodontal disease",
        "Decayed, Missing, Filled Teeth (DMFT) index for quantifying caries experience",
        "Gingival Index (GI) for measuring gingival inflammation levels",
        "Plaque Index (PI) for assessing oral hygiene effectiveness"
      ],
      correct: "B"
    }
  ],
  "2. Pregnancy and Oral Health (Case Study)": [
    {
      id: 26126,
      question: "What is the MOST appropriate scheduling recommendation for Maria's next dental appointment?",
      options: [
        "Schedule appointments in the late morning during the first trimester to accommodate nausea patterns",
        "Schedule appointments in the early afternoon during the first and early second trimester",
        "Schedule appointments only in the third trimester when morning sickness has completely resolved",
        "Schedule appointments in the early morning before breakfast to prevent nausea during treatment"
      ],
      correct: "B"
    },
    {
      id: 26127,
      question: "What is the PRIMARY etiology of Jennifer's current gingival condition?",
      options: [
        "Bacterial plaque accumulation combined with hormonal changes increasing inflammatory response",
        "Vitamin deficiency resulting from inadequate prenatal nutrition and supplement intake",
        "Decreased salivary flow rate due to hormonal changes during pregnancy",
        "Increased consumption of cariogenic foods and beverages to manage pregnancy cravings"
      ],
      correct: "A"
    },
    {
      id: 26128,
      question: "What is the MOST likely diagnosis for this lesion?",
      options: [
        "Squamous cell carcinoma requiring immediate biopsy and oncology referral",
        "Pyogenic granuloma that typically regresses after pregnancy without intervention",
        "Necrotizing ulcerative gingivitis requiring immediate antibiotic therapy",
        "Peripheral giant cell granuloma requiring surgical excision before delivery"
      ],
      correct: "B"
    },
    {
      id: 26129,
      question: "What is the MOST appropriate positioning modification for Lisa?",
      options: [
        "Keep her head higher than feet and place pillow under right hip or turn slightly left",
        "Position her completely supine with feet elevated above heart level",
        "Keep her in fully upright sitting position throughout the entire appointment",
        "Position her on right side with head lower than feet to improve blood flow"
      ],
      correct: "A"
    },
    {
      id: 26130,
      question: "According to current recommendations, what guidance should the dental hygienist provide about fluoride supplementation?",
      options: [
        "Prescribe 2.2 mg fluoride tablets daily throughout pregnancy for optimal fetal tooth development",
        "Recommend drinking optimally fluoridated bottled water or discuss fluoride supplements with her physician",
        "Avoid all fluoride during pregnancy due to potential teratogenic effects on fetus",
        "Apply fluoride varnish monthly throughout pregnancy to maximize maternal and fetal benefits"
      ],
      correct: "B"
    },
    {
      id: 26131,
      question: "What is the MOST important information to communicate to Rachel about gestational diabetes and oral health?",
      options: [
        "Gestational diabetes has no relationship to oral health or periodontal disease progression",
        "There is a bidirectional relationship between diabetes and oral health affecting pregnancy outcomes",
        "Gestational diabetes only affects the baby and has no impact on maternal oral health",
        "Diabetes during pregnancy eliminates the need for professional oral healthcare until delivery"
      ],
      correct: "B"
    },
    {
      id: 26132,
      question: "What is the MOST appropriate response regarding dental radiographs during pregnancy?",
      options: [
        "Dental radiographs should never be taken during pregnancy regardless of clinical need",
        "Radiographs are only safe during the second trimester between 14-27 weeks gestation",
        "Dental radiographs with proper shielding are safe during all trimesters of pregnancy",
        "Radiographs should be delayed until after delivery unless there is life-threatening emergency"
      ],
      correct: "C"
    },
    {
      id: 26133,
      question: "According to current guidelines, which statement about local anesthetics during pregnancy is CORRECT?",
      options: [
        "All local anesthetics are contraindicated during the first trimester of pregnancy",
        "Local anesthetics with epinephrine may be used safely during pregnancy",
        "Only local anesthetics without vasoconstrictor are safe during pregnancy",
        "Local anesthetics should only be used during the third trimester of pregnancy"
      ],
      correct: "B"
    },
    {
      id: 26134,
      question: "What is the MOST appropriate recommendation for Christine after vomiting episodes?",
      options: [
        "Brush teeth immediately with fluoride toothpaste to remove gastric acid",
        "Rinse mouth with one teaspoon baking soda in water and avoid brushing for one hour",
        "Rinse vigorously with commercial mouthwash containing alcohol to neutralize acid",
        "Eat acidic fruits immediately to stimulate saliva production and buffer gastric acid"
      ],
      correct: "B"
    },
    {
      id: 26135,
      question: "What evidence-based guidance should the dental hygienist provide?",
      options: [
        "Postpone all dental care until after delivery to ensure maximum safety for the baby",
        "Oral healthcare during pregnancy has been repeatedly shown to be safe during all trimesters",
        "Only emergency dental care should be provided during pregnancy to minimize risks",
        "Dental care is safe but should be limited to the second trimester only"
      ],
      correct: "B"
    },
    {
      id: 26136,
      question: "What is the MOST appropriate recommendation for infant oral care?",
      options: [
        "Wait until the first tooth erupts at approximately 6-8 months before beginning oral care",
        "Begin cleaning the infant's mouth with a clean damp washcloth as soon as they return home",
        "Start brushing with fluoride toothpaste when the infant reaches 12 months of age",
        "No oral care is needed until all primary teeth have erupted by age 2-3 years"
      ],
      correct: "B"
    },
    {
      id: 26137,
      question: "What is the MOST important PRIMARY prevention strategy to teach Michelle?",
      options: [
        "Give the baby fluoride supplements starting immediately after birth regardless of water fluoridation",
        "Restore all of Michelle's carious lesions before delivery to reduce bacterial transmission to baby",
        "Avoid breastfeeding and use only bottled formula to prevent early childhood caries development",
        "Wait until age 2 to begin brushing the child's teeth to avoid fluorosis risk"
      ],
      correct: "B"
    },
    {
      id: 26138,
      question: "What type of bacterial transmission occurs when Patricia shares utensils and pre-chews food?",
      options: [
        "Horizontal transmission between family members or peers placing the child at caries risk",
        "Vertical transmission from mother to child through saliva increasing child's caries risk",
        "Environmental transmission through contaminated surfaces in the home",
        "Airborne transmission through respiratory droplets during close contact"
      ],
      correct: "B"
    },
    {
      id: 26139,
      question: "According to current pharmacologic guidelines, is this antibiotic prescription appropriate during pregnancy?",
      options: [
        "Amoxicillin is contraindicated and should be avoided during all trimesters of pregnancy",
        "Amoxicillin may be used safely during pregnancy for indicated medical conditions",
        "Amoxicillin is only safe during the second trimester between 14-27 weeks",
        "Amoxicillin should never be prescribed and penicillin must be substituted"
      ],
      correct: "B"
    },
    {
      id: 26140,
      question: "What is the CORRECT information regarding acetaminophen use during pregnancy?",
      options: [
        "Acetaminophen should never be used during pregnancy due to teratogenic effects",
        "Acetaminophen may be used safely during pregnancy for pain management",
        "Acetaminophen is only safe during the third trimester after organogenesis",
        "Acetaminophen should be avoided but aspirin is a safe alternative"
      ],
      correct: "B"
    },
    {
      id: 26141,
      question: "What is the PRIMARY concern regarding poorly controlled diabetes during the first trimester?",
      options: [
        "Increased risk of gestational hypertension and preeclampsia later in pregnancy",
        "Potential birth defects affecting heart, brain, kidneys, and spine development",
        "Higher likelihood of developing gestational diabetes in subsequent pregnancies",
        "Maternal weight gain exceeding recommended guidelines during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 26142,
      question: "According to FDA recommendations, how many servings of fish per week should pregnant women consume?",
      options: [
        "Avoid all fish during pregnancy due to mercury contamination concerns",
        "Eat 2 to 3 servings per week from \"Best Choices\" list with low mercury levels",
        "Consume unlimited amounts of any type of fish for omega-3 fatty acids",
        "Eat only canned tuna fish to ensure adequate protein intake during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 26143,
      question: "What is the recommended timeline for first tooth eruption and establishing a dental home?",
      options: [
        "First tooth erupts at 3-4 months and first dental visit should occur at 6 months",
        "First tooth erupts at 5-8 months and dental home should be established by 12 months",
        "First tooth erupts at 10-12 months and first dental visit should occur at 18 months",
        "First tooth erupts at 12-14 months and dental home should be established by 24 months"
      ],
      correct: "B"
    },
    {
      id: 26144,
      question: "What is the CORRECT amount of fluoride toothpaste recommended for infants?",
      options: [
        "A pea-sized amount of fluoride toothpaste on a soft infant toothbrush",
        "A smear or rice grain-sized amount of fluoride toothpaste on a soft toothbrush",
        "A full brush head of fluoride toothpaste for maximum caries protection",
        "No fluoride toothpaste until the child reaches 2 years of age"
      ],
      correct: "B"
    },
    {
      id: 26145,
      question: "What is the PRIMARY factor contributing to Melissa's increased caries risk?",
      options: [
        "Hormonal changes during pregnancy altering salivary pH and buffering capacity",
        "Frequent carbohydrate consumption and decreased attention to oral hygiene practices",
        "Reduced salivary flow rate causing inadequate clearance of food debris",
        "Increased calcium demands by the developing fetus depleting maternal tooth structure"
      ],
      correct: "B"
    },
    {
      id: 26146,
      question: "What is the PRIMARY goal of improving oral health literacy for pregnant women?",
      options: [
        "Ensuring all women can read complex dental terminology and scientific literature",
        "Enabling women to find, understand, and use information to make good health decisions",
        "Requiring women to attend dental school-level courses on oral disease processes",
        "Mandating that all oral health information be provided only in written format"
      ],
      correct: "B"
    },
    {
      id: 26147,
      question: "What communication method should the hygienist use to confirm Jessica's understanding?",
      options: [
        "Provide written materials in multiple languages and ask her to read them later",
        "Use the Teach Back Method having Jessica explain the information in her own words",
        "Ask simple yes/no questions that require minimal verbal response from the patient",
        "Assume understanding if Jessica nods in agreement during the educational session"
      ],
      correct: "B"
    },
    {
      id: 26148,
      question: "What is the PRIMARY purpose of monthly \"lift the lip\" examinations for infants?",
      options: [
        "To check for proper tooth eruption patterns and developmental anomalies",
        "To detect white spot lesions along the gum line that indicate early caries",
        "To monitor for tongue-tie or other frenum attachments affecting feeding",
        "To assess for proper jaw development and potential orthodontic problems"
      ],
      correct: "B"
    },
    {
      id: 26149,
      question: "According to US Preventive Services Task Force recommendations, what fluoride supplementation is appropriate?",
      options: [
        "No fluoride supplementation until the first tooth erupts into the oral cavity",
        "Begin oral fluoride supplementation at 6 months for infants with deficient water fluoride",
        "Wait until age 12 months to start fluoride supplements regardless of water levels",
        "Provide fluoride varnish applications monthly instead of oral supplementation"
      ],
      correct: "B"
    },
    {
      id: 26150,
      question: "What barrier to care does this scenario PRIMARILY represent?",
      options: [
        "Cost of dental care and inability to afford necessary treatment fees",
        "Lack of knowledge among prenatal providers about importance of oral healthcare",
        "Fear of dental procedures based on previous negative experiences",
        "Inability to find transportation to and from dental appointments"
      ],
      correct: "B"
    },
    {
      id: 26151,
      question: "What information should the hygienist provide about tooth mobility during pregnancy?",
      options: [
        "Tooth mobility during pregnancy indicates severe periodontal disease requiring extractions",
        "Increased mobility is associated with inflammation and mineral changes that reverse after pregnancy",
        "All teeth with mobility must be splinted immediately to prevent tooth loss",
        "Tooth mobility is permanent and indicates irreversible periodontal attachment loss"
      ],
      correct: "B"
    },
    {
      id: 26152,
      question: "What is a potential consequence of poorly controlled maternal diabetes during early pregnancy?",
      options: [
        "Increased risk of low birth weight but no other developmental concerns",
        "Higher risk of birth defects affecting organs forming during the first 8 weeks",
        "No effects on the baby since diabetes only affects maternal health outcomes",
        "Gestational diabetes development later in pregnancy regardless of control"
      ],
      correct: "B"
    },
    {
      id: 26153,
      question: "What is the MOST accurate evidence-based information regarding periodontal treatment during pregnancy?",
      options: [
        "Periodontal treatment definitively prevents preterm birth and low birth weight",
        "Treatment is safe but evidence is unclear if it prevents adverse pregnancy outcomes",
        "Periodontal treatment causes preterm labor and should be avoided until delivery",
        "Treatment should only be provided during the second trimester for safety"
      ],
      correct: "B"
    },
    {
      id: 26154,
      question: "What is the CORRECT guidance regarding ibuprofen use during the second trimester at 19 weeks?",
      options: [
        "Ibuprofen may be used for short duration of 48-72 hours during this time period",
        "Ibuprofen should be completely avoided during all trimesters of pregnancy",
        "Ibuprofen is the safest analgesic option throughout the entire pregnancy",
        "Ibuprofen may be used unlimited for the entire second trimester duration"
      ],
      correct: "A"
    },
    {
      id: 26155,
      question: "What is the CURRENT recommended optimal fluoride concentration in drinking water?",
      options: [
        "0.3 mg/L to minimize any risk of dental fluorosis development",
        "0.7 mg/L to protect against caries while minimizing fluorosis risk",
        "1.5 mg/L to provide maximum caries prevention benefits",
        "2.0 mg/L in areas with high caries prevalence rates"
      ],
      correct: "B"
    },
    {
      id: 26156,
      question: "What guidance should be provided regarding prolonged breastfeeding and caries risk?",
      options: [
        "Breastfeeding at any duration has no relationship to dental caries development",
        "Nocturnal and frequent breastfeeding beyond 12 months may increase caries risk",
        "Breastfeeding should stop at 6 months to completely prevent early childhood caries",
        "Extended breastfeeding provides natural immunity preventing all dental diseases"
      ],
      correct: "B"
    },
    {
      id: 26157,
      question: "What is the MOST appropriate response regarding substance use during pregnancy?",
      options: [
        "Marijuana is safe during pregnancy and has no effects on fetal development",
        "All illicit drugs including marijuana should be avoided during pregnancy",
        "Marijuana is safer than prescription medications for nausea management",
        "Marijuana use is acceptable during the first trimester only"
      ],
      correct: "B"
    },
    {
      id: 26158,
      question: "What is the CORRECT guidance regarding tetracycline use during pregnancy?",
      options: [
        "Tetracycline may be used safely during pregnancy with dose adjustments",
        "Tetracycline should never be used during pregnancy under any circumstances",
        "Tetracycline is safe only during the third trimester after tooth development",
        "Tetracycline is the preferred antibiotic during pregnancy for all infections"
      ],
      correct: "B"
    },
    {
      id: 26159,
      question: "What population does the WIC program primarily serve?",
      options: [
        "All pregnant women regardless of income level or nutritional risk status",
        "Low-income pregnant women, infants, and children through age 5 at nutritional risk",
        "Middle-income families needing temporary assistance with food purchases",
        "Elderly women with infants in their care requiring nutritional support"
      ],
      correct: "B"
    },
    {
      id: 26160,
      question: "What is the recommended age for weaning infants from the bottle?",
      options: [
        "6-8 months when solid foods are first introduced",
        "12-14 months to prevent prolonged bottle use",
        "18-20 months when all primary teeth have erupted",
        "24-30 months when the child can hold a cup independently"
      ],
      correct: "B"
    },
    {
      id: 26161,
      question: "What is the CORRECT information regarding nitrous oxide use during pregnancy?",
      options: [
        "Nitrous oxide is absolutely contraindicated during all trimesters of pregnancy",
        "Nitrous oxide at 30% may be used when local anesthetics are inadequate",
        "Nitrous oxide is safe only during the third trimester after organogenesis",
        "Nitrous oxide should replace local anesthetics as the primary pain control method"
      ],
      correct: "B"
    },
    {
      id: 26162,
      question: "What oral condition might Elizabeth be experiencing during pregnancy?",
      options: [
        "Pregnancy-induced xerostomia from hormonal changes affecting salivary glands",
        "Normal physiologic changes causing temporary reduced salivary flow",
        "Early signs of gestational diabetes requiring immediate medical evaluation",
        "Sjögren's syndrome triggered by pregnancy requiring rheumatology referral"
      ],
      correct: "A"
    },
    {
      id: 26163,
      question: "What is the CORRECT recommendation regarding juice consumption for infants?",
      options: [
        "Offer unlimited juice for vitamin C intake and hydration throughout the day",
        "No juice should be given during the first year of life to prevent caries",
        "Give juice only at mealtimes diluted with water to reduce sugar exposure",
        "Provide juice in bottles at bedtime to ensure adequate caloric intake"
      ],
      correct: "B"
    },
    {
      id: 26164,
      question: "What is the current estimated prevalence of periodontitis among US adults 30 years and older?",
      options: [
        "Approximately 15% of US adults have periodontitis",
        "Approximately 42% of US adults have periodontitis",
        "Approximately 65% of US adults have periodontitis",
        "Approximately 80% of US adults have periodontitis"
      ],
      correct: "B"
    },
    {
      id: 26165,
      question: "According to the 2017 Cochrane review, what is the evidence regarding periodontal treatment and birth outcomes?",
      options: [
        "Strong evidence proves treatment reduces preterm birth and low birth weight",
        "Low quality evidence suggests there may be fewer babies born under 2500g",
        "High quality evidence shows treatment increases risk of preterm birth",
        "No evidence exists examining relationship between treatment and birth outcomes"
      ],
      correct: "B"
    },
    {
      id: 26166,
      question: "What population does Early Head Start primarily serve?",
      options: [
        "Middle-income pregnant women seeking prenatal education classes",
        "Low-income pregnant women, infants, and toddlers until age 3",
        "All pregnant women regardless of income in specific geographic areas",
        "High-risk pregnant women with multiple medical complications"
      ],
      correct: "B"
    },
    {
      id: 26167,
      question: "What does the ALARA principle mean in dental radiography?",
      options: [
        "Always Limit All Radiographic Assessments regardless of clinical need",
        "As Low As Reasonably Achievable to minimize patient radiation exposure",
        "Avoid Low-quality Analog Radiographs and use digital sensors only",
        "All Levels Are Relatively Acceptable for pregnant patients with proper shielding"
      ],
      correct: "B"
    },
    {
      id: 26168,
      question: "What is the PRIMARY focus of Maternal, Infant and Early Childhood Home Visiting Programs?",
      options: [
        "Providing in-home dental examinations and preventive services for families",
        "Improving maternal-child health, preventing child abuse, and promoting development",
        "Offering financial assistance for dental care to low-income pregnant women",
        "Delivering prenatal vitamins and nutritional supplements to pregnant women"
      ],
      correct: "B"
    },
    {
      id: 26169,
      question: "According to current guidelines, is metronidazole appropriate during pregnancy?",
      options: [
        "Metronidazole should never be used during pregnancy due to teratogenic effects",
        "Metronidazole may be used safely during pregnancy for indicated conditions",
        "Metronidazole is only safe during the third trimester after 28 weeks",
        "Metronidazole should be avoided but tetracycline may be substituted"
      ],
      correct: "B"
    },
    {
      id: 26170,
      question: "What does this National Performance Measure assess?",
      options: [
        "Number of pregnant women enrolled in Medicaid with dental benefits",
        "Percentage of women who had a dental visit during pregnancy",
        "Number of dental providers accepting pregnant women in their practices",
        "Percentage of prenatal providers who refer patients to dentists"
      ],
      correct: "B"
    },
    {
      id: 26171,
      question: "According to current guidelines, what is the recommendation for opioid use during pregnancy?",
      options: [
        "Opioids should never be prescribed during pregnancy under any circumstances",
        "Prescribe lowest dose for shortest duration, usually less than 3 days, no refills",
        "Opioids are safe throughout pregnancy with unlimited refills as needed",
        "Opioids should only be prescribed during the second trimester exclusively"
      ],
      correct: "B"
    },
    {
      id: 26172,
      question: "What is the CORRECT guidance regarding chlorhexidine mouth rinse use during pregnancy?",
      options: [
        "Chlorhexidine should never be used during pregnancy due to teratogenic effects",
        "Alcohol-free chlorhexidine mouth rinse may be used safely during pregnancy",
        "Chlorhexidine may only be used during the third trimester after 28 weeks",
        "Chlorhexidine should be avoided but hydrogen peroxide is a safe substitute"
      ],
      correct: "B"
    },
    {
      id: 26173,
      question: "What ethical issue does this scenario present for dental professionals?",
      options: [
        "Practices have the right to refuse any patients based on pregnancy status",
        "Refusing pregnant patients may violate ethical principles of justice and access to care",
        "Medicaid patients should only be seen in community health centers",
        "Pregnant women should wait until after delivery for all dental treatment"
      ],
      correct: "B"
    },
    {
      id: 26174,
      question: "What are the three components of the Triple Aim in healthcare?",
      options: [
        "Access, quality, and continuity of care for all patient populations",
        "Improving health, enhancing patient experience, and decreasing costs",
        "Prevention, treatment, and rehabilitation services for patients",
        "Education, intervention, and evaluation of healthcare outcomes"
      ],
      correct: "B"
    },
    {
      id: 26175,
      question: "What is the PRIMARY reason medical providers often fail to refer pregnant women for dental care?",
      options: [
        "They believe dental care during pregnancy is unsafe for mother and fetus",
        "They lack knowledge about importance and safety of oral healthcare during pregnancy",
        "They do not have time to discuss oral health during prenatal visits",
        "They believe pregnant women will automatically seek dental care independently"
      ],
      correct: "B"
    }
  ],
  "3. Geriatric Dental Care (Case Study)": [
    {
      id: 26176,
      question: "What is the PRIMARY difference between life expectancy and life span?",
      options: [
        "Life expectancy refers to quality of life; life span measures chronologic age only",
        "Life expectancy applies to females only; life span applies to males only",
        "Life expectancy is calculated at birth; life span is determined at age 65",
        "Life expectancy is the average years lived by a birth cohort; life span is the maximum potential age"
      ],
      correct: "D"
    },
    {
      id: 26177,
      question: "Which demographic factor is MOST likely contributing to George's limited access to dental care?",
      options: [
        "Reduced income and lack of dental insurance coverage after retirement",
        "His advanced age requiring specialized geriatric dental treatment protocols",
        "Geographic location in a state with low elderly population density",
        "Male gender predisposing him to lower dental care utilization rates"
      ],
      correct: "A"
    },
    {
      id: 26178,
      question: "According to the Americans with Disabilities Act, what modification is REQUIRED for the dental office?",
      options: [
        "Provide home-based dental services for all patients with disabilities",
        "Ensure wheelchair-accessible parking, ramps, and doorways for public facilities",
        "Refer all wheelchair-bound patients to hospital dental clinics exclusively",
        "Schedule appointments only during off-hours to accommodate special needs"
      ],
      correct: "B"
    },
    {
      id: 26179,
      question: "What classification of functional abilities do Robert's limitations represent?",
      options: [
        "Activities of Daily Living (ADLs) affecting bathing, dressing, and toileting",
        "Basic physical mobility limitations affecting gait and balance only",
        "Instrumental Activities of Daily Living (IADLs) requiring complex skills",
        "Cognitive impairments affecting memory and decision-making exclusively"
      ],
      correct: "C"
    },
    {
      id: 26180,
      question: "According to World Health Organization, what term describes the interaction between Eleanor's capabilities and environmental supports?",
      options: [
        "Chronologic age measurement based on calendar time since birth",
        "Life expectancy calculation for remaining years at current age",
        "Instrumental activities requiring complex cognitive and motor skills",
        "Functional ability enabling wellbeing and healthy aging in older adults"
      ],
      correct: "D"
    },
    {
      id: 26181,
      question: "What is the MOST appropriate approach when communicating with Harold?",
      options: [
        "Speak to Harold directly to create a respectful, independent environment",
        "Direct all questions to the daughter since she provides daily care",
        "Alternate questions between Harold and daughter equally throughout appointment",
        "Write all questions for Harold to read independently without verbal communication"
      ],
      correct: "A"
    },
    {
      id: 26182,
      question: "What term describes Patricia's use of multiple medications to manage her conditions?",
      options: [
        "Therapeutic drug monitoring for chronic disease management protocols",
        "Polypharmacy involving multiple drugs taken simultaneously",
        "Adverse drug reaction syndrome requiring immediate hospitalization",
        "Medication compliance program ensuring proper dosing schedules"
      ],
      correct: "B"
    },
    {
      id: 26183,
      question: "What percentage of the total US population will adults 65 and older represent in 2030?",
      options: [
        "Approximately 13% of the total United States population",
        "Approximately 35% of the total United States population",
        "Approximately 20% of the total United States population",
        "Approximately 50% of the total United States population"
      ],
      correct: "C"
    },
    {
      id: 26184,
      question: "What is the PRIMARY advantage of providing dental care in Dorothy's long-term care facility?",
      options: [
        "Eliminates the need for informed consent from patient or guardian",
        "Allows dental professionals to bill at higher rates for institutional care",
        "Requires less equipment and supplies than traditional office-based care",
        "Provides care in comfortable, familiar setting without transportation disruptions"
      ],
      correct: "D"
    },
    {
      id: 26185,
      question: "From whom should the dental hygienist obtain written permission before providing care?",
      options: [
        "William's physician, family member, or legal guardian before treatment",
        "The nursing home administrator who oversees all resident medical decisions",
        "The dental insurance company that provides coverage for the procedure",
        "Any nursing staff member familiar with the patient's daily care routine"
      ],
      correct: "A"
    },
    {
      id: 26186,
      question: "What is the PRIMARY cause of the darkened enamel color in Margaret's teeth?",
      options: [
        "Acute dental caries requiring immediate restorative intervention",
        "Lifetime consumption of stain-producing foods and secondary dentin formation",
        "Medication-induced discoloration from long-term antibiotic use",
        "Pathologic enamel changes indicating underlying systemic disease"
      ],
      correct: "B"
    },
    {
      id: 26187,
      question: "What age-related tooth change is Frank exhibiting?",
      options: [
        "Dental caries requiring immediate restorative treatment to prevent pulpal involvement",
        "Enamel erosion from dietary acids requiring fluoride varnish application",
        "Occlusal attrition from lifetime of habits reducing microbial accumulation in fissures",
        "Abfraction lesions from excessive toothbrushing force at cervical margins"
      ],
      correct: "C"
    },
    {
      id: 26188,
      question: "What condition is MOST likely responsible for Ruth's cervical tooth structure loss?",
      options: [
        "Root caries from bacterial infection requiring restorative treatment",
        "Dental erosion from chronic gastric acid exposure over time",
        "Attrition from bruxism and clenching habits during sleep",
        "Tooth abrasion from incorrect brushing technique and abrasive dentifrice"
      ],
      correct: "D"
    },
    {
      id: 26189,
      question: "What is the PRIMARY factor causing Charles's tooth erosion?",
      options: [
        "Exposure to dietary acids and gastric acid from reflux disease",
        "Bacterial acid production from inadequate plaque biofilm removal",
        "Mechanical wear from abrasive toothpaste and hard toothbrush",
        "Normal age-related enamel changes occurring in all elderly patients"
      ],
      correct: "A"
    },
    {
      id: 26190,
      question: "According to national statistics on older adults, edentulousness (total tooth loss) has changed significantly over the past 60 years. In 2021, what percentage of adults 65 and older are completely edentulous?",
      options: [
        "Approximately 24% of adults 65 years and older are edentulous",
        "Approximately 13% of adults 65 years and older are edentulous",
        "Approximately 35% of adults 65 years and older are edentulous",
        "Approximately 50% of adults 65 years and older are edentulous"
      ],
      correct: "B"
    },
    {
      id: 26191,
      question: "According to statistics, how does poverty affect edentulousness rates in older adults?",
      options: [
        "Poverty has no relationship to tooth loss rates among elderly patients",
        "Elders in poverty have slightly lower rates due to Medicaid coverage",
        "Elders in poverty have three times higher edentulousness than those above poverty",
        "Poverty affects males more than females regarding total tooth loss"
      ],
      correct: "C"
    },
    {
      id: 26192,
      question: "What local oral factor is PRIMARY in Thomas's increased root caries risk?",
      options: [
        "Decreased salivary flow from normal aging process in all elderly",
        "Increased consumption of fermentable carbohydrates throughout the day",
        "Genetic predisposition to root caries development in older adults",
        "Exposed root surfaces and tooth longevity increasing caries susceptibility"
      ],
      correct: "D"
    },
    {
      id: 26193,
      question: "Which intervention is MOST important for Linda's caries prevention program?",
      options: [
        "Daily mechanical biofilm removal, fluoride use, and salivary substitutes",
        "Recommending sugar-free gum only without any other preventive measures",
        "Increasing consumption of acidic beverages to stimulate saliva production",
        "Reducing toothbrushing frequency to prevent additional enamel damage"
      ],
      correct: "A"
    },
    {
      id: 26194,
      question: "What is the PRIMARY advantage of silver diamine fluoride for Edward's caries management?",
      options: [
        "Provides permanent white restoration matching natural tooth color",
        "Noninvasive treatment requiring no tooth removal or complex equipment",
        "Eliminates need for daily oral hygiene and fluoride applications",
        "Requires general anesthesia for proper application and effectiveness"
      ],
      correct: "B"
    },
    {
      id: 26195,
      question: "What is the MOST likely cause of Alice's xerostomia?",
      options: [
        "Normal age-related decrease in salivary gland function affecting all elderly",
        "Insufficient fluid intake due to decreased thirst sensation with age",
        "Side effect of medications rather than normal aging process",
        "Salivary gland tumor requiring immediate surgical intervention"
      ],
      correct: "C"
    },
    {
      id: 26196,
      question: "What is the recommended recall interval for David?",
      options: [
        "Annual recall visits are sufficient for patients with xerostomia",
        "Recall visits every 2 years to allow adequate healing time",
        "No recall needed once all carious lesions are restored",
        "More frequent recall visits to assess and manage high caries risk"
      ],
      correct: "D"
    },
    {
      id: 26197,
      question: "What population group is MOST commonly affected by Sjögren syndrome?",
      options: [
        "Postmenopausal females, with 60% over age 50 years",
        "Young adult males under age 40 with family history",
        "Adolescents during puberty experiencing hormonal changes",
        "Middle-aged males between ages 45-55 years exclusively"
      ],
      correct: "A"
    },
    {
      id: 26198,
      question: "Which product can Joseph use without limitation on frequency to manage xerostomia?",
      options: [
        "Prescription pilocarpine tablets requiring physician monitoring for side effects",
        "Saliva substitutes in liquid, gel, or spray formulations containing fluoride",
        "Chlorhexidine gluconate rinse limited to short-term use only",
        "High-dose fluoride supplements requiring prescription authorization"
      ],
      correct: "B"
    },
    {
      id: 26199,
      question: "What percentage of US adults 65 years and older have periodontitis?",
      options: [
        "Approximately 30% of adults age 65 years and older",
        "Approximately 75% of adults age 65 years and older",
        "Approximately 60% of adults age 65 years and older",
        "Approximately 90% of adults age 65 years and older"
      ],
      correct: "C"
    },
    {
      id: 26200,
      question: "What term describes the increased susceptibility to periodontal infection in elderly from repeated immune challenges?",
      options: [
        "Acquired immunodeficiency syndrome requiring antibiotic prophylaxis",
        "Autoimmune disorder requiring immunosuppressive medication therapy",
        "Periodontal immunity developing resistance to pathogenic bacteria",
        "Immunosenescence from cumulative immune system challenges throughout life"
      ],
      correct: "D"
    },
    {
      id: 26201,
      question: "How should the dental hygienist approach Ethel's periodontal treatment?",
      options: [
        "Proceed conservatively based on patient's dental needs and health status",
        "Refuse treatment until patient discontinues bisphosphonate medication permanently",
        "Provide only prophylaxis without any instrumentation below gumline",
        "Require general anesthesia for all periodontal treatment procedures"
      ],
      correct: "A"
    },
    {
      id: 26202,
      question: "What condition is Walter MOST likely experiencing?",
      options: [
        "Squamous cell carcinoma requiring immediate biopsy and referral",
        "Chronic atrophic candidiasis from poor denture fit and hygiene",
        "Normal palatal tissue appearance in all complete denture wearers",
        "Allergic reaction to denture acrylic requiring material replacement"
      ],
      correct: "B"
    },
    {
      id: 26203,
      question: "What condition is Grace experiencing, and what is a PRIMARY causative factor?",
      options: [
        "Oral cancer requiring immediate surgical excision and chemotherapy",
        "Herpes simplex virus infection requiring antiviral medication therapy",
        "Angular cheilitis from moisture, vitamin B2 deficiency, or Candida infection",
        "Traumatic injury from accidental falls requiring wound care management"
      ],
      correct: "C"
    },
    {
      id: 26204,
      question: "What population has experienced the MOST significant increase in oral cancer in the past 25 years?",
      options: [
        "Young adults under age 30 with no tobacco or alcohol history",
        "Females over age 65 with history of heavy tobacco use",
        "Adolescents with family history of oral cancer regardless of risk factors",
        "Males with oropharyngeal cancer caused by human papillomavirus (HPV)"
      ],
      correct: "D"
    },
    {
      id: 26205,
      question: "Are Irene's sublingual varicosities a cause for concern?",
      options: [
        "No, sublingual varicosities are customary findings among elderly and not problematic",
        "Yes, they indicate serious vascular disease requiring immediate medical referral",
        "Yes, they are precancerous lesions requiring biopsy and surgical excision",
        "No, but they require monthly monitoring for changes in size or color"
      ],
      correct: "A"
    },
    {
      id: 26206,
      question: "What condition is Paul experiencing as a symptom of his anemia?",
      options: [
        "Median rhomboid glossitis requiring antifungal medication treatment",
        "Atrophic glossitis appearing smooth and shiny with burning sensation",
        "Geographic tongue with migratory patches requiring no treatment",
        "Fissured tongue with deep grooves requiring improved oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 26207,
      question: "What is the MOST effective preventive measure to reduce phenytoin-induced gingival enlargement?",
      options: [
        "Discontinue medication immediately to prevent further gingival growth",
        "Apply topical antibiotics daily to inflamed gingival tissues",
        "Maintain adequate plaque control, especially before starting medication",
        "Schedule surgical gingivectomy every 3 months to remove tissue"
      ],
      correct: "C"
    },
    {
      id: 26208,
      question: "What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Require the patient to use wheelchair exclusively for all appointments",
        "Refuse to treat patient until medical clearance is obtained",
        "Ask patient to wait for family member to provide assistance",
        "Observe gait and offer assistance to treatment area for patient safety"
      ],
      correct: "D"
    },
    {
      id: 26209,
      question: "What is the MOST appropriate approach to obtain Rose's health history information?",
      options: [
        "Interview Rose directly to obtain needed information efficiently",
        "Mail the form to her home and ask her to return it completed",
        "Ask the receptionist to complete the form based on previous records",
        "Provide the form in Braille for all visually impaired patients"
      ],
      correct: "A"
    },
    {
      id: 26210,
      question: "What modification would MOST improve communication with Henry?",
      options: [
        "Speak louder while keeping the face mask on during all conversations",
        "Remove face mask, eliminate background noise, and address patient directly",
        "Write all communication on paper since verbal communication is ineffective",
        "Have the dental assistant relay all information to the patient"
      ],
      correct: "B"
    },
    {
      id: 26211,
      question: "What aspect of care should the dental hygienist emphasize during Florence's nutritional counseling?",
      options: [
        "Increasing consumption of refined carbohydrates for adequate caloric intake",
        "Recommending dietary supplements exclusively without food modifications",
        "Discussing nutritional deficiencies and healthy food choices for oral health",
        "Ignoring dietary habits since they do not affect oral health status"
      ],
      correct: "C"
    },
    {
      id: 26212,
      question: "What is the recommended appointment scheduling approach for Arthur?",
      options: [
        "Schedule long appointments in the evening when the patient is most relaxed",
        "Schedule appointments during lunch hour for convenience only",
        "Schedule random appointment times without considering patient's daily patterns",
        "Schedule short morning appointments since elderly are strongest in morning"
      ],
      correct: "D"
    },
    {
      id: 26213,
      question: "What is the PRIMARY reason for providing Emma with written appointment information?",
      options: [
        "To help remind patient and assist caregivers due to potential memory concerns",
        "To comply with legal documentation requirements for all elderly patients",
        "To reduce phone calls to the office from patients asking about appointments",
        "To demonstrate professionalism and standard office protocol to patients"
      ],
      correct: "A"
    },
    {
      id: 26214,
      question: "What is the PRIMARY reason for minimizing tissue trauma during instrumentation with elderly patients?",
      options: [
        "Elderly patients experience more pain than younger patients during scaling",
        "Reduced healing capabilities require less trauma to gingival tissues",
        "Elderly patients cannot tolerate any discomfort during dental procedures",
        "Liability concerns are higher when treating older adults in the practice"
      ],
      correct: "B"
    },
    {
      id: 26215,
      question: "What recommendations should the dental hygienist provide for Violet's oral hygiene?",
      options: [
        "Discontinue oral hygiene attempts and rely only on professional care",
        "Brush once weekly to prevent excessive strain on arthritic joints",
        "Use power toothbrush and modifications to improve plaque removal",
        "Ask family members to avoid helping with oral hygiene tasks"
      ],
      correct: "C"
    },
    {
      id: 26216,
      question: "What is the MOST appropriate action to prevent postural hypotension?",
      options: [
        "Immediately recline the chair completely flat and elevate patient's feet",
        "Ask patient to stand quickly and walk around the operatory",
        "Dismiss patient immediately since treatment has been completed",
        "Return chair slowly to upright position and allow patient time to adjust"
      ],
      correct: "D"
    },
    {
      id: 26217,
      question: "What alternative fluoride delivery method would be MOST appropriate for Clara?",
      options: [
        "Monthly professional fluoride varnish applications only without home use",
        "Fluoride gel applied by toothbrush to reach proximal and root surfaces",
        "Fluoride supplements taken orally with meals three times daily",
        "Fluoride-free products since she cannot manage rinsing properly"
      ],
      correct: "B"
    },
    {
      id: 26218,
      question: "What fluoride application method is MOST appropriate for Norman's high-risk status?",
      options: [
        "Over-the-counter fluoride rinse used once daily before bedtime",
        "Fluoride toothpaste only without additional fluoride supplementation",
        "Custom tray with fluoride gel applied for 5 minutes twice daily",
        "Professional fluoride varnish applied once yearly at recall appointments"
      ],
      correct: "C"
    },
    {
      id: 26219,
      question: "What should be included in the educational session with Gladys's daughter?",
      options: [
        "Provide verbal instructions only since written materials are not necessary",
        "Instruct the patient only since caregivers should not be involved",
        "Assume the caregiver knows proper techniques without demonstration",
        "Involve caregiver in providing routine and thorough oral hygiene with patient"
      ],
      correct: "D"
    },
    {
      id: 26220,
      question: "What antimicrobial mouth rinse concentration is recommended for additional microbial control in high-risk elderly patients?",
      options: [
        "0.12% chlorhexidine gluconate rinse for patients needing additional control",
        "0.05% sodium fluoride rinse used daily for fluoride benefits only",
        "3% hydrogen peroxide solution used undiluted four times daily",
        "1.5% alcohol-based mouthwash for antimicrobial effects exclusively"
      ],
      correct: "A"
    },
    {
      id: 26221,
      question: "What recall interval is MOST appropriate for Esther?",
      options: [
        "Annual recall visits are sufficient for patients with good oral hygiene",
        "More frequent maintenance visits to evaluate changes and provide care",
        "Recall visits only when patient experiences pain or discomfort",
        "Biannual visits regardless of periodontal disease history or risk"
      ],
      correct: "B"
    },
    {
      id: 26222,
      question: "What equipment option would be MOST practical for providing dental care to Leonard?",
      options: [
        "Permanent dental operatory construction in dedicated space exclusively",
        "Mobile dental vehicle parked outside facility for all appointments",
        "Portable dental equipment set up in conference room as needed",
        "Transport patient to external dental office for all treatment needs"
      ],
      correct: "C"
    },
    {
      id: 26223,
      question: "What does \"direct access\" to dental hygiene services mean?",
      options: [
        "Dental hygienists must have a dentist present during all treatment procedures",
        "Dental hygienists can only provide care in traditional dental office settings",
        "Dental hygienists require physician orders before providing any treatment",
        "Dental hygienists provide care without specific authorization from a dentist"
      ],
      correct: "D"
    },
    {
      id: 26224,
      question: "What screening tool can be used to systematically evaluate Agnes's oral health status in the facility?",
      options: [
        "Brief Oral Health Status Examination (BOHSE) for systematic evaluation",
        "Comprehensive periodontal examination with full mouth radiographs",
        "Self-reported oral health questionnaire completed by the patient",
        "Annual medical physical examination by the facility physician"
      ],
      correct: "A"
    },
    {
      id: 26225,
      question: "What percentage of elderly were homebound and semi-dependent in 2020?",
      options: [
        "Approximately 4.5% were homebound and semi-dependent",
        "Approximately 25% were homebound and semi-dependent",
        "Approximately 35% were homebound and semi-dependent",
        "Approximately 13% were homebound and semi-dependent"
      ],
      correct: "D"
    }
  ],
  "4. Palliative Oral Care (Case Study)": [
    {
      id: 26226,
      question: "What is the PRIMARY focus of palliative dental hygiene oral care for Mrs. Johnson?",
      options: [
        "Performing comprehensive periodontal debridement using ultrasonic scalers",
        "Reducing oral symptoms, preventing pain, and maintaining mouth cleanliness to end of life",
        "Completing all restorative dental treatment before her condition deteriorates further",
        "Scheduling regular office visits for traditional dental hygiene appointments every 6 months"
      ],
      correct: "B"
    },
    {
      id: 26227,
      question: "According to the Canadian Framework for Palliative Care, which principle BEST describes the approach to Mr. Chen's care?",
      options: [
        "Healthcare decisions should be made primarily by medical professionals",
        "Palliative care is person- and family-centered, respecting individual choices",
        "Oral care should be postponed until the patient can travel to the office",
        "Family members should not be involved in healthcare decision-making processes"
      ],
      correct: "B"
    },
    {
      id: 26228,
      question: "When a person becomes dependent for toileting and eating assistance, what can the dental hygienist anticipate regarding their oral care needs?",
      options: [
        "They will likely maintain independent oral hygiene without any assistance needed",
        "They should discontinue all oral hygiene until they regain independence completely",
        "They will likely require assistance with oral care as decline affects all aspects",
        "They only need assistance with denture care but not natural tooth brushing"
      ],
      correct: "C"
    },
    {
      id: 26229,
      question: "What is the significance of these pulpal changes in relation to palliative oral care?",
      options: [
        "These changes always require immediate endodontic treatment for all teeth involved",
        "These changes often lead to tooth death and are part of oral frailty considerations",
        "These changes only occur in patients with diabetes and require insulin adjustment",
        "These changes reverse completely with improved oral hygiene and fluoride application"
      ],
      correct: "B"
    },
    {
      id: 26230,
      question: "What dietary pattern is MOST likely contributing to this patient's increased caries risk?",
      options: [
        "Consumption of sugar-free beverages with meals three times daily only",
        "Eating three balanced meals per day with thorough oral care afterward",
        "Continuous food exposure keeping the mouth constantly in an acidic state",
        "Following a strict vegetarian diet with limited carbohydrate intake throughout day"
      ],
      correct: "C"
    },
    {
      id: 26231,
      question: "What is the PRIMARY cause of this patient's xerostomia?",
      options: [
        "Normal age-related changes that occur in all elderly patients over 70",
        "Side effects from multiple medications disturbing saliva's buffering capacity",
        "Excessive consumption of water and hydrating fluids throughout the day",
        "Genetic predisposition that cannot be modified with any interventions"
      ],
      correct: "B"
    },
    {
      id: 26232,
      question: "What should be the PRIMARY fluid recommendation for managing this patient's xerostomia?",
      options: [
        "Sweetened fruit juices and sugary drinks to stimulate saliva production",
        "Caffeinated coffee and tea to increase alertness and oral moisture",
        "Alcoholic beverages in moderation to enhance salivary gland function",
        "Water as the fluid of choice while avoiding caffeine and alcohol"
      ],
      correct: "D"
    },
    {
      id: 26233,
      question: "What dietary modification would be MOST beneficial for this patient's oral health?",
      options: [
        "Increasing the frequency of high-sugar supplement drinks to six times daily",
        "Switching to diabetic versions of supplement drinks to reduce sugar content",
        "Adding additional refined carbohydrates to improve nutritional caloric intake",
        "Eliminating all nutritional supplements regardless of patient's nutritional needs"
      ],
      correct: "B"
    },
    {
      id: 26234,
      question: "What oral complication is this patient MOST likely experiencing?",
      options: [
        "Normal age-related changes requiring no intervention or treatment",
        "Mucositis from chemotherapy affecting oral tissue mitosis rate",
        "Acute necrotizing ulcerative gingivitis requiring immediate antibiotic therapy",
        "Traumatic injury from aggressive toothbrushing requiring softer brush only"
      ],
      correct: "B"
    },
    {
      id: 26235,
      question: "What type of oral candidiasis is this patient exhibiting?",
      options: [
        "Erythematous candidiasis with red lesions on hard palate",
        "Hyperplastic candidiasis with elevated patches that cannot be removed",
        "Pseudomembranous candidiasis or thrush with removable white plaques",
        "Chronic atrophic candidiasis associated with denture wearing only"
      ],
      correct: "C"
    },
    {
      id: 26236,
      question: "What condition is this patient experiencing?",
      options: [
        "Oral cancer requiring immediate biopsy and oncology referral",
        "Herpes simplex virus infection requiring antiviral medication",
        "Angular cheilitis from overclosure, vitamin deficiency, or Candida infection",
        "Traumatic ulceration from accidental falls requiring wound care only"
      ],
      correct: "C"
    },
    {
      id: 26237,
      question: "A dental hygienist is treating a denture-wearing patient diagnosed with oral candidiasis. In addition to antifungal medication, what denture care instruction is ESSENTIAL?",
      options: [
        "Wear dentures 24 hours daily to maintain proper tissue adaptation",
        "Remove dentures overnight and store in disinfecting solution daily",
        "Clean dentures only once weekly to avoid excessive wear damage",
        "Store dentures in a sealed plastic bag without any solution"
      ],
      correct: "B"
    },
    {
      id: 26238,
      question: "What intervention has been shown to reduce aspiration pneumonia risk in geriatric patients?",
      options: [
        "Encouraging nightly denture wearing to maintain proper oral structures",
        "Using chlorhexidine gluconate solution (0.12%) for oral hygiene care",
        "Avoiding all oral hygiene to prevent stimulating the gag reflex",
        "Positioning patient completely flat during all oral care procedures"
      ],
      correct: "B"
    },
    {
      id: 26239,
      question: "What is the CORRECT positioning for oral hygiene care in patients with dysphagia?",
      options: [
        "Completely supine position with head lower than feet for comfort",
        "Sitting upright at 90 degrees with head hyperextended backward",
        "Head elevated at least 30 degrees with head in neutral to slightly downward position",
        "Side-lying position with no elevation and head rotated to the left side"
      ],
      correct: "C"
    },
    {
      id: 26240,
      question: "What product can this patient use WITHOUT limitation on frequency for xerostomia management?",
      options: [
        "Alcohol-based mouthwashes for antimicrobial effects and freshness",
        "Lemon glycerin swabs for moisture and pleasant taste throughout day",
        "Saliva substitutes in liquid, gel, or spray formulations",
        "Petroleum-based lip products for internal mucous membrane hydration"
      ],
      correct: "C"
    },
    {
      id: 26241,
      question: "What frequency is recommended for baking soda and saline rinse in xerostomia management?",
      options: [
        "Once monthly for maintenance of oral pH balance",
        "Every 1 to 3 hours for 1 week during acute episodes",
        "Every 6 hours for indefinite period throughout life",
        "Only as needed when patient remembers to use it"
      ],
      correct: "B"
    },
    {
      id: 26242,
      question: "As Bruna's frailty increased, what was the appropriate change in her dental hygiene care frequency?",
      options: [
        "Dental hygiene visits were decreased to once yearly due to her declining health",
        "Dental hygiene visits were discontinued completely as she entered long-term care",
        "Dental hygiene visits were increased from every 2 weeks to once weekly",
        "Dental hygiene visits remained at standard 6-month intervals throughout her life"
      ],
      correct: "C"
    },
    {
      id: 26243,
      question: "Why are dental hygienists considered the IDEAL oral health professional for palliative care?",
      options: [
        "They have medical degrees allowing them to prescribe all medications needed",
        "They can perform surgical extractions in the long-term care setting independently",
        "They are educated to recognize effects of aging, frailties, and changing oral conditions",
        "They are only needed for annual examinations in healthy ambulatory patients"
      ],
      correct: "C"
    },
    {
      id: 26244,
      question: "What is the PRIMARY limitation of current direct care staff providing oral care?",
      options: [
        "Direct care staff have extensive dental education and need no support",
        "Direct care staff lack knowledge and experience about oral care",
        "Direct care staff are overqualified for basic oral hygiene tasks",
        "Direct care staff refuse to provide any oral care under any circumstances"
      ],
      correct: "B"
    },
    {
      id: 26245,
      question: "What does this evidence suggest about dental hygienists' role in long-term care?",
      options: [
        "Dental hygienists should be identified as essential workers in long-term care",
        "Dental hygienists are not needed since nursing staff can provide adequate care",
        "Dental care can be safely postponed for years without consequences",
        "Oral care has no impact on overall health outcomes in frail elders"
      ],
      correct: "A"
    },
    {
      id: 26246,
      question: "From whom should the dental hygienist obtain initial consent for the oral assessment?",
      options: [
        "Any nursing staff member working the current shift at the facility",
        "The facility administrator who oversees all resident care decisions",
        "The patient's power of attorney for healthcare (the daughter)",
        "No consent is needed since the patient resides in a long-term care facility"
      ],
      correct: "C"
    },
    {
      id: 26247,
      question: "What training can prepare the dental hygienist to work with these patients?",
      options: [
        "Gentle Persuasive Approach for patients with cognitive impairment",
        "Advanced cardiac life support for medical emergencies only",
        "Surgical extraction techniques for uncooperative patients",
        "Restraint application methods to force compliance with care"
      ],
      correct: "A"
    },
    {
      id: 26248,
      question: "Which assessment tool is internationally recognized for use in healthcare settings including long-term care?",
      options: [
        "Periodontal Screening and Recording (PSR) for community screening only",
        "Resident Assessment Instrument Minimum Data Set (RAI-MDS) for oral/dental status",
        "Basic Screening Survey (BSS) for school-based prevention programs exclusively",
        "Caries Risk Assessment Tool (CRAT) designed only for pediatric populations"
      ],
      correct: "B"
    },
    {
      id: 26249,
      question: "According to the Index of Debris, what level of debris does this represent?",
      options: [
        "Level 0 - No debris present on any surfaces",
        "Level 1 - Minimal debris along gumline only",
        "Level 2 - Moderate debris covering one-third of surfaces",
        "Level 4 - Abundant debris covering greater than two-thirds of surfaces"
      ],
      correct: "D"
    },
    {
      id: 26250,
      question: "Why is the traditional schedule INSUFFICIENT for dependent palliative care patients?",
      options: [
        "Traditional schedules provide excessive care causing unnecessary treatment burden",
        "Traditional schedules are inadequate to keep the mouth clean for dependent persons",
        "Dependent patients never require professional care beyond annual examinations",
        "Insurance will not cover any visits beyond one appointment every two years"
      ],
      correct: "B"
    },
    {
      id: 26251,
      question: "What approach should the dental hygienist use for treatment planning discussions?",
      options: [
        "Make all decisions independently without consulting patient or family members",
        "Use a systematic approach to promote person-centered decision making",
        "Defer all treatment decisions to the nursing staff at the facility",
        "Implement the same treatment plan for all patients regardless of goals"
      ],
      correct: "B"
    },
    {
      id: 26252,
      question: "Where should the dental hygienist provide care for this patient?",
      options: [
        "Only in a fully equipped dental operatory with reclining chair",
        "In the patient's environment where they are most comfortable",
        "Standing upright in the hallway for proper hygienist positioning",
        "Postpone care until patient can be transported to dental office"
      ],
      correct: "B"
    },
    {
      id: 26253,
      question: "What is the MOST likely explanation for this behavior?",
      options: [
        "The patient recognizes themselves and is pleased with their appearance",
        "The patient doesn't recognize themselves and becomes disturbed by unfamiliar image",
        "All cognitively impaired patients prefer to perform oral care in bathrooms",
        "Mirrors are required equipment for all oral care procedures with no exceptions"
      ],
      correct: "B"
    },
    {
      id: 26254,
      question: "What should be the FIRST step in the oral care procedure?",
      options: [
        "Apply petroleum-based products to dry lips for moisture",
        "Begin aggressive scaling with ultrasonic instruments immediately",
        "Apply nonpetroleum moisturizer to lips, then sanitize mouth with antimicrobial rinse",
        "Complete full mouth periodontal charting with exploration of all pockets"
      ],
      correct: "C"
    },
    {
      id: 26255,
      question: "What technique is recommended for removing debris and biofilm without toothpaste?",
      options: [
        "Dip and brush technique with oral physiotherapy tools dipped in chlorhexidine rinse",
        "Aggressive scrubbing with abrasive pumice paste on all surfaces",
        "High-speed ultrasonic scaling with continuous aerosol generation",
        "Application of hydrogen peroxide paste left on tissues for 30 minutes"
      ],
      correct: "A"
    },
    {
      id: 26256,
      question: "What technique can the dental hygienist use to assist with mouth opening?",
      options: [
        "Two-toothbrush technique using one brush handle as mouth prop",
        "Immediate referral to oral surgeon for jaw dislocation treatment",
        "Discontinuation of all oral care until patient can cooperate fully",
        "Use of general anesthesia for all routine oral hygiene procedures"
      ],
      correct: "A"
    },
    {
      id: 26257,
      question: "What therapy can be applied to prevent, reverse, and arrest carious lesions?",
      options: [
        "Complete extraction of all asymptomatic teeth as preventive measure",
        "Interim Stabilization Therapy using silver diamine fluoride or glass ionomers",
        "No intervention since asymptomatic teeth require no treatment ever",
        "Immediate full mouth rehabilitation with crowns and bridges for all teeth"
      ],
      correct: "B"
    },
    {
      id: 26258,
      question: "When should the dental hygienist consider NOT removing calculus?",
      options: [
        "Always remove all calculus regardless of patient condition or safety concerns",
        "When risk-benefit analysis shows removal may cause more harm than good",
        "Never remove calculus from any palliative care patients under any circumstances",
        "Only when the patient specifically requests calculus removal in writing"
      ],
      correct: "B"
    },
    {
      id: 26259,
      question: "What instruments should be used for calculus removal in palliative care settings?",
      options: [
        "High-powered ultrasonic instruments with maximum aerosol generation",
        "Manual curettes ensuring proper transport for instrument reprocessing",
        "Laser devices for all patients regardless of safety considerations",
        "Air polishing units with sodium bicarbonate powder exclusively"
      ],
      correct: "B"
    },
    {
      id: 26260,
      question: "What should be included in the documentation?",
      options: [
        "Only the date of service without any clinical findings or procedures",
        "Dental hygiene process of care and discussions with family and caregivers",
        "Personal opinions about the patient's prognosis without objective findings",
        "No documentation is required for patients in long-term care settings"
      ],
      correct: "B"
    },
    {
      id: 26261,
      question: "What is ESSENTIAL for the dental hygienist to do as the patient's condition changes?",
      options: [
        "Maintain the original care plan without modifications regardless of changes",
        "Discontinue all oral care when any decline in abilities is noted",
        "Continually evaluate and modify the care plan adjusting goals appropriately",
        "Transfer all responsibility for oral care decisions to the nursing staff"
      ],
      correct: "C"
    },
    {
      id: 26262,
      question: "According to United Nations projections, what proportion of the world's population will be aged 65 years or over by 2050?",
      options: [
        "One in twenty people will be 65 or over",
        "One in sixteen people will be 65 or over",
        "One in ten people will be 65 or over",
        "One in six people will be 65 or over"
      ],
      correct: "D"
    },
    {
      id: 26263,
      question: "What oral manifestation can result from decreased blood vessels and cells in tooth pulp with increased secondary dentin?",
      options: [
        "Immediate reversal of all carious lesions without intervention",
        "Death of teeth requiring recognition by dental hygienist",
        "Spontaneous tooth regeneration and improved vitality",
        "Elimination of all periodontal disease without treatment"
      ],
      correct: "B"
    },
    {
      id: 26264,
      question: "What is the PRIMARY goal of palliative dental hygiene oral care?",
      options: [
        "Performing all comprehensive restorative procedures regardless of prognosis",
        "Providing compassion, support, and care for oral health through chronic illness to end of life",
        "Discontinuing all preventive services once patient enters palliative stage",
        "Focusing exclusively on cosmetic improvements regardless of patient comfort"
      ],
      correct: "B"
    },
    {
      id: 26265,
      question: "What tools are used in noninvasive debridement?",
      options: [
        "Scalers, curettes, ultrasonic instruments, and aerosol generation tools",
        "Oral physiotherapy tools including brushes, floss, stimulators, and tongue cleaners",
        "High-speed handpieces with diamond burs for removal of deposits",
        "Surgical instruments including elevators and forceps for extractions"
      ],
      correct: "B"
    },
    {
      id: 26266,
      question: "What is a PRIMARY barrier to oral care access for palliative patients?",
      options: [
        "Excessive insurance coverage providing too many dental benefits",
        "Lack of funding and limited insurance coverage for therapeutic services",
        "Overwhelming number of dental hygienists in long-term care facilities",
        "Excessive government funding requiring patients to use all benefits"
      ],
      correct: "B"
    },
    {
      id: 26267,
      question: "What correlation exists between oral health and aspiration pneumonia?",
      options: [
        "Good oral hygiene and plaque control have no relationship to pneumonia risk",
        "Poor dental plaque control and periodontal disease increase aspiration pneumonia risk",
        "Aspiration pneumonia only occurs in patients without any natural teeth",
        "Oral health status has no impact on respiratory health outcomes"
      ],
      correct: "B"
    },
    {
      id: 26268,
      question: "What dietary modification is commonly recommended for patients with dysphagia?",
      options: [
        "Very thin liquids that flow rapidly requiring fast swallowing",
        "Hard, crunchy foods requiring extensive chewing for safety",
        "Pureed texture foods and honey-thick fluid consistency",
        "Raw vegetables and tough meats to strengthen swallowing muscles"
      ],
      correct: "C"
    },
    {
      id: 26269,
      question: "What distinguishes hyperplastic candidiasis from pseudomembranous candidiasis?",
      options: [
        "Hyperplastic candidiasis can be easily wiped off leaving bleeding tissue",
        "Hyperplastic candidiasis presents as elevated patches that cannot be wiped off",
        "Hyperplastic candidiasis only appears on the dorsal surface of tongue",
        "Hyperplastic candidiasis resolves spontaneously without any treatment required"
      ],
      correct: "B"
    },
    {
      id: 26270,
      question: "What instruction should the dental hygienist give regarding eating and drinking after topical antifungal application?",
      options: [
        "Eat and drink immediately to help spread the medication",
        "Wait 5 minutes before eating to allow minimal absorption",
        "Do not eat or drink for 20 minutes after topical treatment",
        "Rinse mouth thoroughly with water immediately after application"
      ],
      correct: "C"
    },
    {
      id: 26271,
      question: "What should be replaced to prevent reinfection after candidiasis treatment?",
      options: [
        "All dental restorations including fillings and crowns",
        "Denture container and toothbrush",
        "All clothing and bed linens in the household",
        "Eyeglasses and hearing aids"
      ],
      correct: "B"
    },
    {
      id: 26272,
      question: "What solution can be used to disinfect dentures overnight during candidiasis treatment?",
      options: [
        "Boiling water at 100 degrees Celsius for sterilization",
        "Undiluted bleach to ensure maximum antimicrobial effect",
        "Diluted sodium hypochlorite or chlorhexidine solution",
        "Petroleum jelly applied to all denture surfaces for protection"
      ],
      correct: "C"
    },
    {
      id: 26273,
      question: "What rinse provides soothing relief for mucositis symptoms?",
      options: [
        "Undiluted hydrogen peroxide rinse for maximum antimicrobial effect",
        "Baking soda, saline, and water rinse for soothing comfort",
        "Alcohol-based mouthwash for antibacterial properties",
        "Lemon juice rinse for acidic cleansing of tissues"
      ],
      correct: "B"
    },
    {
      id: 26274,
      question: "What is the ESSENTIAL denture care instruction for patients with mucositis?",
      options: [
        "Wear dentures continuously 24 hours daily for tissue support",
        "Daily denture cleaning and remove dentures while sleeping",
        "Clean dentures only monthly to minimize tissue trauma",
        "Never remove dentures once they are inserted initially"
      ],
      correct: "B"
    },
    {
      id: 26275,
      question: "What local factor is a PRIMARY predisposing factor for oral candidiasis?",
      options: [
        "Excellent oral hygiene with thorough daily plaque removal",
        "Poor oral hygiene and inadequate plaque biofilm control",
        "Excessive saliva production causing tissue maceration",
        "Absence of dentures with all natural teeth present"
      ],
      correct: "B"
    }
  ],
  "5. Child Abuse and Family Violence (Case Study)": [
    {
      id: 26276,
      question: "What is the MOST appropriate initial action for the dental hygienist?",
      options: [
        "Complete the examination, document all findings objectively including location and appearance of injuries, and report suspicions to Child Protective Services",
        "Confront the mother about the inconsistencies and ask her directly if she caused the injuries before making any report to authorities",
        "Call law enforcement immediately while the patient is still in the office and have them question the mother about potential abuse",
        "Treat only the dental emergency, make a note in the chart for future reference, and wait to see if similar injuries appear at the next visit"
      ],
      correct: "A"
    },
    {
      id: 26277,
      question: "Based on the clinical findings, what does the presence of condyloma acuminatum in a prepubertal child most likely indicate?",
      options: [
        "A common viral infection transmitted through respiratory droplets that requires topical antiviral treatment and close monitoring",
        "An allergic reaction to certain foods or dental products that will resolve with antihistamine therapy and dietary modifications",
        "A possible indicator of sexual abuse that requires immediate documentation and mandatory reporting to Child Protective Services",
        "A benign growth caused by chronic irritation from thumb sucking that can be surgically removed without further investigation"
      ],
      correct: "C"
    },
    {
      id: 26278,
      question: "What is the MOST appropriate assessment of this situation?",
      options: [
        "This represents clear dental neglect requiring immediate reporting to Child Protective Services regardless of the parent's circumstances or apparent concern",
        "This situation requires differentiation between willful neglect and lack of oral health literacy combined with socioeconomic barriers before determining reporting obligations",
        "This is simply poor parenting that should be addressed through patient education only, with no need for documentation or reporting",
        "This represents medical child abuse similar to Munchausen syndrome by proxy and requires psychiatric evaluation of the parent"
      ],
      correct: "B"
    },
    {
      id: 26279,
      question: "Which pediatric assessment principle is MOST relevant to this case?",
      options: [
        "Infants commonly sustain facial injuries from falls when learning developmental milestones, so this presentation is consistent with normal childhood accidents",
        "The proverb \"those who don't cruise rarely bruise\" indicates that bruising and oral injuries in non-ambulatory infants are sentinel findings suspicious for abuse",
        "Torn frenums are typical injuries in infants who are teething and should be treated as normal developmental occurrences requiring only observation",
        "Subconjunctival hemorrhage in infants always results from increased intracranial pressure and indicates the need for immediate neurosurgical consultation only"
      ],
      correct: "B"
    },
    {
      id: 26280,
      question: "What characteristic of this injury most strongly suggests an adult human bite rather than an animal bite?",
      options: [
        "The elliptical shape and intercanine distance greater than 3.0 cm with tooth indentations consistent with human adult arch form",
        "The location on the upper arm which is the most common site for dog bites in children of this age group",
        "The presence of tearing and irregular breaks in the skin which are pathognomonic for carnivorous animal attacks",
        "The child's nervous behavior which typically indicates fear of animals rather than fear of people or specific adults"
      ],
      correct: "A"
    },
    {
      id: 26281,
      question: "What is the MOST appropriate course of action?",
      options: [
        "Report this case to Child Protective Services immediately because any dental trauma in children requires mandatory reporting by dental professionals",
        "Document the injury with date, time, location, and description; obtain necessary consent for treatment photographs; and treat the fractured tooth appropriately",
        "Separate the mother and child to question them individually about the incident to ensure their stories match exactly in every detail",
        "Refuse to treat the child until law enforcement can investigate the incident to rule out any possibility of inflicted trauma"
      ],
      correct: "B"
    },
    {
      id: 26282,
      question: "Which finding would MOST clearly distinguish potential caregiver-fabricated illness from genuine medical complexity?",
      options: [
        "The pattern of seeking care from multiple different providers combined with inconsistent stories, implausible histories, or symptoms occurring only in the caregiver's presence",
        "The presence of multiple carious lesions which always indicates intentional neglect regardless of other circumstances or family situation",
        "The history of multiple moves which definitively proves the parent is trying to avoid detection by Child Protective Services",
        "The parent's attentiveness and detailed questioning which demonstrates obsessive behavior characteristic of factitious disorder by proxy"
      ],
      correct: "A"
    },
    {
      id: 26283,
      question: "What additional clinical significance might palatal petechiae have in the context of child maltreatment assessment?",
      options: [
        "Petechiae on the palate are always caused by aggressive tooth brushing and require only oral hygiene instruction with proper technique demonstration",
        "Palatal petechiae combined with behavioral indicators may suggest forced oral sex and warrant further assessment and mandatory reporting procedures",
        "This finding indicates a bleeding disorder such as idiopathic thrombocytopenic purpura and requires immediate referral to hematology only",
        "Palatal petechiae in adolescents are a normal finding related to hormonal changes during puberty and require no further assessment or action"
      ],
      correct: "B"
    },
    {
      id: 26284,
      question: "What characteristic of oral burns from abuse would be MOST concerning in this presentation?",
      options: [
        "Burns from accidentally drinking hot liquids typically show uniform, symmetric patterns because children drink quickly without stopping",
        "The father's explanation is completely consistent with accidental injury since children commonly grab hot beverages from tables",
        "Burns from forced feeding or scalding as abuse often show patterns inconsistent with accidental injury and may involve aggressive or forced feeding with hot substances",
        "The child's fearful behavior is normal for a 3-year-old in a dental office and provides no useful information for assessment"
      ],
      correct: "C"
    },
    {
      id: 26285,
      question: "Which combination of findings is MOST indicative of a concerning situation requiring further assessment?",
      options: [
        "The recent move to the area combined with the stepfather's defensiveness, which are normal responses to implied criticism from healthcare providers",
        "The pattern of untreated dental disease, poor hygiene, malnourished appearance, controlling behavior, and refusal to allow private conversation with the child",
        "The tooth pain and emergency presentation, which indicate good parenting because the stepfather brought the child in for needed treatment",
        "The lack of previous dental care in the area, which simply reflects the family's recent relocation and adjustment period to a new community"
      ],
      correct: "B"
    },
    {
      id: 26286,
      question: "What is the victimization rate per 1,000 children for infants younger than 1 year old according to national statistics?",
      options: [
        "8.4 per 1,000, which is the same as the national average victim rate for all children in the population",
        "15.5 per 1,000, which is the highest rate and equivalent to American Indian or Alaska Native children",
        "25.1 per 1,000, representing the highest victimization rate among all age groups of children",
        "13.2 per 1,000, which is the same rate as African American children of all ages"
      ],
      correct: "C"
    },
    {
      id: 26287,
      question: "Which type of child maltreatment accounted for the highest percentage of victims in 2020?",
      options: [
        "Physical abuse at 76.1% because it is the most visible and easily identified form of maltreatment",
        "Sexual abuse at 16.5% because it represents the majority of cases seen by healthcare providers",
        "Neglect at 76.1%, continuing to be the most common type of maltreatment reported in the United States",
        "Psychological maltreatment at 9.4% because emotional abuse has become more recognized in recent years"
      ],
      correct: "C"
    },
    {
      id: 26288,
      question: "What relationship exists between bullying and intimate partner violence (IPV) according to current understanding?",
      options: [
        "Bullying and IPV are completely separate phenomena with no correlation or shared characteristics in terms of power dynamics",
        "The power and control tactics used in bullying overlap with those in IPV, suggesting bullying may be a precursor to IPV",
        "Bullying only occurs in school settings while IPV only occurs in adult relationships, so they cannot be related",
        "Adolescent dating violence is not considered IPV because intimate partner violence only applies to married couples"
      ],
      correct: "B"
    },
    {
      id: 26289,
      question: "This scenario describes which aspect of intimate partner violence?",
      options: [
        "Normal adolescent relationship dynamics that will resolve with maturity and do not require intervention or concern",
        "Reproductive coercion, which is a form of IPV involving control of reproductive and sexual health decisions",
        "Appropriate partner involvement in healthcare decisions that demonstrates caring and commitment to the relationship",
        "A misunderstanding of relationship boundaries that requires only education about healthy communication skills"
      ],
      correct: "B"
    },
    {
      id: 26290,
      question: "What is the significance of strangulation in intimate partner violence situations?",
      options: [
        "Strangulation is a minor form of IPV that rarely results in serious injury and requires only documentation in the patient record",
        "Victims with one previous nonfatal strangulation are seven times more likely to die by homicide than those without this experience",
        "Strangulation marks indicate consensual sexual activity and should not be considered evidence of intimate partner violence",
        "Nonfatal strangulation has no correlation with future violence and does not require any specific intervention or safety planning"
      ],
      correct: "B"
    },
    {
      id: 26291,
      question: "Which screening approach is MOST appropriate when assessing for intimate partner violence?",
      options: [
        "Ask detailed questions about the abuse in the reception area to save time and ensure the partner cannot overhear the conversation",
        "Confront the partner directly about the abuse to determine their side of the story before documenting or taking any action",
        "Ask screening questions such as \"Do you feel safe at home?\" and \"Has your partner ever threatened, hit, or harmed you?\" always in private",
        "Avoid asking any questions because patients will disclose abuse voluntarily if they want help, and asking may offend them"
      ],
      correct: "C"
    },
    {
      id: 26292,
      question: "What is the significance of intimate partner violence during pregnancy?",
      options: [
        "IPV rates decrease during pregnancy because partners become protective, making this presentation highly unusual and unlikely",
        "IPV during pregnancy has minimal health impacts and affects outcomes no differently than IPV at other times in a woman's life",
        "IPV rates are alarmingly high during pregnancy with risks including preterm birth, low birth weight, miscarriage, and pregnancy-associated homicide",
        "Pregnancy provides legal protection from IPV, so screening is unnecessary during prenatal periods because abuse cannot occur"
      ],
      correct: "C"
    },
    {
      id: 26293,
      question: "What is the MOST appropriate response when a patient denies abuse but you still have concerns?",
      options: [
        "Continue to press the patient for details and insist she admit to the abuse before you can help her or provide any resources",
        "State \"I'm concerned. There is help available for you. I have information if you would like\" without forcing the issue or jeopardizing safety",
        "Contact law enforcement immediately and make a report regardless of the patient's wishes or concerns about her safety",
        "Document your suspicions in the patient's chart using accusatory language about the partner to ensure a clear record is established"
      ],
      correct: "B"
    },
    {
      id: 26294,
      question: "Which type of elder abuse is MOST likely occurring in this scenario?",
      options: [
        "Financial exploitation because the daughter is controlling the patient's finances by bringing her to dental appointments",
        "Neglect, involving failure to provide basic needs such as personal hygiene, nutrition, and healthcare including dental care",
        "Physical abuse because weight loss always indicates intentional withholding of food as punishment for the elder's behavior",
        "Self-neglect because all older adults are responsible for their own care regardless of cognitive or physical limitations"
      ],
      correct: "B"
    },
    {
      id: 26295,
      question: "What is your professional obligation regarding this situation?",
      options: [
        "Accept the son's explanation because elderly patients do bruise easily, and there is no need for further assessment or reporting",
        "Report suspected vulnerable adult abuse and neglect as mandated in every state, documenting all observations objectively",
        "Call the patient's physician to report the bruises but take no other action since elder abuse reporting is optional in most states",
        "Wait until you see the patient again to determine if new bruises appear before making any reports to authorities"
      ],
      correct: "B"
    },
    {
      id: 26296,
      question: "This situation MOST likely represents which phenomenon?",
      options: [
        "Normal aging that requires no intervention because all elderly people eventually experience decline in self-care abilities",
        "Elder abuse by the neighbor who is trying to gain control of the patient's finances by bringing them to medical appointments",
        "Self-neglect, defined as harm or potential harm created by a person's own failure to address their self-care needs",
        "Institutional abuse even though the patient lives alone because any neglect of an elderly person is institutional by definition"
      ],
      correct: "C"
    },
    {
      id: 26297,
      question: "What type of elder neglect does this scenario MOST likely represent?",
      options: [
        "Physical neglect involving failure to provide protection from health hazards by withholding medical devices and medications",
        "Financial exploitation because the caregiver is stealing the patient's prescription medication to sell for profit",
        "Emotional abuse because forgetting to fill prescriptions occasionally is a normal occurrence that causes temporary distress",
        "Self-neglect because the patient should be responsible for managing her own medications regardless of cognitive status"
      ],
      correct: "A"
    },
    {
      id: 26298,
      question: "Which red flags in this scenario are MOST concerning for human trafficking?",
      options: [
        "The request for cosmetic dental work paid in cash, which indicates financial success and ability to afford quality dental care",
        "The language barrier and need for the employer to interpret, which is standard practice when patients don't speak English",
        "The controlling third party who refuses to leave, answers for the patient, and the patient's fearful demeanor, poor health, and lack of autonomy",
        "The presence of untreated dental disease, which simply indicates the patient has not had access to dental care until now"
      ],
      correct: "C"
    },
    {
      id: 26299,
      question: "What is the PRIMARY distinction between human trafficking and human smuggling?",
      options: [
        "Human trafficking requires crossing international borders while human smuggling only involves movement within one country",
        "Human trafficking involves ongoing exploitation for profit through labor or sex servitude, while smuggling typically ends when destination is reached",
        "Human smuggling is always violent while human trafficking involves only consensual agreements between adults for employment",
        "Human trafficking only affects children under 18 while human smuggling only involves adults over 18 years of age"
      ],
      correct: "B"
    },
    {
      id: 26300,
      question: "What is the MOST appropriate immediate action?",
      options: [
        "Complete the cosmetic dental work as requested since the boyfriend is paying and the patient appears to be over 18 years old",
        "Immediately contact law enforcement or the National Human Trafficking Hotline, as dental professionals are mandated reporters for trafficking victims",
        "Confront the boyfriend in the reception area about your suspicions to gauge his reaction before taking any further action",
        "Give the patient information about trafficking resources but take no other action since she is an adult and must report herself"
      ],
      correct: "B"
    },
    {
      id: 26301,
      question: "What is the National Human Trafficking Hotline number available 24/7 in over 200 languages?",
      options: [
        "1-800-555-HELP (4357) for general human trafficking information and local resources only during business hours",
        "1-888-373-7888 or text \"HELP\" or \"INFO\" to 233733 (BeFree) for immediate assistance available 24/7",
        "911, which is the only number that should be called for any suspected trafficking situations in all circumstances",
        "1-866-DHS-2-ICE (1-866-347-2423), which is exclusively for immigration-related issues and not for trafficking victims"
      ],
      correct: "B"
    },
    {
      id: 26302,
      question: "What should you AVOID doing when you suspect human trafficking?",
      options: [
        "Asking screening questions that identify your interest in helping without conveying judgment of the individual or situation",
        "Making promises to the patient, divulging your personal address, or offering to harbor the trafficked person yourself",
        "Documenting your observations objectively in the patient record and reporting suspicions to appropriate authorities",
        "Using a trauma-informed approach that builds trust and demonstrates sensitivity during any screening process"
      ],
      correct: "B"
    },
    {
      id: 26303,
      question: "Which documentation practice is MOST appropriate for suspected abuse cases?",
      options: [
        "Record your opinion that the parent is lying and include judgmental statements about the family's credibility in the chart",
        "Wait several days to document the findings to see if your suspicions are confirmed before writing anything in the record",
        "Separate facts from opinion, document all clinical and behavioral findings objectively, use quotes for verbal statements, and record the CPS report",
        "Destroy any photographs taken during the examination to protect patient privacy and avoid legal complications for the practice"
      ],
      correct: "C"
    },
    {
      id: 26304,
      question: "What legal protection exists for mandated reporters who file reports in good faith?",
      options: [
        "No legal protections exist, and mandated reporters can be sued for civil damages if their suspicions prove to be unfounded",
        "State-established immunity laws protect reporters from civil or criminal penalties when filing confidential reports of suspected abuse in good faith",
        "Legal protection only applies if the reporter can prove beyond reasonable doubt that abuse occurred before making the report",
        "Mandated reporters are protected only if they personally witness the abuse occurring and can provide eyewitness testimony"
      ],
      correct: "B"
    },
    {
      id: 26305,
      question: "What is the role of Child Protective Services (CPS) after receiving a report of suspected child maltreatment?",
      options: [
        "CPS provides no services and simply maintains records of reports without conducting investigations or offering interventions",
        "CPS investigates cases and provides intervention and treatment services to children and families when maltreatment has occurred",
        "CPS only prosecutes perpetrators criminally and has no role in providing support services to affected families",
        "CPS contacts the dental office to gather additional evidence and requires dental professionals to participate in court proceedings"
      ],
      correct: "B"
    },
    {
      id: 26306,
      question: "How should cultural healing practices that leave marks on children be assessed?",
      options: [
        "All marks on children must be reported as abuse regardless of cultural context because traditional practices cannot be considered during assessment",
        "Cultural practices such as cupping, coining, or scraping used in some families to treat illness may cause unintentional marks that can be mistaken for abuse",
        "Any mark left by a parent is automatically considered child abuse under CAPTA regardless of intent or cultural background",
        "Healthcare providers should ignore all cultural practices and only use Western medicine standards when evaluating any injuries"
      ],
      correct: "B"
    },
    {
      id: 26307,
      question: "What is Ehlers-Danlos syndrome, and how might it affect assessment for abuse?",
      options: [
        "EDS is a psychiatric disorder that causes children to self-injure, so all bruising in these children represents intentional self-harm",
        "EDS is a group of inherited connective tissue disorders causing extremely loose joints, hyperelastic skin that bruises easily, and easily damaged blood vessels",
        "EDS is a form of child abuse itself where parents intentionally damage children's connective tissue through repeated trauma",
        "EDS only affects elderly adults and cannot occur in children, so this diagnosis should be questioned and investigated immediately"
      ],
      correct: "B"
    },
    {
      id: 26308,
      question: "What is idiopathic thrombocytopenic purpura, and why is it relevant to abuse assessment?",
      options: [
        "ITP is a bleeding disorder where the immune system destroys platelets, causing easy bruising and bleeding that can mimic abuse",
        "ITP is a genetic condition caused by child abuse that develops only in children who have experienced repeated physical trauma",
        "ITP is a skin infection that always indicates neglect because it results from poor hygiene and lack of basic medical care",
        "ITP is a form of cancer that requires immediate chemotherapy and has no relevance to child abuse assessment procedures"
      ],
      correct: "A"
    },
    {
      id: 26309,
      question: "What condition presents with a port-wine stain birthmark that might be mistaken for abuse?",
      options: [
        "Ehlers-Danlos syndrome, which causes skin elasticity problems and always includes port-wine stains as a diagnostic feature",
        "Idiopathic thrombocytopenic purpura, which destroys platelets and creates red port-wine staining across the face",
        "Sturge-Weber syndrome, a rare disorder present at birth with a port-wine stain birthmark and nervous system problems",
        "Munchausen syndrome by proxy, where caregivers create port-wine stains on children to gain medical attention"
      ],
      correct: "C"
    },
    {
      id: 26310,
      question: "Which statement BEST represents CAPTA's definition of child abuse and neglect?",
      options: [
        "Only physical abuse resulting in visible injuries that can be photographed and documented with medical evidence",
        "Any recent act or failure to act by a parent or caretaker resulting in death, serious harm, sexual abuse, exploitation, or presenting imminent risk of serious harm",
        "Exclusively sexual abuse and exploitation, as these are the only forms of maltreatment addressed by federal legislation",
        "Any disagreement between parents and children about discipline, education, or household rules regardless of severity"
      ],
      correct: "B"
    },
    {
      id: 26311,
      question: "What significant change did the Justice for Victims of Trafficking Act of 2015 make to CAPTA?",
      options: [
        "It removed all references to sexual abuse from the federal definition of child maltreatment and neglect",
        "It eliminated mandatory reporting requirements for dental professionals in all states and territories",
        "It identified children who are victims of sex trafficking or other forms of trafficking within the federal definitions of abuse and neglect",
        "It reduced the age of child protection from 18 years to 16 years to focus resources on younger children"
      ],
      correct: "C"
    },
    {
      id: 26312,
      question: "Which statement BEST describes Adverse Childhood Experiences (ACEs)?",
      options: [
        "ACEs include only physical and sexual abuse that occurs before age 12 in school settings exclusively",
        "ACEs include abuse, neglect, and potentially traumatic events before age 18 that affect health across the lifetime",
        "ACEs are limited to witnessing violence and do not include direct experiences of abuse or household dysfunction",
        "ACEs only affect children in low-income families and have no impact on children from middle or upper-class backgrounds"
      ],
      correct: "B"
    },
    {
      id: 26313,
      question: "Which household or caregiver factor is associated with increased risk for child maltreatment?",
      options: [
        "High educational attainment and professional employment status of both parents in the household",
        "Caregiver substance use disorder, mental health problems, domestic violence, instability, or poverty in the household",
        "Living in a two-parent household with stable employment and adequate health insurance coverage",
        "Regular participation in community activities and strong extended family support networks nearby"
      ],
      correct: "B"
    },
    {
      id: 26314,
      question: "What is the typical difference in injury patterns between accidental injuries and injuries from abuse?",
      options: [
        "Accidental injuries show multiple injuries in various stages of healing while abuse injuries heal at the same time",
        "Accidental injuries normally occur over bony protuberances like knees and elbows; abuse injuries often occur on non-bony areas like neck, trunk, or upper arms",
        "Accidental injuries always leave permanent scars while injuries from abuse heal completely without any marks",
        "Accidental injuries only occur indoors while abuse injuries only occur in outdoor or public settings"
      ],
      correct: "B"
    },
    {
      id: 26315,
      question: "What has replaced the term \"shaken baby syndrome\" and why?",
      options: [
        "\"Accidental head trauma\" because research proved that shaking cannot cause serious injury to infants",
        "\"Abusive head trauma\" because neuropathological symptoms can result from shaking, blunt force trauma, or hypoxic-ischemic (smothering) means",
        "\"Developmental head injury\" because all head trauma in infants is part of normal development and learning",
        "\"Caregiver-fabricated head trauma\" because all infant head injuries are intentionally fabricated by caregivers seeking attention"
      ],
      correct: "B"
    },
    {
      id: 26316,
      question: "What percentage of U.S. youth have been electronically bullied according to national statistics?",
      options: [
        "Nearly 5% have been electronically bullied, making it a rare occurrence in U.S. schools",
        "Nearly 15% have been electronically bullied, while 19% have been bullied on school property",
        "Nearly 40% have been electronically bullied, making it more common than in-person bullying",
        "Nearly 60% have been electronically bullied, affecting the majority of all U.S. adolescents"
      ],
      correct: "B"
    },
    {
      id: 26317,
      question: "What percentage of female adults in the U.S. who experience IPV first encounter it before age 25?",
      options: [
        "An estimated 25.5% of females experienced their first IPV incident before age 25 years",
        "An estimated 45.8% of females experienced their first IPV incident before age 25 years",
        "An estimated 71.1% of females experienced their first IPV incident before age 25 years",
        "An estimated 95.2% of females experienced their first IPV incident before age 25 years"
      ],
      correct: "C"
    },
    {
      id: 26318,
      question: "What is the dental professional's role versus CPS's role in suspected abuse cases?",
      options: [
        "Dental professionals must gather all evidence, interview witnesses, and build a complete legal case before contacting CPS",
        "Dental professionals report suspicions and document objectively; CPS has expertise and resources to investigate and provide intervention",
        "Dental professionals should investigate suspected abuse themselves and only contact CPS if they can prove abuse occurred",
        "Dental professionals have no role in abuse detection and should refer all concerning cases to physicians only"
      ],
      correct: "B"
    },
    {
      id: 26319,
      question: "What are potential consequences for mandated reporters who fail to report suspected abuse or neglect?",
      options: [
        "There are no consequences because reporting is voluntary and based solely on the professional's personal judgment",
        "Failure to report can carry harsh penalties including fines, prison time, and for professionals, possible loss of licensure",
        "Consequences are limited to verbal warnings for first-time offenders with no impact on professional licensure",
        "Only physicians face consequences for failure to report; dental professionals are exempt from penalties"
      ],
      correct: "B"
    },
    {
      id: 26320,
      question: "What legal protection exists for this situation?",
      options: [
        "No protection exists and the hygienist can be sued for damages, legal fees, and defamation of character",
        "The law provides protection for mandated reporters who make reports in good faith, protecting them from civil and criminal penalties",
        "Protection only exists if the hygienist can prove actual abuse occurred before the report was made",
        "Protection applies only to physicians and nurses, not to dental hygienists or other dental professionals"
      ],
      correct: "B"
    },
    {
      id: 26321,
      question: "What is the relationship between harsh physical punishment and future maltreatment or violence?",
      options: [
        "Harsh physical punishment teaches children discipline and has no correlation with future abuse or violence",
        "Exposure to harsh physical punishment and physical discipline is related to more severe child maltreatment or revictimization in IPV in the future",
        "Harsh physical punishment only affects children under age 2 and has no long-term consequences for older children",
        "Physical discipline is completely separate from abuse and has no relationship to any form of violence"
      ],
      correct: "B"
    },
    {
      id: 26322,
      question: "Where is it MOST appropriate to place IPV resource materials in a dental office?",
      options: [
        "In the reception area where partners can see the information and understand that abuse is not tolerated",
        "Posted on the front desk so staff can hand them directly to suspected victims during check-out",
        "In restrooms or inconspicuous places where victims can privately access information away from potential perpetrators",
        "Mailed to patients' homes so they have information available, ensuring partners will see it as well"
      ],
      correct: "C"
    },
    {
      id: 26323,
      question: "What is your legal and ethical obligation in this situation?",
      options: [
        "Honor the patient's request for confidentiality because patient privacy always takes precedence over reporting obligations",
        "Report the disclosure to Child Protective Services immediately because dental professionals are mandated reporters and this constitutes suspected sexual abuse",
        "Wait until the patient turns 18 to report because adolescents have the right to consent to keeping abuse confidential",
        "Only report if the patient gives written permission because verbal disclosures do not trigger mandatory reporting requirements"
      ],
      correct: "B"
    },
    {
      id: 26324,
      question: "How are infants with prenatal substance exposure categorized in NCANDS child maltreatment reporting?",
      options: [
        "They are not included in NCANDS reporting because prenatal exposure is not considered a form of child maltreatment",
        "They are reported under the code of \"Other\" maltreatment, a category added for states to report beginning in 2018",
        "They are exclusively classified as \"Medical Neglect\" and cannot be coded under any other maltreatment category",
        "They are categorized as \"Sexual Abuse\" because substance exposure during pregnancy is considered sexual maltreatment"
      ],
      correct: "B"
    },
    {
      id: 26325,
      question: "How did the COVID-19 pandemic affect child maltreatment reporting in 2020?",
      options: [
        "Reports increased dramatically because children were home more and abuse was more visible to medical providers",
        "Reports decreased due to school closures and lockdowns, making it difficult for educational personnel, the largest reporting group, to observe maltreatment",
        "Reports remained exactly the same as previous years because the pandemic had no impact on abuse rates or reporting",
        "Reports increased because dental professionals replaced teachers as the largest group of child abuse reporters during lockdowns"
      ],
      correct: "B"
    }
  ],
  "6. Disability and Access to Care (Case Study)": [
    {
      id: 26326,
      question: "According to the Americans with Disabilities Act (ADA) of 1990, how is an individual with a disability defined?",
      options: [
        "A person who requires institutionalized care, has cognitive impairments, and needs assistance with all activities of daily living",
        "A person who has a physical or mental impairment that substantially limits one or more major life activities or has a history of such impairment",
        "A person who is permanently unable to work, requires a wheelchair for mobility, and depends entirely on others for care",
        "A person who has a temporary medical condition lasting less than 6 months that affects their ability to perform work-related tasks"
      ],
      correct: "B"
    },
    {
      id: 26327,
      question: "What is the recommended approach for speaking appropriately and respectfully to or about individuals with disabilities?",
      options: [
        "Handicapped language, which focuses on the disability first to ensure proper accommodations and medical management",
        "Medical-model language, which emphasizes the pathologic condition and treatment needs before considering the individual",
        "People-first language, which focuses on the person first and not the disability, preventing dehumanization of individuals",
        "Disability-centered language, which highlights the assistive equipment and limitations before mentioning the person's name"
      ],
      correct: "C"
    },
    {
      id: 26328,
      question: "Which statement demonstrates proper people-first language when documenting this patient's information?",
      options: [
        "\"The wheelchair-bound patient requires special accommodations for dental treatment and cannot ambulate independently\"",
        "\"The patient with a physical disability uses a wheelchair for mobility and is confined to the wheelchair for all daily activities\"",
        "\"A person who uses a wheelchair arrived for appointment; patient sustained spinal cord injury 10 years ago in accident\"",
        "\"The handicapped individual is restricted to a wheelchair and demonstrates limitations in mobility requiring assistance\""
      ],
      correct: "C"
    },
    {
      id: 26329,
      question: "Approximately how many adults in the United States live with disabilities according to current statistics?",
      options: [
        "Approximately 15 million adults, representing about 6% of the U.S. population living in communities across all states",
        "Approximately 61 million adults, representing nearly 1 in 4 (26%) of people in the United States living in communities",
        "Approximately 100 million adults, representing nearly 1 in 3 (33%) of people in the United States requiring daily assistance",
        "Approximately 200 million adults, representing over half (52%) of the U.S. population experiencing some form of limitation"
      ],
      correct: "B"
    },
    {
      id: 26330,
      question: "Based on the stage of exposure, how would autism spectrum disorder be classified?",
      options: [
        "Acquired disability, referring to disabilities present after birth that can be traceable to disease, trauma, or environmental factors",
        "Age-associated disability, referring to disabilities that develop after age 65 due to chronic diseases or cognitive impairment",
        "Developmental disability, referring to conditions with impairment in physical, learning, language, or behavioral areas diagnosed before age 22",
        "Congenital disability, referring to irregularities present at birth that are always directly traceable to specific genetic factors"
      ],
      correct: "C"
    },
    {
      id: 26331,
      question: "How would Alzheimer disease be classified based on stage of exposure to disability?",
      options: [
        "Age-associated disability, as cognitive impairments like dementia and Alzheimer disease can cause older individuals to become disabled",
        "Congenital disability, as Alzheimer disease is always present at birth but symptoms don't manifest until later in life",
        "Developmental disability, as Alzheimer disease must be diagnosed before age 22 years to meet classification criteria",
        "Acquired disability, as Alzheimer disease is traceable to traumatic events or injuries sustained earlier in life"
      ],
      correct: "A"
    },
    {
      id: 26332,
      question: "How would this patient's disabilities be classified based on stage of exposure?",
      options: [
        "Developmental disabilities, as they affect learning and behavioral areas requiring comprehensive management throughout life",
        "Military service disabilities, as they resulted from injuries sustained during active duty in the United States military",
        "Age-associated disabilities, as they typically occur in individuals over 65 years with chronic disease development",
        "Congenital disabilities, as they represent irregularities that were present at birth but only recently diagnosed"
      ],
      correct: "B"
    },
    {
      id: 26333,
      question: "What are the three primary dimensions used to classify disabilities according to the ICF model?",
      options: [
        "Congenital conditions, acquired conditions, and developmental conditions that affect physical and mental functioning",
        "Impairments, activity limitations, and participation restrictions that result from health conditions and contextual factors",
        "Physical disabilities, cognitive disabilities, and sensory disabilities that require specialized healthcare interventions",
        "Temporary disabilities, permanent disabilities, and progressive disabilities that vary in duration and severity over time"
      ],
      correct: "B"
    },
    {
      id: 26334,
      question: "This scenario BEST represents which dimension of disability classification?",
      options: [
        "Impairment, representing loss or abnormality in function from the pathologic condition of rheumatoid arthritis",
        "Activity limitation, representing difficulty in performing activities due to the medical condition of arthritis",
        "Participation restriction, representing inability to engage in everyday life activities due to lack of reasonable accommodations",
        "Disability adjusted life year, representing years of productive life lost due to the disability from arthritis"
      ],
      correct: "C"
    },
    {
      id: 26335,
      question: "This scenario BEST represents which dimension of disability classification?",
      options: [
        "Participation restriction, as the patient cannot engage in everyday life activities for reasons outside their control",
        "Activity limitation, as the patient has difficulty performing activities due to the medical condition affecting motor control",
        "Environmental factor, as architectural characteristics and social structures limit the patient's ability to function independently",
        "Personal factor, as the patient's age, coping styles, and behavior patterns determine their level of functioning"
      ],
      correct: "B"
    },
    {
      id: 26336,
      question: "What is the MOST common barrier to healthcare experienced by patients with disabilities?",
      options: [
        "Fear and embarrassment about their condition, which prevents them from seeking necessary healthcare services",
        "Lack of training among healthcare providers, making it difficult to find qualified professionals to treat them",
        "Access to healthcare, including affordability of services, which prevents patients from receiving needed care",
        "Communication difficulties with healthcare providers, resulting in inadequate understanding of treatment recommendations"
      ],
      correct: "C"
    },
    {
      id: 26337,
      question: "According to the ADA, which statement about public accommodations is correct?",
      options: [
        "Only dental offices built after 1990 must provide barrier-free access; older facilities are grandfathered and exempt",
        "Dental offices under 5,000 square feet are exempt from ADA requirements for physical accessibility",
        "People who own, lease, or operate dental offices are responsible for ensuring removal of all barriers regardless of building age",
        "Dental offices can charge additional fees to patients with disabilities to cover costs of providing accommodations"
      ],
      correct: "C"
    },
    {
      id: 26338,
      question: "When assessing this patient for oral self-care assistive devices, which factors should the dental hygienist evaluate?",
      options: [
        "Only the patient's skill level and cognitive application, as physical abilities are not relevant to device selection",
        "Range of motion, grip strength, skill level, and cognitive application to determine appropriate assistive device adaptations",
        "Exclusively the patient's financial ability to purchase expensive specialized equipment from medical supply companies",
        "The caregiver's willingness to provide daily care, as patients with tremors cannot perform any oral care independently"
      ],
      correct: "B"
    },
    {
      id: 26339,
      question: "What characteristic would be MOST important for this patient's customized oral self-care device?",
      options: [
        "A wider grip handle to accommodate the patient's inability to grasp small objects securely",
        "Extended length to accommodate the patient's limited range of motion in reaching the oral cavity",
        "Powered mechanism to compensate for the patient's cognitive impairment and confusion",
        "Weighted base to provide stability for patients with uncontrolled tremors and spasms"
      ],
      correct: "B"
    },
    {
      id: 26340,
      question: "Which characteristics are ideal for customized oral self-care assistive devices?",
      options: [
        "Expensive and professionally manufactured, requiring specialized training to use, with complex interchangeable parts",
        "Lightweight and easy to use, readily available and accessible, inexpensive and easily constructed, with water-resistant parts",
        "Heavy and durable to withstand years of use, requiring professional maintenance, with permanent non-removable components",
        "Custom-molded to each patient's specific anatomy, requiring prescription from physician, with non-transferable features"
      ],
      correct: "B"
    },
    {
      id: 26341,
      question: "Which scenario represents an appropriate indication for protective stabilization?",
      options: [
        "A cooperative patient without sedation who needs routine preventive care and has no history of movement disorders",
        "Emergent care is needed and uncontrolled movements risk safety of patient and staff without use of protective stabilization",
        "A patient with nonemergent treatment needs for full mouth rehabilitation over multiple appointments requiring extensive time",
        "A patient who can be safely immobilized but has history of psychological trauma from previous restraint experiences"
      ],
      correct: "B"
    },
    {
      id: 26342,
      question: "What is required before using protective stabilization on this patient?",
      options: [
        "Only verbal permission from the parent, as written consent is never required for protective stabilization procedures",
        "Informed consent that includes explanation of indications, benefits, risks, and alternative approaches such as sedation",
        "Approval from the state dental board, as protective stabilization requires special licensure in all jurisdictions",
        "Documentation that at least three dental offices refused to treat the patient before stabilization can be used"
      ],
      correct: "B"
    },
    {
      id: 26343,
      question: "What is the MOST important technique when inserting a mouth prop to prevent patient injury?",
      options: [
        "Insert the larger end of mouth prop first horizontally, then turn vertically without protecting the lips from injury",
        "Use the mouth prop between anterior teeth, which are best suited to withstand the pressure of biting forces",
        "Gently pull lower lip forward while inserting prop horizontally, then turn to vertical position, using double fulcrum",
        "Have the primary operator hold the mouth prop throughout the procedure while delivering dental hygiene care"
      ],
      correct: "C"
    },
    {
      id: 26344,
      question: "Which information MUST be included in the patient's record regarding protective stabilization?",
      options: [
        "Only the type of device used, as other details are not legally required for documentation purposes",
        "Indication, type used, informed consent, duration of application, behavior evaluation, untoward outcomes, and future implications",
        "Just the informed consent form, as this document contains all necessary information about the procedure",
        "Only complications that occurred, as routine stabilization procedures do not require documentation if uneventful"
      ],
      correct: "B"
    },
    {
      id: 26345,
      question: "Which technique involves verbally explaining procedures, demonstrating them in a nonthreatening way, then completing the procedure?",
      options: [
        "Voice control, which provides deliberate alterations of voice volume, tone, or pace to influence patient behavior",
        "Direct observation, which shows the patient a video or permits observation of another patient undergoing treatment",
        "Tell-show-do, which involves explaining, demonstrating, and then completing procedures without deviating from demonstration",
        "Positive pre-visit imagery, which shows the patient positive images of dentistry in the waiting area before appointments"
      ],
      correct: "C"
    },
    {
      id: 26346,
      question: "What strategy would be MOST helpful for assessing this patient's grip strength?",
      options: [
        "Having the patient hold various prescription medications to determine if they can manage their own healthcare independently",
        "Having the patient grasp various sizes of foam cylinders and retain finger closure for an extended length of time",
        "Observing the patient write their signature on forms to assess fine motor control and coordination abilities",
        "Asking the patient to describe their grip strength verbally without any physical demonstration or testing"
      ],
      correct: "B"
    },
    {
      id: 26347,
      question: "What can the dental hygienist do to reduce the risk of muscle spasms during wheelchair transfers?",
      options: [
        "Transfer the patient as quickly as possible without warning to minimize the time muscles are in motion",
        "Place supportive pillows or beanbags to provide support and use stress reduction protocols before transfer",
        "Avoid using any assistive devices, as they increase anxiety and contribute to more frequent muscle spasms",
        "Schedule appointments early in the morning only, as muscle spasms never occur before 10:00 AM"
      ],
      correct: "B"
    },
    {
      id: 26348,
      question: "What should the dental hygienist do to prevent pressure injuries during the extended appointment?",
      options: [
        "Keep the patient in the same position throughout the appointment, as movement increases the risk of new injuries",
        "Discuss presence of pressure injuries during health history, avoid positioning on affected areas, and reposition every 20 minutes",
        "Apply heavy pressure to insensate areas to stimulate circulation and prevent development of new pressure injuries",
        "Refuse to treat the patient until all existing pressure injuries are completely healed to avoid liability concerns"
      ],
      correct: "B"
    },
    {
      id: 26349,
      question: "When preparing for wheelchair transfer, at what height should the dental chair be positioned relative to the wheelchair?",
      options: [
        "The dental chair should be significantly higher than wheelchair to allow patient to step up during transfer process",
        "The dental chair should be at the same height or slightly lower than wheelchair to accommodate weight and minimize strength needed",
        "The dental chair should be at its highest position regardless of wheelchair height to facilitate clinician access",
        "The dental chair should be at its lowest position touching the floor to prevent any possibility of patient falling"
      ],
      correct: "B"
    },
    {
      id: 26350,
      question: "Which body mechanics should the dental hygienist use during the transfer to prevent back injury?",
      options: [
        "Keep feet together for stability, bend at the waist instead of knees, and twist the back while lifting the patient",
        "Separate feet for balance, bend knees, keep back straight and slightly forward at waist, lift with legs using stand-pivot-sit method",
        "Stand with feet together, keep legs straight and locked, bend forward at waist with rounded back to reach patient",
        "Position feet in narrow stance, hyperextend the back during lift, and rotate the spine while moving the patient"
      ],
      correct: "B"
    },
    {
      id: 26351,
      question: "What precautionary step should the dental hygienist take during the transfer?",
      options: [
        "Remove the catheter and collection bag before transfer, as these devices should never remain in place during dental appointments",
        "Inquire about use of assistive bowel and bladder devices and take precautionary steps to prevent dislodgement during transfer",
        "Ignore the presence of the catheter completely, as urinary devices have no relevance to dental care or transfers",
        "Refuse to transfer the patient and provide all dental care in the wheelchair to avoid any contact with medical devices"
      ],
      correct: "B"
    },
    {
      id: 26352,
      question: "What is the correct placement of a sliding board during wheelchair transfer?",
      options: [
        "Place sliding board vertically between patient's back and wheelchair to provide lumbar support during transfer process",
        "Place one end of sliding board underneath patient's thighs and the other end across the dental chair to allow sliding",
        "Place sliding board on the floor between wheelchair and dental chair for patient to slide their feet across during transfer",
        "Place sliding board across patient's lap horizontally to provide a surface for patient to rest arms during the transfer"
      ],
      correct: "B"
    },
    {
      id: 26353,
      question: "Where should the dental hygienist's knees or thighs be positioned during the lift?",
      options: [
        "Behind the patient's back to provide support and prevent the patient from falling backward during the lifting process",
        "At the sides of patient's hips to stabilize the pelvis and prevent lateral movement during the transfer",
        "Closed on patient's knees to support and stabilize the patient's leg, allowing patient to bear some weight during lift",
        "Extended straight without any contact with patient to maintain maximum distance and prevent injury to clinician"
      ],
      correct: "C"
    },
    {
      id: 26354,
      question: "What should the dental hygienist do immediately after lifting the patient off the wheelchair seat?",
      options: [
        "Immediately release the transfer belt and step away to allow the patient to complete the transfer independently",
        "Stand still in place without moving until the patient indicates they are ready to be moved toward the dental chair",
        "Pivot on the foot closer to dental chair and maneuver patient over the seat, then lower patient by bending at knees",
        "Twist the back and shoulders while keeping feet planted to rotate the patient toward the dental chair"
      ],
      correct: "C"
    },
    {
      id: 26355,
      question: "Who should coordinate the lift signal during a two-person wheelchair transfer?",
      options: [
        "The person supporting the patient's legs should coordinate because they can see the dental chair clearly",
        "The person supporting the patient's torso should coordinate because they are lifting the most weight",
        "The dental assistant should coordinate from across the room to provide objective oversight of transfer",
        "The patient should coordinate the lift signal because they know best when they are ready to move"
      ],
      correct: "B"
    },
    {
      id: 26356,
      question: "What is the MOST appropriate way to provide dental hygiene care for this patient?",
      options: [
        "Refuse to treat the patient until they can be transferred to the dental chair, as dental care cannot be provided in wheelchairs",
        "Provide care with patient remaining in wheelchair positioned alongside or behind dental chair, using portable headrest or chair's headrest",
        "Refer the patient to a hospital operating room, as this is the only setting where patients in wheelchairs can receive dental care",
        "Schedule the appointment for 15 minutes or less, as extended care cannot be safely delivered to patients in wheelchairs"
      ],
      correct: "B"
    },
    {
      id: 26357,
      question: "How can the dental hygienist provide adequate head support for this patient during care?",
      options: [
        "Have the patient hold their own head up throughout treatment without any additional support or assistance",
        "Use a portable headrest or turn wheelchair around so patient's head leans back against dental chair's headrest",
        "Position patient's head hanging forward toward chest throughout appointment to maintain stability and prevent movement",
        "Have another staff member manually hold patient's head in position for the entire duration of dental hygiene treatment"
      ],
      correct: "B"
    },
    {
      id: 26358,
      question: "What is the MOST important assessment for this patient regarding oral self-care?",
      options: [
        "Assessing the patient's range of motion and grip strength to determine which assistive devices to recommend for independent care",
        "Conducting caregiver interviews to assess willingness to provide daily care, determine skill level, provide instruction, and address concerns",
        "Evaluating the patient's cognitive application to ensure they can learn proper brushing technique with minimal assistance",
        "Testing the patient's skill level by watching them simulate brushing to determine what they can accomplish with ease"
      ],
      correct: "B"
    },
    {
      id: 26359,
      question: "What type of protective stabilization involves physical immobilization by another person such as a parent or healthcare professional?",
      options: [
        "Active stabilization, which involves physical immobilization by another person during the procedure",
        "Passive stabilization, which involves using an immobilization device such as a papoose board",
        "Restrictive stabilization, which involves using chemical sedation to reduce patient movement",
        "Preventive stabilization, which involves behavior modification techniques without any physical restriction"
      ],
      correct: "A"
    },
    {
      id: 26360,
      question: "What type of protective stabilization does a papoose board represent?",
      options: [
        "Active stabilization involving physical immobilization by another person such as parent or healthcare professional",
        "Passive stabilization involving use of an immobilization device rather than physical restraint by people",
        "Voluntary stabilization involving patient's conscious decision to limit their own movements during procedure",
        "Chemical stabilization involving use of medications to sedate the patient and reduce movement"
      ],
      correct: "B"
    },
    {
      id: 26361,
      question: "Why is it critical to inspect for mobile teeth before using a mouth prop?",
      options: [
        "Mobile teeth increase revenue opportunities because they can be extracted during the same appointment for additional fees",
        "Mobile teeth indicate excellent oral hygiene and suggest the patient does not need mouth prop assistance during treatment",
        "Mobile teeth increase aspiration-related risks if the mouth prop inadvertently dislodges a tooth during use",
        "Mobile teeth prevent proper mouth prop placement and make it impossible to use the device safely in any situation"
      ],
      correct: "C"
    },
    {
      id: 26362,
      question: "What special precaution should be taken when using protective stabilization devices on patients prone to seizures?",
      options: [
        "Apply protective stabilization devices as tightly as possible to prevent any movement if a seizure occurs during treatment",
        "Never remove protective stabilization devices regardless of patient status, as this would violate protocol standards",
        "Use protective stabilization with caution and remove immobilization devices quickly in the event of seizure onset",
        "Protective stabilization is absolutely contraindicated in all patients with seizure disorders under any circumstances"
      ],
      correct: "C"
    },
    {
      id: 26363,
      question: "Who should ideally hold and control the mouth prop during dental hygiene treatment?",
      options: [
        "The primary healthcare professional delivering treatment, as this provides the best control and visibility of the oral cavity",
        "The assisting healthcare professional, not the primary healthcare professional delivering the dental hygiene care",
        "The patient should hold their own mouth prop throughout treatment to promote independence and cooperation",
        "The parent or caregiver should hold the mouth prop since they know the patient best and can anticipate movements"
      ],
      correct: "B"
    },
    {
      id: 26364,
      question: "What does establishing a \"double fulcrum\" mean when using a mouth prop?",
      options: [
        "Using two mouth props simultaneously, one on each side of the mouth to provide bilateral support during treatment",
        "Having two different healthcare professionals each hold one end of the mouth prop for stability and control",
        "Placing ring finger on mandibular anterior gingiva (first fulcrum) and pinky on patient's chin (second fulcrum) while holding prop",
        "Using the mouth prop to create two pressure points on maxillary and mandibular teeth simultaneously during procedure"
      ],
      correct: "C"
    },
    {
      id: 26365,
      question: "Which behavioral guidance technique shows the patient a video or permits them to observe a cooperative patient receiving treatment?",
      options: [
        "Tell-show-do technique, which verbally explains and demonstrates procedures before completing them",
        "Direct observation technique, which shows videos or permits observation of cooperative patients undergoing treatment",
        "Positive reinforcement technique, which rewards desired behaviors to strengthen likelihood of recurrence",
        "Voice control technique, which uses deliberate alterations in voice volume and tone to influence behavior"
      ],
      correct: "B"
    },
    {
      id: 26366,
      question: "Which technique involves giving the patient a short break during a stressful procedure before considering more advanced techniques?",
      options: [
        "Voice control, which provides deliberate alterations of voice volume and tone to influence patient behavior",
        "Distraction, which diverts patient's attention from unpleasant procedures and includes short breaks during stressful procedures",
        "Memory restructuring, which restructures memories of negative events into positive memories after the event occurs",
        "Protective stabilization, which immobilizes or reduces patient's ability to move arms, legs, body, or head"
      ],
      correct: "B"
    },
    {
      id: 26367,
      question: "Which behavioral guidance technique emphasizes specific cooperative behaviors rather than generalized praise?",
      options: [
        "Nonverbal communication, which provides reinforcement through appropriate contact, posture, and facial expression",
        "Positive pre-visit imagery, which shows positive images of dentistry before appointments to reduce anxiety",
        "Descriptive praise, which emphasizes specific behaviors such as \"Thank you for sitting still\" rather than generalized praise",
        "Tell-show-do technique, which explains and demonstrates procedures before completing them without deviation"
      ],
      correct: "C"
    },
    {
      id: 26368,
      question: "How should the patient be positioned to reduce aspiration risk during dental hygiene treatment?",
      options: [
        "In a fully supine position with head lower than feet to facilitate drainage of fluids away from the airway",
        "In a sitting position or as close to upright as possible, using semi-inclined position to prevent aspiration",
        "In a Trendelenburg position with head tilted down 15-20 degrees below the horizontal plane of the body",
        "In a side-lying lateral position throughout treatment to allow fluids to drain out of the corner of mouth"
      ],
      correct: "B"
    },
    {
      id: 26369,
      question: "What alternative method can be used instead of the air-water syringe for patients with increased aspiration risk?",
      options: [
        "Increase water pressure and flow rate to quickly flush debris before patient can aspirate materials into airway",
        "Use wet gauze as towelettes to cleanse the oral cavity of debris rather than using air-water syringe",
        "Skip all rinsing procedures entirely and leave all debris and calculus in the mouth to avoid aspiration",
        "Use air only without any water to dry the mouth completely, eliminating all moisture to prevent aspiration"
      ],
      correct: "B"
    },
    {
      id: 26370,
      question: "How can the dental hygienist provide additional head support and stabilization during care?",
      options: [
        "Have the patient hold their own head steady without any assistance from the clinician throughout the appointment",
        "Wrap nondominant arm around patient's head and firmly under patient's chin for stabilization, placing pillows or rolls on sides of head",
        "Position patient's head hanging off the end of the dental chair to provide natural stabilization through gravity",
        "Instruct patient to turn head constantly from side to side throughout treatment to prevent muscle fatigue and stiffness"
      ],
      correct: "B"
    },
    {
      id: 26371,
      question: "What assistive equipment can provide additional support for patients with unstable joints and limbs during dental treatment?",
      options: [
        "Metal restraints attached to the dental chair arms to prevent any movement of extremities during treatment procedures",
        "Beanbag chairs or cushions placed in dental chair to provide support and minimize pressure injuries for patients with paralysis",
        "Elastic bands wrapped tightly around all joints to immobilize them completely and prevent any movement during care",
        "Wooden boards placed under the patient to create a rigid flat surface that eliminates all cushioning and support"
      ],
      correct: "B"
    },
    {
      id: 26372,
      question: "What should the dental hygienist do with the patient's specialized wheelchair cushion during the appointment?",
      options: [
        "Leave the cushion in the wheelchair, as patients should never have personal items with them in the dental chair",
        "Transfer any special padding underneath patient from wheelchair to dental chair to help with patient comfort throughout appointment",
        "Discard the cushion as it is contaminated from wheelchair use and cannot be safely used in the dental environment",
        "Store the cushion in a separate room away from the patient to prevent cross-contamination during dental procedures"
      ],
      correct: "B"
    },
    {
      id: 26373,
      question: "What is an essential safety step before beginning any wheelchair transfer?",
      options: [
        "Remove wheelchair brakes to allow easy movement during transfer and prevent the chair from being too stable",
        "Ensure wheelchair locks into position and check nearby area for sharp edges, hazards, obstacles, or cords that could cause injury",
        "Position dental chair at its highest elevation to create maximum distance between wheelchair and chair during transfer",
        "Have patient stand up and walk around the operatory first to demonstrate they are capable of ambulating independently"
      ],
      correct: "B"
    },
    {
      id: 26374,
      question: "What is the BEST course of action for this patient?",
      options: [
        "Refuse treatment and reschedule for another day when the patient has more energy and can transfer to dental chair",
        "Force the transfer despite patient's fatigue, as dental care can only be delivered with patient in the dental chair",
        "Provide dental care with patient remaining in wheelchair, as some patients may be too tired or weak to transfer",
        "Call emergency medical services to transport patient to hospital for treatment, as this is the only safe alternative"
      ],
      correct: "C"
    },
    {
      id: 26375,
      question: "What is the unique feature of the Plak-Vac Oral Suction Toothbrush?",
      options: [
        "It is a standard toothbrush that must be used without any suction or water to prevent aspiration in patients",
        "It is a uniquely designed toothbrush that can be connected to bedside or portable suction devices during use",
        "It is an electric toothbrush with a built-in water reservoir that automatically dispenses water during brushing",
        "It is a manual toothbrush with an extended handle designed exclusively for use by caregivers on bedridden patients"
      ],
      correct: "B"
    }
  ],
  "7. Intellectual and Developmental Disabilities (Case Study)": [
    {
      id: 26376,
      question: "Based on the IQ level and functional abilities, what level of intellectual disability does this patient have?",
      options: [
        "Mild intellectual disability with IQ 50-69, representing approximately 85% of the ID population",
        "Moderate intellectual disability with IQ 36-49, capable of learning self-care and social adjustment",
        "Severe intellectual disability with IQ 20-35, requiring elementary self-care training with supervision",
        "Profound intellectual disability with IQ less than 20, requiring continual supervision and total care"
      ],
      correct: "B"
    },
    {
      id: 26377,
      question: "What level of intellectual disability does this patient have, and what teaching approach is MOST appropriate?",
      options: [
        "Mild ID; explain and demonstrate oral hygiene instructions, teach activities instead of concepts, provide recognition and rewards",
        "Moderate ID; teach only fundamental skills via show-and-tell method, provide tangible rewards after every step",
        "Severe ID; use habit training by repeating procedures continuously, include caregiver in all instruction",
        "Profound ID; provide all education to caregiver only, as patient is incapable of learning any self-care"
      ],
      correct: "A"
    },
    {
      id: 26378,
      question: "What is the MOST appropriate teaching method for this patient?",
      options: [
        "Teach detailed oral hygiene concepts using written instructions and expect independent performance",
        "Use habit training by repeating procedures continuously, set realistic goals, and include caregiver in teaching",
        "Provide education only to caregiver, as patient cannot acquire any oral care behaviors whatsoever",
        "Teach complex interdental cleaning techniques first, then progress to basic brushing skills"
      ],
      correct: "B"
    },
    {
      id: 26379,
      question: "Who should receive the oral hygiene education for this patient?",
      options: [
        "The patient only, using simplified language and demonstrations until they master all techniques independently",
        "Both patient and caregiver equally, as they will share responsibility for performing all oral hygiene procedures",
        "The caregiver, who is responsible for the patient's general and oral hygiene care and performs daily regimen",
        "The group home staff only, as they are legally responsible for all medical and dental care decisions"
      ],
      correct: "C"
    },
    {
      id: 26380,
      question: "Which prenatal infection-related dental manifestations might be observed in this patient?",
      options: [
        "Microdontia, congenitally missing teeth, and delayed eruption patterns from developmental abnormalities",
        "Hutchinson incisors, mulberry molars, and microdontia as dental-related signs of prenatal infections",
        "Enamel hypoplasia, tetracycline staining, and shortened roots from postnatal antibiotic therapy",
        "Fissured tongue, enlarged circumvallate papillae, and tongue thrust from medication side effects"
      ],
      correct: "B"
    },
    {
      id: 26381,
      question: "What term describes these behaviors, and what is their significance?",
      options: [
        "Adaptive behaviors that help the patient cope with stress and should be encouraged during appointments",
        "Self-injurious behaviors (SIBs) that may intimidate caregivers and can make the patient difficult to manage",
        "Attention-seeking behaviors that indicate the patient is bored and needs more stimulating activities",
        "Communication behaviors that represent the patient's only way to express needs and should be interpreted"
      ],
      correct: "B"
    },
    {
      id: 26382,
      question: "What is the MOST commonly used behavioral treatment for self-injurious behavior?",
      options: [
        "Physical restraint using papoose board immediately upon any sign of self-injurious behavior",
        "Differential reinforcement of another behavior, giving patient something to hold or assemble with hands",
        "Ignoring all behaviors completely throughout appointment without any acknowledgment or response",
        "Immediate sedation with pharmacologic agents at the first indication of any self-injurious behavior"
      ],
      correct: "B"
    },
    {
      id: 26383,
      question: "What is the MOST likely cause of this tooth surface abrasion?",
      options: [
        "Aggressive toothbrushing with hard-bristled brush and abrasive dentifrice applied with excessive pressure",
        "Dietary erosion from frequent consumption of acidic beverages and citrus fruits throughout the day",
        "Bruxism linked to anxiety and emotional distress, which increases with age and can cause attrition",
        "Congenital enamel defects that cause teeth to be softer and wear more easily than normal enamel"
      ],
      correct: "C"
    },
    {
      id: 26384,
      question: "Which factors contribute to the high prevalence of periodontal disease and dental caries in patients with intellectual disabilities?",
      options: [
        "Genetic predisposition only, as oral hygiene and access to care have no impact on disease development",
        "Lack of professional care, limited funds, host susceptibility, poor oral hygiene, and caregiver oral health knowledge",
        "Excessive fluoride exposure during childhood causing fluorosis, which increases susceptibility to disease",
        "Normal aging process that affects all individuals equally regardless of disability status or care received"
      ],
      correct: "B"
    },
    {
      id: 26385,
      question: "What percentage of the world population is diagnosed with intellectual disability?",
      options: [
        "Less than 1% to 3% of the world population, representing a very small fraction of global population",
        "Approximately 10% to 15% of the world population, representing a moderate portion of global population",
        "Approximately 25% to 30% of the world population, representing a significant portion of global population",
        "More than 50% of the world population, representing the majority of individuals worldwide"
      ],
      correct: "A"
    },
    {
      id: 26386,
      question: "Which prenatal factors can cause intellectual disabilities in the developing fetus?",
      options: [
        "Only genetic factors present at conception, as environmental factors have no impact on fetal development",
        "Infections like rubella and HIV, drug/alcohol consumption, poor nutrition, hypertension, diabetes, and irradiation",
        "Exclusively nutritional deficiencies, as maternal infections cannot cross the placental barrier to affect fetus",
        "Postnatal factors only, as intellectual disabilities cannot develop until after the baby is born"
      ],
      correct: "B"
    },
    {
      id: 26387,
      question: "During which period did this patient's intellectual disability most likely develop?",
      options: [
        "Prenatal period (32% of IDs), which includes time before birth when infections or maternal factors cause disabilities",
        "Perinatal period (11% of IDs), which includes time immediately before, during, and after birth with complications",
        "Postnatal period (4% of IDs), which includes time after birth when brain infections or trauma occurs",
        "Genetic period at conception, which includes chromosomal disturbances and metabolic disorders evident from conception"
      ],
      correct: "B"
    },
    {
      id: 26388,
      question: "What causes fragile X syndrome, and what is its significance?",
      options: [
        "Fragile X results from prenatal infections and is the least common type of ID due to environmental factors",
        "Fragile X results from perinatal hypoxemia and represents a rare form of acquired intellectual disability",
        "Fragile X results from changes in fragile X messenger ribonucleoprotein gene and is the most common genetic cause of ID",
        "Fragile X results from postnatal brain trauma and represents a preventable cause of intellectual disability"
      ],
      correct: "C"
    },
    {
      id: 26389,
      question: "What causes intellectual disability in phenylketonuria?",
      options: [
        "Abnormal accumulation of phenylalanine that is toxic to the brain, requiring strict dietary management",
        "Deletion of part of chromosome 15 causing behavior issues and short stature along with intellectual disability",
        "Toxic accumulation of bilirubin in the brain from blood incompatibilities during the perinatal period",
        "Dietary protein deficiency during postnatal development that prevents normal brain growth and function"
      ],
      correct: "A"
    },
    {
      id: 26390,
      question: "Approximately what percentage of intellectual disabilities occur during the prenatal period?",
      options: [
        "Approximately 4% of IDs occur prenatally, making it the least common period for ID development",
        "Approximately 11% of IDs occur prenatally, making it less common than perinatal causes",
        "Approximately 32% of IDs occur prenatally, making it the most common period for ID development",
        "Approximately 85% of IDs occur prenatally, representing the vast majority of all intellectual disabilities"
      ],
      correct: "C"
    },
    {
      id: 26391,
      question: "What causes trisomy 21, and how common is it among individuals with Down syndrome?",
      options: [
        "Trisomy 21 results from translocation of chromosome 21 to another chromosome and occurs in 95% of cases",
        "Trisomy 21 results from mosaicism error in first cell divisions after conception and occurs in 95% of cases",
        "Trisomy 21 results from failure of chromosome 21 pair to segregate during egg or sperm formation and occurs in 95% of cases",
        "Trisomy 21 results from deletion of part of chromosome 21 during fetal development and occurs in 95% of cases"
      ],
      correct: "C"
    },
    {
      id: 26392,
      question: "What is the relationship between maternal age and Down syndrome incidence?",
      options: [
        "Down syndrome incidence decreases with increased maternal age, with lowest rates in mothers over 40 years",
        "Down syndrome incidence is correlated with increased maternal age; however, 51% are born to mothers under 35 due to high fertility rates",
        "Down syndrome only occurs in mothers over 40 years of age and never occurs in younger mothers",
        "Maternal age has no relationship to Down syndrome incidence, as it is purely a random genetic occurrence"
      ],
      correct: "B"
    },
    {
      id: 26393,
      question: "What characteristic of Down syndrome contributes to the high incidence of ear problems and hearing loss?",
      options: [
        "Enlarged tongue and mandibular prognathism that create pressure changes affecting the auditory canal",
        "Anatomic predispositions including small ear canals and persistent middle ear fluid from chronic infections",
        "Medication side effects from seizure medications that damage auditory nerves over time",
        "Excessive cerumen production from thyroid disorders that block the ear canal and prevent sound transmission"
      ],
      correct: "B"
    },
    {
      id: 26394,
      question: "What causes the appearance of tongue enlargement in patients with Down syndrome?",
      options: [
        "The tongue is actually enlarged due to hypertrophy of tongue muscles from chronic tongue thrusting behaviors",
        "The tongue appears enlarged due to underdeveloped maxilla, mandibular prognathism, narrow palate, and enlarged tonsils creating small oral space",
        "The tongue is swollen from undiagnosed hypothyroidism that causes fluid retention in all soft tissues",
        "The tongue appears large due to atrophied jaw muscles that cannot support the mandible in proper position"
      ],
      correct: "B"
    },
    {
      id: 26395,
      question: "What oral hygiene recommendations are MOST appropriate for this patient?",
      options: [
        "Avoid all tongue cleaning, as it will damage the papillae and cause bleeding and pain",
        "Perform tongue brushing and use ADA-accepted antimicrobial dentifrice and mouth rinse to reduce biofilm, gingivitis, and halitosis",
        "Use only water for oral care, as all dentifrices and mouth rinses cause irritation to fissured tongues",
        "Apply topical anesthetic before every meal to numb the tongue and reduce discomfort from eating"
      ],
      correct: "B"
    },
    {
      id: 26396,
      question: "What percentage of older individuals with Down syndrome have thyroid disorders?",
      options: [
        "As many as 5% of older individuals with Down syndrome have thyroid disorders",
        "As many as 24% of older individuals with Down syndrome have thyroid disorders",
        "As many as 50% of older individuals with Down syndrome have thyroid disorders",
        "As many as 75% of older individuals with Down syndrome have thyroid disorders"
      ],
      correct: "B"
    },
    {
      id: 26397,
      question: "What is the MOST common serious medical condition among persons with Down syndrome?",
      options: [
        "Thyroid disorders affecting growth and development, occurring in all individuals with Down syndrome",
        "Seizure disorders requiring lifelong medication management, occurring in majority of individuals",
        "Congenital heart disease, present in 40-60% of children and major cause of mortality in first 2 years",
        "Alzheimer disease beginning in childhood, affecting all individuals with Down syndrome by age 10"
      ],
      correct: "C"
    },
    {
      id: 26398,
      question: "Which cardiac conditions in patients with Down syndrome require antibiotic prophylaxis according to current guidelines?",
      options: [
        "All congenital heart defects require prophylactic antibiotics regardless of type or severity of defect",
        "Only cardiac conditions associated with highest risk of adverse outcomes from endocarditis require prophylaxis",
        "No cardiac conditions require prophylaxis, as current guidelines eliminated this requirement for all patients",
        "Only patients who have already had endocarditis in the past require prophylactic antibiotic coverage"
      ],
      correct: "B"
    },
    {
      id: 26399,
      question: "What is atlantoaxial instability, and what percentage of individuals with Down syndrome are affected?",
      options: [
        "Abnormal increase in mobility between first two cervical vertebrae, found in 10-20% of younger individuals with Down syndrome",
        "Decreased mobility of all cervical vertebrae causing complete neck rigidity, found in 50-60% of individuals",
        "Curvature of the spine that affects the thoracic and lumbar regions, found in 80-90% of individuals",
        "Excessive external hip rotation and abduction causing gait problems, found in all individuals with Down syndrome"
      ],
      correct: "A"
    },
    {
      id: 26400,
      question: "What is the relationship between phenytoin and gingival enlargement in patients with Down syndrome?",
      options: [
        "Phenytoin causes gingival enlargement regardless of oral hygiene, and oral care has no impact on severity",
        "Effective oral biofilm control reduces extent of drug-influenced gingival enlargement, so daily self-care must be effective before using medication",
        "Phenytoin prevents gingival enlargement, so patients taking this medication have healthier gingiva than those not taking it",
        "Gingival enlargement from phenytoin only occurs in patients without Down syndrome and never in those with it"
      ],
      correct: "B"
    },
    {
      id: 26401,
      question: "What is the incidence of congenitally missing permanent teeth in persons with Down syndrome compared to the general population?",
      options: [
        "Congenitally missing teeth occur less frequently in Down syndrome (1-5%) compared to general population",
        "Congenitally missing teeth occur at the same rate in Down syndrome as in the general population",
        "Congenitally missing teeth occur at a significantly higher rate in Down syndrome (25-50%) compared to general population",
        "All individuals with Down syndrome have congenitally missing teeth, representing 100% of this population"
      ],
      correct: "C"
    },
    {
      id: 26402,
      question: "Which maxillary teeth are MOST frequently reduced in size in patients with Down syndrome?",
      options: [
        "Central incisors and canines, which are reduced in approximately 25% of individuals",
        "First molars and lateral incisors, which are never affected by size reduction in any patients",
        "Second molars (52%), lateral incisors (42%), canines (41%), first molars (40%), and central incisors (35%)",
        "All maxillary teeth are equally affected by microdontia in 100% of patients with Down syndrome"
      ],
      correct: "C"
    },
    {
      id: 26403,
      question: "At what age does periodontal disease typically begin in individuals with Down syndrome?",
      options: [
        "Periodontal disease begins as early as age 6 years in these individuals, with nearly all adults affected",
        "Periodontal disease begins at age 18 years, which is the same as the general population",
        "Periodontal disease begins at age 40 years, affecting only elderly individuals with Down syndrome",
        "Periodontal disease never occurs in individuals with Down syndrome due to genetic protection"
      ],
      correct: "A"
    },
    {
      id: 26404,
      question: "What is the PRIMARY cause of high incidence of periodontal disease in individuals with Down syndrome?",
      options: [
        "Poor oral hygiene alone, as immunologic factors play no role in periodontal disease development",
        "Immunodeficiency and impaired host defense rather than poor oral hygiene alone, though hygiene contributes",
        "Excessive fluoride exposure during childhood causing enamel defects that promote bacterial accumulation",
        "Genetic factors that cause gingival tissue to spontaneously break down regardless of bacteria or hygiene"
      ],
      correct: "B"
    },
    {
      id: 26405,
      question: "What percentage of persons with Down syndrome have obstructive sleep apnea?",
      options: [
        "Approximately 5% of persons with Down syndrome have obstructive sleep apnea",
        "Approximately 15% of persons with Down syndrome have obstructive sleep apnea",
        "Approximately 45% of persons with Down syndrome have obstructive sleep apnea",
        "Approximately 85% of persons with Down syndrome have obstructive sleep apnea"
      ],
      correct: "C"
    },
    {
      id: 26406,
      question: "How does obstructive sleep apnea affect patients with Down syndrome who also have heart disease?",
      options: [
        "Sleep apnea has no effect on cardiac conditions, as these are completely separate and unrelated problems",
        "Low blood oxygenation from apnea causes increased lung blood pressure, enlarging right heart and causing cardiac complications",
        "Sleep apnea improves cardiac conditions by allowing the heart to rest during periods of apnea",
        "Sleep apnea only affects the brain and has no impact on any other organs including the heart"
      ],
      correct: "B"
    },
    {
      id: 26407,
      question: "What is the relationship between Alzheimer disease and Down syndrome in adults?",
      options: [
        "Alzheimer disease never occurs in individuals with Down syndrome due to genetic protection factors",
        "Neuropathologic changes of Alzheimer disease appear almost universal in adults with Down syndrome over age 40, though not all show behavioral signs",
        "Alzheimer disease only occurs in individuals with Down syndrome who have severe intellectual disability",
        "All individuals with Down syndrome develop clinical Alzheimer disease by age 30 with complete memory loss"
      ],
      correct: "B"
    },
    {
      id: 26408,
      question: "What is the typical behavioral characteristic of persons with Down syndrome?",
      options: [
        "Generally aggressive and violent, requiring restraint and sedation for all dental procedures",
        "Generally content and affectionate, but can become aggressive if confused or disoriented",
        "Always completely uncooperative, making dental treatment impossible under any circumstances",
        "Always hyperactive with inability to sit still, requiring constant physical restraint throughout appointments"
      ],
      correct: "B"
    },
    {
      id: 26409,
      question: "What should guide the dental hygienist's treatment planning approach for this patient?",
      options: [
        "Provide minimal treatment only, as patients with Down syndrome cannot tolerate or benefit from extensive care",
        "Assess patient's tolerance for extensive treatment and provide same treatment options as patients without Down syndrome, adapting as needed",
        "Refer patient to hospital for general anesthesia, as this is the only setting where patients with Down syndrome can receive care",
        "Provide only emergency care to relieve pain, as comprehensive treatment is contraindicated for all patients with Down syndrome"
      ],
      correct: "B"
    },
    {
      id: 26410,
      question: "According to the DSM-5, what criteria must be present for a diagnosis of autism spectrum disorder?",
      options: [
        "Only communication difficulties, as social interaction and behavior patterns are not relevant to diagnosis",
        "Developmental deficits in communication/interaction with others, restricted interests/repetitive behaviors, and symptoms affecting function in school/work/life",
        "Only repetitive behaviors and restricted interests, as communication skills are always normal in autism",
        "Symptoms must begin after age 10 years and only affect academic performance in school settings"
      ],
      correct: "B"
    },
    {
      id: 26411,
      question: "What is the current prevalence of autism spectrum disorders according to the CDC?",
      options: [
        "1 in every 1000 eight-year-old children in the United States",
        "1 in every 500 eight-year-old children in the United States",
        "1 in every 150 eight-year-old children in the United States",
        "1 in every 44 eight-year-old children in the United States"
      ],
      correct: "D"
    },
    {
      id: 26412,
      question: "What is the gender distribution of autism spectrum disorders?",
      options: [
        "Females have approximately four times higher incidence of ASD than males",
        "Males have approximately four times higher incidence of ASD than females",
        "Males and females have exactly equal incidence of ASD with no gender differences",
        "ASD only occurs in males and never occurs in females under any circumstances"
      ],
      correct: "B"
    },
    {
      id: 26413,
      question: "Which form of autism spectrum disorder does this child MOST likely have?",
      options: [
        "Autistic disorder (classic autism), the most severe form with difficulty talking and relating to others",
        "Asperger syndrome, a mild form with impaired social interactions without significant language or cognitive problems",
        "Rett syndrome, a rare form found almost exclusively in females with poor head growth",
        "Childhood disintegrative disorder, developing after 2 years of normal development with dramatic loss of skills"
      ],
      correct: "B"
    },
    {
      id: 26414,
      question: "Which form of autism spectrum disorder does this patient MOST likely have?",
      options: [
        "Asperger syndrome, characterized by social awkwardness without significant developmental regression",
        "Autistic disorder, characterized by lifelong communication difficulties without any period of normal development",
        "Rett syndrome, a rare form found almost exclusively in females with regression after normal development",
        "Pervasive developmental disorder not otherwise specified, with mild symptoms that don't meet other criteria"
      ],
      correct: "C"
    },
    {
      id: 26415,
      question: "What is risperidone, and what is its purpose in treating autism spectrum disorder?",
      options: [
        "Risperidone is a stimulant medication like methylphenidate used to increase attention and focus",
        "Risperidone is an anticonvulsant medication like phenytoin used to prevent seizures in all patients",
        "Risperidone is an antipsychotic medication used to improve behavior, though it cannot treat all ASD symptoms",
        "Risperidone is an antidepressant medication used to cure autism spectrum disorder completely"
      ],
      correct: "C"
    },
    {
      id: 26416,
      question: "At what age can ASD symptoms typically be realized, and when can a reliable diagnosis be made?",
      options: [
        "Symptoms realized by 6 months of age; reliable diagnosis can be made at birth through genetic testing",
        "Symptoms realized by 18 months of age; reliable diagnosis can be made by age 2 by medical professional",
        "Symptoms realized by 5 years of age; reliable diagnosis cannot be made until child enters school",
        "Symptoms realized by 10 years of age; reliable diagnosis requires waiting until adolescence for confirmation"
      ],
      correct: "B"
    },
    {
      id: 26417,
      question: "What is the first characteristic sign of autism spectrum disorder?",
      options: [
        "Excessive crying and screaming beginning immediately at birth in the hospital nursery",
        "Few or no big smiles or other warm, joyful, engaging expressions by 6 months of age",
        "Delayed motor milestones such as rolling over, sitting up, and crawling by 12 months",
        "Aggressive behaviors toward parents and caregivers beginning at 3 months of age"
      ],
      correct: "B"
    },
    {
      id: 26418,
      question: "What term describes this communication pattern observed in children with autism?",
      options: [
        "Expressive aphasia, representing inability to formulate original thoughts or sentences in response to questions",
        "Echolalia, meaninglessly imitating what they hear as memory exercise without use for communication",
        "Receptive aphasia, representing inability to understand spoken language or comprehend verbal instructions",
        "Selective mutism, representing conscious choice not to speak in certain situations due to anxiety"
      ],
      correct: "B"
    },
    {
      id: 26419,
      question: "A 6-year-old patient with autism spectrum disorder has language skills but uses pronouns incorrectly. When the child wants milk, they say \"Do you want your milk?\" instead of \"I want milk.\" What characteristic of autism does this language pattern represent?",
      options: [
        "Children with autism slowly learn to use first person for self and second person for others around age 6",
        "This represents normal language development that occurs in all children regardless of autism diagnosis",
        "This indicates severe cognitive impairment requiring immediate referral to speech pathology for evaluation",
        "This language pattern never changes, and individuals with autism always use pronouns incorrectly throughout life"
      ],
      correct: "A"
    },
    {
      id: 26420,
      question: "What characteristic of autism does this behavior represent?",
      options: [
        "Oppositional defiant disorder requiring immediate psychiatric intervention and behavior medication",
        "Normal childhood behavior that occurs in all children when they are placed in unfamiliar situations",
        "Extreme need for sameness; minor changes in routine or environment cause despair and confusion",
        "Sign of physical pain indicating the chair position is causing musculoskeletal discomfort and injury"
      ],
      correct: "C"
    },
    {
      id: 26421,
      question: "What characteristic of autism does this behavior represent?",
      options: [
        "Children with autism are more interested in objects than people because objects rarely change appearance",
        "Children with autism prefer people over objects because people provide more stimulation and interaction",
        "This behavior indicates visual impairment requiring immediate referral to ophthalmology for evaluation",
        "This is normal behavior for all children and is not specific to autism spectrum disorder diagnosis"
      ],
      correct: "A"
    },
    {
      id: 26422,
      question: "What changes typically occur in children with autism around age 5-6 years?",
      options: [
        "All symptoms of autism completely resolve and the child becomes neurotypical with normal social skills",
        "Language becomes more communicative after experiencing patterns; food is accepted, noises tolerated, and panic tantrums subside",
        "Symptoms become more severe with complete loss of all communication and social skills previously acquired",
        "No changes occur at any age, as autism symptoms remain completely static throughout the entire lifespan"
      ],
      correct: "B"
    },
    {
      id: 26423,
      question: "What does this patient's response to the dental environment represent?",
      options: [
        "Normal response to dental treatment that occurs in all patients regardless of autism diagnosis",
        "Sensory overload common in children with ASD, which can lead to aggression, emotional outbursts, and self-injurious behaviors",
        "Oppositional defiant disorder requiring immediate psychiatric referral and behavior modification medications",
        "Pain response indicating the dental hygienist is causing physical injury and should stop all treatment immediately"
      ],
      correct: "B"
    },
    {
      id: 26424,
      question: "What is the MOST effective way to condition a child with ASD before the first dental visit?",
      options: [
        "Schedule the appointment without any preparation, as advanced notice will increase anxiety and fear",
        "Have caregiver bring child to office to familiarize with environment; use instructional video clips showing what will happen during visit",
        "Prescribe sedation medication for first visit, as behavioral conditioning is never effective for children with autism",
        "Restrain the child immediately upon arrival using papoose board to prevent any behavioral problems during treatment"
      ],
      correct: "B"
    },
    {
      id: 26425,
      question: "Which communication tool is MOST beneficial for children with more severe forms of ASD?",
      options: [
        "Verbal explanations only, as visual aids are not helpful for children with autism spectrum disorders",
        "Picture Exchange Communication System (PECS) with picture cards and social stories to express feelings and understand procedures",
        "Complex written instructions at college reading level to ensure comprehensive understanding of all procedures",
        "No communication tools, as children with severe autism cannot understand or participate in any form of communication"
      ],
      correct: "B"
    }
  ],
  "8. Orofacial Cleft Conditions (Case Study)": [
    {
      id: 26426,
      question: "What is the ranking of orofacial clefts among congenital disabilities in the United States?",
      options: [
        "Orofacial clefts are the first most prevalent congenital disability, affecting approximately 10,000 infants annually",
        "Orofacial clefts are the second most prevalent congenital disability, affecting approximately 8,000 infants annually",
        "Orofacial clefts are the third most prevalent congenital disability, affecting approximately 6,000 infants annually",
        "Orofacial clefts are the fifth most prevalent congenital disability, affecting approximately 4,000 infants annually"
      ],
      correct: "C"
    },
    {
      id: 26427,
      question: "What is the overall prevalence of orofacial clefts in infants?",
      options: [
        "One in 500 infants is affected by an orofacial cleft in the United States",
        "One in 1000 infants is affected by an orofacial cleft in the United States",
        "One in 2000 infants is affected by an orofacial cleft in the United States",
        "One in 5000 infants is affected by an orofacial cleft in the United States"
      ],
      correct: "B"
    },
    {
      id: 26428,
      question: "Which type of orofacial cleft is LEAST common?",
      options: [
        "Cleft lip only (1 in 2807 infants), which is less common than clefts involving palate",
        "Cleft palate only (1 in 1687 infants), which is less common than combined presentations",
        "Cleft lip with palate (1 in 1563 infants), which is less common than isolated clefts",
        "All types occur with equal frequency, with no significant difference in prevalence rates"
      ],
      correct: "A"
    },
    {
      id: 26429,
      question: "Which racial or ethnic group has the HIGHEST prevalence of orofacial clefts?",
      options: [
        "African Americans or Blacks have the highest prevalence among all racial and ethnic groups",
        "Non-Hispanic Whites have the highest prevalence, followed by Hispanics and Asian populations",
        "Non-Hispanic American Indians or Alaska Natives have the highest prevalence of orofacial clefts",
        "Non-Hispanic Asians or Pacific Islanders have the highest prevalence in the United States"
      ],
      correct: "C"
    },
    {
      id: 26430,
      question: "What is the gender distribution for orofacial clefts involving both lip and palate?",
      options: [
        "Females are more likely to exhibit clefts involving both lip and palate than males",
        "Males are more likely to exhibit clefts involving both lip and palate than females",
        "Males and females have exactly equal prevalence of clefts involving both structures",
        "Gender has no relationship to the type or location of orofacial clefts that develop"
      ],
      correct: "B"
    },
    {
      id: 26431,
      question: "What term describes orofacial clefts that occur without other related health problems?",
      options: [
        "Syndromic clefts, which indicate the patient has no other congenital disorders or syndromes",
        "Nonsyndromic (isolated) clefts, which indicate the patient has no other related health problems",
        "Pierre Robin sequence, which indicates three distinct characteristics including cleft palate only",
        "Chromosomal clefts, which indicate genetic abnormalities without any physical health problems"
      ],
      correct: "B"
    },
    {
      id: 26432,
      question: "What is this specific presentation of three distinct characteristics called?",
      options: [
        "Down syndrome, which is the most common syndrome associated with orofacial clefts",
        "Treacher Collins syndrome, which always presents with these three characteristic findings",
        "Pierre Robin sequence, which includes cleft palate, small mandible, and airway obstruction from tongue displacement",
        "Crouzon syndrome, which is characterized by premature fusion of cranial sutures with clefting"
      ],
      correct: "C"
    },
    {
      id: 26433,
      question: "Which statement BEST describes teratogens in relation to orofacial clefts?",
      options: [
        "Teratogens are protective agents that reduce the risk of congenital abnormalities in the fetus",
        "Teratogens are genetic mutations passed from parents to offspring through chromosomal inheritance",
        "Teratogens are agents or substances that can cause congenital abnormalities in a developing embryo or fetus",
        "Teratogens are prenatal vitamins that prevent neural tube defects when taken during pregnancy"
      ],
      correct: "C"
    },
    {
      id: 26434,
      question: "Which environmental factors are known teratogens that increase orofacial cleft risk?",
      options: [
        "Only genetic factors increase risk; environmental factors have no impact on orofacial cleft development",
        "Maternal smoking, alcohol consumption, nutritional deficiencies, diabetes, obesity, and certain medications during pregnancy",
        "Exclusively nutritional excesses such as high protein intake and excessive vitamin supplementation",
        "Only medications taken after birth; prenatal exposures do not affect orofacial cleft development"
      ],
      correct: "B"
    },
    {
      id: 26435,
      question: "Which maternal factors are identified as PROTECTIVE and reduce orofacial cleft risk?",
      options: [
        "Using WIC program services and being a Medicaid recipient, which indicate lower socioeconomic status",
        "Maternal education level of bachelor's degree or higher and early prenatal care",
        "Maternal smoking cessation after first trimester and alcohol consumption in moderation only",
        "Taking anticonvulsant medications as prescribed and maintaining gestational diabetes with insulin"
      ],
      correct: "B"
    },
    {
      id: 26436,
      question: "During which weeks of fetal development does cleft lip (cheiloschisis) formation occur?",
      options: [
        "Cleft lip begins during the fifth week and is complete by the tenth week of pregnancy",
        "Cleft lip begins during the tenth week and is complete by the fifteenth week of pregnancy",
        "Cleft lip begins during the first week and is complete by the fifth week of pregnancy",
        "Cleft lip begins during the fifteenth week and is complete by the twentieth week of pregnancy"
      ],
      correct: "A"
    },
    {
      id: 26437,
      question: "What structure is formed by the fusion of the medial nasal and maxillary processes?",
      options: [
        "The uvula at the posterior aspect of the soft palate in the oropharyngeal region",
        "The hard palate extending from incisive foramen to junction with soft palate posteriorly",
        "The philtrum, which is the vertical groove in the midline of the upper lip",
        "The nasal septum, which divides the nasal cavity into right and left chambers"
      ],
      correct: "C"
    },
    {
      id: 26438,
      question: "When does the palate begin to form, and when is it complete during fetal development?",
      options: [
        "Palate begins at end of third week and is complete by the eighth week of pregnancy",
        "Palate begins at end of fifth week and is complete by the twelfth week of pregnancy",
        "Palate begins at end of tenth week and is complete by the fifteenth week of pregnancy",
        "Palate begins at end of first week and is complete by the fifth week of pregnancy"
      ],
      correct: "B"
    },
    {
      id: 26439,
      question: "Which factors might prevent fusion of the lateral palatine processes?",
      options: [
        "Only genetic factors; anatomic factors cannot affect palatal shelf movement or fusion",
        "Late horizontal movement of shelves, rupture after fusion, or micrognathia and macroglossia blocking movement",
        "Exclusively nutritional factors during second trimester; anatomic factors play no role",
        "Only maternal smoking; other environmental and anatomic factors do not affect fusion"
      ],
      correct: "B"
    },
    {
      id: 26440,
      question: "What type of cleft does this infant have?",
      options: [
        "Complete cleft lip, which always extends into nostrils and involves alveolar bone",
        "Incomplete cleft lip, which is a notch involving philtrum without invading hard structures or nostrils",
        "Bifid uvula, which represents the mildest form of clefting involving only soft tissue",
        "Submucosal cleft, which lacks muscle or bone fusion yet soft tissue is present"
      ],
      correct: "B"
    },
    {
      id: 26441,
      question: "What type of cleft does this infant have?",
      options: [
        "Incomplete bilateral cleft lip without involvement of any hard structures or bone",
        "Complete bilateral cleft lip involving alveolar bone and primary palate, extending into nostrils",
        "Cleft palate only involving secondary palate without any involvement of lip structures",
        "Bifid uvula representing the least severe form of orofacial clefting possible"
      ],
      correct: "B"
    },
    {
      id: 26442,
      question: "What type of cleft does this patient have?",
      options: [
        "Incomplete cleft palate involving only the uvula without any hard or soft palate involvement",
        "Complete cleft palate involving both anterior and posterior palates, hard and soft palate structures",
        "Bifid uvula representing a cleft of the uvula only without any other palatal involvement",
        "Submucosal cleft lacking muscle or bone fusion with intact soft tissue covering the defect"
      ],
      correct: "B"
    },
    {
      id: 26443,
      question: "What type of cleft does this patient have?",
      options: [
        "Complete cleft palate involving anterior and posterior palates with significant functional impairment",
        "Submucosal cleft with lack of muscle or bone fusion but soft tissue coverage",
        "Bifid uvula, an incomplete cleft palate where cleft of uvula is observed",
        "Complete bilateral cleft palate with involvement of primary and secondary palates"
      ],
      correct: "C"
    },
    {
      id: 26444,
      question: "What type of cleft does this patient have?",
      options: [
        "Bifid uvula with visible cleft of the uvula only without palatal involvement",
        "Complete cleft palate with full-thickness defect through hard and soft palate",
        "Submucosal cleft lacking muscle or bone fusion, yet soft tissue is present",
        "Incomplete unilateral cleft lip with notch involving philtrum without hard structure invasion"
      ],
      correct: "C"
    },
    {
      id: 26445,
      question: "At what age does cleft lip repair (cheiloplasty) typically occur?",
      options: [
        "Cleft lip repair occurs within first 12 months, often between 3 and 6 months of age",
        "Cleft lip repair must wait until age 2 years when facial growth is more stable",
        "Cleft lip repair occurs immediately after birth within the first week of life",
        "Cleft lip repair is delayed until age 5 years when child can cooperate with recovery"
      ],
      correct: "A"
    },
    {
      id: 26446,
      question: "At what age does cleft palate closure (palatoplasty) typically occur?",
      options: [
        "Palatoplasty occurs within first month of life, immediately after birth for optimal results",
        "Palatoplasty transpires between 9 and 18 months of age for appropriate timing",
        "Palatoplasty is delayed until age 5 years when palatal growth is complete",
        "Palatoplasty occurs between 3 and 6 months, same timing as cleft lip repair"
      ],
      correct: "B"
    },
    {
      id: 26447,
      question: "What does the \"rule of 10\" for elective cleft surgery include?",
      options: [
        "10 days of age, 10 ounces in weight, and blood pressure value greater than 10 mmHg",
        "10 months of age, 10 kilograms in weight, and hemoglobin value greater than 10 g/dL",
        "10 weeks of age, 10 pounds in weight, and hemoglobin value greater than 10 g/dL",
        "10 years of age, 10 pounds above ideal weight, and platelet count greater than 10,000"
      ],
      correct: "C"
    },
    {
      id: 26448,
      question: "What type of secondary surgery may be indicated after primary orofacial cleft surgery?",
      options: [
        "Cardiac surgery to correct congenital heart defects that always accompany orofacial clefts",
        "Orthognathic surgery to correct jaw and face relationships, sometimes with orthodontic treatment",
        "Neurological surgery to address developmental delays that always result from cleft repairs",
        "Pulmonary surgery to correct respiratory problems that universally occur after cleft surgery"
      ],
      correct: "B"
    },
    {
      id: 26449,
      question: "Which specialists are part of the interprofessional team managing orofacial clefts?",
      options: [
        "Only plastic surgeon and pediatrician, as other specialists are not needed for cleft management",
        "Plastic surgeon, pediatrician, pediatric dentist, orthodontist, speech pathologist, psychologist, otolaryngologist, social worker, oral surgeon, geneticist, audiologist, prosthodontist, sociologist",
        "Only dental specialists including pediatric dentist, orthodontist, and prosthodontist for oral care",
        "Exclusively medical specialists; dental professionals are not involved in interprofessional cleft teams"
      ],
      correct: "B"
    },
    {
      id: 26450,
      question: "What is the PRIMARY reason infants with cleft palate have feeding difficulties?",
      options: [
        "Infants have abnormal sucking and swallowing reflexes that prevent any oral feeding attempts",
        "Infants have difficulty producing negative pressure needed to suck milk due to underdeveloped or improperly oriented musculature",
        "Infants refuse to eat due to pain from the cleft defect in the palate",
        "Infants have esophageal abnormalities that prevent swallowing of any liquids or solids"
      ],
      correct: "B"
    },
    {
      id: 26451,
      question: "What feeding intervention would be MOST helpful for an infant with cleft palate?",
      options: [
        "Continue using rigid bottle with standard nipple, as this is the only safe feeding method",
        "Use squeezable bottle or syringe with soft, elongated, cross-cut nipple rather than rigid bottle",
        "Discontinue all oral feeding and use feeding tube exclusively until after surgical repair",
        "Use spoon feeding only, as bottles are contraindicated for all infants with cleft palate"
      ],
      correct: "B"
    },
    {
      id: 26452,
      question: "What is the MOST common problem in children with orofacial clefts?",
      options: [
        "Dental caries affecting all primary teeth due to enamel defects from the cleft condition",
        "Middle ear infection from lack of eustachian tube ventilation because palatal muscles control tube opening",
        "Severe allergies causing chronic sinus infections unrelated to the palatal cleft defect",
        "Gastroesophageal reflux disease causing damage to teeth and oral tissues from acid"
      ],
      correct: "B"
    },
    {
      id: 26453,
      question: "What can result from chronic ear infections if not addressed in children with clefts?",
      options: [
        "Hearing impairments from permanent damage to auditory sensory nerves if problem not addressed",
        "Vision problems from optic nerve damage that occurs secondary to chronic ear infections",
        "Intellectual disabilities that develop when chronic infections spread to brain tissue",
        "Complete deafness within months that is always irreversible regardless of treatment"
      ],
      correct: "A"
    },
    {
      id: 26454,
      question: "What causes hypernasal speech in patients with cleft palate?",
      options: [
        "Enlarged adenoids and tonsils that completely block the nasal airway during speech",
        "Velopharyngeal dysfunction (VPD) that allows air to escape into nasal cavity during speech",
        "Tongue thrust habit that forces air through the nose rather than the oral cavity",
        "Chronic sinusitis that creates resonance changes unrelated to palatal function or closure"
      ],
      correct: "B"
    },
    {
      id: 26455,
      question: "What treatment approaches are used for velopharyngeal dysfunction?",
      options: [
        "Only speech therapy, as surgical and prosthetic options are contraindicated for all patients",
        "Surgery, special speech device/obturator that closes palate, speech therapy, or combination of approaches",
        "Exclusively medications to strengthen palatal muscles; no other treatments are effective",
        "Only observation, as VPD always resolves spontaneously without any intervention required"
      ],
      correct: "B"
    },
    {
      id: 26456,
      question: "What is the MOST common type of malocclusion in individuals with cleft palates?",
      options: [
        "Class I malocclusion with normal molar relationship and proper overbite and overjet",
        "Class II malocclusion with mandibular retrusion and excessive overjet of maxillary teeth",
        "Class III malocclusion, which is most common in individuals with cleft palates",
        "Open bite malocclusion without any sagittal jaw relationship discrepancy present"
      ],
      correct: "C"
    },
    {
      id: 26457,
      question: "What causes Class III malocclusion in individuals with cleft palates?",
      options: [
        "Excessive maxillary growth from overactive bone formation after surgical cleft repair",
        "Missing teeth or stunted maxillary growth; maxillary growth constricted due to scar tissue from primary surgeries",
        "Mandibular deficiency from underdevelopment of mandible unrelated to cleft or surgery",
        "Excessive mandibular growth from genetic factors unrelated to the cleft or surgical repairs"
      ],
      correct: "B"
    },
    {
      id: 26458,
      question: "Which teeth are MOST commonly congenitally missing in patients with clefts?",
      options: [
        "Central incisors and first molars, which are always absent in all patients with clefts",
        "Lateral incisor and canine, which may be absent or severely displaced due to cleft location",
        "Second molars and third molars, which fail to develop in patients with any type of cleft",
        "All teeth are present in patients with clefts; congenitally missing teeth never occur"
      ],
      correct: "B"
    },
    {
      id: 26459,
      question: "What dental problems may be present in patients with orofacial clefts?",
      options: [
        "All teeth are perfectly formed; enamel defects never occur in patients with orofacial clefts",
        "Teeth may be morphologically deformed, hypoplastic, or hypomineralized in cleft patients",
        "Only supernumerary teeth occur; enamel defects and hypoplasia never develop in these patients",
        "Teeth are always oversized and hypermineralized due to excessive enamel formation"
      ],
      correct: "B"
    },
    {
      id: 26460,
      question: "Why do children with orofacial clefts have significantly higher caries prevalence?",
      options: [
        "Enamel defects only; other factors like oral clearance and biofilm have no impact on caries",
        "Longer oral clearance time, more fermentable sugars, longer bottle-feeding, decreased salivary flow, mouth breathing, tenacious nasal fluid",
        "Only genetic factors; oral hygiene and feeding practices have no effect on caries development",
        "Exclusively poor oral hygiene by caregivers; no other factors contribute to increased caries risk"
      ],
      correct: "B"
    },
    {
      id: 26461,
      question: "Which teeth show the highest caries prevalence in primary dentition of patients with clefts?",
      options: [
        "Mandibular anterior teeth and mandibular molars, which are always most severely affected",
        "Maxillary incisors, teeth adjacent to cleft, and molars show highest caries prevalence",
        "Only third molars are affected; other teeth never develop caries in patients with clefts",
        "All teeth are equally affected with no pattern of increased caries in any specific location"
      ],
      correct: "B"
    },
    {
      id: 26462,
      question: "Why does wearing orthodontic appliances and obturators increase caries risk?",
      options: [
        "Appliances have no effect on caries risk; only dietary factors influence decay development",
        "More surface irregularities with orthodontics and obturators retain food and biofilm; appliances and soft foods increase substrate retention",
        "Appliances stimulate saliva production and decrease caries risk compared to patients without appliances",
        "Orthodontics and obturators prevent biofilm formation and significantly reduce caries risk"
      ],
      correct: "B"
    },
    {
      id: 26463,
      question: "What complications can occur from wearing prostheses in patients with clefts?",
      options: [
        "Prostheses have no effect on periodontal tissues; inflammation never occurs with appliance wear",
        "Chronic tissue irritation from ill-fitting prostheses increases gingival inflammation and hyperplastic response; mechanical rubbing causes recessed gingiva",
        "Prostheses always improve periodontal health by protecting tissues from bacterial accumulation",
        "Only dental caries increases; periodontal disease never develops in patients wearing prostheses"
      ],
      correct: "B"
    },
    {
      id: 26464,
      question: "What preventive measures should be included for patients with orofacial clefts?",
      options: [
        "Only dietary counseling; fluoride and sealants are contraindicated for patients with clefts",
        "Patient and parental dietary counseling, frequent hygiene recall, fluoride therapy, and dental sealants",
        "No preventive care is necessary; treatment of decay after it develops is the only approach",
        "Exclusively systemic fluoride supplements; topical fluoride and sealants provide no benefit"
      ],
      correct: "B"
    },
    {
      id: 26465,
      question: "What recall interval would be MOST beneficial for children with orofacial clefts?",
      options: [
        "Annual recall only, as more frequent appointments are unnecessary and provide no additional benefit",
        "Every 3 or 4 months for additional assessments, reinforcement, biofilm reduction, and fluoride varnish",
        "Every 2 years, as infrequent visits are adequate for children with clefts and high caries risk",
        "No recall appointments are needed; only emergency appointments when pain develops are appropriate"
      ],
      correct: "B"
    },
    {
      id: 26466,
      question: "Which toothbrushing technique is MOST appropriate for children with orofacial clefts?",
      options: [
        "Bass technique only, as this is the only method proven effective for children with clefts",
        "Fones technique and sulcular technique; power toothbrush with small head helpful due to limited lip elasticity and cleft anatomy",
        "No toothbrushing until after all surgical repairs are complete to avoid damaging tissues",
        "Stillman technique exclusively, as circular motions are contraindicated in patients with clefts"
      ],
      correct: "B"
    },
    {
      id: 26467,
      question: "What instructions should be given regarding obturator care?",
      options: [
        "Obturators should never be removed or cleaned; cleaning can damage the appliance permanently",
        "Daily care for obturators is similar to care of partial and complete dentures with regular cleaning",
        "Obturators require professional cleaning only; home care is contraindicated for these appliances",
        "Soak obturators in bleach overnight daily, as this is the only effective cleaning method"
      ],
      correct: "B"
    },
    {
      id: 26468,
      question: "What communication challenges might the hygienist encounter with patients with clefts?",
      options: [
        "No communication challenges exist; all patients with clefts have normal speech and hearing",
        "Difficulty understanding hypernasal speech and verbally explaining procedures; hearing problems affect communication",
        "Only vision problems affect communication; speech and hearing are always normal in cleft patients",
        "Communication is easier with cleft patients than other patients due to enhanced listening skills"
      ],
      correct: "B"
    },
    {
      id: 26469,
      question: "What emotional responses might parents exhibit when learning of a cleft diagnosis?",
      options: [
        "Only happiness and relief, as cleft diagnosis is always considered positive news by parents",
        "Disbelief, confusion, fear, shock, grief, guilt, sadness, and anxiety about child's diagnosis",
        "No emotional response at all, as parents are never affected emotionally by cleft diagnosis",
        "Exclusively anger at healthcare providers; no other emotional responses typically occur"
      ],
      correct: "B"
    },
    {
      id: 26470,
      question: "What education should the dental hygienist provide to parents of children with clefts?",
      options: [
        "No education needed; parents should discover information on their own without professional guidance",
        "Education regarding potential dental complications, feeding difficulties, timing and frequency of hygiene care, and building relationship with multidisciplinary team",
        "Only information about surgical procedures; dental complications and preventive care are irrelevant",
        "Exclusively information about genetic testing; no other topics need to be discussed with parents"
      ],
      correct: "B"
    },
    {
      id: 26471,
      question: "What additional roles can dental hygienists fulfill in interprofessional collaborations?",
      options: [
        "Only direct clinical care; dental hygienists cannot participate in any other team activities",
        "Provide oral screenings, risk assessment, oral health education to support groups, and continuing education for other healthcare providers",
        "Exclusively surgical assistance; no other roles are appropriate for dental hygienists on teams",
        "Only documentation; dental hygienists should not provide education or screenings for cleft patients"
      ],
      correct: "B"
    },
    {
      id: 26472,
      question: "What should the dental hygienist do regarding suspected abuse in a child with cleft?",
      options: [
        "Ignore findings, as reporting is optional and not required by law for dental professionals",
        "Note findings in patient's chart and report suspected abuse to Child Protective Services as required by law",
        "Confront parents immediately and accuse them of abuse without documenting or reporting",
        "Discuss with patient only and do not document or report findings to any authorities"
      ],
      correct: "B"
    },
    {
      id: 26473,
      question: "How does palatal development progress during fetal development?",
      options: [
        "Palatal development progresses from posterior to anterior or from uvula to primary palate",
        "Palatal development progresses from lateral to medial or from sides toward the midline",
        "Palatal development progresses from anterior to posterior or from primary palate to uvula",
        "Palatal development occurs simultaneously in all areas without any specific directional pattern"
      ],
      correct: "C"
    },
    {
      id: 26474,
      question: "How can micrognathia affect palatal development?",
      options: [
        "Micrognathia enlarges the oral cavity space and facilitates easier palatal shelf fusion",
        "Micrognathia (small mandible) can block or affect movement of palatal shelves during fusion",
        "Micrognathia has no effect on palate; it only affects mandibular development and function",
        "Micrognathia prevents tongue development but does not affect palatal shelf movement"
      ],
      correct: "B"
    },
    {
      id: 26475,
      question: "Which statement about folic acid and orofacial clefts is correct?",
      options: [
        "Folic acid has been proven to completely prevent all orofacial clefts when taken during pregnancy",
        "Folic acid definitely causes orofacial clefts and should be avoided by all pregnant women",
        "Although preventative extent of folic acid in reducing clefts remains inconclusive, multivitamin high in folic acid is recommended to reduce neural tube defects",
        "Folic acid supplementation is harmful during pregnancy and increases risk of all birth defects"
      ],
      correct: "C"
    }
  ],
  "9. Neurologic Disabilities (Case Study)": [
    {
      id: 26476,
      question: "When should this patient's appointment be scheduled for optimal treatment?",
      options: [
        "Early morning before breakfast when the patient is most rested from sleep",
        "60 to 90 minutes after a meal when medications are most effective",
        "Late afternoon when medications have reached peak blood levels throughout the day",
        "Immediately before lunch so the patient can eat right after the appointment"
      ],
      correct: "B"
    },
    {
      id: 26477,
      question: "Which oral condition is this patient MOST likely experiencing as a side effect of Parkinson disease medications?",
      options: [
        "Xerostomia resulting from anticholinergic effects of the medications taken for disease management",
        "Burning mouth syndrome caused by vitamin B12 deficiency unrelated to medications",
        "Oral candidiasis from immunosuppression due to the neurodegenerative disease process itself",
        "Traumatic ulcerations from involuntary biting during tremor episodes while eating meals"
      ],
      correct: "A"
    },
    {
      id: 26478,
      question: "Which reflex should the dental hygienist help control by maintaining the patient's head in a supported and flexed position?",
      options: [
        "Asymmetric tonic neck reflex that occurs when the head turns away from midline",
        "Tonic labyrinthine reflex triggered by tilting the head backward without neck support",
        "Startle reflex activated by surprising stimuli such as sudden lights or movements",
        "Gag reflex stimulated by instruments touching the posterior portion of the tongue"
      ],
      correct: "B"
    },
    {
      id: 26479,
      question: "What is the estimated occurrence of GERD in patients with cerebral palsy, especially with severe motor disabilities?",
      options: [
        "GERD occurs in approximately 25% of cerebral palsy patients with motor involvement",
        "GERD occurs in approximately 50% of cerebral palsy patients with motor involvement",
        "GERD occurs in approximately 75% of cerebral palsy patients with motor involvement",
        "GERD occurs in approximately 90% of cerebral palsy patients with motor involvement"
      ],
      correct: "C"
    },
    {
      id: 26480,
      question: "What percentage of multiple sclerosis cases are initially diagnosed as relapsing-remitting MS?",
      options: [
        "Over 50% of patients are initially diagnosed with relapsing-remitting MS as first presentation",
        "Over 65% of patients are initially diagnosed with relapsing-remitting MS as first presentation",
        "Over 75% of patients are initially diagnosed with relapsing-remitting MS as first presentation",
        "Over 85% of patients are initially diagnosed with relapsing-remitting MS as first presentation"
      ],
      correct: "D"
    },
    {
      id: 26481,
      question: "Which oral hygiene recommendation would be MOST beneficial for this patient?",
      options: [
        "Manual toothbrush with detailed verbal instructions given slowly during the appointment",
        "Power toothbrush with visual aids and written instructions for patient and caregiver",
        "Interdental brushes only as the primary cleaning method to simplify the routine",
        "Chlorhexidine rinse as a substitute for mechanical plaque removal by brushing"
      ],
      correct: "B"
    },
    {
      id: 26482,
      question: "What is the leading cause of death for patients with amyotrophic lateral sclerosis?",
      options: [
        "Cardiac complications from progressive heart muscle weakness and cardiomyopathy over time",
        "Renal failure from chronic dehydration and inability to maintain adequate fluid balance",
        "Aspiration pneumonia and respiratory complications from inability to breathe and swallow properly",
        "Septic shock from recurrent infections due to compromised immune system function"
      ],
      correct: "C"
    },
    {
      id: 26483,
      question: "What adaptive device would be MOST helpful for this patient to improve oral self-care?",
      options: [
        "Standard manual toothbrush with ergonomic handle and soft bristles for gentle cleaning",
        "Toothbrush that cleans buccal and lingual surfaces simultaneously with weighted handle for stability",
        "Electric toothbrush with small brush head and automatic timer for consistent cleaning",
        "Interdental cleaning device with long handle for posterior access and biofilm removal"
      ],
      correct: "B"
    },
    {
      id: 26484,
      question: "Which oral complication is this patient at HIGHEST risk for developing?",
      options: [
        "Enamel hypoplasia from disruption in tooth development during the traumatic injury",
        "Xerostomia from medications increasing caries and periodontal disease risk significantly",
        "Aggressive periodontitis from immune system suppression caused by brain injury",
        "Oral cancer from radiation therapy commonly used to treat brain trauma complications"
      ],
      correct: "B"
    },
    {
      id: 26485,
      question: "What is this patient's functional potential for independence based on the C4 spinal cord injury level?",
      options: [
        "Can perform minimal self-care activities using electric wheelchair without ventilator support",
        "Can perform complete personal self-care and wheelchair transfers using manual wheelchair independently",
        "Can walk with leg braces and crutches without need for any wheelchair assistance",
        "Has no functional independence and requires wheelchair, ventilator, and tracheostomy for survival"
      ],
      correct: "D"
    },
    {
      id: 26486,
      question: "What percentage of patients taking phenytoin experience drug-influenced gingival enlargement?",
      options: [
        "Gingival enlargement occurs in approximately 25% of patients taking phenytoin medication",
        "Gingival enlargement occurs in approximately 35% of patients taking phenytoin medication",
        "Gingival enlargement occurs in approximately 50% of patients taking phenytoin medication",
        "Gingival enlargement occurs in approximately 75% of patients taking phenytoin medication"
      ],
      correct: "C"
    },
    {
      id: 26487,
      question: "What is the MOST appropriate recommendation regarding nitrous oxide use for this patient?",
      options: [
        "Nitrous oxide sedation is recommended as it helps prevent seizures during dental treatment",
        "Nitrous oxide sedation is not recommended as it is known to elicit seizures in epilepsy patients",
        "Nitrous oxide sedation is appropriate only if combined with oxygen at 100% concentration",
        "Nitrous oxide sedation is safe if the patient takes anticonvulsant medication 30 minutes before"
      ],
      correct: "B"
    },
    {
      id: 26488,
      question: "What cranial nerve is affected in Bell palsy causing these symptoms?",
      options: [
        "Trigeminal nerve (cranial nerve V) responsible for facial sensation and mastication muscles",
        "Facial nerve (cranial nerve VII) responsible for facial expression and taste sensation",
        "Glossopharyngeal nerve (cranial nerve IX) responsible for swallowing and gag reflex function",
        "Hypoglossal nerve (cranial nerve XII) responsible for tongue movement and speech articulation"
      ],
      correct: "B"
    },
    {
      id: 26489,
      question: "What is the MOST important oral self-care recommendation for this patient during recovery?",
      options: [
        "Aggressive flossing twice daily in all areas to prevent food impaction between teeth",
        "Rinsing with water after eating and using oral irrigator to remove food from vestibule",
        "Using chlorhexidine mouthwash four times daily as a substitute for mechanical cleaning",
        "Brushing teeth vigorously three times daily focusing on the affected side only"
      ],
      correct: "B"
    },
    {
      id: 26490,
      question: "What is the MOST likely diagnosis based on these clinical characteristics?",
      options: [
        "Bell palsy with acute onset facial paralysis and temporary unilateral weakness",
        "Type 1 trigeminal neuralgia with episodic severe shocking pain and complete resolution between attacks",
        "Atypical facial pain with constant aching sensation and no identifiable trigger points",
        "Temporomandibular joint disorder with chronic pain exacerbated by jaw movement"
      ],
      correct: "B"
    },
    {
      id: 26491,
      question: "How long did it take for more than 40% of trigeminal neuralgia patients to receive evaluation by a neurologist or neurosurgeon?",
      options: [
        "More than 40% of patients took less than 6 months for neurological evaluation",
        "More than 40% of patients took between 6 months and 1 year for evaluation",
        "More than 40% of patients took between 1 year and 18 months for evaluation",
        "More than 40% of patients took more than 2 years for neurological evaluation"
      ],
      correct: "D"
    },
    {
      id: 26492,
      question: "What is the MOST effective communication technique for providing oral hygiene instructions to this patient?",
      options: [
        "Give detailed written instructions with multiple steps for the patient to review independently",
        "Provide instructions slowly step-by-step in simple concrete language with demonstrations",
        "Explain all procedures quickly using technical dental terminology for accuracy and precision",
        "Have the caregiver perform all oral hygiene while explaining the process to the patient"
      ],
      correct: "B"
    },
    {
      id: 26493,
      question: "What is the PRIMARY mechanism by which phenytoin causes gingival enlargement?",
      options: [
        "Phenytoin stimulates excessive inflammatory cytokine production in gingival tissues",
        "Phenytoin alters fibroblast metabolism causing cells to produce excessive collagen",
        "Phenytoin causes vitamin C deficiency leading to defective collagen synthesis",
        "Phenytoin induces chronic dehydration of tissues leading to compensatory hyperplasia"
      ],
      correct: "B"
    },
    {
      id: 26494,
      question: "What type of brain damage has this patient experienced based on his clinical presentation?",
      options: [
        "Right-sided brain damage causing left-sided paralysis with spatial and perceptual deficits",
        "Left-sided brain damage causing right-sided paralysis with language and speech problems",
        "Bilateral brain damage causing complete paralysis with severe cognitive and memory deficits",
        "Brainstem damage causing cranial nerve dysfunction with loss of protective reflexes"
      ],
      correct: "B"
    },
    {
      id: 26495,
      question: "At what blood pressure reading is hypertensive crisis diagnosed requiring immediate medical consultation?",
      options: [
        "Blood pressure of 160/100 mmHg or higher indicates hypertensive crisis requiring medical intervention",
        "Blood pressure of 170/110 mmHg or higher indicates hypertensive crisis requiring medical intervention",
        "Blood pressure of 180/120 mmHg or higher indicates hypertensive crisis requiring medical intervention",
        "Blood pressure of 190/130 mmHg or higher indicates hypertensive crisis requiring medical intervention"
      ],
      correct: "C"
    },
    {
      id: 26496,
      question: "What is the maximum time window for most effective stroke treatment after symptom onset?",
      options: [
        "Treatments are most effective when initiated within 1 hour of symptom onset",
        "Treatments are most effective when initiated within 2 hours of symptom onset",
        "Treatments are most effective when initiated within 3 hours of symptom onset",
        "Treatments are most effective when initiated within 6 hours of symptom onset"
      ],
      correct: "C"
    },
    {
      id: 26497,
      question: "What is the characteristic manifestation of tremor in Parkinson disease?",
      options: [
        "Action tremor that occurs when the patient contracts muscles during voluntary movement",
        "Resting tremor that is rhythmic, stops during intended movements, and primarily involves hands",
        "Intention tremor that worsens as the patient approaches a target during coordinated movements",
        "Postural tremor that occurs when the patient maintains a position against gravity"
      ],
      correct: "B"
    },
    {
      id: 26498,
      question: "What neurotransmitter is deficient in Parkinson disease due to loss of dopamine-synthesizing neurons?",
      options: [
        "Serotonin deficiency affecting mood regulation and emotional stability in disease progression",
        "Dopamine deficiency interfering with nerve impulse conduction related to muscle activity coordination",
        "Acetylcholine deficiency causing cognitive impairment and memory loss over time",
        "Norepinephrine deficiency resulting in autonomic dysfunction and blood pressure regulation problems"
      ],
      correct: "B"
    },
    {
      id: 26499,
      question: "What is the MOST common type of cerebral palsy?",
      options: [
        "Ataxic cerebral palsy affecting balance and coordination from cerebellar damage",
        "Spastic cerebral palsy characterized by muscle stiffness from frontal lobe damage",
        "Athetoid cerebral palsy with uncontrolled movements from basal ganglia damage",
        "Mixed form cerebral palsy with combination of multiple symptoms from various areas"
      ],
      correct: "B"
    },
    {
      id: 26500,
      question: "Which brain area is damaged in athetoid cerebral palsy?",
      options: [
        "Frontal lobe of the cerebral cortex causing spasticity in muscles leading to stiffness",
        "Basal ganglia causing damage to motor centers resulting in dyskinetic movements",
        "Cerebellum causing problems in balance coordination and depth perception deficits",
        "Parietal lobe of the cerebral cortex causing somatic sensory loss and perception problems"
      ],
      correct: "B"
    },
    {
      id: 26501,
      question: "Which factors may cause transient worsening of existing MS symptoms?",
      options: [
        "Cold weather exposure and cool baths that cause vasoconstriction and reduced blood flow",
        "Fever, heavy physical exertion, hot weather, hot showers, and exposure to sunlight",
        "Mild exercise and moderate physical activity that maintains cardiovascular fitness levels",
        "Adequate sleep and stress reduction techniques that promote nervous system healing"
      ],
      correct: "B"
    },
    {
      id: 26502,
      question: "What medication is commonly used to treat acute exacerbations of multiple sclerosis?",
      options: [
        "Antibiotic therapy to treat underlying infection causing the exacerbation of symptoms",
        "Corticosteroids such as steroids for their anti-inflammatory effects during acute episodes",
        "Anticoagulant medications to prevent blood clots that may worsen the neurologic symptoms",
        "Antidepressant medications to manage the psychological aspects of disease exacerbation"
      ],
      correct: "B"
    },
    {
      id: 26503,
      question: "What percentage of ALS cases are sporadic with no known risk factors or family history?",
      options: [
        "Sporadic ALS accounts for 50% to 60% of all cases diagnosed",
        "Sporadic ALS accounts for 70% to 80% of all cases diagnosed",
        "Sporadic ALS accounts for 90% to 95% of all cases diagnosed",
        "Sporadic ALS accounts for 98% to 100% of all cases diagnosed"
      ],
      correct: "C"
    },
    {
      id: 26504,
      question: "What is the mode of inheritance for Huntington disease?",
      options: [
        "Autosomal recessive requiring both parents to carry the mutated gene for expression",
        "Inherited through mutation on huntingtin gene on chromosome 4 passed from parent to child",
        "X-linked recessive affecting primarily males with females being asymptomatic carriers only",
        "Sporadic mutation occurring randomly without any family history or genetic predisposition"
      ],
      correct: "B"
    },
    {
      id: 26505,
      question: "What is the probability that each child of a parent with Huntington disease will develop the disease?",
      options: [
        "Each child has a 25% chance of developing the disease from inheriting mutated gene",
        "Each child has a 50% chance of developing the disease from inheriting mutated gene",
        "Each child has a 75% chance of developing the disease from inheriting mutated gene",
        "Each child has a 100% chance of developing the disease from inheriting mutated gene"
      ],
      correct: "B"
    },
    {
      id: 26506,
      question: "What is the gold standard for diagnosing traumatic brain injury?",
      options: [
        "Computed tomography scan showing structural brain damage and hemorrhage presence",
        "Clinical interview assessing difficulties with learning memory concentration and problem solving",
        "Magnetic resonance imaging revealing microscopic damage to brain tissue and axons",
        "Electroencephalogram demonstrating abnormal electrical activity patterns in the brain"
      ],
      correct: "B"
    },
    {
      id: 26507,
      question: "What is the PRIMARY cause of most spinal cord injuries?",
      options: [
        "Motor vehicle accidents are the primary cause of spinal cord injuries in the United States",
        "Falls are the primary cause of spinal cord injuries especially in elderly populations",
        "Acts of violence including gunshot wounds are the primary cause of injuries",
        "Sports and recreation accidents are the primary cause of spinal cord injuries"
      ],
      correct: "A"
    },
    {
      id: 26508,
      question: "What functional abilities would a patient with C6 spinal cord injury have?",
      options: [
        "Can perform sitting and eating with devices and use manual wheelchair for mobility",
        "Can perform complete personal self-care with wheelchair self-transfers independently",
        "Has no functional abilities and requires ventilator and electric wheelchair for survival",
        "Can walk with leg braces and crutches without need for any wheelchair"
      ],
      correct: "A"
    },
    {
      id: 26509,
      question: "What is this life-threatening condition called when seizures last longer than 5 minutes?",
      options: [
        "Absence seizure requiring immediate administration of anticonvulsant medications intravenously",
        "Status Epilepticus requiring emergency intervention to prevent irreversible neurologic damage",
        "Focal onset seizure requiring observation only as it will resolve spontaneously without treatment",
        "Petit mal seizure requiring placement in recovery position until consciousness returns naturally"
      ],
      correct: "B"
    },
    {
      id: 26510,
      question: "At what age range are absence seizures most common in children?",
      options: [
        "Absence seizures are most common in children between 2 to 4 years of age",
        "Absence seizures are most common in children between 4 to 14 years of age",
        "Absence seizures are most common in children between 10 to 16 years of age",
        "Absence seizures are most common in children between 14 to 18 years of age"
      ],
      correct: "B"
    },
    {
      id: 26511,
      question: "When should corticosteroids be started for maximum benefit in Bell palsy treatment?",
      options: [
        "Corticosteroids should be started within 24 hours of symptom onset for maximum benefit",
        "Corticosteroids should be started within 48 hours of symptom onset for maximum benefit",
        "Corticosteroids should be started within 72 hours of symptom onset for maximum benefit",
        "Corticosteroids should be started within 1 week of symptom onset for maximum benefit"
      ],
      correct: "C"
    },
    {
      id: 26512,
      question: "What is the MOST important eye care recommendation for this patient?",
      options: [
        "Wear sunglasses outdoors only during daytime hours to protect from UV radiation exposure",
        "Use lubricants artificial tears and protective eyewear as eye cannot be closed fully",
        "Apply warm compresses to the affected eye three times daily to improve circulation",
        "Instill antibiotic eye drops four times daily to prevent bacterial infection of cornea"
      ],
      correct: "B"
    },
    {
      id: 26513,
      question: "Which branches of the trigeminal nerve are MOST commonly affected in trigeminal neuralgia?",
      options: [
        "Ophthalmic branch affecting the eye and forehead causing vision problems and headaches",
        "Maxillary and mandibular branches affecting cheek jaw teeth gums and lips more commonly",
        "All three branches equally affected with no predilection for any specific area distribution",
        "Lingual and inferior alveolar branches affecting tongue and lower teeth exclusively only"
      ],
      correct: "B"
    },
    {
      id: 26514,
      question: "What is the PRIMARY cause of trigeminal neuralgia pain?",
      options: [
        "Bacterial infection of the trigeminal ganglion causing inflammatory neuritis and nerve damage",
        "Pressure from blood vessel against trigeminal nerve wearing away myelin sheath causing abnormal signals",
        "Autoimmune destruction of trigeminal nerve causing progressive loss of nerve function over time",
        "Traumatic injury to trigeminal nerve branches during dental procedures causing permanent nerve damage"
      ],
      correct: "B"
    },
    {
      id: 26515,
      question: "What is the average duration from earliest symptoms to death in Alzheimer disease?",
      options: [
        "Average duration is 4 years from earliest symptoms to death in Alzheimer disease",
        "Average duration is 6 years from earliest symptoms to death in Alzheimer disease",
        "Average duration is 8 years from earliest symptoms to death in Alzheimer disease",
        "Average duration is 12 years from earliest symptoms to death in Alzheimer disease"
      ],
      correct: "C"
    },
    {
      id: 26516,
      question: "What bacterium has been identified in brain tissue of Alzheimer disease patients associated with periodontal infection?",
      options: [
        "Aggregatibacter actinomycetemcomitans and its leukotoxin in hippocampus and cortex regions",
        "Porphyromonas gingivalis and its gingipain proteases in brain areas associated with memory",
        "Tannerella forsythia and its surface layer proteins in cerebrospinal fluid and brain tissue",
        "Prevotella intermedia and its inflammatory mediators in cerebral cortex and white matter"
      ],
      correct: "B"
    },
    {
      id: 26517,
      question: "What toothbrushing technique is recommended for patients with Alzheimer disease who cannot tolerate noise?",
      options: [
        "Bass technique with manual toothbrush to avoid vibration and noise from power devices",
        "Modified Stillman technique with manual toothbrush for gentle sulcular cleaning approach",
        "Fones technique with power toothbrush if patient tolerates noise or manual if cannot",
        "Charters technique with manual toothbrush to stimulate gingival tissues effectively"
      ],
      correct: "C"
    },
    {
      id: 26518,
      question: "What type of stroke results from a blood clot that travels to the brain from another part of the body?",
      options: [
        "Thrombotic stroke where clot develops within blood vessel of brain or neck blocking flow",
        "Embolic stroke where blood clot travels to brain from another body part blocking circulation",
        "Hemorrhagic stroke where vessel ruptures leaking blood into brain tissue causing pressure",
        "Stenotic stroke where severe narrowing of artery reduces blood flow to brain tissue"
      ],
      correct: "B"
    },
    {
      id: 26519,
      question: "What is the MOST important modifiable risk factor for cerebrovascular accident?",
      options: [
        "Family history of stroke which cannot be changed but indicates increased genetic susceptibility",
        "Age and gender which are non-modifiable risk factors that increase stroke probability",
        "Hypertension which increases stroke risk by 2 to 4 times and can be controlled",
        "Race and ethnicity which are non-modifiable factors affecting stroke incidence rates"
      ],
      correct: "C"
    },
    {
      id: 26520,
      question: "What deficit is characteristic of left-sided brain damage from stroke?",
      options: [
        "Spatial and perceptual deficits with quick impulsive behavior and difficulty using mirrors",
        "Language and speech problems with decreased auditory memory for long instructions",
        "Memory deficits for events and people with generalized memory loss affecting daily function",
        "Visual field deficits with neglect of left side and decreased awareness of left body parts"
      ],
      correct: "B"
    },
    {
      id: 26521,
      question: "What is the PRIMARY cause of hemorrhagic stroke?",
      options: [
        "Atherosclerotic plaque rupture causing clot formation and vessel occlusion blocking blood flow",
        "Rupture of brain vessel from high blood pressure or aneurysm causing blood leakage into tissue",
        "Cardiac arrhythmia causing irregular heartbeat and clot formation traveling to brain vessels",
        "Severe arterial stenosis causing gradual reduction in blood flow leading to tissue death"
      ],
      correct: "B"
    },
    {
      id: 26522,
      question: "Which factor is associated with worsening of multiple sclerosis symptoms?",
      options: [
        "Various types of infections that may trigger immune system activation causing disease relapse",
        "Cold exposure and decreased ambient temperature that causes vasoconstriction and reduced circulation",
        "Adequate rest and stress reduction that allows immune system to function optimally",
        "Regular moderate exercise that maintains cardiovascular fitness and overall health status"
      ],
      correct: "A"
    },
    {
      id: 26523,
      question: "What is the MOST likely cause of enamel hypoplasia in children with congenital cerebral palsy?",
      options: [
        "Enamel defect related to stage of tooth development during time of cerebral injury",
        "Medication side effect from antispasticity drugs taken during tooth development years",
        "Nutritional deficiency from difficulty eating and malnutrition during childhood growth",
        "Genetic syndrome associated with cerebral palsy causing inherited enamel defects"
      ],
      correct: "A"
    },
    {
      id: 26524,
      question: "What is this patient's functional potential for independence based on the spinal cord injury level?",
      options: [
        "Can perform personal self-care and wheelchair self-transfers independently using manual wheelchair",
        "Requires complete assistance for all activities with electric wheelchair and ventilator support needed",
        "Can perform minimal activities with assistance requiring electric wheelchair for all mobility",
        "Can walk independently with leg braces and crutches without need for wheelchair assistance"
      ],
      correct: "A"
    },
    {
      id: 26525,
      question: "What treatment approach is effective for improving cognition in traumatic brain injury?",
      options: [
        "Cognitive behavioral therapy improving cognition and reducing anxiety in both TBI and PTSD",
        "Pharmacological therapy exclusively using antipsychotic medications for all cognitive symptoms",
        "Physical therapy focusing on motor rehabilitation without cognitive intervention components",
        "Occupational therapy addressing only activities of daily living without cognitive training"
      ],
      correct: "A"
    }
  ]
};
